(function() {
	'use strict';

	angular
		.module('proRefs', ['ui.router', 'ui.bootstrap', 'ngSanitize'])
		.run(runBlock);
    
	function runBlock($location, dataService, webSessionStorage, $state, headerService,
		loginService, $http, $rootScope, custData, custDataDev, setCustService, modalService) {
		var sDatabaseID = "";
		var sDataSource = "";
		var searchObject = $location.search();
		var sRetCodeToDelete = "";
		

// searchObject.conf = "MO-DEV";		//TESTING - Preload sDatabaseID for testing.
// $rootScope.TESTING = true;			//TESTING == true:
										// - Prevents ReturnCode deletion in loginService
										// - Prevents payment from going to VancoPay, so can check params.
										// - Gives additional debug alerts not shown to users.
// $rootScope.AUTOPAY = true;		//AUTOPAY == true:
										// - Automatically marks off Payment Step as "Completed"
// searchObject = { ReturnCode: "rMxId55CN4kiNwBB8_wf" };		//Login w/ReturnCode
		
		if ($rootScope.TESTING) { 
			sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
		}
			
		if (searchObject.ReturnCode) { 
			sRetCodeToDelete = searchObject.ReturnCode;
		} else if (webSessionStorage.getStoredData('sReturnCode') != null) {
			/* if "Refresh" occurs, this allows login so as not to force
				user to manually login again: */
			sRetCodeToDelete = webSessionStorage.getStoredData('sReturnCode');
		}

		//Login with ReturnCode ==> LoginService calls SecDeleteReturnCode immediately after login
		if (sRetCodeToDelete != "") {
			loginService.secReturnLogin(sRetCodeToDelete)
			.then(function (data) {
				if (data[0].DATABASEID != "") {
					sDataSource = data[0].DATABASEID;
					setCustService.fromDataSource(sDataSource);
					
					/* PUBLIC APP... Do NOT Use appValidationService. Additional apps shows in MENU if
						Authorized thru LoginService. */
					if (data[0].USERID != "") {	
						loginService.login(data[0].USERNAME, data[0].PASSWORD)
						.then(function(loginReturn) {
							if (loginReturn[0].SECUSERLOGIN[0].RESULT == "Success") {
								loginService.user.USERENTITYID = 
									loginReturn[0].SECUSERLOGIN[0].USERENTITYID;
								if (data[0].FN == "PayFee") {
									$state.go('myCerts',{sFunction: data[0].FN});
								} else { 
									var arcUserChurch = loginService.user.UserChurchFNs;
									if (arcUserChurch.length > 0) {	
										for (var i=0; i<arcUserChurch.length; i++) {
											if (arcUserChurch[0].FN == "ProRef") {
												$state.go('certMgmt');
											break; }
											else if (i == arcUserChurch.length-1) {
												$state.go('myCerts');
											}
										}
									} else { $state.go('myCerts'); }	
								}			
							}
						});
					} else if (data[0].USERNAME == "Expired") {
						modalService.okAlert("Expired", 
							"Your session login has expired.<br><br>" +
							"Please log in again to continue.");
						$state.go('login');
					}
				}
			});
		}
		
		// Login page with Conference identified:
		else {
			if (searchObject.conf) {
				sDatabaseID = searchObject.conf;
				setCustService.fromDatabaseID(sDatabaseID);
			} else { 
				webSessionStorage.setStoredData('sDataSource', "HelpFalcon");
			}
		}
		
	}
})();

(function () {
    'use strict';
    
    angular
        .module('proRefs')
        .factory('webSessionStorage', webSessionStorage);
        
    function webSessionStorage($window) {
        var store = $window.sessionStorage;
        var factory = {};
        
        factory.getStoredData = function (sKey) {
            return store.getItem(sKey);
        };
        
        factory.setStoredData = function (sKey, sData) {
            if (sData) {
                store.setItem(sKey, sData);
            }  
            else {
                store.removeItem(sKey);
            }
        };
        
        return factory;
	}
    
})();
(function () {
	'use strict';

	angular
		.module('proRefs')
		.factory('vancoService', vancoService);

	vancoService.$inject = ['$http','webSessionStorage','loginService','$rootScope','datesService',
		'errorEmailNotification','dataService','mcWebCFC','protectURL','vancoPay','$httpParamSerializer',
		'$window','$log'];	

	function vancoService($http, webSessionStorage, loginService, $rootScope, datesService,
		errorEmailNotification, dataService, mcWebCFC, protectURL, vancoPay, $httpParamSerializer, 
		$window, $log) {
		var sDataSource = "";
		
		var service = {
			goToVancoPayments: goToVancoPayments,
			saveRcvPaymentTransData: saveRcvPaymentTransData
		};
		return service;
		
		function goToVancoPayments(lastName, firstName) {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
		/* Get Fee: */
			var params= {
				method: "LibGetASetting",
				sDataSource: sDataSource,
				sSetting: "ProBkgrdScreenFee"
			};
			return $http.post(mcWebCFC, params)
            .then(function(results) {
                if (results.data.length > 0) {
					var fee = results.data[0].SETTINGVALUE;
					saveRcvPaymentTransData(lastName, firstName, fee);
				} else {
					var sEmailContent = errorEmailNotification.error4
						("WebProtect/vancoService() LibGetBkgrdScreenFee");
					dataService.emailSendError(sEmailContent);
				}
            });
		}
		
		function saveRcvPaymentTransData(lastName, firstName, fee) {		
			var iRcvID = 0;
			var subItem = lastName + ", " + firstName;
			var sToday = datesService.todayToDbString();
			var curYear = datesService.currentYear();
			if (subItem.length > 20) {
				subItem = subItem.substr(0, 20);
			}
					
			var sRawDataString = "WebProtect || vancoService || " + loginService.user.USERID +
				" || I || PaymentStatus==Started || BillingEntityID==" + 
				loginService.user.USERENTITYID + " || App==Protect || RcvItem==SS || RcvSubItem==" +
				subItem + " || RcvSubItemID==" + $rootScope.sProID + " || AmountToApply==" + 
				fee + " || AsOfDate==" + sToday + " || FinYear==" + curYear + " ^^ ";				
			var params1 = {
				method: "RcvSavePaymentTransData",
				sDataSource: sDataSource,
				sRawDataString: sRawDataString
			};
			return $http.post(mcWebCFC, params1)
			.then(function(results1) {
				if (results1.data[0].RESULTCODE == "Success") {
					iRcvID = results1.data[0].RCVID;

				/* Get a ReturnCode: */
					dataService.secGetReturnCode(10, "PayFee", loginService.user.USERID + "|" +
						loginService.user.USERFULLNAME)
					.then(function(result2) {
						if (result2.length > 0) {
							var ReturnCode = result2[0].RETURNCODE;

						/* Go To VancoPay app: */	
							if (iRcvID > 0) {
								var returnURLWithCode = protectURL + "?ReturnCode=" + ReturnCode;
								var params3 = {
									sDataSource: sDataSource,
									iUserID: loginService.user.USERID,
									App: "Protect",
									ReturnURL: returnURLWithCode,
									iRcvID: iRcvID
								}; 
								var paramsString = $httpParamSerializer(params3);
								var url = vancoPay + "?" + paramsString;

//If TESTING... do not go to VancoPay. Instead, copy parameters and run VancoPay in Debug:
								if ($rootScope.TESTING) {
									$log.info("params:",params3);
								} else {
									$window.location.replace(url);
								}
							}
						}
					});
				} else {
					var sEmailContent1 = "WebProtect/vancoService - RcvSavePaymentTransData()" +
						"<br><br>There was an error saving the Vanco Payment RcvPaymentTransData " +
						"for:<br>ProID: " + $rootScope.sProID + "<br>Payment Amount: " + fee +
						"<br><br>Error: " + results1.data[0].RESULTREASON +
						"<br><br>Attempted to resolve in v.175. See v175 notes on stepsCtrl for details.";
					dataService.emailSendError(sEmailContent1);
				}
			});
		}
		
	}
})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('validatorService', validatorService);

	validatorService.$inject = [];	

    function validatorService() {
		var service = {
			emailIsValid: emailIsValid,
			phoneIsValid: phoneIsValid
		};
		
		return service;
		
		function emailIsValid(sEmail) {
			var isValid = false;
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);

			if (sEmail.search(filter) == -1) {
				return isValid = false;
			} else { isValid = true; }
			
			return isValid;
		}
		
		function phoneIsValid(phone) {
			var isValid = false;
			var numOnlyPattern = /[^0-9]/g;
			var valPhone = String(phone);
			var numOnlyPh = valPhone.replace(numOnlyPattern,'');
			
			if (String(numOnlyPh).length == 10) { return true; }
			
			return isValid;
		}
		
	}
})();    
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('emailValidator', emailValidator);

    function emailValidator() {
		var factory = {
			validateEmail: validateEmail
		};
		
		return factory;
		
		function validateEmail(sEmail) {
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);

			if (sEmail.search(filter) == -1) {
				return false;
			} else {
				return true;
			}
		}		
	}

})();    
(function () {
	'use strict';
 
	angular
		.module('proRefs')
		.factory('userAcctEmails', userAcctEmails);
	
	userAcctEmails.$inject = ['$http','webSessionStorage','$rootScope','protectURL','proJsCFC'];

	function userAcctEmails($http, webSessionStorage, $rootScope, protectURL, proJsCFC) {
		var factory = {
			sendSelfInitUAEmail: sendSelfInitUAEmail
		};
		
		return factory;
		
		
		function sendSelfInitUAEmail(sUserName, sEmail) {
			var sDatabaseID = webSessionStorage.getStoredData("sDatabaseID");
			var sDataSource = webSessionStorage.getStoredData("sDataSource");
			var sEmailContent = "";
			var sFrom = "";
			var sReplyTo = "";
			var proURL = protectURL + "?conf=" + sDatabaseID;
			
			sEmailContent = "Your MissionConnect account has been initialized.<br><br>" +
				"For your records, the secure website address is:<br>" +
				"<font color='#0000FF'><a href=" + proURL + "><u>" + proURL + 
				"</u></a></font><br><br>" +
				"Your Username is: " + sUserName + "<br><br>" +
				"Please store your Username and Password in a safe place for future reference.<br><br>" +
				"If you forget your password, you can have it sent to this email address by " +
				"clicking the &quot;Forgot Password?&quot; button on the login page.<br><br>" +
				"Login tips:<br>" +
				"Type in your username and password. Do not use a copy and paste method, as that sometimes " +
				"includes additional data that does not display, but will cause it not to work.<br>" +
				"Both the username and password are case sensitive. Capital letters should be entered " +
				"as capitalized, etc.";
				
			var params= {
				method: "LibGetASetting",
				sDataSource: sDataSource,
				sSetting: "RcvEmailReplyToProtect"	
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				if (result.data.length > 0) {
					sReplyTo = result.data[0].SETTINGVALUE;
				}
				var params1= {
					method: "LibGetASetting",
					sDataSource: sDataSource,
					sSetting: "RcvEmailFromProtect"	
				};
				return $http.post(proJsCFC, params1)
				.then(function (result) {
					if (result.data.length > 0) {
						sFrom = result.data[0].SETTINGVALUE + " <" + sReplyTo + ">";
					}
					
					if (sDatabaseID.substr(-3,3) == "DEV") {
						sEmail = "testing@greatspirit.com";
					} else if (sDatabaseID == "VID") {
						sEmail = "lyndzie@greatspirit.com";
					}
					
					var params2 = {
						method: "EmailSendCustom",
						sEmailAddr: sEmail,
						sFrom: sFrom,
						sReplyTo: sReplyTo,
						sSubject: "Account Information",
						sEmailContent: sEmailContent
					};
					return $http.post(proJsCFC, params2)
					.then(function (result) {
						return result.data;
					});
				});	
			});
		}	
		
	}
})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('timeOutService', timeOutService);

	timeOutService.$inject = ['$timeout','modalService','loginService','$state',
		'$uibModal'];//,'$log'];	

    function timeOutService($timeout, modalService, loginService, $state, 
		$uibModal) {//, $log) {
		var appTimer;
		
		var service = {
			setTimer: setTimer,
			resetTimer: resetTimer
		};
		return service;

		function setTimer(nMin) { 
			var ms = Number(nMin * 60000); //$log.info('timer set for ', ms);
			service.timer = nMin;
			appTimer = $timeout(function () {
				lastChance();			
			}, ms);			
		}
		
		/** Last Chance... modal asking if user is still there,
		  *  and wants to continue using this application.	
		  **/
		function lastChance() {
			var modalInstance = $uibModal.open({
				animation: true,
				size: 'sm',
				templateUrl: 'app/modals/modTimeout.html',
				controller: 'ModalTimeoutController',
				bindToController: true,
				controllerAs: 'modTO',
				keyboard: true,
				backdrop: 'static',
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0'
			});
			modalInstance.result
			.then(function(modResult) {
				if (modResult.continue == false) {
					$state.go('login', {reload: true});
					loginService.logout();
				} else {
					service.setTimer(30);
				}
			});
		}

		function resetTimer(nMin) {
			$timeout.cancel(appTimer); //$log.info('cancelled');
			service.setTimer(nMin);

		}
	}
	
})();

(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('setCustService', setCustService);

	setCustService.$inject = ['custData','custDataDev','webSessionStorage','headerService',
		'$rootScope','$log'];	

    function setCustService(custData, custDataDev, webSessionStorage, headerService,
		$rootScope, $log) {
		var service = {
			fromDataSource: fromDataSource,
			fromDatabaseID: fromDatabaseID
		};
		return service;
				
		function fromDataSource(dataSource) {
			webSessionStorage.setStoredData('sDataSource', dataSource);

			if (dataSource.slice(-3) == "Dev" || dataSource == "FalconVideos") {
				for (var i=0; i<custDataDev.length; i++) {
					custData.push(custDataDev[i]);
				}
			}
			
			for (i=0; i<custData.length; i++) {
				if (custData[i].DataSource == dataSource) {
					webSessionStorage.setStoredData('sDatabaseID', custData[i].DatabaseID);
					headerService.setCustomer(custData[i].CustomerName);					
					$rootScope.$broadcast('updateCustomer');
				break; }
			}			
		}
		
		function fromDatabaseID(databaseID) { $log.info("setCustService.fromDatabaseID")
			webSessionStorage.setStoredData('sDatabaseID', databaseID);
			
			if (databaseID.slice(-3) == "DEV" || databaseID == "VID") {
				for (var i=0; i<custDataDev.length; i++) {
					custData.push(custDataDev[i]);
				}
			}

			for (i=0; i<custData.length; i++) {
				if (custData[i].DatabaseID == databaseID) {
					webSessionStorage.setStoredData('sDataSource', custData[i].DataSource);
					headerService.setCustomer(custData[i].CustomerName);					
					$rootScope.$broadcast('updateCustomer');
				break; }
			}
		}
		
	}
})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('referRefEmail', referRefEmail);
	
	referRefEmail.$inject = ['webSessionStorage','loginService','refJSURL','webProMO'];

    function referRefEmail(webSessionStorage, loginService, refJSURL, webProMO) {
		var factory = {
			getEmailContent: getEmailContent
		};
		
		return factory;
		
		
		function getEmailContent(sApplicant, sReferralUserName, sReferralName, sReturnCode) {
			var sDatabaseID = webSessionStorage.getStoredData("sDatabaseID");
			var sRefJSLink = refJSURL + "?ReturnCode=" + sReturnCode;
			
			// ONLY for MO PastorRef @ present! Customize text for others when needed:	
			switch (sDatabaseID) {
				case "MO": case "MO-DEV":
					var sEmailContent = sReferralName + ",<br><br>A reference for " +
						sApplicant + " has been referred to you by " +
						loginService.user.USERFULLNAME + " for completion. This is to fulfill " +
						"a requirement in the process for Safe Sanctuaries Certification." +
						"<br><br>";				

					sEmailContent += "You may login to your Safe Sanctuaries " +
						"account online and complete all of your waiting pastoral reference " +
						"requests at one time. (No more losing the request email among all the " +
						"other emails in your Inbox.) " +
						"<b>This application also works from your tablet, smart phone, or other " +
						"devices.</b>";

					if (sReferralUserName != "") {
						sEmailContent += "Just click the link below from within that device " +
							"to open the new Pastor's Reference application.<br><br>" +
							"Your UserName is: " + sReferralUserName +
							"<br><font color='#0000FF'><a href=" + webProMO + "><u>" + 
							webProMO + "</u></a></font><br><br>OR"; }
					else {
						sEmailContent += "<br><br>However, it appears you do not have an " +
							"active MissionConnect (Safe Sanctuaries) online account, which " +
							"is required to use this feature. If you receive frequent " +
							"reference requests, and would like an account, " +
							"please contact the MO Safe Sanctuaries office.";
					}

					sEmailContent += "<br><br>If you prefer to complete just the single reference " +
						"at this time, click the following link to go directly to the reference for " +
						sApplicant + ".<br>" +
						"<font color='#0000FF'><a href=" + sRefJSLink + "><u>" + sRefJSLink + 
						"</u></a></font><br><br>" +
						"Please try to complete this reference within 2 weeks."; 
				break;
			}
			return sEmailContent;
		}
	}

})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('personRecord', personRecord);

	personRecord.$inject = ['webSessionStorage','dataService','loginService','datesService'];	

    function personRecord(webSessionStorage, dataService, loginService, datesService) {
		
		var factory = {
			createUpdateString: createUpdateString
		};
		
		return factory;	
	
	/* Person Record is only updated if Locked (-1) OR field remains NULL.
		Fields NOT used in WebProtect applications, which would need to be added
		if used in future: Prefix, SuffixInitials, UseName, DeathDate, EthnicType,
		SpecialNeed, MaritalStatus, AnniversaryDate, CustomFields(PrCustDef1,2,3,4) **/
		
		function createUpdateString(objPerson, arrData) {
			var sFirstName = "";
			var sMiddleName = "";
			//var sLastName = "";
			var sFormerName = "";
			var sGender = "";
			var sBDay = "";
			var iUMChurchID = 0;
			var sSuffixName = "";
			var sClergyLay = "";
			//collect the entered data from application:
			for (var i=0; i<arrData.length; i++) {
				if (arrData[i].data != null) {
					switch (arrData[i].itemName) {
						case "FirstName":
							var fn = arrData[i].data;
							fn = fn.toLowerCase();
							sFirstName = fn.charAt(0).toUpperCase() + fn.slice(1);
						break;
						case "MiddleName":
							var mn = arrData[i].data;
							mn = mn.toLowerCase();
							if (mn != "none" && mn != "n/a") {
								sMiddleName = mn.charAt(0).toUpperCase() + mn.slice(1);
							} else { mn = ""; }
						break;
						case "FormerName":
							var frm = arrData[i].data;
							frm = frm.toLowerCase();
							sFormerName = frm.charAt(0).toUpperCase() + frm.slice(1);
						break;
						case "Gender":
							sGender = arrData[i].data;
						break;
						case "BirthDate":
							sBDay = datesService.jsDateStrToDbDateStr(arrData[i].data);
						break;
						case "UMCChurch":
							iUMChurchID = Number(arrData[i].data);
						break;
						case "SuffixName":
							sSuffixName = arrData[i].data;
						break;
						
					/* Custom Yes/No (MO), not "Clergy/Lay" */	
						case "Clergy":
							if (arrData[i].data == "Yes") {
								sClergyLay = "C";
							} else { sClergyLay = "L"; }
						break;
					}
				}
			}
				
			var sRawDataString = "";
			if (objPerson.Locked == -1) {
				sRawDataString += " || FirstName==" + sFirstName + 
					" || MiddleName==" + sMiddleName;
			} else if (objPerson.MiddleName == null && sMiddleName != "") {
				sRawDataString += " || MiddleName==" + sMiddleName;
			}
			if (objPerson.SuffixName == null && sSuffixName != "") {
				sRawDataString += " || SuffixName==" + sSuffixName;
			}
			if (objPerson.BirthDate == null && sBDay != "") {
				sRawDataString += " || BirthDate==" + sBDay;
			}
			if (objPerson.Gender == null && sGender != "") {
				sRawDataString += " || Gender==" + sGender;
			}
			if (objPerson.Locked == -1) {
				if (sClergyLay != "") {
					sRawDataString += " || ClergyLay==" + sClergyLay;
				}
			} else if (objPerson.ClergyLay == null) {
				if (sClergyLay != "") {
					sRawDataString += " || ClergyLay==" + sClergyLay;
				} else { sRawDataString += " || ClergyLay==L"; }
			}
			if (objPerson.PrimaryChurchID == null && iUMChurchID > 0) {
				sRawDataString += " || PrimaryChurchID==" + String(iUMChurchID);
			}
			if (objPerson.FormerName == null && sFormerName != "") {
				sRawDataString += " || FormerName==" + sFormerName;
			}
			if (sRawDataString != "") {
				var sSaveString = "WebApps_Pro || Appl_PersonInfo || " +
						String(loginService.user.USERID) + " || U || EntityID==" +
						String(objPerson.ENTITYID) + sRawDataString + " ^^ ";
			} else { sSaveString = ""; }			
						
			return sSaveString;			
		}
		
	}
})(); 
(function () {
	'use strict';

	angular
		.module('proRefs')
		.factory('payPalService', payPalService);

	payPalService.$inject = ['webSessionStorage','dataService','loginService','$rootScope',
		'errorEmailNotification','protectURL','$httpParamSerializer','$window','$log'];	

	function payPalService(webSessionStorage, dataService, loginService, $rootScope,
		errorEmailNotification, protectURL, $httpParamSerializer, $window, $log) {
$log.info("PayPalService")
		
		var service = {
			goToPayPal: goToPayPal,
			goToPayPalVarFee: goToPayPalVarFee
		};
		return service;
		
		function goToPayPal(feeSetting, iCertTypeID) {
			var sDataSource = webSessionStorage.getStoredData('sDataSource');
			var sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
			var nFee = 0;
			var sFeeDesc = "";
			var sItemName = "";
			var sPayPalLogin = "";
			var sPayPalURL = "";
			var sPayPalPostURL = "";
			
			dataService.libGetASetting('PayPalLogin')
			.then(function(login) {
				sPayPalLogin = login[0].SETTINGVALUE;
				
				dataService.libGetASetting('PayPalURL')
				.then(function(url) {
					sPayPalURL = url[0].SETTINGVALUE;
					
					dataService.libGetASetting('PayPalPostURL')
					.then(function(postURL) {
						sPayPalPostURL = postURL[0].SETTINGVALUE;

						dataService.libGetASetting(feeSetting)
						.then(function(results) {
							if (results.length > 0) {
								nFee = results[0].SETTINGVALUE;
							} else {
								var sEmailContent = errorEmailNotification.error4
									("MCWebApps/Protect/payPalService");
								sEmailContent += "<br>LibGetASetting("+feeSetting+")";
								dataService.emailSendError(sEmailContent);
							}
							
							dataService.secGetReturnCode(10,"PayFee",loginService.user.USERID
								+"|"+loginService.user.USERFULLNAME)
							.then(function(data) {
								if (data.length > 0) {
									var sReturnURL = protectURL + "?ReturnCode=" + data[0].RETURNCODE;
									
									switch (sDatabaseID) {
										case "MC": case "MC-DEV":
											if (iCertTypeID == 4) {
												sItemName = "McCurdy Ministries Volunteer Certification";
												sFeeDesc = "McCurdy Ministries certification fee";
											}	
										break;
									}
			
									var params = {
										cmd: "_xclick",
										business: sPayPalLogin,
										amount: nFee,
										invoice: $rootScope.sProID,
										item_name: sItemName,
										item_number: 1,
										notify_url: sPayPalPostURL,
										return: sReturnURL,
										rm: 1,
										cancel_return: sReturnURL,
										custom: "DataSource="+sDataSource+"|App=Protect|UserID="+
											loginService.user.USERID,
										os0: sFeeDesc,
										no_shipping: 1,
										pay: "Pay Now"	
									};
									var paramsString = $httpParamSerializer(params);
									var url = sPayPalURL + "?" + paramsString;
									$window.location.replace(url); 
								}
							});
						});
					});		
				});
			});
		}
		
		function goToPayPalVarFee(nFee, iCertTypeID) {
			var sDataSource = webSessionStorage.getStoredData('sDataSource');
			var sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
			var sFeeDesc = "";
			var sItemName = "";
			var sPayPalLogin = "";
			var sPayPalURL = "";
			var sPayPalPostURL = "";
			
			dataService.libGetASetting('PayPalLogin')
			.then(function(login) {
				sPayPalLogin = login[0].SETTINGVALUE;
				
				dataService.libGetASetting('PayPalURL')
				.then(function(url) {
					sPayPalURL = url[0].SETTINGVALUE;
					
					dataService.libGetASetting('PayPalPostURL')
					.then(function(postURL) {
						sPayPalPostURL = postURL[0].SETTINGVALUE;

						dataService.secGetReturnCode(10,"PayFee",loginService.user.USERID
							+"|"+loginService.user.USERFULLNAME)
						.then(function(data) {
							if (data.length > 0) {
								var sReturnURL = protectURL + "?ReturnCode=" + data[0].RETURNCODE;
								
								switch (sDatabaseID) {
									case "NWTX": case "NWTX-DEV":
										if (iCertTypeID == 4) {
											sItemName = "NWTX Camp Volunteer";
											sFeeDesc = "NWTX Camp Volunteer fees and donations";
										} else {
											sItemName = "Volunteer in Mission";
											sFeeDesc = "NWTX VIM Fee";
										}	
									break;
								}
		
								var params = {
									cmd: "_xclick",
									business: sPayPalLogin,
									amount: nFee,
									invoice: $rootScope.sProID,
									item_name: sItemName,
									item_number: 1,
									notify_url: sPayPalPostURL,
									return: sReturnURL,
									rm: 1,
									cancel_return: sReturnURL,
									custom: "DataSource="+sDataSource+"|App=Protect|UserID="+
										loginService.user.USERID,
									os0: sFeeDesc,
									no_shipping: 1,
									pay: "Pay Now"	
								};
								var paramsString = $httpParamSerializer(params);
								var url = sPayPalURL + "?" + paramsString;
								$window.location.replace(url);
							}
						});
					});		
				});
			});
		}
	}
	
})();	

(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('passwordStrength', passwordStrength);

    function passwordStrength() {
		var reLowerCase = new RegExp(/([a-z]+)/);
		var reUpperCase = new RegExp(/([A-Z]+)/);
		var reNumber = new RegExp(/([0-9]+)/);
		var reSymbol = new RegExp(/(\W+)/);
		
		var factory = {
			getPWStrength: getPWStrength
		};
		
		return factory;
		
		function getPWStrength(sPassword) {
			var iStrength = 0;
			var sPasswordStrength = "Too Short";
			var sPWClass = "tooShort";
			if (sPassword.length > 8) {
				iStrength++;
				if ((sPassword.search(reLowerCase) != -1) && 
					(sPassword.search(reUpperCase) != -1)) {
						iStrength++;
				}
				if (sPassword.search(reNumber) != -1) {
					iStrength++;
				}
				if (sPassword.search(reSymbol) != -1) {
					iStrength++;
				}
				if (sPassword.length > 11) {
					iStrength++;
				}
				
				switch (iStrength) {
					case 0: 
						sPasswordStrength = "Too Short";
						sPWClass = "tooShort";
					break;
					case 1: 
						sPasswordStrength = "Very Weak";
						sPWClass = "veryWeak";					
					break;
					case 2: 
						sPasswordStrength = "Weak";
						sPWClass = "weak";
					break;
					case 3: 
						sPasswordStrength = "Fair";
						sPWClass = "fair";					
					break;
					case 4: 
						sPasswordStrength = "Strong";
						sPWClass = "strong";					
					break;
					case 5: 
						sPasswordStrength = "Very Strong";
						sPWClass = "veryStrong";					
					break;
				}
			}
			
			return {
				strength: sPasswordStrength,
				class: sPWClass
			}
			
		}
	}
	
})();    
(function () {
	'use strict';

	angular
		.module('proRefs')
		.factory('moodleService', moodleService);

	moodleService.$inject = ['$http','moodleCFC','$log'];	

	function moodleService($http, moodleCFC, $log) {
$log.info("MoodleService");

		var factory = {
			moodle:{},
			enrollUser: enrollUser,
			getCurrentStatus: getCurrentStatus,
			getUser: getUser,
			updateUser: updateUser
		};
		return factory;

		
		function enrollUser(retCode, mProID) {
			var params = {
				method: "Moodle_EnrollUser",
				userid: factory.moodle.id,
				returnCode: retCode,
				sProID: mProID,
				iCourseID: 25	
			};
			return $http.post(moodleCFC, params)
			.then(function(result) { // $log.info("Moodle_EnrollUser results:",result);
				return result.data;
			});
		}
		
		function getCurrentStatus(iMoodleID, courseid) {
			factory.moodle.id = iMoodleID;
			var params = {
				method: "Moodle_CourseStatus",
				userid: iMoodleID,
				iCourseID: courseid
			};  //$log.info("Moodle_CourseStatus call:", new Date());
			return $http.post(moodleCFC, params)
			.then(function (results) { // $log.info("Moodle_CourseStatus results:",results.data, new Date());
				var curStatus = "0 of 8 chapters completed";
				var curChapter = 0;
				var str = results.data.toString();
				var arr = str.split("<SINGLE>");
				for (var i=0; i<arr.length; i++) {
					if (arr[i].indexOf('name="instance"') < 0) {
						arr.splice(i, 1);
						i--;
					}
				}
				for (i=0; i<arr.length; i++) {
					var strKEY = arr[i];
					var arrKEY = strKEY.split("<KEY ");
					for (var j=0; j<arrKEY.length; j++) {
						if (arrKEY[j].indexOf('name="instance"') < 0 &&
							arrKEY[j].indexOf('name="state"') < 0) {
							arrKEY.splice(j, 1);
							j--;
						}
					}
					var completedChpt = "0";
					for (j=0; j<arrKEY.length; j++) {
						if (arrKEY[j].indexOf('name="instance"') > -1) {
							var sChpt = arrKEY[j]; // $log.info("sChpt:",arrKEY[j])
							var begChpt = sChpt.indexOf('<VALUE>');
							var endChpt = sChpt.indexOf('</VALUE>');
							curChapter = sChpt.substring(begChpt+7, endChpt);

							switch (curChapter) {	
								case "41": curChapter = "1"; break;
								case "42": curChapter = "2"; break;
								case "43": curChapter = "3"; break;
								case "44": curChapter = "4"; break;
								case "45": curChapter = "5"; break;
								case "46": curChapter = "6"; break;
								case "47": curChapter = "7"; break;
								case "48": curChapter = "8"; break;
								case "22": /*do nothing */ break;
							}
						} else if (arrKEY[j].indexOf('name="state"') > -1) {
							var sStat = arrKEY[j];
							var begStat = sStat.indexOf('<VALUE>');
							var endStat = sStat.indexOf('</VALUE>');							
							var status = sStat.substring(begStat+7, endStat); 
// $log.info("CurChapter:",curChapter,"Status:",status);
							if (status == "1") {
								if (Number(curChapter) > Number(completedChpt)) {
									completedChpt = curChapter;
									curStatus = completedChpt + " of 8 chapters completed";
								} //possibly need ...	
							}
						}
					} // $log.info('currentStatus =', curStatus);	
				}
				return curStatus;
			});
		}
		
		/* To test just the GetUser call... change method to "Moddle_GetUser_TEST": */
		function getUser(mProID, fName, lName, email) {
			var params = {
				method: "Moodle_GetUser",
				sProID: mProID,
				sFirstName:fName,
				sLastName: lName,
				sEmail: email
			};
			return $http.post(moodleCFC, params) 
			.then(function(result) { //$log.info("svc:Moodle_GetUser:",result);
				return result.data;
			});
		}
		
		function updateUser(retCode, mProID) {
			var params = {
				method: "Moodle_UpdateUser",
				userid: factory.moodle.id,
				returnCode: retCode,
				sProID: mProID
			};
			return $http.post(moodleCFC, params)
			.then(function(results) { //$log.info("Moodle_UpdateUser results:",results.data, new Date())
				return results.data;				
			});
		}
		
	}
})();
(function(){
    'use strict';

    angular
		.module('proRefs')
		.factory('modalService', modalService);

	modalService.$inject = ['$uibModal','$log'];

	function modalService($uibModal, $log) {
$log.info("modalService");
		
		var factory = {
            okAlert: openOKAlert,
            resultAlert: openResultAlert
		};
		return factory;
		
		//customize more if need larger...
		function openOKAlert(title, alertMsg) {
			$uibModal.open({
				animation: true,
				size: 'sm',
				templateUrl: 'app/modals/modAlert.html',
				controller: 'ModalController',
				bindToController: true,
				controllerAs: 'vmMod',
				keyboard: true,
				backdrop: 'static',
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
				resolve: {
					modType: function() {
						return "OK";
					},
					title: function() {
						return title;
					},
					alertMsg: function() {
						return alertMsg;
					}	
				}
			});
		}
		
		function openResultAlert(sz,result) { //sz:"sm","lg";
			$uibModal.open({
				animation: true,
				size: sz,
				templateUrl: 'app/modals/modAlert.html',
				controller: 'ModalController',
				bindToController: true,
				controllerAs: 'vmMod',
				keyboard: true,
				backdrop: true,
				backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
				resolve: {
					title: function() {						
						return result[0].RESULT;
					},
					alertMsg: function() {
						return result[0].RESULTREASON;
					}
				}
			});
		}
	
	}		
})();	
(function(){
/**
 * Created by jacob on 6/17/14.
 * SecUserLoginFunctions consolidates SecUserLogin, SecGetReturnCode and UserGetChurchFunctions (which
 * 		doesn’t apply to all apps, so probably should add a parameter to skip it when not needed)
 */
    'use strict';

    angular
		.module('proRefs')
		.factory('loginService', loginService);

	loginService.$inject = ['$http','webSessionStorage','$rootScope','modalService',
		'authServiceCFC','mcWebCFC','custData','$state','setCustService','$log'];

	function loginService($http, webSessionStorage, $rootScope, modalService,
		authServiceCFC, mcWebCFC, custData, $state, setCustService, $log) {
$log.info("Login Service")		
		var sDataSource = "";
		
		var factory = {
            user: {
				USERID: 0,
				loggedIn: false,
				RETURNCODE: "",
				UserChurchFNs: []
			},
			login: login,
			logout: logout,
			secDeleteReturnCode: secDeleteReturnCode,
			secGetReturnCode: secGetReturnCode,
			secReturnLogin: secReturnLogin
// 			secReturnReset: secReturnReset
		};
		return factory;
		
	/* Runs SecUserLogin, SecGetReturnCode, UserGetChurchFunctions (sFn) */	
		function login(username, password) {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
			var params = {
				method : "SecUserLoginFunctions",
				sDataSource: sDataSource,
				sUserName: username,
				sPassword: password,
				sApp: "WebProtect.194",
				iMinutes: 30,
				sFn: "ProRef"
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) { //$log.info("login results:",results)
				if(results.data[0].SECUSERLOGIN[0].RESULT == "Success") {
					setUserInfo(results);
				}
				return results.data;
			});
		}

		function logout() {
			var params = {
				method: "SecDeleteReturnCode",
				sDataSource: sDataSource,
				sReturnCode: factory.user.RETURNCODE
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) {
				if (results.data[0].RESULTS == 'Delete Successful') {
					factory.user.RETURNCODE = "";
				}
				factory.user.loggedIn = false;
				factory.user.USERID = 0;
				factory.user.UserChurchFNs = [];
				$rootScope.myApps = [];
			});
		}
		
		function secDeleteReturnCode(retCode) {
			var params = {
				method: "SecDeleteReturnCode",
				sReturnCode: retCode
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return results.data;
			});
		}

	/* Used from NavBarCtrl to Get returnCode just to transfer to
		different app... then SecUserLoginFunctions is run again from new
		app to set a new ReturnCode to 30 minutes.
		iMin=1, sFn=[app to load]  */	
		function secGetReturnCode(iMin,sFn) {
			var params = {
				method: "SecGetReturnCode",
				sDataSource: sDataSource,
				iUserID: factory.user.USERID,
				sApp: "WebProtect",
				iMinutes: iMin,
				sFn: sFn,
				sParams: ""
			};
			return $http.post(authServiceCFC, params)
			.then(function(results) {
				if (results.data.length > 0) {
					factory.user.RETURNCODE = results.data[0].RETURNCODE;
				}
				return results.data
			});
		}

	/* UNABLE TO USE secReturnLogin from AuthService.cfc
		App opened by passing permission from other app...
		Store DatabaseID & FN=$rootScope.goToApp to open.
		Then call regular login with ReturnCode's USERNAME/PASSWORD.
		Fields returned with SecReturnLogin(ReturnCode):
		(USERNAME, DATABASEID(sDataSource), APP, FN, USERID, PASSWORD, PARAMS) */	
        function secReturnLogin(sReturnCode) {
            var params = {
                method: "SecReturnLogin",
                sReturnCode: sReturnCode
            };
            return $http.post(mcWebCFC, params)
            .then(function (results) {
				try {
					if (results.data[0].DATABASEID != "") {
						sDataSource = results.data[0].DATABASEID;
					}
					if (!$rootScope.TESTING) {
						secDeleteReturnCode(sReturnCode);
					}
				}
				catch (err) {
				//"TypeError: Cannot read property 'USERID' of undefined"	
					modalService.okAlert("Error", err);
				}	
				return results.data;
			});
		}
  
	/* CALLED When Apps used to extend ReturnCode another 30 minutes (default)
	    before expiration. If expires, user has to Login again for NEW returnCode. */
/* Deprecated 05/28/19 - when added timeOutService to app: 
        function secReturnReset(resetCode, iUserID, iMin) {
			var params = {
				method: "SecReturnReset",
				iUserID: iUserID,
				sReturnCode: resetCode,
				iNewMinutes: iMin
			};
            return $http.post(mcWebCFC, params)
            .then(function (results) {
                if (results.RESULT == "Expired") {
					factory.user.loggedIn = false;
					modalService.okAlert("Expired",
						"Your session has expired.<br><br>" +
						"Please log in again to continue.");
					$state.go('login', {reload:true});	 
                }
                return results.data;
            });
		}
*/


/* Internal Utilities: */        

        function setUserInfo (results) { //$log.info(results)
			//Return from Login when No Conf, but one matching Username/password:
			if (results.data[0].SDATASOURCE != sDataSource) {
				setCustService.fromDataSource(results.data[0].SDATASOURCE);			
			}
			
			factory.user = results.data[0].SECUSERLOGIN[0];
			factory.user.RETURNCODE = results.data[0].SECGETRETURNCODE[0].RETURNCODE;
			//used if refresh browser:
			webSessionStorage.setStoredData('sReturnCode', factory.user.RETURNCODE);
			
			factory.user.loggedIn = true;			
			if (results.data[0].USERGETCHURCHFUNCTIONS.length > 0) {
				factory.user.UserChurchFNs = (results.data[0].USERGETCHURCHFUNCTIONS);
				factory.user.CHURCHID = results.data[0].USERGETCHURCHFUNCTIONS[0].CHURCHID;
				factory.user.CHURCHNAME = results.data[0].USERGETCHURCHFUNCTIONS[0].CHURCHNAME;
			} else {
				factory.user.UserChurchFNs = [];
			}
			$rootScope.$broadcast('updateNav');		
		}
		
	}
})();
(function () {
	'use strict';
 
	angular
		.module('proRefs')
		.factory('helpDeskService', helpDeskService);

	helpDeskService.$inject = ['$http','$sce','mcWebCFC','webSessionStorage','$rootScope',
		'version','loginService','$state','modalService'];

	function helpDeskService($http, $sce, mcWebCFC, webSessionStorage, $rootScope,
		version, loginService, $state, modalService) {
		var sDataSource = webSessionStorage.getStoredData('sDataSource');
		
		var service = {
			helpHdInitiateIssue: helpHdInitiateIssue,
			helpHdSaveIssue: helpHdSaveIssue
		};
		return service;
		
		function helpHdInitiateIssue() {
			var params = {
				method: "HelpHdInitiateIssue",
				sReturnType: "json"
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				return (results.data);
			});
		}
		
		function helpHdSaveIssue(id, name, email, sProb) {
			if (loginService.user.USERID > 0) {
				var UserID = loginService.user.USERID;
			} else { UserID = -1 }
			var params = {
				method: "HelpHdSaveIssue",
				iIssueID: id,
				sDataSource: sDataSource,
				sApp: "MCWebApps",
				sForm: $rootScope.sCurForm,
				sVersion: version,
				iUserID: UserID,
				sUserFullName: name,
				sUserEmail: email,
				sDatabaseID: webSessionStorage.getStoredData('sDatabaseID'),
				sProblem: sProb
			};
			return $http.post(mcWebCFC, params)
			.then(function(results) {
				if (results.data == "true") {
					$state.go($rootScope.sCurForm);
					modalService.okAlert("Success",
						"Your Help Desk issue has been sent successfully.");
				}
			});
		}
				
	}
	
})();
		

(function () {
	'use strict';
 
	angular
		.module('proRefs')
		.factory('headerService', headerService);
		
	headerService.$inject = ['$rootScope'];
	
	function headerService($rootScope) {
		var headerIcon = { 
			image: "assets/images/MCicon32.png",
			alt: "MissionConnect"};
		
		var service = {
			customer: {name: "MissionConnect"},
			setCustomer: setCustomer,
			getHeaderIcon: getHeaderIcon
		};
		
		return service;
		
		function setCustomer(custName) {
			service.customer.name = custName;
			if (service.customer.name == "MissionConnect") {
				headerIcon = {
					image: "assets/images/MCicon32.png",
					alt: "MissionConnect"
				};
			} else {
				headerIcon = {
					image: "assets/images/crossflameRW_48px.png",
					alt: "UMC Cross and Flame"
				};
			}
			$rootScope.$broadcast('updateCustomer');
		}
		
		function getHeaderIcon() {
			switch (service.customer.name) {
				case "MissionConnect":
					headerIcon = {
						image: "assets/images/MCicon32.png",
						alt: "MissionConnect"
					};
				break;
				default:
					headerIcon = {
						image: "assets/images/crossflameRW_48px.png",
						alt: "UMC Cross and Flame"
					};
				break;	
			}
			return headerIcon;
		}
		
	}

})();	 
(function () {
    'use strict';

	angular
		.module('proRefs')
		.factory('formatterService', formatterService);

	formatterService.$inject = ['modalService'];

	function formatterService(modalService) {

		var service = {
			addThousandsCommas: addThousandsCommas,
			digitsOnly: digitsOnly,
			formatPhone: formatPhone,
			formatSSN: formatSSN,
			formatZip: formatZip
		};

		return service;

		function addThousandsCommas(numStr) {
			var pattern = /(\d+)(\d{3})/;
			numStr = numStr.toString();
			while (pattern.test(numStr)) {
				numStr = numStr.replace(pattern, '$1' + ',' + '$2');
			}
			return numStr;
		}
		
		//Remove all but Digits 0-9
		function digitsOnly(numStr) {
			var pattern = /\D/g;
			var str = numStr;
			var newString = str.replace(pattern,'');
			return newString;
		}
		
		function formatPhone(phStr) {
			var pattern = /\D/g;
			var numOnly = phStr.toString().trim().replace(pattern,'');
			var tel = "";
			switch (numOnly.length) {
				case 1: case 2:
					tel = "(" + numOnly;
				break;	
				case 3:
					tel = "(" + numOnly + ") ";
				break;
				case 4: case 5:
					tel = "(" + numOnly.substr(0,3) + ") " + 
						numOnly.slice(3);
				break;
				case 6:
					tel = "(" + numOnly.substr(0,3) + ") " + 
						numOnly.slice(3) + "-";
				break;
				case 7: case 8: case 9: case 10:
					tel = "(" + numOnly.substr(0,3) + ") " + 
						numOnly.substr(3,3) + "-" + numOnly.slice(6);
				break;
				default:
					tel = numOnly;
				break;	
			}
			return tel;
		}
		
		function formatSSN(SSN) { //$log.info("formatSSN",SSN)
			var sSSN = SSN.toString();
			var formattedSSN = "";
			formattedSSN = sSSN.substr(0,3) + "-" + sSSN.substr(3,2) + "-" +
				sSSN.substr(5,4);
			return formattedSSN;	//123456789 ==> 123-45-6789
		}
		
		function formatZip(zip) {
			var pattern = /\D/g;
			var frmZIP = "";
			var numStr = String(zip);
			var numOnly = numStr.trim().replace(pattern,'');
			switch (numStr.length) {
				case 1: case 2: case 3: case 4: case 5:
					frmZIP = String(numOnly);
				break;
				case 6: 
					if (String(numOnly).length == 5) {
						frmZIP = String(numOnly) + "-";
					} else {
						frmZIP = String(numOnly).substr(0,5) + "-" + String(numOnly).slice(5); 
					}
				break;
				case 7: case 8: case 9: case 10:
					frmZIP = String(numOnly).substr(0,5) + "-" + String(numOnly).slice(5);
				break;
				default:
					frmZIP = String(numOnly).substr(0,5) + "-" + String(numOnly).slice(5);
					if (frmZIP.length > 10) {
						modalService.okAlert("Invalid Entry",
							"A Zipcode consists of 5 digits or 9 digits. Please " +
							"enter a valid Zipcode before continuing.");
					}
				break;
			}
			return frmZIP;
		}

	}
})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('errorEmailNotification', errorEmailNotification);

	errorEmailNotification.$inject = ['webSessionStorage','$rootScope','loginService'];

    function errorEmailNotification(webSessionStorage, $rootScope, loginService) {
		var sDataSource = webSessionStorage.getStoredData("sDataSource");
		var sEmailContent = "";
		
		var factory = {
			error1: error1,
			error2: error2,
			error3: error3,
			error4: error4,
			error5: error5,
			errorMoodle: errorMoodle
		};
		return factory;
		
		
		function error1(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ReturnCode: " + $rootScope.retCodeKey + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error2(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"Applicant: " + $rootScope.Applicant + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error3(sFormProc, iSaveKey) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"Applicant: " + $rootScope.Applicant + "<br>" +
				"StepSaveKey: " + String(iSaveKey) + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error4(sFormProc) {
			sEmailContent = "Error in " + sFormProc + "()<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent;
		}
		
		function error5(sForm, emailContent) {
			sEmailContent = "Error in " + sForm + "<br>" +
				emailContent + "<br><br>" +
				"DataSource: " + sDataSource + "<br>" +
				"ProID: " + $rootScope.sProID + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID;
			return sEmailContent; 
		}
		
		function errorMoodle(mReturn,proc) {
			sEmailContent = "Error in WebApps_Pro/" + proc + "()<br><br>" +
				"User not found, and not created. Run test in WebProtect for:<br> " +
				"ProID: " + $rootScope.sProID + "<br>" +
				"User: " + loginService.user.USERFULLNAME + "<br>" +
				"UserID: " + loginService.user.USERID + "<br><br>" +
				"Returned from Moodle: " + mReturn;
			return sEmailContent;	
		}
	}

})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('emailValidator', emailValidator);

    function emailValidator() {
		var factory = {
			isValid: isValid
		};
		
		return factory;
		
		function isValid(sEmail) {
			var filter = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);

			if (sEmail.search(filter) == -1) {
				return false;
			} else {
				return true;
			}
		}		
	}

})();    
(function () {
	'use strict';

	angular
		.module('proRefs')
		.factory('declineEmail', declineEmail);

	function declineEmail() {
		var factory = {
			getEmailContent: getEmailContent
		};
		return factory;
		
		
		function getEmailContent(sApplicant, sRefName, sDatabaseID) {
			
			var sWebProtect = "https://umcdata.net/MissionConnect/Public/Protect/Web_Protect.html?conf=" + sDatabaseID;
			
			var sEmailContent = sEmailContent = sApplicant + ",<br><br>" +
					"Your Reference Request has been declined by " + sRefName + ".<br><br>" +
					"Please return to your MissionConnect:Protect online process to resend this " +
					"Reference Request to another individual. For your convenience, the link to the " +
					"MissionConnect: Protect website is provided below.<br><br>" +
					"<font color='#0000FF'><a href=" + sWebProtect + "><u>" + sWebProtect + 
					"</u></a></font>";

			return sEmailContent;
		}
	}

})();
(function () {
	'use strict';

	angular
		.module('proRefs')
		.factory('datesService', datesService);

	datesService.$inject = ['$log'];

	function datesService($log) {
$log.info("Dates Service")		
		var service = {
			calStrToDbDateStr: calStrToDbDateStr,
			currentYear: currentYear,
			get19thBirthDate: get19thBirthDate,
			jsDateStrToCalendarStr: jsDateStrToCalendarStr,
			jsDateStrToDbDateStr: jsDateStrToDbDateStr,
			s1yrFromToday: s1yrFromToday,
			s6mosFromToday: s6mosFromToday,
			s15mosFromToday: s15mosFromToday,
			todayToCalString: todayToCalString,
			todayToDbString: todayToDbString
		};
		return service;
		
		function calStrToDbDateStr(sCal) {
			var dCal = new Date(sCal);
			var mm = dCal.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dCal.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sDbDate = String(dCal.getFullYear()) + "-" + mm + "-" + dd;
			return sDbDate;			// "01/01/2017" ==> "2017-01-01"
		}
		
		function currentYear() {
			var today = new Date();
			var yr = today.getFullYear();
			return yr; //2017	
		}
		
		function get19thBirthDate(bDay) { $log.info("passed in:", bDay)
			var s19thBDay = "";
			var dt = new Date(bDay); $log.info("dt",dt)
			var mm = dt.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dt.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			s19thBDay = mm + "/" +  dd + "/" + String(dt.getFullYear()+19);
			return s19thBDay;  	// 19th BirthDate as MM/DD/YYYY
		}

		function jsDateStrToCalendarStr(dtStr) {
			var sCalDate = "";
			var dt = new Date(dtStr);
			var mm = dt.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dt.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			sCalDate = mm + "/" + dd + "/" + String(dt.getFullYear()) ;
			return sCalDate; // "August 03, 2017 17:50:20" ==> "08/03/2017"
		}

		function jsDateStrToDbDateStr(dtStr) {
			var sDbDate = "";
			var dt = new Date(dtStr);
			var mm = dt.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = dt.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			sDbDate = dt.getFullYear() + "-" + mm +	"-" + dd;
			return sDbDate; // // "August 03, 2017 17:50:20" ==> "2017-08-03"
		}
		
		function s1yrFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sCalDate = mm + "/" + dd + "/" + String(today.getFullYear()+1);
			return sCalDate; // today in 2017 as "MM/DD/2018"
		}
		
		function s6mosFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var yr = today.getFullYear();
			var sCalDate = "";
			if (mm < 7) { sCalDate = String(mm+6) + "/" + dd + "/" + yr; }
			else { sCalDate = String((mm+6)-12) + "/" + dd + "/" + String(yr+1); }
			return sCalDate; // today= 7/1/2017 ==> "01/01/2018"
		}
		
		function s15mosFromToday() {
			var today = new Date();
			var mm = today.getMonth()+1;
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var yr = Number(today.getFullYear())+1;
			var sCalDate = "";
			if (mm < 10) { sCalDate = String(mm+3) + "/" + dd + "/" + yr; }
			else { sCalDate = String((mm+3)-12) + "/" + dd + "/" + String(yr+1); }
			return sCalDate; // today= 10/1/2017 ==> "01/01/2019"
		}
		
		function todayToCalString() {
			var today = new Date();
			var mm = today.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sCalToday = mm + "/" + dd + "/" + String(today.getFullYear()) ;
			return sCalToday;	// today as "MM/DD/YYYY"
		}
		
		function todayToDbString() {
			var today = new Date();
			var mm = today.getMonth()+1;
			if (mm < 10) { mm = "0" + String(mm); }
			var dd = today.getDate();
			if (dd < 10) { dd = "0" + String(dd); }
			var sDbToday = String(today.getFullYear()) + "-" + mm + "-" + dd;
			return sDbToday;	// today as "YYYY-MM-DD"
		}

	}
})();
/** UPDATES:
  *		05/28/19 lds - removed ReturnCodeReset function and all calls to it, as timeOutService now 
  *			handling internally.
  **/

(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('dataService', dataService);

	dataService.$inject = ['$http','$sce','webSessionStorage','moodleCFC','proJsCFC',
		'loginService','$rootScope','proEmailCFC','mcWebCFC','modalService','$log'];	

    function dataService($http, $sce, webSessionStorage, moodleCFC, proJsCFC,
		loginService, $rootScope, proEmailCFC, mcWebCFC, modalService, $log) {
		var sDataSource = "";

		var service = {
			setDataSource: setDataSource,
			addrGetAll: addrGetAll,
			chLoadAll: chLoadAll,
			emGetAll: emGetAll,
			emGetFirstSeq: emGetFirstSeq,
			emailSendCustom: emailSendCustom,
			emailSendError: emailSendError,
			emailSend_MCRefLink: emailSend_MCRefLink,
			emailSend_MORefLink: emailSend_MORefLink,
			emailSend_NWTXRefLink: emailSend_NWTXRefLink,
			emailSend_NWTXTraining: emailSend_NWTXTraining,
			emailSend_PastorRef: emailSend_PastorRef,
			fxGet: fxGet,
			getChurchName: getChurchName,
			getUserInfoFromEntityID: getUserInfoFromEntityID,
			libGetASetting: libGetASetting,
			libGetMaintenanceMsg: libGetMaintenanceMsg,
			libLoadStates: libLoadStates,
			peoGetDetails: peoGetDetails,
			peoSave: peoSave,
			phLoadTypes: phLoadTypes,
			proGetCertRecords: proGetCertRecords,
			proGetChOrgSettings: proGetChOrgSettings,
			proGetDSs: proGetDSs,
			proGetFeesVouchers: proGetFeesVouchers,
			proGetForm: proGetForm,
			proGetFormData: proGetFormData,
			proGetMain: proGetMain,
			proGetPastorChCerts: proGetPastorChCerts,
			proGetProcessRecordPub: proGetProcessRecordPub,
			proGetProcessSteps: proGetProcessSteps,
			proLoadDefOptions: proLoadDefOptions,
			proLoadPastors: proLoadPastors,
			proLoadPRRefs: proLoadPRRefs,
			proPayProcessUpdate: proPayProcessUpdate,
			proSaveFeesVouchers: proSaveFeesVouchers,
			proSaveFormData: proSaveFormData,
			proSaveMain: proSaveMain,
			proSaveProcess: proSaveProcess,
			proSaveResultsFA: proSaveResultsFA,
			proSaveResultsPMM: proSaveResultsPMM,
			proSaveRefTracker: proSaveRefTracker,
			proSaveScreenSend: proSaveScreenSend,
			proSendPMM: proSendPMM,
			proSendPMMAccio: proSendPMMAccio,
			proSubmitFirstAdvantage: proSubmitFirstAdvantage,
			rcvGetValidate: rcvGetValidate,
			rcvGetVoucher: rcvGetVoucher,
			secDeleteReturnCodeFromKey: secDeleteReturnCodeFromKey,
			secGetReturnCode: secGetReturnCode,
			secGetReturnCodeFromKey: secGetReturnCodeFromKey,
			secReturnLogin: secReturnLogin,
			sendForgottenPassword: sendForgottenPassword,
			suGetEvent: suGetEvent,
			suLoadEventsLite: suLoadEventsLite,
			userGetChurchFunctions: userGetChurchFunctions,
			usersChangePassword: usersChangePassword,
			usersGetId: usersGetId,
			usersGetOne: usersGetOne,
			usersGetOneFromEntityID: usersGetOneFromEntityID,
			usersSave: usersSave
		};
		return service;

		function setDataSource() {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
		}
		
		function addrGetAll(iEntityID) { //applCtrl
            var params = {
                method: "AddrGetAll",
                sDataSource: sDataSource,
				iEntityID: iEntityID
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function chLoadAll() { //applCtrl
            var params = {
                method: "ChLoadAll",
                sDataSource: sDataSource,
                sChurchName: "%",
                iDistNum: -1,
                sIncludeOnlyActive: "True",
                sSortBy: "ChurchName",
                sTopItem: "<No Selection>"
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function emGetAll(iEntityID) { //applCtrl
			var params = {
				method: "EmGetAll",
				sDataSource: sDataSource,
				iEntityID: iEntityID
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function emGetFirstSeq(iEntityID) {//ReqRef_MOPastor
			var params = {
				method: "EmGetFirstSeq",
				sDataSource: sDataSource,
				iEntityID: iEntityID
			};
			return $http.post(proJsCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function emailSendCustom(sEmailAddr, sFrom, sReplyTo, sSubject, sEmailContent) {
            var params = {
                method: "EmailSendCustom",
                sEmailAddr: sEmailAddr,
                sFrom: sFrom,
                sReplyTo: sReplyTo,
                sSubject: sSubject,
                sEmailContent: sEmailContent
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		/** TODO:
		  *	Change from lori to 'errors@greatpirit.com' when all functioning well. 
		  **/
		function emailSendError(sEmailContent) {
            var params = {
                method: "EmailSendCustom",
                sEmailAddr: "lori@greatspirit.com",
                sFrom: "GSS Error-Notification <errors@greatspirit.com",
				sReplyTo: "errors@greatspirit.com",
                sSubject: "WebProtect Error",
                sEmailContent: sEmailContent
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function emailSend_MCRefLink(sCI, sEmail, sFrom, sRefName, sRefLink, sReplyTo, formText) {
			var params = {
				method: "EmailSend_MCRefLink",
				sApplicant: loginService.user.USERFULLNAME,
				sContactInfo: sCI,
				sEmailAddr: sEmail,
				sFrom: sFrom,
				sRefName: sRefName,
				sRefRequestLink: sRefLink,
				sReplyTo: sReplyTo,
				sProInitFormText: formText
			};
			return $http.post(proEmailCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function emailSend_MORefLink(sCI, sEmail, sFrom, sRefName, sRefLink, sReplyTo, formText) {
			var params = {
				method: "EmailSend_MORefLink",
				sApplicant: loginService.user.USERFULLNAME,
				sContactInfo: sCI,
				sEmailAddr: sEmail,
				sFrom: sFrom,
				sRefName: sRefName,
				sRefRequestLink: sRefLink,
				sReplyTo: sReplyTo,
				sProInitFormText: formText
			};
			return $http.post(proEmailCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function emailSend_NWTXRefLink(sCI, sEmail, sFrom, sRefName, sRefLink, sReplyTo, formText) {
			var params = {
				method: "EmailSend_NWTXRefLink",
				sApplicant: loginService.user.USERFULLNAME,
				sContactInfo: sCI,
				sEmailAddr: sEmail,
				sFrom: sFrom,
				sRefName: sRefName,
				sRefRequestLink: sRefLink,
				sReplyTo: sReplyTo,
				sProInitFormText: formText
			};
			return $http.post(proEmailCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function emailSend_NWTXTraining(sEmail, sFrom, sReplyTo, sProgramType) {
			var params = {
				method: "EmailSend_NWTXTraining",
				sEmailAddr: sEmail,
				sFrom: sFrom,
				sReplyTo: sReplyTo,
				sUserFullName: loginService.user.USERFULLNAME,
				sProgramType: sProgramType,
				sProID: $rootScope.sProID
			};
			return $http.post(proEmailCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function emailSend_PastorRef(sCI, sEmail, sFrom, sReplyTo, sRefName, sURL, sUserName, 
			sRefLink, formText) {
			var params = {
				method: "EmailSend_PastorRef",
				sApplicant: loginService.user.USERFULLNAME,
				sContactInfo: sCI,
				sEmailAddr: sEmail,
				sFrom: sFrom,
				sReplyTo: sReplyTo,
				sRefName: sRefName,
				sSiteURLWithConf: sURL,
				sRefUserName: sUserName,
				sRefRequestLink: sRefLink,
				sProInitFormText: formText
			};
			return $http.post(proEmailCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function fxGet(sApp, sForm, sTextID) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "FxGet",
				sDataSource: sDataSource,
				sApp: sApp,
				sForm: sForm,
				sTextID: sTextID
			};
			return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function getChurchName(iEntityID) {
			var params = {
				method: "GetChurchName",
				sDataSource: sDataSource,
				iEntityID: iEntityID	
			};
			return $http.post(proJsCFC, params)
			.then(function(result) {
				return result.data;	
			});
		}

		function getUserInfoFromEntityID(iEntityID) {
            var params = {
                method: "GetUserInfoFromEntityID",
                sDataSource: sDataSource,
                iEntityID: iEntityID
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
// 				resetReturnCode();
                return results.data;
            });
		}
		
		function libGetASetting(sSetting) {
			if (sDataSource == "") { setDataSource(); }
			var params= {
				method: "LibGetASetting",
				sDataSource: sDataSource,
				sSetting: sSetting	
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				return result.data;
			});
		}
		
		function libGetMaintenanceMsg() {
			var params= {
				method: "LibGetMaintenanceMsg"
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				return result.data;
			});
		}
		
		function libLoadStates() { //appl.html
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "LibLoadStates",
				sDataSource: sDataSource,
				sTopItem: "<No Selection>"
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}

		function peoGetDetails(iEntityID) { //applCtrl, personRecord
			var params = {
				method: "PeoGetDetails",
				sDataSource: sDataSource,
				iEntityID: iEntityID,
				iUserID: loginService.user.USERID
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function peoSave(sSaveString) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "PeoSave",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(proJsCFC, params)
			.then(function (results) { $log.info('results:',results)
				return results.data;
			});
		}
		
		function phLoadTypes() { //appl.html, contactInfo
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "PhLoadTypes",
				sDataSource: sDataSource,
				sTopItem: "Type:"
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proGetCertRecords(iUserID, iEntityID) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "ProGetCertRecords",
				sDataSource: sDataSource,
				iUserID: iUserID,
				iEntityID: iEntityID,
				iCertTypeID: 0
			};
			return $http.post(proJsCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function proGetChOrgSettings(iChurchID) {
			var params = {
				method: "ProGetChOrgSettings",
				sDataSource: sDataSource,
				iEntityID: iChurchID
			};
			return $http.post(proJsCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		function proGetDSs() {
			var params = {
                method: "ProGetDSs",
                sDataSource: sDataSource
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function proGetFeesVouchers() {
			var params = {
				method: "ProGetFeesVouchers",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				sProID: $rootScope.sProID	
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proGetForm(sFormName) {
			var params = {
                method: "ProGetForm",
                sDataSource: sDataSource,
                sFormType: "WebProtect",
                sFormName: sFormName
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function proGetFormData(sFormName) {
			var params = {
                method: "ProGetFormData",
                sDataSource: sDataSource,
                sFormName: sFormName,
                sProID: $rootScope.sProID
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function proGetMain(sProID) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
                method: "ProGetMain",
                sDataSource: sDataSource,
                sProID: sProID
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function proGetPastorChCerts(iEntityID) {
			var params = {
				method: "ProGetPastorChCerts",
				sDataSource: sDataSource,
				iEntityID: iEntityID
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			})
		}
		
		function proGetProcessRecordPub(sProID) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "ProGetProcessRecordPub",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				sProID: sProID
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;   
			});
		}
		
		function proGetProcessSteps(iCertTypeID) {
			var params = {
				method: "ProGetProcessSteps",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				iCertTypeID: iCertTypeID	
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;	
			});
		}
		
		function proLoadDefOptions(form) {
			var params = {
				method: "ProLoadDefOptions",
				sDataSource: sDataSource,
				sFormName: form	
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			})
		}
		
		//ONLY in MO currently. Edit if for others! (Include ProAddStaff table, and exclusions)
		function proLoadPastors(iChurchID) { //refer, //refRequest
			var params = {
                method: "ProLoadPastors",
                sDataSource: sDataSource,
                iChurchID: iChurchID
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function proLoadPRRefs(iEntityID, bIncompleteOnly) {
			if (sDataSource == "") { setDataSource(); }
			var params = {
                method: "ProLoadPRRefs",
                sDataSource: sDataSource,
                iEntityID: iEntityID,
                bIncompleteOnly: bIncompleteOnly
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
// 				resetReturnCode();
				return results.data;
            });
		}
		
		function proPayProcessUpdate(iRcvID) {
			var params = {
				method: "ProPayProcessUpdate",
				sDataSource: sDataSource,
				iRcvID: iRcvID
			};
			return $http.post(mcWebCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proSaveFeesVouchers(sRawDataString) {
			var params = {
				method: "ProSaveFeesVouchers",
				sDataSource: sDataSource,
				sRawDataString: sRawDataString	
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		//resets ReturnCode expiration:	
		function proSaveFormData(sSaveString) {
			var params = {
				method: "ProSaveFormData",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
// 				resetReturnCode();
				return results.data;
			});
		}
		
		function proSaveMain(sSaveString) {
			var params = {
				method: "ProSaveMain",
				sDataSource: sDataSource,
				sRawDataString: sSaveString	
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			})
		}
		
		function proSaveProcess(sSaveString) {
			var params = {
				method: "ProSaveProcess",
				sDataSource: sDataSource,
				sRawDataString: sSaveString
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proSaveRefTracker(iUserID) {
			var params = {
				method: "ProSaveRefTrackerWithApp",
				sDataSource: sDataSource,
				iUserID: iUserID,
				sApp: "ProRefs_v.044"
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proSaveResultsFA(iStepID,FAReturn) {
			var params = {
				method: "ProSaveResultsLN",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				iStepID: iStepID,
				sResultsString: FAReturn
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proSaveResultsPMM(iStepID,PMMReturn) {
			var params = {
				method: "ProSaveResultsPMM",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				iStepID: iStepID,
				sResultsString: PMMReturn
			};
			return $http.post(proJsCFC, params)
			.then(function (results) {
				return results.data;
			});
		}
		
		function proSaveScreenSend(sSaveString) {
			var params = {
				method: "ProSaveScreenSend",
				sDataSource: sDataSource,
				sRawDataString: sSaveString	
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				return result.data;
			});
		}
		
		function proSendPMM(sOrderDetail) {
			var params = {
				method: "ProSendPMM",
				sOrderDetail: sOrderDetail	
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				return result;	
			});
		}
		
		function proSendPMMAccio(sOrderDetail) {
			var params = {
				method: "ProSendPMMAccio",
				sOrderDetail: sOrderDetail	
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				return result;	
			});
		}
		
		//Testing: change method to ProTestFirstAdvantage(testCFC)
		//LIVE: proSubmitFirstAdvantage(proJsCFC)
		function proSubmitFirstAdvantage(sOrderDetail) {
			var params = {
				method: "ProSubmitFirstAdvantage",
				sOrderDetail: sOrderDetail
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				return result;	
			});
		}
		
		function rcvGetValidate(invID) {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
			var params= {
				method: "RcvGetValidate",
				sDataSource: sDataSource,
				sInvoiceID: invID
			}; $log.info('params',params);
			return $http.post(mcWebCFC, params)
            .then(function(results) {
                if (results.data.length > 0) {
					return results.data;
				}	
			});
		}
		
		function rcvGetVoucher(vCode) {
			var params = {
				method: "RcvGetVoucher",
				sDataSource: sDataSource,
				sVoucherCode: vCode
			};
			return $http.post(proJsCFC, params)
			.then(function (result) {
				return result.data;
			});
		}
		
		function secDeleteReturnCodeFromKey(iReturnKey) {
			var params = {
                method: "SecDeleteReturnCodeFromKey",
                iReturnKey: iReturnKey
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		//sFn: PastorRef (sStepLinkFlag), PayFee, etc.
		function secGetReturnCode(iMin, sFn, sParams) {
			var params = {
                method: "SecGetReturnCode",
                sDataSource: sDataSource,
                iUserID: loginService.user.USERID,
                sApp: "WebProtect",
                iMinutes: iMin,
                sFn: sFn,
                sParams: sParams
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function secGetReturnCodeFromKey(returnCodeKey) {
			var params = {
                method: "SecGetReturnCode",
                sDataSource: sDataSource,
                iReturnKey: returnCodeKey
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function secReturnLogin(sReturnCode) {
			var params = {
                method: "SecReturnLogin",
                sReturnCode: sReturnCode
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {  //$log.info("secReturnLogin results:",results)
				return results.data;
            });
		}
		
		function sendForgottenPassword(sUserName) {
			if (sDataSource == "") { setDataSource(); }
			if (sDataSource.slice(-3) != 'Dev') {
				var params = {
					method: "SendForgottenPassword",
					sDataSource: sDataSource,
					sUserName: sUserName,
					sCustomEmailText: ""
				};
				return $http.post(proJsCFC, params)
				.then(function (results) {
					return results.data;
				});
			} else {
				modalService.okAlert("Forgot Password", 
					"This function is not available for a Dev database, " +
					"as the email is sent directly from the cfc after retrieving " +
					"the email address from the user account.");
			}
		}

		function suGetEvent(eventID) {
			var params = {
				method: "SUGetEvent",
				sDataSource: sDataSource,
				iEventID: eventID
			};
			return $http.post(proJsCFC, params)
			.then(function(result) {
				return result.data;
			});
		}
		
		function suLoadEventsLite(status) {
			var params = {
				method: "SULoadEventsLite",
				sDataSource: sDataSource,
				sIncludeStatus: status
			};
			return $http.post(proJsCFC, params)
			.then(function(results) {
				return results.data;
			});
		}
		
		//Preset to ONLY For pulling MENU applications:
		function userGetChurchFunctions() {
			if (sDataSource == "") { setDataSource(); }
			var params = {
				method: "UserGetChurchFunctions",
				sDataSource: sDataSource,
				iUserID: loginService.user.USERID,
				sFn: "all",
				bFnOnly: 1	
			};
			return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function usersChangePassword(sSaveString) {
			var params = {
				method: "UsersChangePassword",
				sDataSource: sDataSource,
                sRawDataString: sSaveString
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		//*** if ever need all UserIDs (even inactive), remove hardcode & add "True" for param)
		function usersGetId(iEntityID, sUserName) {
			var params = {
				method: "UsersGetId",
				sDataSource: sDataSource,
				iEntityID: iEntityID,
				sUserName: sUserName,
				sActiveOnly: "False"
			};
			return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function usersGetOne(iUserID) {
			var params = {
				method: "UsersGetOne",
				sDataSource: sDataSource,
                iUserID: iUserID
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
                return results.data;
            });
		}
		
		function usersGetOneFromEntityID(iEntityID) {
			var params = {
				method: "UsersGetOneFromEntityID",
				sDataSource: sDataSource,
                iEntityID: iEntityID
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
				if (results == "No User Account Found") {
					return results;
				} else {
					return results.data;
				}
			});
		}

		function usersSave(sSaveString) {
			var params = {
				method: "UsersSave",
				sDataSource: sDataSource,
                sRawDataString: sSaveString
            };
            return $http.post(proJsCFC, params)
            .then(function (results) {
// 				resetReturnCode();
                return results.data;
            });
		}
		
		
//Internally called functions:
		
/*	Deprecated 05/28/19 with release of timeOutService:
		function resetReturnCode() {
			loginService.secReturnReset(loginService.user.RETURNCODE, loginService.user.USERID, 30)
			.then(function(result) {
				$log.info("Reset ReturnCode:",result[0].RESULT);
				return result.RESULT;
			});
		}
*/
		
    }    
 })(); 
 
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('contactInfo', contactInfo);

	contactInfo.$inject = ['$http','webSessionStorage','dataService','loginService',
		'datesService','errorEmailNotification','proJsCFC','$log'];	

    function contactInfo($http, webSessionStorage, dataService, loginService, 
		datesService, errorEmailNotification, proJsCFC, $log) {
		var sDataSource = "";
		
		var factory = {
			saveHomeAddr: saveHomeAddr,
			updateAddrEntityUse: updateAddrEntityUse,
			saveNewPhones: saveNewPhones,
			splitOffPhoneType: splitOffPhoneType,
			saveNewEmails: saveNewEmails,
			savePersonalEmail: savePersonalEmail,
			updateEmailToPrimary: updateEmailToPrimary
		};
		
		return factory;	
	

//ADDRESS:
	/* RULES: Pull the address fields from the field data to save new Address.
		UPDATE: If current Home Address edited... update address -- no history of prev entry.
		INSERT (Addr): If NO Home Address, save entered data as Home Address.
		INSERT (AddrEntityUse): If NO current Primary, set Home Address as Primary. 
		primAddr=null if NO current Primary Address 
		selHmAddr=null if entered address... no selected address */	
		function saveHomeAddr(iEntityID, arrData, selHmAddr, primAddr) {
			if (sDataSource == "") { setDataSource(); }
			var sDbToday = datesService.todayToDbString();
			var sAddr = "";
			var sCity = "";
			var sState = "";
			var sZipCode = "";
			var homeTypeID = 0;
			var addrID = 0;
			for (var i=0; i<arrData.length; i++) {
				switch (arrData[i].itemName) {
					case "Address":
						sAddr = arrData[i].data;
					break;
					case "City":
						sCity = arrData[i].data;
					break;
					case "State":
						sState = arrData[i].data;
					break;
					case "Zip":
						sZipCode = arrData[i].data;
					break;
				}
			}
			
			var sRawDataString = "WebApps_Pro || saveAddr || " + loginService.user.USERID + " || ";
			if (selHmAddr == null) { sRawDataString += "I"; }
			else { sRawDataString += "U || AddrID==" + selHmAddr.ADDRID; }	
			sRawDataString += " || Addr1==" + sAddr + " || City==" + sCity + 
				" || State==" + sState + " || Zip==" + sZipCode + 
				" || Country==USA || CarrierRoute== || USAddr==1 || International3==" +
				" || PurgeStoppedAddr==1 || CertifyAddr==0 ^^ ";
				
			var params = {
				method: "AddrSave64",
				sDataSource: sDataSource,
				sRawDataString: sRawDataString
			};
			return $http.post(proJsCFC, params)
			.then(function (addrResults) { 
				if (addrResults.data.length > 0) {
					if (addrResults.data[0].RESULTREASON == "Update successful.") {
						return addrResults.data; }
					else {
						var sResultReason = addrResults.data[0].RESULTREASON;
						if (sResultReason.indexOf("AddrID=")> 0) {
							var idx = sResultReason.indexOf("AddrID=");
							sRawDataString = "";
							addrID = sResultReason.slice(idx+7);
							
							//Get AddrTypes:
							var params1 = {
								method: "AddrLoadTypes",
								sDataSource: sDataSource
							};
							return $http.post(proJsCFC, params1)
							.then(function (addrTypes) {
								var arrTypes = addrTypes.data;
								for (var i=0; i<arrTypes.length; i++) {
									if (arrTypes[i].ADDRTYPE == "Home") {
										homeTypeID = arrTypes[i].ADDRTYPEID;
									break; }
								}
					
								// NEW, Add AddrEntityUse record:
								if (addrID > 0) { 
									sRawDataString = "WebApps_Pro || saveAddrUse || " +
										String(loginService.user.USERID) + " || I || EntityID==" +
										iEntityID + " || AddrID==" + addrID + " || AddrTypeID==" +
										homeTypeID + " || PrimaryAddr==";
									if (primAddr == null ||
										(primAddr != null && primAddr.ADDRTYPEID == homeTypeID)) { 
										sRawDataString += "1";
									} else { sRawDataString += "0"; }
									sRawDataString += " || StartDate==" + sDbToday + 
										" || Mailing==1 || Shipping==0 || Physical==0 ^^ ";
								} 
								/* Primary Address is the HOME Address, but User selected a different
									Home Address than what is set as Primary, so update BOTH: */
								else if (primAddr != null && primAddr.ADDRTYPEID == homeTypeID &&
									primAddr.ADDRID != selHmAddr.ADDRID) {
									sRawDataString = "WebApps_Pro || saveAddrUse || " +
										String(loginService.user.USERID) + " || U || SaveKey==" +
										selHmAddr.SAVEKEY + " || EntityID==" + iEntityID + 
										" || AddrID==" + selHmAddr.ADDRID + " || PrimaryAddr==1 ^^ " +
										"U || SaveKey==" + primAddr.SAVEKEY + " || EntityID==" +
										iEntityID + " || AddrID==" + primAddr.ADDRID + 
										" || PrimaryAddr==0 ^^ ";
								} 
								
								var params2 = {
									method: "AddrSaveEntityUse",
									sDataSource: sDataSource,
									sRawDataString: sRawDataString
								};
								return $http.post(proJsCFC, params2)
								.then(function (entUse) {
									return entUse.data;
								});
							});	
						}	
					}

				}
			});
		}
		
		function updateAddrEntityUse(iEntityID, selHmAddr, primAddr) {
		/* Primary Address set to HOME, but User selected a different
			existing Address as HOME, so update BOTH: */
			if (sDataSource == "") { setDataSource(); }
			var sRawDataString = "WebApps_Pro || saveAddrUse || " +
				String(loginService.user.USERID) + " || U || SaveKey==" + 
				selHmAddr.SAVEKEY + " || EntityID==" + iEntityID + 
				" || AddrID==" + selHmAddr.ADDRID + " || PrimaryAddr==1 ^^ " +
				"U || SaveKey==" + primAddr.SAVEKEY + " || EntityID==" +
				iEntityID + " || AddrID==" + primAddr.ADDRID + " || PrimaryAddr==0 ^^ ";
			
			var params = {
				method: "AddrSaveEntityUse",
				sDataSource: sDataSource,
				sRawDataString: sRawDataString
			};
			return $http.post(proJsCFC, params)
			.then(function (saveResults) {
				return saveResults.data;
			});
		}
		
		
//PHONES:
	/* Loads all current Phones. Validates if a Primary Exists.
		Compares newly entered Phones against existing, and updates
		if new phone entered for same PHONETYPE, else adds the new
		phone. If PHONETYPE==Primary, Updates existing and new, if
		NEW Primary added. */
		function saveNewPhones(iEntityID, arrData) {
$log.info("ContactInfo saveNewPhones()")			
			if (sDataSource == "") { setDataSource(); }
			var sRawDataString = "";
			var sDbToday = datesService.todayToDbString();
			var iCurPrimaryIdx = -1;
			
			//Get All Current Phones:
			var params = {
				method: "PhGetAll",
				sDataSource: sDataSource,
				iEntityID: iEntityID 
			};
			return $http.post(proJsCFC, params)
			.then(function (phones) {
				var arrPhones = phones.data;
				var dToday = new Date();

				//Filter for Only current phones:
				for (var i=0; i<arrPhones.length; i++) {
					var dStart = new Date(arrPhones[i].STARTDATE);
					var dStop = "";
					if (arrPhones[i].STOPDATE != "") {
						dStop = new Date(arrPhones[i].STOPDATE);
					}	
					if (dStart > dToday || 
						(dStop != "" && dStop < dToday)) {
						arrPhones.splice(i, 1);
						i--;
					}		
				}
				
				//Get Phone Types:
				var params2 = {
					method: "PhLoadTypes",
					sDataSource: sDataSource
				};
				return $http.post(proJsCFC, params2)
				.then(function (phTypes) {
					if (phTypes.data.length > 0) {
						var arrTypes = phTypes.data;
						
						//Insert the PHONETYPEID into the arrData:
						for (i=0; i<arrData.length; i++) {
							if (arrData[i].itemName == "CellPhone") {
								for (j=0; j<arrTypes.length; j++) {
									if (arrTypes[j].PHONETYPE == "Cell") {
										arrData[i].typeID = arrTypes[j].PHONETYPEID;
									break; }
								}	
							} else if (arrData[i].itemName == "HomePhone") {
								for (j=0; j<arrTypes.length; j++) {
									if (arrTypes[j].PHONETYPE == "Home") {
										arrData[i].typeID = arrTypes[j].PHONETYPEID;
									break; }
								}
							}	
						}
					}
					
					//Validate if a Primary Phone exists:
					if (arrPhones.length > 0) {
						for (var j=0; j<arrPhones.length; j++) {
							if (arrPhones[j].PRIMARYPHONE == true) {
								iCurPrimaryIdx = j;
							break; }
						}
					}
					
					//Create Save Strings:
					for (i=0; i<arrData.length; i++) { 
						switch (arrData[i].itemName) {
							case "PrimaryPhone":
								if (arrData[i].data != "" && arrData[i].typeID != "") {
									if (arrPhones.length > 0) {
										for (j=0; j<arrPhones.length; j++) {
											if (arrPhones[j].PHONENUMBER == arrData[i].numOnly) {
												//Already exists, but not listed as Primary, so update:
												if (arrPhones[j].PRIMARYPHONE == false) {
													sRawDataString += "U || EntityID==" + iEntityID + 
														" || Seq==" + arrPhones[j].SEQ + " || PhoneTypeID==" +
															arrData[i].typeID + " || PrimaryPhone==1 ^^ ";
												}
												if (iCurPrimaryIdx > -1) {
													sRawDataString += "U || EntityID==" + iEntityID + 
														" || Seq==" + arrPhones[iCurPrimaryIdx].SEQ + 
														" || PrimaryPhone==0 ^^ ";
												}
											break; }
											else if (j == arrPhones.length-1) {
												/* This was listed as "Primary Phone, and is not currently 
													in the database, so INSERT as Primary, and UPDATE any
													existing Primary as Non-Primary: */	
												sRawDataString += "I || EntityID==" + iEntityID + 
													" || PhoneTypeID==" + arrData[i].typeID +
													" || PhoneNumber==" + arrData[i].numOnly +
													" || StartDate==" + sDbToday + " || PrimaryPhone==1 ^^ ";
												if (iCurPrimaryIdx > -1) {
													sRawDataString += "U || EntityID==" + iEntityID + 
														" || Seq==" + arrPhones[iCurPrimaryIdx].SEQ + 
														" || PrimaryPhone==0 ^^ ";					
												}
											}
										}		
									} else {
										sRawDataString += "I || EntityID==" + iEntityID + 
											" || PhoneTypeID==" + arrData[i].typeID + 
											" || PhoneNumber==" + arrData[i].numOnly +
											" || StartDate==" + sDbToday + " || PrimaryPhone==1 ^^ ";
									}
								}
							break;
							case "SecondaryPhone": case "OtherPhone":
								if (arrData[i].data != "" && arrData[i].typeID != "") {
									if (arrPhones.length > 0) {	
										for (j=0; j<arrPhones.length; j++) {
											if (arrPhones[j].PHONENUMBER == arrData[i].numOnly) {
												//Phone Exists, so do not save;
											break; }
											else if (j == arrPhones.length-1) {
												sRawDataString += "I || EntityID==" + iEntityID + 
													" || PhoneTypeID==" + arrData[i].typeID +
													" || PhoneNumber==" + arrData[i].numOnly +
													" || StartDate==" + sDbToday + " || PrimaryPhone==0 ^^ ";
											}
										}
									} else {
										sRawDataString += "I || EntityID==" + iEntityID + 
											" || PhoneTypeID==" + arrData[i].typeID +
											" || PhoneNumber==" + arrData[i].numOnly +
											" || StartDate==" + sDbToday + " || PrimaryPhone==0 ^^ ";
									}
								}		
							break;
							case "CellPhone": case "HomePhone":
								if (arrData[i].data != "") { $log.info("arrData:",arrData[i],"arrPhones:",arrPhones,"iCurPrimaryIdx",iCurPrimaryIdx)
									if (arrPhones.length > 0) { 
										for (j=0; j<arrPhones.length; j++) {
											if (arrPhones[j].PHONENUMBER == arrData[i].numOnly) {
												//Phone Exists, but if same PHONETYPEID, but NOT the Primary,
												// Change it to be the Primary...		
												if (j != iCurPrimaryIdx && arrPhones[j].PHONETYPEID ==
													arrData[i].typeID) {
													sRawDataString += "U || EntityID==" + iEntityID +
														" || Seq==" + arrPhones[j].SEQ + 
														" || PrimaryPhone==1 ^^ ";
													if (iCurPrimaryIdx > -1) {	
														sRawDataString += "U || EntityID==" + iEntityID +
														" || Seq==" + arrPhones[iCurPrimaryIdx].SEQ +
														" || PrimaryPhone==0 ^^ ";
													}	
												}
											break; }
											else if (j == arrPhones.length-1) {
												sRawDataString += "I || EntityID==" + iEntityID + 
													" || PhoneTypeID==" + arrData[i].typeID +
													" || PhoneNumber==" + arrData[i].numOnly +
													" || StartDate==" + sDbToday + " || PrimaryPhone==";
												if (iCurPrimaryIdx > -1) {
													if (arrPhones[iCurPrimaryIdx].PHONETYPEID ==
														arrData[i].typeID) {
														sRawDataString += "1 ^^ U || EntityID==" + iEntityID + 
															" || Seq==" + arrPhones[iCurPrimaryIdx].SEQ + 
															" || PrimaryPhone==0 ^^ "; }
													else { sRawDataString += "0 ^^ "; }
												} else { sRawDataString += "1 ^^ "; }
											}
										}			
									} else {
										sRawDataString += "I || EntityID==" + iEntityID + 
											" || PhoneTypeID==" + arrData[i].typeID + 
											" || PhoneNumber==" + arrData[i].numOnly +
											" || StartDate==" + sDbToday + " || PrimaryPhone==1 ^^ ";	
									}
								}
							break;
						}
					}

					if (sRawDataString != "") { 
						var sSaveString = "WebApps_Pro || Appl_Phones || " + loginService.user.USERID +
							" || " + sRawDataString;
						var params3 = {
							method: "PhSave",
							sDataSource: sDataSource,
							sRawDataString: sSaveString 
						};
						return $http.post(proJsCFC, params3)
						.then(function (results) { //$log.info("SavePhResult:",results)
							return results.data;
						});
					} else { return "No New Phones"; }
				});	
			});
		}
		
		function splitOffPhoneType(savedPh) {
			if (sDataSource == "") { setDataSource(); }
			//Get Phone Types:
			var params2 = {
				method: "PhLoadTypes",
				sDataSource: sDataSource
			};
			return $http.post(proJsCFC, params2)
			.then(function (phTypes) {
				if (phTypes.data.length > 0) {
					var arrTypes = phTypes.data;

					var idx = savedPh.indexOf("[");
					var ph = savedPh.substring(0, idx-1);
					var type = savedPh.substring(idx+1,(savedPh.length)-1);
					for (var i=0; i<arrTypes.length; i++) {
						if (arrTypes[i].PHONETYPE == type) {
							var typeID = arrTypes[i].PHONETYPEID;
						break; }
					}
					
					return {type:type, typeID:typeID, data:ph.trim()};
				}	
			});		
		}
		
		
//EMAILS:

		//Specifically for NEW accounts where initial email is Primary:
		function savePersonalEmail(iEntityID, sEmail) {
			if (sDataSource == "") { setDataSource(); }
			var iPersonalEmailType = 0;
			var sDbToday = datesService.todayToDbString();
			
			//Get Email Types:
			var params1 = {
				method: "EmLoadTypes",
				sDataSource: sDataSource
			};
			return $http.post(proJsCFC, params1)
			.then(function(emTypes) {
				var arrTypes = emTypes.data;
				
				for (var j=0; j<arrTypes.length; j++) {
					if (arrTypes[j].EMAILTYPE == "Personal") {
						iPersonalEmailType = arrTypes[j].EMAILTYPEID;
					break; }
				}
				
				var sRawDataString = "WebApps_Pro || CI_AddEmail || -11 || I || EntityID==" + iEntityID + 
					" || EmailTypeID==" + iPersonalEmailType + " || Email==" + sEmail + 
					" || StartDate==" + sDbToday + 
					" || PrimaryEmail==1 || RcvEmailComm==1 || Privacy==Public ^^ ";
					
				var params2 = {
					method: "EmSave",
					sDataSource: sDataSource,
					sRawDataString: sRawDataString 
				};
				return $http.post(proJsCFC, params2)
				.then(function (results) {
					return results.data;
				});
			});
		}

	/* Loads all current Emails. Validates if a Primary Exists.
		Compares newly entered Emails against existing, and inserts
		if new Email doesn't exist. If Primary Email not the same as newly
		entered Primary Email, and user indicates emComm==true, to use this 
		email for other Conf Communications, then update existing and make
		new Email Primary. */
		function saveNewEmails(iEntityID, arrData) {
			if (sDataSource == "") { setDataSource(); }
			var sRawDataString = "";
			var sDbToday = datesService.todayToDbString();
			var primEmail = null;
			
			//Get All Current Emails:
			var params = {
				method: "EmGetAll",
				sDataSource: sDataSource,
				iEntityID: iEntityID 
			};
			return $http.post(proJsCFC, params)
			.then(function (emails) { //$log.info("emails",emails.data);
				var arrEmails = emails.data;
				var dToday = new Date();
					
				//Filter for Only current Emails:
				for (var i=0; i<arrEmails.length; i++) {
					var dStart = new Date(arrEmails[i].STARTDATE);
					var dStop = "";
					if (arrEmails[i].STOPDATE != "") {
						dStop = new Date(arrEmails[i].STOPDATE);
					}	
					if (dStart > dToday || 
						(dStop != "" && dStop < dToday)) {
						arrEmails.splice(i, 1);
						i--;
					}	
				}

				//Get Email Types:
				var params1 = {
					method: "EmLoadTypes",
					sDataSource: sDataSource
				};
				return $http.post(proJsCFC, params1)
				.then(function(emTypes) {
					var arrTypes = emTypes.data;
					
					//Insert the EMAILTYPEID into the arrData:
					for (i=0; i<arrData.length; i++) {
						if (arrData[i].itemName == "Email") {
							for (j=0; j<arrTypes.length; j++) {
								if (arrTypes[j].EMAILTYPE == "Personal") {
									arrData[i].typeID = arrTypes[j].EMAILTYPEID;
								break; }
							}
						}
					}
					
					//Validate if a Primary Email exists:
					if (arrEmails.length > 0) {
						for (var j=0; j<arrEmails.length; j++) {
							if (arrEmails[j].PRIMARYEMAIL == true) {
								primEmail = arrEmails[j];
							break; }
						}
					}

					//Create Save Strings:
					for (i=0; i<arrData.length; i++) { 
						switch (arrData[i].itemName) {
							case "Email":
								//Check if entered Email exists:
								if (arrEmails.length > 0) {
									for (j=0; j<arrEmails.length; j++) {
										var em = arrEmails[j].EMAIL;
										var emData = arrData[i].data;
										if (emData.toLowerCase() == em.toLowerCase()) {
											if (arrEmails[j].PRIMARYEMAIL != true && 
												arrData[i].emComm==true) {
												sRawDataString += "U || EntityID==" + iEntityID + 
													" || Seq==" + arrEmails[j].SEQ + 
													" || PrimaryEmail==1 ^^ ";
												if (primEmail != null && primEmail.SEQ != arrEmails[j].SEQ) {
													sRawDataString += "U || EntityID==" + iEntityID +
														" || Seq==" + primEmail.SEQ + 
														" || PrimaryEmail==0 ^^ ";
												}
											}
										break; }
										else if (j == arrEmails.length-1) {
											//Entered email not listed, so add:
											sRawDataString += "I || EntityID==" + iEntityID + 
												" || EmailTypeID==" + arrData[i].typeID + " || Email==" +
												arrData[i].data + " || StartDate==" + sDbToday + 
												" || PrimaryEmail==";
											if (primEmail == null || arrData[i].emComm==true) {
												sRawDataString += 
													"1 || RcvEmailComm==1 || Privacy==Public ^^ ";
												if (primEmail != null) {
													//Also update existing primary to not be Primary:
													sRawDataString += "U || EntityID==" + iEntityID +
														" || Seq==" + primEmail.SEQ + 
														" || PrimaryEmail==0 ^^ ";
												}
											} else { sRawDataString += "0 ^^ "; }
										}
									}
								} else {
									//No existing emails, so make PRIMARY.
									sRawDataString = "I || EntityID==" + iEntityID + 
										" || EmailTypeID==" + arrData[i].typeID + " || Email==" +
										arrData[i].data + " || StartDate==" + sDbToday + 
										" || PrimaryEmail==1 || RcvEmailComm==1 || Privacy==Public ^^ ";	
								}		
							break;		
						}
					}

					if (sRawDataString != "") {
						var sSaveString = "WebApps_Pro || Appl_Email || " + loginService.user.USERID +
							" || " + sRawDataString;
						var params3 = {
							method: "EmSave",
							sDataSource: sDataSource,
							sRawDataString: sSaveString 
						};
						return $http.post(proJsCFC, params3)
						.then(function (results) {
							return results.data;
						});
					} else { return "No New Emails"; }
				});
			});
		}
		
		function updateEmailToPrimary(iEntityID, selEmail, primEmail) {
			if (sDataSource == "") { setDataSource(); }
			
			var sRawDataString = "WebApps_Pro || Appl_Email || " + loginService.user.USERID +
				" || U || EntityID==" + iEntityID + " || Seq==" + selEmail.SEQ + 
				" || PrimaryEmail==1 || RcvEmailComm==1 || Privacy==Public ^^ " +
				"U || EntityID==" + iEntityID + " || Seq==" + primEmail.SEQ + " || PrimaryEmail==0 ^^ ";
		
			var params = {
				method: "EmSave",
				sDataSource: sDataSource,
				sRawDataString: sRawDataString	
			};
			return $http.post(proJsCFC, params)
			.then(function(result) {
				return result.data;
			});
		}
		
		
//Internally called functons:
		function setDataSource() {
			sDataSource = webSessionStorage.getStoredData('sDataSource');
		}
		
	}
})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('confirmPWChg', confirmPWChg);

    function confirmPWChg() {
		var factory = {
			confirmEmail: confirmEmail,
			confirmPassword: confirmPassword,
			notReadyToSave: notReadyToSave
		};
		return factory;
		
		function confirmEmail(sNewEmail, sConfirmEmail) {
			var strEmail;
			if (sNewEmail != "" && sConfirmEmail != "") {
				if (sNewEmail.toLowerCase() == sConfirmEmail.toLowerCase()) {
					strEmail = "true"; }
				else {
					strEmail = "The New Email and the Confirmed Email addresses do not match. " +
						"Please enter the Email addresses again."; 
				}
			} else {
				strEmail = "false";
			}
			return strEmail;
		}
				
		function confirmPassword(sNewPW, sConfirmPW) {
			var strPW;
			
			if (sNewPW.indexOf("'")>-1) {
				strPW = "false'";
			} else if (sNewPW != "" && sConfirmPW != "") {
				if (sNewPW == sConfirmPW) { strPW = "true"; }
				else {
					strPW = "The New Password and the Confirmed Password do not match. " +
						"Please enter the passwords again."; 
				}
			} else {
				strPW = "false";
			}
			return strPW;
		}
		
		//click Save button when NOT activated, so tell user why...
		function notReadyToSave(sOldPW, sNewPW, sConfirmPW, sNewEmail, sConfirmEmail) {
			var str = "";
			if (sOldPW == "" && sNewPW == sConfirmPW) {
				str = "It is required that you enter your old password " +
					"in order to Save a new one."; }
			else if ((sNewEmail != "" || sConfirmEmail != "") &&
				sNewEmail.length != sConfirmEmail.length) {
				str = "You must enter the new Email Address twice, and the " +
					"entries must match, in order to save a new Email.\n\n" +
					"Please be sure you are entering the same address in " +
					"both the New and Confirm Email Address fields."; }
			else if ((sNewPW != "" || sConfirmPW != "") &&
				sNewPW.length != sConfirmPW.length) {
				str = "You must enter the new Password twice, and the \n" +
					"entries must match, in order to save a new Password.\n\n" +
					"Please be sure you are entering the same password in " +
					"both the New and Confirm Password fields."; }	
			else if (sOldPW == "" && sNewPW == "" && sConfirmPW == "" &&
				sNewEmail == "" && sConfirmEmail == "") {
				str = "There is nothing to Save! \n\n" +
					"Please enter your new Password or Email before " +
					"clicking the Save button.";	
			}
			return str;
		}
	}

})();
(function () {
	'use strict';
 
	angular
		.module('proRefs')
		.factory('confirmEmailChg', confirmEmailChg);
		
	confirmEmailChg.$inject = ['$window','emailValidator'];
	
	function confirmEmailChg($window, emailValidator) {
		var factory = {
			confirmEmail: confirmEmail
		};
		return factory;
		
		function confirmEmail(sNewEmail, sConfirmEmail) {
			var strEmail;
			if (sNewEmail != "" && sConfirmEmail != "") {
				if (sNewEmail.toLowerCase() == sConfirmEmail.toLowerCase()) {
					if (emailValidator.isValid(sNewEmail) == true) {
						strEmail = "true"; }
					else {
						strEmail = "false";
						$window.alert("The email entered is not a valid email address. " +
							"Please enter a valid email address.");
					}	
				} else {
					strEmail = "noMatch";
					$window.alert("The Email and the Confirmed Email addresses do not match. " +
						"Please enter the Email addresses again."); }
			} else { 
				strEmail = "false"; 
			}
			return strEmail;
		}
						
	}

})();
(function () {
	'use strict';

	angular
		.module('proRefs')
		.factory('backgroundService', backgroundService);

	backgroundService.$inject = ['$rootScope','dataService','modalService','errorEmailNotification',
		'loginService','formatterService','datesService','webSessionStorage','$log'];

	function backgroundService($rootScope, dataService, modalService, errorEmailNotification, 
		loginService, formatterService, datesService, webSessionStorage, $log) {
		var arrFormData = [];
		var arrFormDefs = [];
		var BranchAcct = 842628;
		var iBkgrdStepID = 0;
		var sAddr1 = "";
		var sCity = "";
		var sDatabaseID = "";
		var sDOB = "";
		var sFirstName = "";
		var sFormerName = "";
		var sGender = "";
		var sLastName = "";
		var sMiddleName = "";
		var sOrderDetail = "";
		var sPassword = "";
		var sSSN = "";
		var sState = "";
		var sSuffixName = "";
		var sTestPMM = "YES"; //Testing="YES", Live="NO"
		var sUsername = "";
		var sZipcode = "";
		
		var service = {
			firstAdvantage: firstAdvantage,
			protectMyMinistry: protectMyMinistry
		};
		
		return service;


	/* Currently MO ONLY: */
		function firstAdvantage(iStepID, onSuccess, onError) {
			iBkgrdStepID = iStepID;
			$rootScope.sCurForm = "FA Background Service";
$log.info($rootScope.sCurForm);
			
			dataService.proGetMain($rootScope.sProID)
			.then(function(dataMain) {
				if (dataMain.length > 0) {
					//6/28/18 v...139 ~ changed to use CHURCHID to ID if BranchAcct... 
					//  since [B],[L] not available to view. lds
					if (dataMain[0].CHURCHID != "") {
						var proChurchID = dataMain[0].CHURCHID;
						
						dataService.proGetChOrgSettings(proChurchID)
						.then(function(dataChOrg) { 
							if (dataChOrg[0].SCREENACCOUNT != "") {
								BranchAcct = dataChOrg[0].SCREENACCOUNT;
							}
						});
					}
				}

				dataService.libGetASetting("LNPassword")
				.then(function(pwd) {
					if (pwd.length > 0) {
						sPassword = pwd[0].SETTINGVALUE;
					} else {
						modalService.resultAlert("sm", pwd[0]);
						var sEmailContent = 
							errorEmailNotification.error4("backgroundService/libGetFAPassword()");
						dataService.emailSendError(sEmailContent);
					}
					
					dataService.proGetForm("Application")
					.then(function(defs) {
						if (defs.length > 0) {
							arrFormDefs = defs;
						} else {
							var sEmailContent = 
								errorEmailNotification.error4("backgroundService/proGetForm()");
							dataService.emailSendError(sEmailContent);
						}
						
						dataService.proGetFormData("Application", $rootScope.sProID)
						.then(function(formData) {
							if (formData.length > 0) {
								arrFormData = formData;
								populateVariables();
								createMO_OrderDetail(); $log.info("OrderDetail:",sOrderDetail);
								saveScreenSend(sOrderDetail);

								dataService.proSubmitFirstAdvantage(sOrderDetail)
								.then(function(result) {
									var str = result.data; 
									saveFAResults(result.data);
									var idx = str.indexOf("OrderStatus");
									if (idx > -1) {
										var status = str.substr(idx+12, 10);
										var sOrderStatus = "";
										switch(status) {
											case "InProgress": sOrderStatus = "In Progress"; break;
											default: 
												sOrderStatus = status; 
												var sEmailContent0 = errorEmailNotification.error4("webApps_Pro/backgroundService");
												sEmailContent0 += "<br><br>Function: proSubmitFirstAdvantage()<br>sOrderStatus is not yet listed in case for: " + sOrderStatus + 
												". Please add!";
												dataService.emailSendCustom("lori@greatspirit.com", "lori@greatspirit.com", "lori@greatspirit.com", "Coding Needed", sEmailContent0);
											break; 
										}
										
										if (sOrderStatus != "") {
											modalService.okAlert("Success",
												"Information for your Background Screen has " +
												"been successfully submitted.\n\n" +
												"The current Status is \"" + sOrderStatus + "\"");
										}
										var arrReturn = [{status:status, error:sError,
											result:str}];
										onSuccess(arrReturn);
									} else {
										status = "Error";
										var sError = "";
										idx = str.indexOf("<ErrorCode>");
										if (idx > -1) {
											var errorCode = str.substr(idx+11, 3);
											switch (errorCode) {
												case 210: sError = "User is Locked"; break;
											}
											if (sError != "") { 
												modalService.okAlert("Error",
													sError); }
										}
										status = sError;
										var sEmailContent = errorEmailNotification.error4("WebApps_Pro/backgroundService");
										sEmailContent += "<br><br>Function: proSubmitFirstAdvantage()" +
											"<br>There was an error submitting the background screen." +
											"<br>ErrorCode = " + errorCode + "<br>Error Description: " +
											sError + "<br>FirstAdvantage return: " + str;
										dataService.emailSendError(sEmailContent);
										arrReturn = [{status:status, error:sError, result:str}];
										onError(arrReturn);
									}
								});
								
							} else {
								modalService.resultAlert("sm", formData[0]);
								var sEmailContent = 
									errorEmailNotification.error4("backgroundService/proGetForm()");
								dataService.emailSendError(sEmailContent);
							}	
						});	
					});			
				});
			});
		}
		
		//NWTX, MC
		function protectMyMinistry(iStepID, iCertTypeID, onSuccess, onError) {
			iBkgrdStepID = iStepID;			
			$rootScope.sCurForm = "PMM Background Service";
$log.info($rootScope.sCurForm);
			
			sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
			switch (sDatabaseID) {
				case "MC": case "NWTX":
					sTestPMM = "NO";
				break;
				default:
					sTestPMM = "YES";
				break;
			}
			
			dataService.libGetASetting("ProPMMPassword")
			.then(function(pwd) {
				if (pwd.length > 0) {
					sPassword = pwd[0].SETTINGVALUE;
				} else {
					modalService.resultAlert("sm", pwd[0]);
					var sEmailContent = errorEmailNotification.error4("backgroundService/libGetAPassword");
					dataService.emailSendError(sEmailContent);
				}
				
				dataService.libGetASetting("ProPMMUsername")
				.then(function(un) {
					if (un.length > 0) {
						sUsername = un[0].SETTINGVALUE;
					}
					
					//NWTX using Application5. If others, need to add Switch case for Conference
					if (Number(iCertTypeID) == 4) { var sApp = "Application"; }
					else if (Number(iCertTypeID) == 5) { sApp = "Application5"; }
					
					dataService.proGetForm(sApp)
					.then(function(defs) {
						if (defs.length > 0) {
							arrFormDefs = defs;
						} else {
							var sEmailContent = 
								errorEmailNotification.error4("backgroundService/proGetForm");
							dataService.emailSendError(sEmailContent);
						}

						dataService.proGetFormData(sApp, $rootScope.sProID)
						.then(function(data) { //$log.info("data:",data)
							if (data.length > 0) {
								arrFormData = data;
								populateVariables();
								switch (sDatabaseID) {
									case "NWTX": case "NWTX-DEV":
										createNWTX_OrderDetail();
									break;
									case "MC": case "MC-DEV":
										createMC_OrderDetail();
									break;
								} //$log.info("sOrderDetail",sOrderDetail)
								saveScreenSend(sOrderDetail);
									
								dataService.proSendPMM(sOrderDetail)
								.then(function(sendReturn) { $log.info("proSendPMM:",sendReturn)
									var resultPMM = sendReturn.data;
									var status = "";
									
									dataService.proSaveResultsPMM(iBkgrdStepID, resultPMM)
									.then(function(result) { $log.info("proSaveResultsPMM:",result);
										if (result[0].RESULTCODE != 'Success') {
											var sEmailContent = 
												errorEmailNotification.error4("backgroundService/" +
												"savePMMResults");
											sEmailContent += "<br>Error: Failure saving initial PMM " +
												"Result.<br><br>" +
												"ProSendPMM Returned: " + resultPMM.toString() + "<br><br>" +
												"ProSaveResultsPMM Returned: " + result[0].RESULTREASON;
											dataService.emailSendError(sEmailContent);
										}

										var idx = resultPMM.indexOf("Status");
										if (idx > -1) {
											status = resultPMM.substr(idx+7, 7);
											if (status == "SUCCESS") {
												onSuccess();
											} else { 
												var sEmailContent0 = 
													errorEmailNotification.error4("webApps_Pro/" +
													"backgroundService");
												sEmailContent0 += "<br><br>Function: proSendPMM()<br>" +
													"returned 'Status' is not yet listed in case " + 
													"for: " + status + ". Please add!";
												dataService.emailSendCustom("lori@greatspirit.com",
													"lori@greatspirit.com", "lori@greatspirit.com",
													"Coding Needed", sEmailContent0);
												onError();
											} 
										} else {
											sEmailContent = 
												errorEmailNotification.error4("WebApps_Pro/" +
												"backgroundService");
											sEmailContent += "<br><br>Function: proSendPMM()" +
												"<br><br>There was an error submitting the background " +
												"screen.<br>Error Description: " + resultPMM;
												
											dataService.emailSendError(sEmailContent);
											onError();
										}
									});	
								});
							} else {	
								var sEmailContent = 
									errorEmailNotification.error4("backgroundService/proGetFormData");
								sEmailContent += "<br><br>Send in:<br>sApp: " + sApp + "<br>sProID: " +
									$rootScope.sProID + "<br>iCertTypeID: " + String(iCertTypeID);	
								dataService.emailSendError(sEmailContent);
							}	
						});	
					});		
				});
			});		
		}
		

//Internally called functions:
		
		function populateVariables() {
			if (arrFormData.length > 0) {
				for (var i=0; i<arrFormData.length; i++) {
					for (var j=0; j<arrFormDefs.length; j++) {
						if (arrFormDefs[j].ITEMID == arrFormData[i].ITEMID) {
							switch (arrFormDefs[j].ITEMNAME) {
								case "FirstName":
									sFirstName = arrFormData[i].ITEMDATA;
								break;
								case "MiddleName":
									sMiddleName = arrFormData[i].ITEMDATA; 
								break;
								case "LastName":
									sLastName = arrFormData[i].ITEMDATA;
								break;
								case "SuffixName":
									if (arrFormData[i].ITEMDATA == "No Value Found") {
										sSuffixName = "";
									} else { sSuffixName = arrFormData[i].ITEMDATA; }
								break;
								case "FormerName":
									if (arrFormData[i].ITEMDATA == "No Value Found") {
										sFormerName = "";
									} else { sFormerName = arrFormData[i].ITEMDATA; }
								break;
								case "Gender":
									sGender = arrFormData[i].ITEMDATA;
								break;
								case "BirthDate":
									var bday = arrFormData[i].ITEMDATA;
									switch (sDatabaseID) {
										case "MC": case "MC-DEV":
										case "NWTX": case "NWTX-DEV":
											sDOB = bday;
										break;
										default:
											sDOB = datesService.calStrToDbDateStr(bday);
										break;	
									}
								break;
								case "Address":
									sAddr1 = arrFormData[i].ITEMDATA;
								break;
								case "City":
									sCity = arrFormData[i].ITEMDATA;
								break;
								case "State":
									sState = arrFormData[i].ITEMDATA;
								break;
								case "Zip":
									sZipcode = arrFormData[i].ITEMDATA;
								break;
								case "SSN":
									var SSN = arrFormData[i].ITEMDATA.toString();
									var rePattern = /[^0-9]/g;
									var numOnlySSN = SSN.replace(rePattern,''); 
									sSSN = formatterService.formatSSN(numOnlySSN);
								break;
							}
						}
					}
				}
			}
		}
		
		function createMO_OrderDetail() {
			sOrderDetail = 
				"<aaa:BackgroundCheck xsi:schemaLocation='http://www.screeningxchange.com/schemas CPBackgroundCheck.xsd' account='842628' userId='XChange' aaa:password='" + sPassword + "' xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:aaa='http://www.screeningxchange.com/schemas'>" +
					"<aaa:BackgroundSearchPackage xmlns='http://www.screeningxchange.com/schemas'>" +
						"<aaa:PackageInformation>" +
							"<aaa:PackageId>2112</aaa:PackageId>" +
							"<aaa:ClientReferences>" +
								"<aaa:ClientReference>"+$rootScope.sProID+"</aaa:ClientReference>" +
							"</aaa:ClientReferences>" +
							"<aaa:OrderAccount>" +
								"<aaa:UserId>XChange</aaa:UserId>" +
								"<aaa:Account>" + BranchAcct + "</aaa:Account>" +
							"</aaa:OrderAccount>" +
						"</aaa:PackageInformation>" +
						"<aaa:PersonalData>" +
							"<aaa:PersonName type='subject'>" +
								"<aaa:GivenName>" +	sFirstName + "</aaa:GivenName>" +
								"<aaa:MiddleName>" + sMiddleName + "</aaa:MiddleName>" +
								"<aaa:FamilyName>" + sLastName + "</aaa:FamilyName>" +
								"<aaa:MaidenName>" + sFormerName + "</aaa:MaidenName>" +
								"<aaa:Suffix>" + sSuffixName + "</aaa:Suffix>" +
							"</aaa:PersonName>" +
							"<aaa:PostalAddress type='current'>" +
								"<aaa:CountryCode>US</aaa:CountryCode>" +
								"<aaa:PostalCode>" + sZipcode + "</aaa:PostalCode>" +
								"<aaa:Region>" + sState + "</aaa:Region>" +
								"<aaa:Municipality>" + sCity + "</aaa:Municipality>" +
								"<aaa:DeliveryAddress>" +
									"<aaa:AddressLine>" + sAddr1 + "</aaa:AddressLine>" +
								"</aaa:DeliveryAddress>" +
							"</aaa:PostalAddress>" +
							"<aaa:DemographicDetail>" +
								"<aaa:HasSSN>Y</aaa:HasSSN>" +
								"<aaa:GovernmentId issuingAuthority='SSN'>" + sSSN + "</aaa:GovernmentId>" +
								"<aaa:DateOfBirth>" + sDOB + "</aaa:DateOfBirth>" +
								"<aaa:Gender>" + sGender + "</aaa:Gender>" +
							"</aaa:DemographicDetail>" +
						"</aaa:PersonalData>" +
					"</aaa:BackgroundSearchPackage>" +
				"</aaa:BackgroundCheck>";
		}
		
		function createNWTX_OrderDetail() {
			sOrderDetail = 
				"<OrderXML>" +
					"<Method>SEND ORDER</Method>" +
					"<Authentication>" +
						"<Username>" + 	sUsername + "</Username>" +
						"<Password>" + sPassword + "</Password>" +
					"</Authentication>" +
					"<TestMode>" + sTestPMM + "</TestMode>" +
					"<ReturnResultURL>https://services.priorityresearch.com/webservice/AddToWebService.cfm</ReturnResultURL>" +
					"<Order>" +
						"<BillingReferenceCode>" + $rootScope.sProID + "</BillingReferenceCode>" +
						"<Subject>" +
							"<FirstName>" +	sFirstName + "</FirstName>" +
							"<MiddleName>" + sMiddleName + "</MiddleName>" +
							"<LastName>" + sLastName + "</LastName>" +
							"<Generation></Generation>" +
							"<DOB>" + sDOB + "</DOB>" +
							"<SSN>" + sSSN + "</SSN>" +
							"<Gender>" + sGender + "</Gender>" +
							"<Ethnicity></Ethnicity>" +
							"<DLNumber></DLNumber>" +
							"<ApplicantPosition>Volunteer</ApplicantPosition>" +
							"<CurrentAddress>" +
								"<StreetAddress>" + sAddr1 + "</StreetAddress>" +
								"<City>" + sCity + "</City>" +
								"<State>" + sState + "</State>" +
								"<Zipcode>" + sZipcode + "</Zipcode>" +
							"</CurrentAddress>" +
							"<Aliases>" +
								"<Alias>" +
									"<FirstName></FirstName>" +
									"<MiddleName></MiddleName>" +
									"<LastName>" + sFormerName + "</LastName>" +
								"</Alias>" +
							"</Aliases>" +
						"</Subject>" +
						"<PackageServiceCode OrderId='" + $rootScope.sProID + "'>Basic</PackageServiceCode>" +
						"<OrderDetail OrderID='" + $rootScope.sProID + "' ServiceCode='combo'></OrderDetail>" +
					"</Order>" +
				"</OrderXML>";
		}
		
		function createMC_OrderDetail() {
			sOrderDetail = 
				"<OrderXML>" +
					"<Method>SEND ORDER</Method>" +
					"<Authentication>" +
						"<Username>" + 	sUsername + "</Username>" +
						"<Password>" + sPassword + "</Password>" +
					"</Authentication>" +
					"<TestMode>" + sTestPMM + "</TestMode>" +
					"<ReturnResultURL>https://services.priorityresearch.com/webservice/AddToWebService.cfm</ReturnResultURL>" +
					"<Order>" +
						"<BillingReferenceCode>" + $rootScope.sProID + "</BillingReferenceCode>" +
						"<Subject>" +
							"<FirstName>" +	sFirstName + "</FirstName>" +
							"<MiddleName>" + sMiddleName + "</MiddleName>" +
							"<LastName>" + sLastName + "</LastName>" +
							"<Generation></Generation>" +
							"<DOB>" + sDOB + "</DOB>" +
							"<SSN>" + sSSN + "</SSN>" +
							"<Gender>" + sGender + "</Gender>" +
							"<Ethnicity></Ethnicity>" +
							"<DLNumber></DLNumber>" +
							"<ApplicantPosition>Volunteer</ApplicantPosition>" +
							"<CurrentAddress>" +
								"<StreetAddress>" + sAddr1 + "</StreetAddress>" +
								"<City>" + sCity + "</City>" +
								"<State>" + sState + "</State>" +
								"<Zipcode>" + sZipcode + "</Zipcode>" +
							"</CurrentAddress>" +
							"<Aliases>" +
								"<Alias>" +
									"<FirstName></FirstName>" +
									"<MiddleName></MiddleName>" +
									"<LastName>" + sFormerName + "</LastName>" +
								"</Alias>" +
							"</Aliases>" +
						"</Subject>" +
						"<PackageServiceCode OrderId='" + $rootScope.sProID + "'>1 county auto</PackageServiceCode>" +
					"</Order>" +
				"</OrderXML>";
		}
		
		function saveFAResults(data) {
			//Saves FA Return to ProDocs, and adds ProProcess record:
			dataService.proSaveResultsFA(iBkgrdStepID, data)
			.then(function(result) {
				if (result[0].RESULTS != 'Success') {
					var sEmailContent = errorEmailNotification.error4("backgroundService/saveFAResults");
					sEmailContent += "Failure saving initial FA Result. Error: " + result;
					dataService.emailSendError(sEmailContent);
				}
			});
		}
		
		function saveScreenSend(sOrderDetail) {
			var sSendString = "WebApps_Pro || ScreenSend || " + loginService.user.USERID + 
				" || I || ProID==" + $rootScope.sProID + " || SendString==" + sOrderDetail + " ^^ ";

			dataService.proSaveScreenSend(sSendString)
			.then(function(sendSave) { $log.info("proSaveScreenSend:",sendSave)
				if (sendSave[0].RESULTCODE != "Success") {
					var sEmailContent = errorEmailNotification.error4("backgroundService/" +
						"proSaveScreenSend");
					dataService.emailSendError(sEmailContent);
				}
			});
		}		
	}
	
})();
(function () {
	'use strict';

	angular
		.module('proRefs')
		.factory('arrayFactory', arrayFactory);

	arrayFactory.$inject = ['datesService'];

	function arrayFactory(datesService) {
		var sDbToday = datesService.todayToDbString();

		var factory = {
			getCurrentOnly: getCurrentOnly
		};
		return factory;

		function getCurrentOnly(arr) {
			for (var i=0; i<arr.length; i++) {
				if (arr[i].STARTDATE > sDbToday ||
					(arr[i].STOPDATE != "" &&
					arr[i].STOPDATE < sDbToday)) {
					arr.splice(i, 1);
					i--;
				}
			}
			return arr;
		}

	}
})();
(function () {
    'use strict';
 
	angular
        .module('proRefs')
        .factory('appValidationService', appValidationService);

	appValidationService.$inject = ['loginService','dataService'];	

    function appValidationService(loginService, dataService) {
		var service = {
			validateAccess: validateAccess
		};
		
		return service;
		
		function validateAccess() {
			var apps = loginService.user.UserChurchFNs;
			var perm = "MyCerts";
			if (apps.length > 0) {
				for (var i=0; i<apps.length; i++) { 
					if (apps[i].FN == "ProRef") {
						//Clergy with Protect References - if "In Process" take there instead:
						dataService.proGetCertRecords(loginService.user.USERID,
							loginService.user.USERENTITYID)
						.then(function(certs) {
							if (certs.length > 0) {
								for (var j=0; j<certs.length; j++) {
									if (certs[j].PROSTATUS == "In Process") {
										perm = "MyCerts";
									break; }
									else if (i == certs.length-1) {	
										perm = "CertMgmt";
									}
								}
							} else {
								perm = "CertMgmt";
							}
						});
					break; }				
				}
			} 
			
			return perm; //MyCerts, CertMgmt
		}	
	}
})();
(function() {
	'use strict';

	angular
		.module('proRefs')
		.config(function($httpProvider) {
			$httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'; 

		// Override $http service's default transformRequest 
			$httpProvider.defaults.transformRequest = [function(data) { 
				/* The workhorse; converts an object to x-www-form-urlencoded serialization. * @param {Object} obj * @return {String} */ 
				var param = function(obj) { 
					var query = ''; 
					var name, value, fullSubName, subName, subValue, innerObj, i; 
					for(name in obj) { 
						value = obj[name]; 
						if(value instanceof Array) { 
							for(i=0; i<value.length; ++i) { 
								subValue = value[i]; 
								fullSubName = name + '[' + i + ']'; 
								innerObj = {}; 
								innerObj[fullSubName] = subValue; 
								query += param(innerObj) + '&'; 
							} 
						} 
						else if(value instanceof Object) { 
							for(subName in value) { 
								subValue = value[subName]; 
								fullSubName = name + '[' + subName + ']'; 
								innerObj = {}; 
								innerObj[fullSubName] = subValue; 
								query += param(innerObj) + '&'; 
							}
						}//ln35: was if (value !== undefined...
						else if(angular.isDefined(value) && value !== null) { 
							query += encodeURIComponent(name) + '=' + 
							encodeURIComponent(value) + '&'; 
						}
					}
					return query.length ? query.substr(0, query.length - 1) : query; 
				}; 
				return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
			}];
		});
})();
/* 
	ProtectRefs ==> Replaces ProtectReferences and is part of the MCWebApps family.
	It has been updated to work with MCWebApps giving pastors access to ContactInfo
	It is ONLY working for MO at present... and only those with "ProRef" permission in 
	[UserChurch] connected to a ChurchID.
	ContactInfo ONLY loads [Person] records tied to the UserChurch.ChurchID for the ProRef record.

	loginServices:
		loginService.user = { 
			USEREMAIL,				==> chgPWCtrl
			USERID,					==> refCtrl, dataService
			USERFULLNAME,			==> certMgmtCtrl, refCtrl, referRefEmail
			USERENTITYID			==> certMgmtCtrl, applCtrl
			RETURNCODE				==> 
			RETURNKEY
			firstName				==> stepsCtrl
			lastName				==> stepsCtrl
			loggedIn
			UserChurchFNs			==> populated with USERGETCHURCHFUNCTIONS return for
										ProRefs, etc. permissions
			CHURCHID				Not in use... commented out in loginServices
			CHURCHNAME				Not in use... commented out in loginServices
		};
	
GLOBALS:

	sessionStorage:		
		sDataSource = 	webSessionStorage.getStoredData('sDataSource');
		sDatabaseID	=	webSessionStorage.getStoredData('sDatabaseID');

	$rootScope:	
		$rootScope.Applicant ==> refCtrl for Error message
		$rootScope.bPasswordExpired	==> chgPWCtrl to prevent leaving chgPWCtrl until 
			password updated.
		$rootScope.sProID	//myCerts ==> accessed from stepsCtrl; applCtrl; lcPolicyCtrl;
		$rootScope.sCurForm	//added on each form for use in HelpDesk form identification	
		
TODO:
	AppName: ProtectRefs (new MCWebApps version of ProtectReferences)
	PATH: cd Applications/ColdFusion9/wwwroot/Burt/Falcon/Web_TestSite/proRefs
	
	Change DEV EMAILS to go to "testing@greatspirit.com";
	
	LIVE:
		- index.module
			* TESTING text - comment out.
		- index.constants
			* Change paths to LIVE MissionConnect site from Web_TestSite
			* update version#
		- dataService
			* Test/change over ALL testCFC references to LIVE Protect_JS.cfc or WebApps.cfc
			* Error Emails to go to errors@GSS not lori@GSS		
			
		- Contact eThink to change path to MCWebApps/Protect...	
		- ProFormDefs - Last Def in Training "C-2" should be "Score" instead.
*/	
angular
	.module('proRefs')
	.filter('certTypeDesc', certTypeDesc);
		
certTypeDesc.$inject = ['webSessionStorage'];		
		
function certTypeDesc(webSessionStorage) {
	var sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	var desc = "";
		
	return function (CERTTYPEID) {
		switch (sDatabaseID) {
			case "MC": case "MC-DEV":
				switch (CERTTYPEID) {
					case 1:
						desc = "Safe Sanctuaries";
					break;
					case 4:
						desc = "S S Online Process";
					break;
				}
			break;
			case "MO": case "MO-DEV": case "VID":
				switch (CERTTYPEID) {
					case 1:
						desc = "Safe Sanctuaries Conf";
					break;
					case 3:
						desc = "Safe Sanctuaries Church";
					break;	
					case 4:
						desc = "S S Online Process";
					break;
					case 5:
						desc = "LCA";
					break;
				}
			break;
			case "NWTX": case "NWTX-DEV":
				switch (CERTTYPEID) {
					case 1:
						desc = "BCC CP Approved";
					break;
					case 4:
						desc = "BCC Online Process";
					break;
					case 5:
						desc = "Volunteers In Mission";
					break;
				}
			break;
		}
		return desc;
	}	
}
angular
    .module('proRefs')
    .controller('TrainingController', TrainingController);

TrainingController.$inject = ['$rootScope','dataService','$stateParams','$sce','$document',
	'loginService','datesService','errorEmailNotification','modalService','$log'];

function TrainingController($rootScope, dataService, $stateParams, $sce, $document, 
	loginService, datesService, errorEmailNotification, modalService, $log) {
    var vm = this; //vmTr
    
    vm.arrData = [];
    vm.arrDataFields = [];
    vm.arrDefOpts = [];
    vm.arrDefs = [];
    vm.bBack = false;
    vm.bQuestion = false;	//turns on/off "Next" button, not visible until Question answered
    vm.bCorrect = false;	//turns on/off "That is Correct!" response to Answer
    vm.bIncorrect = false;	//turns on/off the "Incorrect" response text & button
    vm.bGoToScore = false;	//when true, all Chapters/Questions complete, but data found missing
							//so return to single question to complete answer, then display full score
    vm.header = "";
    vm.iCurChapter = 0;
    vm.sCurPage = "C-1";
    vm.iLastChapter = 0;
    vm.iStepSaveKey = $stateParams.objStep.SAVEKEY;
    vm.sChapter = "";
    vm.sContactInfo = "";
    vm.sectionHdr = "";
    vm.subheader = "";
    vm.videoPath = "";
    vm.bVideoPlay = false;

	//Scoring:
	vm.Score = 0;
	vm.Qs = 0;
	vm.Correct = 0;
	vm.Tries2 = 0;
	vm.Tries3 = 0;
	vm.Tries4 = 0;
	vm.Tries5 = 0;
    
//INITIALIZE:
	$rootScope.sCurForm = "Training";
$log.info($rootScope.sCurForm);	
	
	dataService.libGetASetting("ProContactInfo")
	.then(function(result) {
		if (result.length > 0) {
			vm.sContactInfo = $sce.trustAsHtml(result[0].SETTINGVALUE);
		}
	});
	
	if ($stateParams.objStep.STEPPROGRESS != "") {
		var progress = $stateParams.objStep.STEPPROGRESS;
		if (Number(progress.substr(0,2)) > 0) {
			vm.iCurChapter = Number(progress.substr(0,2)) + 1;
		}
	}	
	
	//Used from here only to determine starting point if 
	//questions in a chapter already completed...
	dataService.proGetFormData("Training")
	.then(function(data) {
		if (data.length > 0) {
			vm.arrData = data;
		}
		
		dataService.proLoadDefOptions("Training")
		.then(function(defOpts) {
			vm.arrDefOpts = defOpts;
			
			dataService.proGetForm("Training")
			.then(function(defs) {
				vm.arrDefs = defs;
				vm.iLastChapter = vm.arrDefs[vm.arrDefs.length-1].GROUPSEQ;
				
				createForm();
				
			});
		});
	});
	
/*	Training Schema:
	Defs ordered by GroupSeq/ItemSeq
	GROUPSEQ: 	0=Introduction, > 0= Chapter#
	GROUPNAME:	Chapter Header
	ITEMNAME:
		"C-1" to "C-x": CONTENT pages, can be several C-x defs for a single display page.
		"Q-1" to "Q-x": QUESTIONS. Can be multiple Q-x defs on a single display page.
		Every Question "Q-#" Def must be followed respectively by:
			"A-#" and "F-#": Answer & Failed/Incorrect Answer explanation & tally.
		"A-#" is a Definition contained in ProFormDefs.
		"A-#|#" is a unique identifier of "A-#|Chapter" used in ProDefOptions for answer options.
		There is MUST BE ONLY ONE A-# Def, and ONE F-# Def!
	TIP:	For ItemName = "A-#": contains Correct Answer
			For ControlType = Video: contains video HREF Path
	When a Chapter is Completed, ProProcess step is updated, and user no longer has access to 
		those pages.		
*/	
	
	function createForm() {
		var bPageFound = false;
		
		for (var i=0; i<vm.arrDefs.length; i++) {
			var curSec = vm.sCurPage.substr(0,1);
			var curPg = Number(vm.sCurPage.slice(2));
			var sSec = vm.arrDefs[i].ITEMNAME.substr(0,1);
			if (vm.arrDefs[i].ITEMNAME.indexOf("|")<0) {
				var iPg = Number(vm.arrDefs[i].ITEMNAME.slice(2));
			} else {
				var idx = vm.arrDefs[i].ITEMNAME.indexOf("|");
				iPg = vm.arrDefs[i].ITEMNAME.substring(2,idx);
			}
			
			if (vm.arrDefs[i].GROUPSEQ == vm.iCurChapter && 
				curSec == sSec && curPg == iPg) {
				bPageFound = true;	
				if (vm.arrDefs[i].GROUPSEQ == 0) {
					vm.header = "Introduction";
					vm.subheader = vm.arrDefs[i].GROUPNAME;
				} else if (vm.arrDefs[i].GROUPNAME == "Training Results") {
					vm.header = vm.arrDefs[i].GROUPNAME;
				} else {
					vm.header = "Chapter " + vm.arrDefs[i].GROUPSEQ;
					vm.subheader = vm.arrDefs[i].GROUPNAME;
				}
				
				var obj = {HTML:"", id:vm.arrDefs[i].ITEMID, label:"",
					control:vm.arrDefs[i].CONTROLTYPE, curPage:vm.arrDefs[i].ITEMNAME, 
					opt0:"",opt1:"",opt2:"",opt3:"",opt4:"", opt5:"",
					saveKey:0, data:"", answer:"", response:"", tries:0, maxTries:0};
				
				switch (vm.arrDefs[i].CONTROLTYPE) {
					case "htmlText":
						if (vm.sCurPage.substr(0,1)=="F") {
							obj.control = "FailText";
							obj.label = vm.arrDefs[i].CAPTION;
						} else {
							obj.HTML = $sce.trustAsHtml(vm.arrDefs[i].CAPTION);
						}	
					break;
					case "Label-bold": //Questions ONLY... otherwise use htmlText!
						obj.label = vm.arrDefs[i].CAPTION;
					break;
					case "Radio-sub":
						if (vm.arrDefs[i].CAPTION == "True|False") {
							obj.opt0 = "True"; obj.opt1 = "False";
							obj.control = "RadioTF";
							obj.maxTries = 2;
						} else if (vm.arrDefs[i].CAPTION == "Yes|No") {
							obj.opt0 = "Yes"; obj.opt1 = "No";
							obj.control = "RadioYN";
							obj.maxTries = 2;
						} else {
							var arrOpts = [];
							if (vm.arrDefs[i].CAPTION == "") {
								//options come from ProDefOptions:
								for (var m=0; m<vm.arrDefOpts.length; m++) {
									if (vm.arrDefOpts[m].ITEMNAME == vm.arrDefs[i].ITEMNAME) {
										arrOpts.push(vm.arrDefOpts[m]);
									}
								}
							} else {	
								var opts = vm.arrDefs[i].CAPTION;
								arrOpts = opts.split("|");
							}
							for (m=0; m<arrOpts.length; m++) {
								switch (m) {
									case 0: obj.opt0 = arrOpts[0]; break;
									case 1: obj.opt1 = arrOpts[1]; break;
									case 2: obj.opt2 = arrOpts[2]; break;
									case 3: obj.opt3 = arrOpts[3]; break;
									case 4: obj.opt4 = arrOpts[4]; break;
									case 5: obj.opt5 = arrOpts[5]; break;
								}
							}
							obj.maxTries = arrOpts.length;
						}
						switch (vm.arrDefs[i].TIP) {
							case true: 
								if (obj.control == "RadioTF") { obj.answer = "True"; }
								else { obj.answer = "Yes"; }
							break;
							case false:
								if (obj.control == "RadioTF") { obj.answer = "False"; }
								else { obj.answer = "No"; }
							break;
							default: obj.answer = vm.arrDefs[i].TIP; break;
						}
					break;
					case "SectionHdr": //only 1 allowed per page
						vm.sectionHdr = vm.arrDefs[i].CAPTION;
					break;
					case "Video":
						vm.videoPath = $sce.trustAsResourceUrl(vm.arrDefs[i].TIP);
						vm.sectionHdr = vm.arrDefs[i].CAPTION;
					break;
				}
				vm.arrDataFields.push(obj);
			
				//Question MUST ALWAYS be followed by Answer, and Failure Response Defs!
				switch (curSec) {
					case "Q":
						//Check if OTHER Q-# defs. If not... load Answer:
						for (var d=(i+1); d<vm.arrDefs.length; d++) {
							sSec = vm.arrDefs[d].ITEMNAME.substr(0,1);
							if (vm.arrDefs[d].ITEMNAME.indexOf("|")<0) {
								iPg = Number(vm.arrDefs[d].ITEMNAME.slice(2));
							} else {
								idx = vm.arrDefs[d].ITEMNAME.indexOf("|");
								iPg = vm.arrDefs[d].ITEMNAME.substring(2,idx);
							}
							if (vm.arrDefs[d].GROUPSEQ == vm.iCurChapter && curSec == sSec && curPg == iPg) {
							break; }
							else if (d == vm.arrDefs.length-1) {
								vm.bQuestion = true;
								vm.sCurPage = "A-"+String(curPg);
							}
						}
					break;
					case "A":
						//Check if question already answered:
						if (vm.arrData.length > 0) {
							for (d=0; d<vm.arrData.length; d++) {
								if (vm.arrData[d].ITEMID == vm.arrDefs[i].ITEMID) {
									vm.sCurPage = "Q-"+String(Number(curPg)+1);
									vm.arrDataFields = [];
									bPageFound = false;
									i = -1;
								break; }
								else if (d == vm.arrData.length-1) {
									vm.sCurPage = "F-"+String(curPg);
								}
							}
						} else {
							vm.sCurPage = "F-"+String(curPg);
						}
					break;
					case "F":
						i = vm.arrDefs.length-1;
					break;
				}
			} else if (i == vm.arrDefs.length-1 && bPageFound==false) { //$log.info("Page",vm.sCurPage,"not found")
				if (vm.sCurPage.substr(0,1) == "C") {
					for (var j=0; j<vm.arrDefs.length; j++) {
						//No more content, So load Questions:
						if (vm.arrDefs[j].GROUPSEQ == vm.iCurChapter &&
							vm.arrDefs[j].ITEMNAME == "Q-1") {
							vm.sCurPage = "Q-1";
							i = -1;	
						break; }					
						else if (vm.arrDefs[j].GROUPSEQ == Number(vm.iCurChapter+1) &&
							vm.arrDefs[j].ITEMNAME == "C-1") {
							//NO Questions for Current Chapter, so move to NEXT Chapter of Content:
							if (vm.iCurChapter > 0) {
								var sProgress = String(vm.iCurChapter) + " of " + 
									String(vm.iLastChapter) + " chapters completed";
								updateTrainingStep(sProgress);
							} else {
								vm.iCurChapter++; 
								vm.sCurPage = "C-1";
								i = -1;
							}	
						break; }
					}
				} else {
					if (vm.iCurChapter == vm.iLastChapter) {
						vm.sCurPage = "Score";
						loadResults();
					} else {
						sProgress = String(vm.iCurChapter) + " of " + 
							String(vm.iLastChapter) + " chapters completed";
						updateTrainingStep(sProgress);
					}	
				}	
			}
		}
	}	
	
	function updateTrainingStep(sProgress) {
		var sRawDataString = "WebApps_Pro || Training || " + loginService.user.USERID +
			" || U || SaveKey==" + vm.iStepSaveKey + " || ProID==" + 
			$rootScope.sProID + " || StepID==" + $stateParams.objStep.STEPID; 
		if (sProgress == "8 of 8 chapters completed") { 
			sRawDataString += " || StepDate==" + datesService.todayToDbString() + 
				" || StepLink==1 || StepProgress==Completed"; }
		else { sRawDataString += " || StepProgress==" + sProgress; }
		sRawDataString += " ^^ ";
		
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if (result[0].RESULTCODE == "Success") {
				if (vm.sCurPage !="Score") {
					vm.iCurChapter++;
					vm.sCurPage = "C-1";
					createForm();
				}	
			} else {
				var sEmailContent = errorEmailNotification.error4("trainingCtrl/updateTrainingStep");
				dataService.emailSendError(sEmailContent);
			}
		});
	}		

	function saveData() {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].curPage.substr(0,1) == "A") {
				var sRawDataString = "WebApps_Pro || Training || " + loginService.user.USERID +
					" || I || ProID==" + $rootScope.sProID + " || ItemID==" + vm.arrDataFields[i].id +
					" || ItemData==" + vm.arrDataFields[i].data + " ^^ ";
				if (vm.arrDataFields[i].tries > 1) {
					var tries = vm.arrDataFields[i].tries;
					if (vm.arrDataFields[i].maxTries < tries) { tries = vm.arrDataFields[i].maxTries; }
					sRawDataString += "I || ProID==" + $rootScope.sProID + " || ItemID==" + 
						vm.arrDataFields[i+1].id + " || ItemData==" + tries + " ^^ ";
				}
			break; }
		}
		
		dataService.proSaveFormData(sRawDataString)
		.then(function (results) {
			if (results.length > 0) {
				vm.bQuestion = false;
			}
		});
	}
	
	function loadResults() {
		//load updated data:
		dataService.proGetFormData("Training")
		.then(function(data) {
			if (data.length > 0) {
				vm.arrData = data;
				calculateScore();
			}
		});
	}
	
	function calculateScore() {
		var bReset = false;
		for (var i=0; i<vm.arrDefs.length; i++) {
			if (bReset == false) {
				switch (vm.arrDefs[i].ITEMNAME.substr(0,1)) {
					case "A":
						for (var j=0; j<vm.arrData.length; j++) {
							if (vm.arrData[j].ITEMID == vm.arrDefs[i].ITEMID) {
								vm.Qs++;	
							break; }
							else if (j == vm.arrData.length-1) {
								bReset = true;
								resetCalc();
								vm.bGoToScore = true;
								if (vm.arrDefs[i].ITEMNAME.indexOf("|")<0) {
									var pg = Number(vm.arrDefs[i].ITEMNAME.slice(2));
								} else {
									var idx = vm.arrDefs[i].ITEMNAME.indexOf("|");
									pg = vm.arrDefs[i].ITEMNAME.substring(2,idx);
								}
								modalService.okAlert("Oops!",
									"We seem to have lost the answer to Chapter " +
									String(vm.arrDefs[i].GROUPSEQ) + ", Question " + pg + 
									". You will be returned to that page to complete that question again.")
								vm.iCurChapter = vm.arrDefs[i].GROUPSEQ;
								vm.sCurPage = "Q-" + String(pg);
								createForm();
							}
						}
					break;
					case "F":
						for (j=0; j<vm.arrData.length; j++) {
							if (vm.arrData[j].ITEMID == vm.arrDefs[i].ITEMID) {
								switch (vm.arrData[j].ITEMDATA) {
									case 2: vm.Tries2++; break;
									case 3: vm.Tries3++; break;
									case 4: vm.Tries4++; break;
									case 5: vm.Tries5++; break;
								}
							break; }
							else if (j == vm.arrData.length-1) {
								vm.Correct++;
							}
						}
					break;	
				}
				if (i==vm.arrDefs.length-1) {
					//display Results:
					vm.sectionHdr = vm.arrDefs[i].CAPTION;
					vm.sCurPage = "Score";
					vm.Score = Number(vm.Correct/vm.Qs)*100;
					updateTrainingStep("8 of 8 chapters completed");
				}
			}
		}
	}
	
	function resetCalc() {
		vm.Qs = 0;
		vm.Correct = 0;
		vm.Tries2 = 0;
		vm.Tries3 = 0;
		vm.Tries4 = 0;
	}
	
/* Broadcasts: */

/* Calls from View: */
	vm.answerHandler = function(id) {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].id == id) {
				//Tally attempts:
				vm.arrDataFields[i].tries++;
				//Register FIRST response to save as "data"
				if (vm.arrDataFields[i].data == "") { 
					vm.arrDataFields[i].data = vm.arrDataFields[i].response;
				}
				if (vm.arrDataFields[i].response == vm.arrDataFields[i].answer) {
					vm.bIncorrect = false;
					vm.bCorrect = true;
					saveData();
				} else {
					vm.bIncorrect = true;
				}
			break; }
		}
	}
	
	vm.goBack = function() {
		switch (vm.sCurPage.substr(0,1)) { 
			case "C":
				var pg = Number(vm.sCurPage.slice(2));
				vm.sCurPage = "C-"+String(pg-1);
			break;
		}
		vm.sectionHdr = "";
		vm.arrDataFields = [];
		createForm();
	};
	
	vm.goNext = function() {
		if (vm.bGoToScore == true) {
			vm.sectionHdr = "";
			vm.arrDataFields = [];
			vm.bCorrect = false;	//reset "That is correct!
			vm.bIncorrect = false;	//reset "That is the wrong answer!
// 			vm.bQuestion = true;	//hides the "Next" button
			vm.iCurChapter = vm.iLastChapter;
			loadResults();
		} else {
			switch (vm.sCurPage.substr(0,1)) { 
				case "C":
					var pg = Number(vm.sCurPage.slice(2));
					vm.sCurPage = "C-"+String(pg+1);
					vm.sectionHdr = "";
					vm.arrDataFields = [];
					createForm();
				break;
				case "Q": case "A": case "F": //should always be "F"...
					vm.bCorrect = false;
					pg = Number(vm.sCurPage.slice(2));
					vm.sCurPage = "Q-"+String(pg+1);
					vm.sectionHdr = "";
					vm.arrDataFields = [];
					createForm();
				break;
			}	
		}
	};
	
	vm.tryAgain = function() {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			vm.arrDataFields[i].response = "";
		}
		vm.bIncorrect = false;
	}
}
angular		
	.module('proRefs')
	.controller('StepsController', StepsController);

StepsController.$inject = ['$rootScope','loginService','dataService','$state','errorEmailNotification',
	'$sce','webSessionStorage','datesService','vancoService','payPalService','$window',
	'moodleService','$uibModal','$scope','butmanCampEmail','cetaCampEmail','vimEmail','timeOutService',
	'$log'];
	
function StepsController($rootScope, loginService, dataService, $state, errorEmailNotification,
	$sce, webSessionStorage, datesService, vancoService, payPalService, $window, 
	moodleService, $uibModal, $scope, butmanCampEmail, cetaCampEmail, vimEmail, timeOutService,
	$log) {
	var vm = this; 	//vmSC

	vm.arrSteps = [];
	vm.authStepID = 0;
	vm.bPayFee = false;
	vm.certRecord = $rootScope.curCertRecord;
	vm.completed = { image: "assets/images/accept32.png" };
	vm.genRefSaveKey = 0;
	vm.iCertTypeID = 0;
	vm.modalInstance;
	vm.paymentProgress = "";
	vm.paymentStepID = 0;
	vm.paymentSaveKey = "";
	vm.refresh = { image: "assets/images/refresh_22.png" };
	vm.sAppExpire = "";
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.selStep = {};
	vm.sFirstName = "";		// stored for Vanco RcvPaymentTransData name
	vm.sLastName = "";		// stored for Vanco RcvPaymentTransData name
	vm.sStepsDone = "";
	vm.trainProgress = "";
	vm.trainSaveKey = 0;
	vm.trainStepID = 0;

/* MO Only: */	
	vm.bEnrollUser = false;
	vm.LCPolicyStepID = 0;
	vm.covenantStepID = 0;
	vm.pastorRefSaveKey = 0;
	vm.msDateFirstAccess = 0;
	
/* MC Only: */
	vm.Youth = false;
		

//INITIALIZE:
	$rootScope.sCurForm = "Process Steps";
$log.info("Steps");
	
	if (vm.sDatabaseID == "MO" || vm.sDatabaseID == "MO-DEV" || vm.sDatabaseID == "VID") {
		dataService.peoGetDetails(loginService.user.USERENTITYID)
		.then(function(peoData) { //$log.info("peoData:",peoData)
			vm.sFirstName = peoData[0].FIRSTNAME;
			loginService.user.firstName = vm.sFirstName;
			vm.sLastName = peoData[0].LASTNAME;
			loginService.user.lastName = vm.sLastName;
		});	
	}
	getProcessRecordPub();

	function getProcessRecordPub() { //$log.info('ProID:',$rootScope.sProID, $rootScope.curCertRecord);
		dataService.proGetProcessRecordPub($rootScope.sProID)
		.then(function(data) {  // $log.info("proGetProcessRecordPub:",data)
			if (data.length > 0) {
				vm.iCertTypeID = data[0].CERTTYPEID;
				for (var i=0; i<data.length; i++) {
					switch (data[i].STEPLINKFLAG) {
						case "Application": break;
						case "PayFee": 						//MO, MC
						case "CampFees": case "VIMFees":	//NWTX
							vm.paymentStepID = data[i].STEPID;
							vm.paymentSaveKey = data[i].SAVEKEY;
							vm.paymentProgress = data[i].STEPPROGRESS;
						break;
						case "Authorization":
							vm.authStepID = data[i].STEPID;
							if (data[i].STEPPROGRESS == "Not Applicable") {
								vm.Youth = true;
								data[i].hideBtn = "true";
								data[i].STEPDESCPUB = "<b>Youth under 19 years of age are not required " +
									"to complete this step.<br>If you were required to provide your " +
									"Social Security Number, you may return here on your 19th birthday " +
									"to authorize the background screen for continued certification.</b>"
							}
						break;
						case "Covenant":
							vm.covenantStepID = data[i].STEPID;
						break;
						case "LCPolicy":
							vm.LCPolicyStepID = data[i].STEPID;
						break;
						case "Training":
							vm.trainStepID = data[i].STEPID;
							vm.trainSaveKey = data[i].SAVEKEY;
							vm.trainProgress = data[i].STEPPROGRESS;
						break;
						case "NWTXTraining":
							vm.trainStepID = data[i].STEPID;
							if (data[i].STEPPROGRESS == "Training Request Sent") {
								data[i].hideBtn = "true";
							}	
						break; 
						case "PastorRef": case "ClergyProfRef": case "DSRef": 	//MO PR Refs
						case "GeneralRef": case "ClergyGenRef":					//MO Name Refs
						case "ProfRef1": case "ProfRef2": case "PersonalRef":	//NWTX Name Refs
						case "ProfRef": //case "GeneralRef"						//MC Name Refs
							if (data[i].CREATEDON != "") {
								var sSent = datesService.jsDateStrToCalendarStr(data[i].CREATEDON);
								data[i].sCreatedOn = sSent;
							}	
						break;
					}
					if (data[i].STEPDESCPUB != "") {
						data[i].HtmlStepDesc = $sce.trustAsHtml(data[i].STEPDESCPUB);
					}
					
				/* Set Step button text: */	
					if (data[i].STEPPROGRESS == "") {
						data[i].btnLabel = "Begin Step";
					} else if (data[i].sCreatedOn != undefined) {
						data[i].btnLabel = "Resend";
						data[i].toolTip = "Resend this Reference to the same person as a Reminder, " +
							"or to a New Person, or new Email address, if needed.";
					} else { data[i].btnLabel = "Continue"; }
					
				/* Check PreRequisites for hiding Step button: */	
					//var preReq = data[i].STEPPREREQPUB; 	//ex. "+1*2*"
					if (angular.isDefined(data[i].STEPPREREQPUB)==true) {
						var subPreReq = data[i].STEPPREREQPUB.slice(1);		//ex. 1
						var arrPreReq = subPreReq.split("*");
						if (arrPreReq.length > 0) {
							for (var j=0; j<arrPreReq.length; j++) {
								if (arrPreReq[j] != "") {
									for (var k=0; k<data.length; k++) {
										if (data[k].STEPSEQPUB == arrPreReq[j] &&
											data[k].STEPPROGRESS != "Completed") {
											data[i].STEPPROGRESS = data[i].STEPDESCPUBUN;
											data[i].hideBtn = "true";
										break; }
									}
								}
							}
						}
					}	
				}
				vm.arrSteps = data;
			}
			
		/* custom initialized data: */
			switch (vm.sDatabaseID) { 
				case "MO": case "MO-DEV":
					if (vm.iCertTypeID == 4) {
						if (data[0].STEPEXPIRES != null) {
							vm.sAppExpire = datesService.jsDateStrToCalendarStr(data[0].STEPEXPIRES);
						} else { vm.sAppExpire = "[Exp. Date not set]"; }
						
						//Update the Progress of the Training Step upon load of Steps:
// $log.info('StepData:', data);
						for (i=0; i<data.length; i++) {
							if (data[i].STEPLINKFLAG == "Training" && data[i].STEPDATE == "") {
								if (data[i].STEPREFID != "") {
									moodleService.moodle.id = data[i].STEPREFID;
// 									var objTraining = data[i];
									var sCreated = datesService.jsDateStrToDbDateStr(data[i].CREATEDON);
									if (sCreated < "2018-12-07") {
										var iCourseID = 2; }
									else { iCourseID = 25; }									
									moodleService.getCurrentStatus(moodleService.moodle.id, iCourseID)
									.then(function(status) { 
// $log.info('(173)GetCurrentStatus:', status, 'vm.trainProgress:', vm.trainProgress, new Date());
										
										if (vm.trainProgress != status ||
											status == "8 of 8 chapters completed") {
											vm.trainProgress = status;
											updateTrainingStep(status);
										}
									});
								}
// 								else { $log.info("Not yet Enrolled in Training"); }
							break; }
						}
						
						/** Debug... v...182 
						  *	Update Vanco Payment if paid but ProProcess StepID=402 NOT updated.
						  * Completes Payment StepID=402 and adds TransactionRef to the StepRefID.
						  **/
						for (i=0; i<data.length; i++) {
							if (data[i].STEPLINKFLAG == "PayFee" && data[i].STEPPROGRESS == 
								"Started, Update Pending") { 
								dataService.rcvGetValidate($rootScope.sProID)
								.then(function(rcvVal) {
									if (rcvVal.length > 0) {
										if (rcvVal[0].VALRESULT == "Success" && rcvVal[0].RCVID > 0) {
											dataService.proPayProcessUpdate(rcvVal[0].RCVID)
											.then(function(payResult) {
												if (payResult[0].RESULTCODE == 'Success') {
													$state.reload();
												}	
											});
										}
									}
								});
							break; }	
						}
							
					}	// else //certType=5, LCA
				break;
				//case "MC": case "MC-DEV":
					//initialized in MCWebApps, directly from Login page.
				//break;
				case "NWTX": case "NWTX-DEV":
					if (vm.iCertTypeID == 4) {
						if (data[0].STEPEXPIRES != null) { //used ONLY on Application... so import
							vm.sAppExpire = datesService.jsDateStrToCalendarStr(data[0].STEPEXPIRES);
						}
						vm.sAppExpire = "Noon, on the Wednesday before the first Camp you wish to attend.";
					} else {
						vm.sAppExpire = "30 days prior to the VIM trip date.";
					}
				break;
			}
		});
	}	
	
	
	//DEV databases get Payment Step automatically checked off
	//MO & MC Only. [NWTX on Custom payment form]
	function savePaymentProcessStep() {
		var sRawProProcess = "WebProtect || stepsCtrl || " + loginService.user.USERID;
			if (vm.paymentSaveKey == "") { sRawProProcess += " || I"; }
			else { sRawProProcess += " || U || SaveKey==" + vm.paymentSaveKey; }
		sRawProProcess += " || ProID==" + $rootScope.sProID + " || StepID==" +
			vm.paymentStepID + " || StepDate==";
			
		if (vm.sDatabaseID.slice(-3) == "DEV" && $rootScope.AUTOPAY == true) {
			sRawProProcess += datesService.todayToDbString() + " || StepProgress==Completed ^^ ";
		} else {
			sRawProProcess += " || StepProgress==Started, Update Pending ^^ ";
		}	

		dataService.proSaveProcess(sRawProProcess)
		.then(function(retProcess) {
			if (retProcess[0].RESULTCODE == "Success") {
				var reason = retProcess[0].RESULTREASON;
				var j = reason.indexOf("SaveKey");
				if (j > -1) {
					vm.paymentSaveKey = reason.slice(j+8);
				} 
				else if (vm.sDatabaseID.slice(-3)=="DEV" && $rootScope.AUTOPAY == true) { 
					$state.reload(); 
				}
			}
		});		
	}
	
	/* v.166 added iCourseID for Moodle_CourseStatus call. */
	function updateTrainingStep(sProgress) {
		var bSendError = false;		
		if (angular.isDefined(loginService.user.USERID) == true) {
			var sRawDataString = "WebProtect || stepsCtrl_183 || " + loginService.user.USERID;
		} else {
			sRawDataString = "WebProtect || saveTraining_183 || -77";
			bSendError = true;
		}
		
		if (vm.trainSaveKey == 0) { sRawDataString += " || I"; }
		else { sRawDataString += " || U || SaveKey==" + vm.trainSaveKey; }
		sRawDataString += " || ProID==" + $rootScope.sProID + " || StepID==" + vm.trainStepID; 
		if (sProgress == "8 of 8 chapters completed") { 
			sRawDataString += " || StepDate==" + datesService.todayToDbString() + 
				" || StepLink== || StepProgress==Completed"; }
		else { sRawDataString += " || StepLink==1 || StepProgress==" + sProgress; }
		switch (vm.sDatabaseID) {
			case "MO": case "MO-DEV":
				if (angular.isDefined(moodleService.moodle.id)==true) {
					sRawDataString += " || StepRefID==" + moodleService.moodle.id + " ^^ ";
				} else { sRawDataString += " ^^ ";}	
			break;
			default:
				sRawDataString += " || StepRefID== ^^ ";
			break;	
		}
// $log.info('updateTrainingStep:', sRawDataString);	
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) { 
// $log.info("updateTrainingStep_result:",result)
			if (result[0].RESULTCODE != "Success") {
				var prevRecord = "version ...183<br>" +
					"trainSaveKey: "+ vm.trainSaveKey + "<br>sRawDataString: " +
					sRawDataString;
				var sEmailContent = errorEmailNotification.error4("stepsCtrl/updateTrainingStep");
				sEmailContent += "<br><br>" + result[0].RESULTREASON + "<br>"+ prevRecord;
				dataService.emailSendError(sEmailContent);
			} else if (bSendError) {
				prevRecord = "version.146<br>" +
					"trainSaveKey: "+ vm.trainSaveKey + "<br>sRawDataString: " +
					sRawDataString;
				sEmailContent = errorEmailNotification.error4("stepsCtrl/updateTrainingStep");
				sEmailContent += "<br><br>" + result[0].RESULTREASON + "<br>"+ prevRecord;
				sEmailContent += "<br><br>" + "version 146 debug...  thinking user returnCode is timed out " +
					"or some other way of losing USERID, thus errors on save. I replaced with -77 USERID " +
					"and send user to login again. Check time required to transfer to eThink, as seems to " +
					"be related.";
				dataService.emailSendError(sEmailContent);
			}	 
			
			if (vm.trainSaveKey == 0) {
				var idx = result[0].RESULTREASON.indexOf("SaveKey=");
				vm.selStep.SAVEKEY = result[0].RESULTREASON.slice(idx+8);
				vm.trainSaveKey = result[0].RESULTREASON.slice(idx+8);
				vm.trainProgress = "0 of 8 chapters completed";
			//both MO & MC: (add switch if others in future...)
				vm.trainStepID = 404;
			}

			switch (vm.sDatabaseID) {
				case "MC": case "MC-DEV":
					$state.go('train', {objStep: vm.selStep});
				break;
				case "MO": case "MO-DEV":
					$state.reload();	
				break;
			}
		});
	}	
						
	function updateTrainingStepNWTX() {
	// Update the Step for NWTX:
		for (var i=0; i<vm.arrSteps.length; i++) {	
			if (vm.arrSteps[i].STEPLINKFLAG == "NWTXTraining") {
				var sRawDataString = "WebProtect || stepsCtrl || " + loginService.user.USERID + " || ";
				if (vm.arrSteps[i].SAVEKEY == "") {
					sRawDataString += "I"; }
				else { sRawDataString += "U || SaveKey==" + vm.arrSteps[i].SAVEKEY; }
				sRawDataString += " || ProID==" + $rootScope.sProID + " || StepID==" + 
					vm.trainStepID + " || StepDate== || StepExpires== || StepNote==Training Request Sent " +
					datesService.todayToCalString() + " || StepLinkType==" +
					" || StepLink== || StepProgress==Training Request Sent || StepRefID== ^^ ";
			
				dataService.proSaveProcess(sRawDataString) 
				.then(function(result) {
					if (result[0].RESULTCODE != "Success") {
						var sEmailContent = errorEmailNotification.error4("stepsCtrl/updateTrainingStepNWTX");
						sEmailContent += "<br><br>" + result[0].RESULTREASON;
						dataService.emailSendError(sEmailContent);
					} else { $state.reload(); }	
				});
			}
		}	
	}
	
	
/* Broadcasts: */

	$scope.$on('closeModal', function() {
		vm.modalInstance.close();
	});

	
/* Called from view: */		
	
	vm.goToStep = function(sStepLinkFlag) {
		timeOutService.resetTimer(30);
		for (var i=0; i<vm.arrSteps.length; i++) {
			if (vm.arrSteps[i].STEPLINKFLAG == sStepLinkFlag) {
				vm.selStep = vm.arrSteps[i];
			break; }
		}
		
		switch (sStepLinkFlag) { 
			case "Application": case "Application5":
				$state.go('application', {
					sStepLinkFlag: sStepLinkFlag,
					iApplSaveKey: vm.selStep.SAVEKEY,
					iApplStepID: vm.selStep.STEPID,
					iAuthStepID: vm.authStepID
				}); 
			break;
			case "ConfCert":
				var cert = $rootScope.certInProcess;
				if (cert.CHURCHID != "") {
					loginService.user.CHURCHID = cert.CHURCHID;
				}
				$rootScope.sProID = cert.PROID;
				$rootScope.curCertRecord = cert;
				$state.reload();
			break;
			case "Covenant": //Step 2 in LCA Process (MO)
				$state.go('lcaCovenant', {iStepID: vm.covenantStepID}, {reload:true});
			break;
			case "PayFee":
				if (vm.bPayFee == false) { //double-click handler
					vm.bPayFee = true;
					switch (vm.sDatabaseID) {
						case "MO": case "MO-DEV": case "VID": //Vanco
							//Call again to ensure not already paid by LCA in MC:LocalChurch w/applicant view
							//open... v.145 ~ lds
							dataService.proGetProcessRecordPub($rootScope.sProID)
							.then(function(data) {
								for (var i=0; i<data.length; i++) {
									if (data[i].STEPLINKFLAG == "PayFee") {
										if (data[i].STEPPROGRESS == "Completed") {
											$state.reload();
										} else {
/*v175: Due to 2 concurrent calls... sometimes trying to go to VancoPay before ProProcess save is completed.
	Make into subsequent calls: */			//savePaymentProcessStep();
											var sRawProProcess = "WebProtect || stepsCtrl_v175 || " + 
												loginService.user.USERID;
											if (vm.paymentSaveKey == "") { sRawProProcess += " || I"; }
											else { sRawProProcess += " || U || SaveKey==" + vm.paymentSaveKey; }
											sRawProProcess += " || ProID==" + $rootScope.sProID + " || StepID==" +
												vm.paymentStepID + " || StepDate==";
			
											if (vm.sDatabaseID.slice(-3) == "DEV" && $rootScope.AUTOPAY == true) {
												sRawProProcess += datesService.todayToDbString() + 
													" || StepProgress==Completed ^^ ";
											} else {
												sRawProProcess += " || StepProgress==Started, Update Pending ^^ ";
											}	

											dataService.proSaveProcess(sRawProProcess)
											.then(function(retProcess) {
												if (retProcess[0].RESULTCODE == "Success") {
													if (vm.sDatabaseID.slice(-3)=="DEV" && 
														$rootScope.AUTOPAY == true) { 
														$state.reload(); 
													} else {
													//v175: vanco Call ONLY AFTER Successful ProProcessSave:
														vancoService.goToVancoPayments(vm.sLastName, 
															vm.sFirstName);
													}		
												} else {
													var sEmailContent = "WebProtect/stepsCtrl_v175 - " +
														"vm.goToStep(PayFee)<br><br>Error in saving the " +
														"Payment ProProcess record. User unable to go to " +
														"VancoPay until ProProcess record saved successfully. "
														"<br><br>Error: " + retProcess[0].RESULTREASON;
													dataService.emailSendError(sEmailContent);
												}
											});												
										}
									break; }
								}
							});
						break;
						case "MC": case "MC-DEV":
							if (vm.paymentProgress != "") {
								dataService.proGetProcessRecordPub($rootScope.sProID)
								.then(function(data) {
									for (var i=0; i<data.length; i++) {
										if (data[i].STEPLINKFLAG == "PayFee") {
											if (data[i].STEPPROGRESS == "Completed") {
												$state.reload();
											} else {
												savePaymentProcessStep();
												if (vm.Youth == false) {
													payPalService.goToPayPal("ProBkgrdScreenFee",4);
												} else { payPalService.goToPayPal("ProCertFeeYouth",4); }
											}
										break; }
									}
								});	
							} else {
								savePaymentProcessStep();
								if (vm.Youth == false) {
									payPalService.goToPayPal("ProBkgrdScreenFee",4);
								} else { payPalService.goToPayPal("ProCertFeeYouth",4); }
							}	
						break;
					}
				}	
			break;
			case "CampFees":
			//.132: 5/16/18 for missing vm.paymentStepID on payment Save... add again! ~ lds
			//.133: 5/17/18 added debug Email, and hardcoded paymentStepID. ~ lds
				if (vm.paymentStepID == 0) {
					vm.paymentStepID = vm.selStep.STEPID;
					vm.paymentSaveKey = vm.selStep.SAVEKEY;
					var sEmailContent = errorEmailNotification.error5("stepsCtrl(goToStep:CampFees)",
						"PaymentStepID was 0.<br>" +
						"Did vm.arrSteps populate? ... length:" + String(vm.arrSteps.length) + "<br>" +
						"vm.selStep.STEPID = " + vm.selStep.STEPID + "<br>" +
						"vm.selStep.SAVEKEY = " + vm.selStep.SAVEKEY + "<br>" +
						"vm.selStep.CREATEDON = " + vm.selStep.CREATEDON + "<br>" +
						"vm.selStep.LASTUPDATED = " + vm.selStep.LASTUPDATED + "<br>" +
						"vm.selStep.STEPPROGRESS = " + vm.selStep.STEPPROGRESS);
					dataService.emailSendError(sEmailContent);
				}
				
				if (vm.paymentProgress == "Started, Update Pending") {
					//Call again to ensure not already paid thru PayPal... v.136
					dataService.proGetProcessRecordPub($rootScope.sProID)
					.then(function(data) {
						for (var i=0; i<data.length; i++) {
							if (data[i].STEPLINKFLAG == "CampFees") {
								if (data[i].STEPPROGRESS == "Completed") {
									$state.reload();
								} else {
									//hardcoded: vm.paymentStepID until bug fixed. 5/17/18 ~ lds
									$state.go('nwtxPayment', {
										iCertTypeID: 4,
										paymentSaveKey: vm.paymentSaveKey,
										paymentStepID: 402
									}, {reload:true});
								}
							break; }
						}
					});	
				} else {
					//hardcoded: vm.paymentStepID until bug fixed. 5/17/18 ~ lds
					$state.go('nwtxPayment', {
						iCertTypeID: 4,
						paymentSaveKey: vm.paymentSaveKey,
						paymentStepID: 402
					}, {reload:true});
				}
			break;
			case "VIMFees":
				$state.go('nwtxPayment', {
					iCertTypeID: 5,
					paymentSaveKey: vm.paymentSaveKey,
					paymentStepID: vm.paymentStepID
				}, {reload:true});
			break;
			case "Authorization":
				$state.go('authorization', {
					iAuthStepID: vm.authStepID,
					iBkgrdStepID: vm.bsResultsStepID
				}, {reload:true});
			break;
			case "LCPolicy":
				$state.go('lcPolicy', {iStepID: vm.LCPolicyStepID});
			break;
			case "Training":
				dataService.secGetReturnCode(120, "Training", loginService.user.USERID + "|" +
					loginService.user.USERFULLNAME)
				.then(function(result) {
					switch (vm.sDatabaseID) {
						case "MC": case "MC-DEV":
							if (vm.selStep.STEPPROGRESS == "") {
								updateTrainingStep("0 of 8 chapters completed");
							} else {
								$state.go('train', {objStep: vm.selStep});
							}
						break;
						case "MO": case "MO-DEV": case "VID":
							var sMoodleReturnCode = result[0].RETURNCODE;
// $log.info("sMoodleReturnCode:",sMoodleReturnCode);
							var mProID = $rootScope.sProID.toLowerCase(); 
/* 05/23/18 - Took user to an edit Account page rather than course due to missing First/Last names on 
	account. Required login to Moodle to edit account record. ~ lds */

							/** If vm.sFirstName has a space, it does not return response in CFC... so
							  *	  remove any spaces... sending single name only!
							  *	  - 4/2/19 lds ver...180
							  * Changed to a RegExp and applied to First AND Last Names - 6/19/19 lds ver...189
							  *	**/
							var lettersOnlyPattern = /[^A-Za-z]/g;
							var eFirstName = vm.sFirstName.replace(lettersOnlyPattern, '');
							var eLastName = vm.sLastName.replace(lettersOnlyPattern, '');
// $log.info("getUser:", mProID, eFirstName, eLastName, loginService.user.USEREMAIL);
// $log.info("moodle_GetUser_call:", new Date());
							moodleService.getUser(mProID, eFirstName, eLastName, 
								loginService.user.USEREMAIL)
							.then(function(mUser) {  
// $log.info("(568)moodleGetUser_results:", mUser);
// $log.info("moodle_GetUser_results:", new Date());
								if (angular.isDefined(mUser.users)==true) { 
									/* result: users[0]: { id:#####, username:p######, firstname:"Jane",
										lastname:"Doe", firstaccess:0, lastaccess:0, ...
									If firstaccess==0, then have not Enrolled or entered eThink yet.  */
									
									//vm.msDateFirstAccess = Number(mUser.users[0].firstaccess)*1000; 
// $log.info("Dt:",vm.msDateFirstAccess,vm.selStep)
									moodleService.moodle.id = mUser.users[0].id;
									if (mUser.users[0].firstaccess == 0 || vm.trainProgress == "" ||
										vm.selStep.STEPREFID == "") {
										vm.bEnrollUser = true;
										var progress = "0 of 8 chapters completed";
										updateTrainingStep(progress);	
									}
								} else { //registered username, received id:
										//result: [0]:{id:#####, username:"p######"}	
									vm.bEnrollUser = true;
									progress = "0 of 8 chapters completed";
									updateTrainingStep(progress);
								}
									
								//Enroll NEW User:
								if (vm.bEnrollUser || vm.selStep.STEPREFID == "") {  
// $log.info('Enroll User...', new Date());
									// iCourseID = 25; NEW Course
									moodleService.enrollUser(sMoodleReturnCode, mProID)
									.then(function(mEnroll) {
// $log.info("Enroll Results:",mEnroll, 'str:', mEnroll.toString(), new Date());
										var str = mEnroll.toString();
										if (str == "Error EnrollUser" ||
											str == "Error AuthUser") {
											var sEmailContent = 
												errorEmailNotification.errorMoodle(mEnroll,"enrollUser");
											dataService.emailSendError(sEmailContent);
										} else {
											var iStart = str.indexOf("<VALUE>");
											var iStop = str.indexOf("</VALUE>");
											var sURL = str.substring(iStart+7, iStop);
											var SSCourseURL = 
												"&wantsurl=https://mosafesanctuaries.org/course/view.php?id=25";
											var URLRequest = sURL + SSCourseURL;
											$window.location.replace(URLRequest);
// $log.info('(611)Send to eThink:', URLRequest);
										}		
									});
								} else {
// $log.info("(617)User Enrolled, so Call Moodle_UpdateUser");
// $log.info("Moodle_UpdateUser_Call:", new Date());							
									moodleService.updateUser(sMoodleReturnCode, mProID)
									.then(function(mUpdate) {
// $log.info("(618)UpdateUser_results:", mUpdate);
// $log.info("Moodle_UpdateUser_results:", new Date());
										var str = mUpdate.toString();
										if (str == "Error UpdateUser" || str == "Error AuthUser") {
											var sEmailContent = 
												errorEmailNotification.errorMoodle(mUpdate,"updateUser");
											dataService.emailSendError(sEmailContent);
										} else {
											var iStart = str.indexOf("<VALUE>");
											var iStop = str.indexOf("</VALUE>");
											var sURL = str.substring(iStart+7, iStop);
											var SSCourseURL = 
												"&wantsurl=https://mosafesanctuaries.org/course/view.php?"; 
											var sCreated = 
												datesService.jsDateStrToDbDateStr(vm.selStep.CREATEDON);
											if (sCreated < "2018-12-07") {
												SSCourseURL += "id=2"; }
											else { SSCourseURL += "id=25"; }
											var URLRequest = sURL + SSCourseURL;
// $log.info("(639)Already enrolled:",URLRequest);											
											$window.location.replace(URLRequest);
										}
									});	
								}
							});
						break;
					}
				});
			break;
			case "NWTXTraining":
				var sDataSource = webSessionStorage.getStoredData('sDataSource');
				// Need to grab Paid Camp for sending "Ready For Training" Email to each site
				var str = String(vm.trainStepID);
				var sReplyTo = "mchelp@greatspirit.com";
				var sFrom = "MissionConnect Help Desk <" + sReplyTo + ">";
				var sEmailAddr = "testing@greatspirit.com";
				var sProgramType = ""; //$log.info("certType:",str.substr(0,1))
				if (str.substr(0,1) == "4") { 
					dataService.proGetFormData("CampPayment")
					.then(function(payData) { //$log.info("proGetFormData:",payData);
						if (payData.length > 0) {
							dataService.suGetEvent(payData[0].ITEMDATA)
							.then(function(event) {
								var camp = event[0].EVENTCODE;
								if (sDataSource == "FalconNwtx") {
									switch (camp.substr(0,2)) {
										case "B_": sEmailAddr = butmanCampEmail; break;
										case "C_": sEmailAddr = cetaCampEmail; break;
									}
								}	
								sProgramType = "BCC Online Process";
//$log.info(sEmailAddr,sFrom,sReplyTo,sProgramType)
								dataService.emailSend_NWTXTraining(sEmailAddr,sFrom,sReplyTo,sProgramType)
								.then(function(result) {
									if (result == 'Completed') {
										updateTrainingStepNWTX();
									}
								});
							});
						}
					});
				} else {
					if (sDataSource == "FalconNwtx") {
						sEmailAddr = vimEmail;
					}	
					sProgramType = "Volunteers in Mission";
					dataService.emailSend_NWTXTraining(sEmailAddr,sFrom,sReplyTo,sProgramType)
					.then(function(result) {
						if (result == 'Completed') {
							updateTrainingStepNWTX();
						}
					});
				}
			break;
			case "PastorRef": case "ClergyProfRef": case "DSRef": 	//MO PR Refs
			case "GeneralRef": case "ClergyGenRef":					//MO Name Refs
			case "ProfRef1": case "ProfRef2": case "PersonalRef":	//NWTX Name Refs
			case "ProfRef": //case "GeneralRef"						//MC Name Refs
// $log.info('refRequest:', sStepLinkFlag, 'vm.selStep:', vm.selStep);
				$state.go('refRequest', {
					sStepLinkFlag: sStepLinkFlag,
					refSaveKey: vm.selStep.SAVEKEY,
					refStepID: vm.selStep.STEPID
				}, {reload:true});
			break;
		}
	};
	
	vm.logOff = function() {
		$rootScope.loggedIn = false;
		loginService.logout();
		loginService.user = {};
		$rootScope.myApps = [];
		$state.go('login', {reload:true});
	};
	
	vm.openStepInst = function() {
		$state.go('stepInst', {
			iCertTypeID: vm.iCertTypeID
		}, {reload:true});	
	};
	
	vm.refreshPage = function() {
        $state.reload();
    };
    
    vm.resendRef = function(refStep) {
	    timeOutService.resetTimer(30);
		$rootScope.refResend = refStep;
		vm.modalInstance = $uibModal.open({
			animation: true,
			templateUrl: 'app/modals/resendRef.html',
			controller: 'ResendRefController',
			bindToController: true,
			controllerAs: 'vmRRef',
			keyboard: true,
			backdrop: 'static'
		});
	};
    
}	

angular		
	.module('proRefs')
	.controller('StepInstController', StepInstController);

StepInstController.$inject = ['dataService','$sce','$state','$stateParams','webSessionStorage'];
	
function StepInstController(dataService, $sce, $state, $stateParams, webSessionStorage) {
	var vm = this; 	//vmSI
	
	vm.back = { image: "assets/images/left_32.png" };
	vm.sInstructions = "";
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');	
	
/* Initialize: */
	dataService.fxGet("WebProtect","Steps","X")
	.then(function(data) {
		if (data.length > 0) {
			switch ($stateParams.iCertTypeID) { 
				case 4:
					for (var i=0; i<data.length; i++) {
						if (data[i].TEXTID == "Instructions") {
							vm.sInstructions = $sce.trustAsHtml(data[i].TEXT);
						break; }
					}
				break;
				case 5:
					switch (vm.sDatabaseID) {
						case "MO": case "MO-DEV":
							for (i=0; i<data.length; i++) {
								if (data[i].TEXTID == "LCAInstructions") {
									vm.sInstructions = $sce.trustAsHtml(data[i].TEXT);
								break; }
							}					
						break;
						case "NWTX": case "NWTX-DEV":
							for (i=0; i<data.length; i++) {
								if (data[i].TEXTID == "VIMInstructions") {
									vm.sInstructions = $sce.trustAsHtml(data[i].TEXT);
								break; }
							}
						break;
					}
				break;
			}
		}
	});
	

/* Called from view: */		
	
	vm.returnToSteps = function() {
        $state.go('steps', {reload:true});
    };
	
}	

angular
    .module('proRefs')
    .controller('ResendRefController', ResendRefController);

ResendRefController.$inject = ['dataService','loginService','$state','$rootScope','modalService',
	'refJSURL','protectURL','validatorService','arrayFactory','errorEmailNotification',
	'datesService','webSessionStorage','$log'];

function ResendRefController(dataService, loginService, $state, $rootScope, modalService, 
	refJSURL, protectURL, validatorService, arrayFactory, errorEmailNotification, 
	datesService, webSessionStorage, $log) {
		
    var vm = this; //vmRRef
    
    //Initial Ref details populated to Modal from Steps via $rootScope
	vm.refStep = $rootScope.refResend;
    
    vm.arrDSs = [];
    vm.arrPastors = [];
    vm.bInSendProcedure = false;
    vm.iChurchID = 0;
    vm.iReturnKey = 0;
    vm.pastorUserName = "";
    vm.sFrom = "";
    vm.sInitFormText = "";
	vm.sRefEmail = "";
    vm.sRefName = "";
    vm.sReplyTo = "";
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.selDS = {};
    vm.selPastor = {};
    vm.sStepExpires = "";    vm.stepID = vm.refStep.STEPID;
    vm.sStepLink = vm.refStep.STEPLINK;
    vm.sStepLinkFlag = vm.refStep.STEPLINKFLAG;
    vm.sStepLinkType = vm.refStep.STEPLINKTYPE;
    vm.sStepNote = vm.refStep.STEPNOTE;
    vm.saveKey = vm.refStep.SAVEKEY;
    vm.stepRefID = vm.refStep.STEPREFID;


// INITIALIZE:
	$rootScope.sCurForm = "Resend Reference";
$log.info($rootScope.sCurForm);	

    var arrStepRef = vm.stepRefID.split("|");
    vm.sRefEmail = arrStepRef[0];
    vm.iReturnKey = Number(arrStepRef[1]);
    
    switch (vm.sStepLinkType) { 
		case "Name":
			vm.sRefName = vm.sStepLink;
		break;
		case "PR":
			switch (vm.sStepLinkFlag) {
				case "DSRef":
					getDSs();
				break;
				case "ClergyProfRef":
					getPastors(0);
				break;
				case "PastorRef":
					if (loginService.user.CHURCHID > 0) { 
						//stored when clicking CertRecord
						vm.iChurchID = loginService.user.CHURCHID;
						getPastors(vm.iChurchID); }
					else { getPastors(0); }
				break;
			}
		break;
	}
	
	function getDSs() {
		dataService.proGetDSs()
		.then(function(DSs) {$log.info("DS:",DSs)
			for (var i=0; i<DSs.length; i++) {
				DSs[i].FullName = DSs[i].FIRSTNAME + " " + DSs[i].LASTNAME;
			}
			vm.arrDSs = DSs;
			for (i=0; i<vm.arrDSs.length; i++) {
				if (vm.arrDSs[i].ENTITYID == vm.sStepLink) {
					vm.selDS = vm.arrDSs[i];
				break; }
			}
		});
	}
	
	function getPastors(chID) {
		dataService.proLoadPastors(chID)
		.then(function (pastors) {
			if (pastors.length > 0) {
				vm.arrPastors = pastors;
				for (var i=0; i<vm.arrPastors.length; i++) {
					if (vm.arrPastors[i].ENTITYID == vm.sStepLink) {
						vm.selPastor = vm.arrPastors[i];
					break; }
					else if (i == vm.arrPastors.length-1) {
						getClergy();
					}
				}
			}
		});
	}
	
	function getClergy() {
		dataService.proLoadPastors(0)
		.then(function (clergy) {
			if (clergy.length > 0) {
				vm.arrPastors = clergy;
				for (var i=0; i<vm.arrPastors.length; i++) {
					if (vm.arrPastors[i].ENTITYID == vm.sStepLink) {
						vm.selPastor = vm.arrPastors[i];
					break; }
				}
			}
		});
	}
	
	dataService.libGetASetting("ProConfEmail") //or "RcvEmailReplyToProtect"
	.then(function(result) {
		if (result.length > 0) {
			vm.sReplyTo = result[0].SETTINGVALUE;
		} else { 
			dataService.emailSendError("This Conference is missing the ProConfEmail setting."); 
		}	
	});
	
	dataService.libGetASetting("RcvEmailFromProtect")
	.then(function(result) {
		if (result.length > 0) {
			vm.sFrom = result[0].SETTINGVALUE;
		} else { dataService.emailSendError("This Conference is missing the RcvEmailFromProtect setting.")}	
	});
	
	dataService.libGetASetting("ProContactInfo")
	.then(function(result) {
		if (result.length > 0) {
			vm.sContactInfo = result[0].SETTINGVALUE;
		}
	});
	
	dataService.fxGet("Protect", "Initialization","EmailText")
	.then(function(result) {
		if (result.length > 0) {
			vm.sInitFormText = result[0].TEXT;
		}	
	});
	
	function getPastorUserAccount(iEntityID) {
		dataService.usersGetOneFromEntityID(iEntityID)
		.then(function(resultPR) {
			if (resultPR == "No User Account Found") {
				vm.pastorUserName = "";
					
				dataService.emGetFirstSeq(vm.selPastor.ENTITYID)
				.then(function(emails) {
					if (emails.length > 0) {
						if (emails.length == 1 && emails[0].STOPDATE != "") {
							vm.sRefEmail = emails[0].EMAIL;
						} else {
							var curEmails = arrayFactory.getCurrentOnly(emails)
							if (curEmails.length > 0) {
								vm.sRefEmail = curEmails[0].EMAIL;
							}
						}
					} else {
						modalService.okAlert("Invalid Entry",
							"Please select a different clergy person, as there is no " +
							"email associated with the person you selected.");
					}
				});
			} else { 
				vm.pastorUserName = resultPR[0].USERNAME;
				vm.sRefEmail = resultPR[0].USEREMAIL;
				if (validatorService.emailIsValid(vm.sRefEmail) == true) {
					vm.bReadyToSend = "true";	
				}	
			}
		});
	}
	
	function getReturnCode(iMin, sParams) {
		dataService.secGetReturnCode(iMin, vm.sStepLinkFlag, sParams)
		.then(function(retCode) {
			if (retCode.length > 0) {
				vm.refReturnCode = retCode[0].RETURNCODE;
				vm.refReturnKey = retCode[0].RETURNKEY;
							
				deleteOldReturnCode();
			}
		});
	}
	
	function deleteOldReturnCode() {
		dataService.secDeleteReturnCodeFromKey(vm.iReturnKey)
		.then(function(result) {
			if (result[0].RESULTS != "Delete Succeeded") {
				var sEmailContent = errorEmailNotification.error4("resendRefCtrl/deleteOldReturnCode");
				dataService.emailSendError(sEmailContent);
			}
			saveProProcessRecord();
		})
	}
	
	function saveProProcessRecord() {
		var sRawDataString = "WebApps_Pro || ResendRefReq || " + 
			loginService.user.USERID + " || U || SaveKey==" + vm.saveKey +
			" || ProID==" + $rootScope.sProID + " || StepID==" + vm.stepID;
			if (vm.sStepExpires != "") {
				sRawDataString += " || StepExpires==" + vm.sStepExpires;
			}
			if (vm.sStepNote != "") { vm.sStepNote += "; "; }
			sRawDataString += " || StepNote==" + vm.sStepNote + "Resent " + 
				datesService.todayToCalString() +
				" || StepLinkType==" + vm.sStepLinkType + " || StepLink==" + vm.sStepLink +
				" || StepProgress==Reference Request Sent || StepRefID==" +
				vm.sRefEmail + "|" + vm.refReturnKey + " ^^ ";

		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if (result[0].RESULTCODE == "Success") {
				sendEmail();
			}
		});
	}
	
	function sendEmail() {
		if (vm.sDatabaseID.slice(-3) == "DEV") {
			vm.sRefEmail = "testing@greatspirit.com";
		} else if (vm.sDatabaseID == "VID") {
			vm.sRefEmail = "lyndzie@greatspirit.com";
		}
		vm.sFrom += " <" + vm.sReplyTo + ">";
		var sProRefsURL = protectURL + "?conf=" + vm.sDatabaseID; //alt: webProMO if not testing MO-DEV
		var sRefJSLink = refJSURL + "?ReturnCode=" + vm.refReturnCode;
		switch (vm.sStepLinkType) {
			case "Name":
				switch (vm.sDatabaseID) {
					case "MC": case "MC-DEV":
						dataService.emailSend_MORefLink(vm.sContactInfo, 
							vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
							vm.sReplyTo, vm.sInitFormText)
						.then(function(result) {
							if (result == "Completed") {
								$rootScope.$broadcast('closeModal');
								$state.go('steps', {reload:true});
							} else {
								modalService.okAlert("Error",
									"An Error occurred while sending the " +
									"Reference Request email.");
							}
						});
					break;	
					case "MO": case "MO-DEV":
						dataService.emailSend_MORefLink(vm.sContactInfo, 
							vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
							vm.sReplyTo, vm.sInitFormText)
						.then(function(result) {
							if (result == "Completed") {
								$rootScope.$broadcast('closeModal');
								$state.go('steps', {reload:true});
							} else {
								modalService.okAlert("Error",
									"An Error occurred while sending the " +
									"Reference Request email.");
							}
						});
					break;	
					case "NWTX": case "NWTX-DEV":
						dataService.emailSend_NWTXRefLink(vm.sContactInfo, 
							vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
							vm.sReplyTo, vm.sInitFormText)
						.then(function(result) {
							if (result == "Completed") {
								$rootScope.$broadcast('closeModal');
								$state.go('steps', {reload:true});
							} else {
								modalService.okAlert("Error",
									"An Error occurred while sending the " +
									"Reference Request email.");
							}
						});
					break;
				}
			break;
			case "PR":
				if (vm.pastorUserName != "") {
					dataService.emailSend_PastorRef(vm.sContactInfo, 
						vm.sRefEmail, vm.sFrom, vm.sReplyTo, vm.sRefName,
						sProRefsURL, vm.pastorUserName, sRefJSLink,
						vm.sInitFormText)
					.then(function(result) {
						if (result == "Completed") {
							$rootScope.$broadcast('closeModal');
							$state.go('steps', {reload:true});
						} else {
							modalService.okAlert("Error",
								"An Error occurred while sending the " +
								"Reference Request email.");
						}
					});
				} else {
					dataService.emailSend_MORefLink(vm.sContactInfo, 
						vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
						vm.sReplyTo, vm.sInitFormText)
					.then(function(result) {
						if (result == "Completed") {
							$rootScope.$broadcast('closeModal');
							$state.go('steps', {reload:true});
						} else {
							modalService.okAlert("Error",
								"An Error occurred while sending the " +
								"Reference Request email.");
						}
					});
				}
			break;
		}
	}
    
    
/* Broadcasts: */

/* Calls from View: */

	vm.cancel = function() {
		$rootScope.$broadcast('closeModal');
		$state.go('steps', {reload:true});
	}
	
	vm.pastors_changeHandler = function() {
		if (vm.selPastor.ENTITYID > 0) {
			getPastorUserAccount(vm.selPastor.ENTITYID);
		}
	};

	vm.sendRequest = function() {
		if (vm.bInSendProcedure == false) { //dups prevention
			vm.bInSendProcedure = true;
			switch (vm.sStepLinkType) {
				case "Name":
					if (vm.sRefName == "" || vm.sRefName.indexOf(" ") == -1) {
						modalService.okAlert("Invalid Entry",
							"Please enter the full name of the person to whom " +
							"you are sending this Reference Request.");
					} else if (validatorService.emailIsValid(vm.sRefEmail) == true) {
						vm.sStepLink = vm.sRefName;
						var sParams = loginService.user.USERID + "|" + loginService.user.USERFULLNAME +
							"|" + $rootScope.sProID;
						switch (vm.sStepLinkFlag) {
							case "ProfRef1": case "ProfRef2": case "PersonalRef": 	//NWTX No Exp
							case "ClergyProfRef":									//MO No Exp (Clergy)
								getReturnCode(525600, sParams);
							break;
							default: //2 weeks:
								var dToday = new Date();
								var dExp = new Date(dToday.getTime() + 1.2096e9);
								vm.sStepExpires = datesService.jsDateStrToCalendarStr(dExp);
								getReturnCode(20160, sParams);								
							break;
						}
					} else {
						modalService.okAlert("Invalid Entry",
							"You must enter a valid email address before " +
							"this request can be sent.");
					}
				break;		
				case "PR":
					if (vm.sStepLinkFlag == "DSRef") {
						vm.sRefName = "Rev. " + vm.selDS.FullName;
						vm.sStepLink = vm.selDS.ENTITYID;
					} else {
						if (vm.selPastor.ENTITYID > 0) {
							if (vm.selPastor.CHURCHPASTORS.indexOf("Rev") > -1) {
								vm.sRefName = "Rev. ";
							} else { vm.sRefName = ""; }
							vm.sRefName += vm.selPastor.FIRSTNAME + " " + vm.selPastor.LASTNAME;
							vm.sStepLink = vm.selPastor.ENTITYID;
						} else {
							modalService.okAlert("Missing Entry", 
								"You first need to select a clergy person to " +
								"send this Reference Request to.");
						}		
					}
					sParams = loginService.user.USERID + "|" + loginService.user.USERFULLNAME +
						"|" + $rootScope.sProID;
					getReturnCode(525600, sParams);		//ALL MO Clergy don't expire.
				break;
			}
		}			
	};
	
}
angular
    .module('proRefs')
    .controller('ReferralController', ReferralController);

ReferralController.$inject = ['$rootScope','dataService', '$state', 'validatorService', 'modalService',
	'referRefEmail', 'webSessionStorage', '$stateParams', 'errorEmailNotification',
	'loginService'];

function ReferralController($rootScope, dataService, $state, validatorService, modalService,
	referRefEmail, webSessionStorage, $stateParams, errorEmailNotification, 
	loginService) {
    
    var vm = this;
//$stateParams:
	//$stateParams.Applicant;
	//$stateParams.ApplUserID;
	//$stateParams.iProRefUserID;
	//$stateParams.iStepSaveKey;
	//$stateParams.retCodeKey;
	//$stateParams.sProID;
	//$stateParams.sStepLinkFlag;
	
	vm.Applicant = $stateParams.Applicant;	//needed in VIEW
	vm.back = { image: "assets/images/left_32.png" };
	vm.iChurchID = 0;
	vm.iNewReturnKey = 0;
	vm.iReferralEntID = 0;
	vm.otherPastors = [];
	vm.selPastor = {}; //APPOINTEDORSTAFF = "Appointed" or "Staff"
	vm.sNewReturnCode = "";
	vm.sReferralEmail = "";
	vm.sReferralName = ""; 
	vm.sReferralUserName = "";


//INITIALIZE:
	$rootScope.sCurForm = "Reference Referral";
	
	getProMainForChurchID();
	
	function getProMainForChurchID() {
		dataService.proGetMain($stateParams.sProID)
		.then(function(data) {
			if (data.length > 0 && data[0].CHURCHID > 0) {
				dataService.proLoadPastors(data[0].CHURCHID)
				.then(function(data) {
					if (data.length > 0) {
						vm.otherPastors = data;
						vm.otherPastors.unshift({
							ENTITYID: "0", 
							CHURCHPASTORS: '<No Selection>'
						});
						vm.selPastor = vm.otherPastors[0];
					}
				});
			}	
		});
	}

	function getNewReturnCode() {
		var sParams = $stateParams.ApplUserID + "|" + vm.Applicant + "|" + $stateParams.sProID;
		dataService.secGetReturnCode($stateParams.iProRefUserID, $stateParams.sStepLinkFlag, sParams, 0)
		.then(function(data) {
			if (data.length > 0) {
				vm.sNewReturnCode = data[0].RETURNCODE;
				vm.iNewReturnKey = data[0].RETURNKEY;
				updateProProcessRecord();
			}
		});		
	}

	function updateProProcessRecord() {
		//currently ONLY MO PastorRef has "Referral" capabilities, otherwise add switch for sStepLinkFlag
		//StepNote== need to add Staff or "" for MO
		var sRawDataString = "ProRefs_JS || referCtrl || " + loginService.user.USERID + 
			" || U || SaveKey==" + $stateParams.iStepSaveKey + 
			" || StepLink==" + vm.iReferralEntID + " || StepRefID==" +
			vm.sReferralEmail + "|" + vm.iNewReturnKey + " ^^ ";
			
		dataService.proSaveProcess(sRawDataString)
		.then(function(data) {
			if (data[0].RESULTCODE == "Success") {
				deleteOldReturnCode(); }
			else {
				var sEmailContent = errorEmailNotification.error3("referCtrl/proSaveProcess",
					$stateParams.iStepSaveKey);
				dataService.emailSendError(sEmailContent);
			}
		});
	}

	function deleteOldReturnCode() {
		dataService.secDeleteReturnCodeFromKey($stateParams.retCodeKey)
		.then(function(data) {
			if (data[0].RESULTS != "Delete Succeeded") {
				var sEmailContent = errorEmailNotification.error1("referCtrl/deleteReturnCode");
				dataService.emailSendError(sEmailContent)
			}		
			//$stateParams.retCodeKey = vm.iNewReturnKey; //??? used?
			getUserAccount();
		});
	}
	
	function getUserAccount() {
// $log.info("iReferralEntID: "+String(vm.iReferralEntID));		
		dataService.getUserInfoFromEntityID(vm.iReferralEntID)
		.then(function(data) {
// $log.info("dataServices.getUserAccount()",data);			
			if (data.length > 0) {
				vm.sReferralUserName = data[0].USERNAME;
				sendEmailToReferral();
			}	
		});
	}	

	function sendEmailToReferral() {
		var sReferralEmailContent = referRefEmail.getEmailContent(vm.Applicant,
			vm.sReferralUserName, vm.sReferralName, vm.sNewReturnCode);
				
		if (sReferralEmailContent != "") {
			var sDatabaseID = webSessionStorage.getStoredData("sDatabaseID");
			var sSubject = "Reference Request Form";
			switch (sDatabaseID) {
				case "MO":
					var sReplyTo = "SSanctuaries@moumethodist.org";
					var sFrom = "Safe Sanctuaries Administrator <" + sReplyTo + ">";
				break;
				case "VID":
					vm.sReferralEmail = "lyndzie@greatspirit.com";
					sReplyTo = "mchelp@greatspirit.com";
					sFrom = "GSS Testing <mchelp@greatspirit.com>";
				break;
				default:
					vm.sReferralEmail = "testing@greatspirit.com";
					sReplyTo = "mchelp@greatspirit.com";
					sFrom = "GSS Testing <mchelp@greatspirit.com>";
				break;
			}
			dataService.emailSendCustom(vm.sReferralEmail, sFrom, sReplyTo, sSubject,
				sReferralEmailContent)
			.then(function(data) {
				if (data == "Completed") {
					modalService.okAlert("Success",
						"The reference for " + vm.Applicant + 
						"<br>has been forwarded to " + vm.sReferralName + ".");
					$state.go('certMgmt',{reload:true});
				}			      
			});
		}
	}
	
	
/* External calls: */

	vm.sendRefToOtherPastor = function() {
		if (vm.selPastor.ENTITYID == "0") {
			modalService.okAlert("Missing Entry", 
				"You must first make a selection from the <br>" +
					"pastors/staff droplist to refer this <br>" +
					"reference to someone else."); }
		else if (vm.selPastor.EMAIL == "") {
			modalService.okAlert("Invalid Entry",
				"There is no available email connected to \n" +
					"the person you have selected. Please contact \n" +
					"the Safe Sanctuaries office to add an Email \n" +
					"address for " + vm.selPastor.FIRSTNAME + " " +
					vm.selPastor.LASTNAME + " before proceeding."); }
		else if (validatorService.emailIsValid(vm.selPastor.EMAIL) == true) {
			vm.sReferralName = vm.selPastor.FIRSTNAME + " " + vm.selPastor.LASTNAME;
			vm.iReferralEntID = vm.selPastor.ENTITYID;
			vm.sReferralEmail = vm.selPastor.EMAIL;
			if ($stateParams.iProRefUserID > 0) {
				getNewReturnCode(); 
			}
		}
	};
	
	vm.goBackToForm = function() {
		$state.go('ref', {retCodeKey: $stateParams.retCodeKey});
	};
}
angular
    .module('proRefs')
    .controller('RefRequestController', RefRequestController);

RefRequestController.$inject = ['$stateParams','dataService','$state','$rootScope','$log'];

function RefRequestController($stateParams, dataService, $state, $rootScope, $log) {
    var vm = this;
    
    vm.arrFormText = [];
    vm.refHeader = "";
    vm.refSubheader = "";
    vm.refRequirement = "";
    vm.sStepLinkFlag = $stateParams.sStepLinkFlag;
    
    
//INITIALIZATION:
	$rootScope.sCurForm = "Reference Request";
$log.info($rootScope.sCurForm);
// $log.info("$stateParams:",$stateParams)	

	if (vm.arrFormText.length == 0 || vm.arrFormText[0].FORM != $stateParams.sStepLinkFlag) {
		getFormText();
	}
	
	function getFormText() {
		dataService.fxGet("WebAppsPro", $stateParams.sStepLinkFlag, "X")
		.then(function(results) {
			if (results.length > 0) {
				vm.arrFormText = results;
				for (var i=0; i<vm.arrFormText.length; i++) {
					switch (vm.arrFormText[i].TEXTID) {
						case "Header": 
							vm.refHeader = vm.arrFormText[i].TEXT; 
						break;
						case "Subheader": 
							vm.refSubheader = vm.arrFormText[i].TEXT; 
						break;
						case "Requirement": 
							vm.refRequirement = vm.arrFormText[i].TEXT; 
						break;
					}
				}
				
				switch ($stateParams.sStepLinkFlag) { 
					case "PastorRef": case "ClergyProfRef": case "DSRef":
						$state.go('pastorRef', {
							sStepLinkFlag: $stateParams.sStepLinkFlag,
							refSaveKey: $stateParams.refSaveKey,
							refStepID: $stateParams.refStepID
						}); //can't use reload:true since reloads parent too, perpetual loop
					break;
					default:
						$state.go('defaultRef', {
							sStepLinkFlag: $stateParams.sStepLinkFlag,
							refSaveKey: $stateParams.refSaveKey,
							refStepID: $stateParams.refStepID
						});
					break;	//can't use reload:true since reloads parent too, perpetual loop
				}
			}
		});
	}


/* Broadcasts: */

/* Calls from View: */
	
	vm.cancel = function() {
		$state.go('steps', {reload:true});
	};
	
}

angular
    .module('proRefs')
    .controller('RefPastorRefController', RefPastorRefController);

RefPastorRefController.$inject = ['$stateParams','loginService','dataService','datesService','arrayFactory',
	'webSessionStorage','modalService','validatorService','$rootScope','refJSURL','protectURL','webProMO','$state',
	'$log'];

function RefPastorRefController($stateParams, loginService, dataService, datesService, arrayFactory, 
	webSessionStorage, modalService, validatorService, $rootScope, refJSURL, protectURL, webProMO, $state, 
	$log) {
		
    var vm = this; //vmRefPR

	vm.arrDSs = [];
	vm.arrPastors = [];
	vm.bInSendProcedure = false;
	vm.bReadyToSend = "false";
	vm.related = "No";
    vm.iChurchID = 0;
    vm.pastorUserName = "";
    vm.refReturnCode = "";
    vm.refReturnKey = 0;
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
    vm.sContactInfo = "";
    vm.sDbToday = datesService.todayToDbString();
    vm.selDS = {};
    vm.selPastor = {};
	vm.sFrom = "";
	vm.sInitFormText = "";
	vm.sLinkType = "";
    vm.sRefEmail = "";			//Reference person's email
    vm.sRefName = "";			//Reference person's name (for sent Email text)
    vm.sReplyTo = "";
    vm.sStepLinkFlag = $stateParams.sStepLinkFlag;
    vm.txtRefName = "";
    

//INITIALIZE:
	$rootScope.sCurForm = "PR Reference Request";

	if (vm.sStepLinkFlag == 'DSRef') {
		getDSs(); }
	else if (vm.sStepLinkFlag == 'ClergyProfRef') {
		getPastors(0); }
	else if (loginService.user.CHURCHID > 0) { 
		//stored when clicking CertRecord
		vm.iChurchID = loginService.user.CHURCHID;
		getPastors(vm.iChurchID); }
	else { getPastors(0); }
	
	function getDSs() {
		dataService.proGetDSs()
		.then(function(DSs) {
			for (var i=0; i<DSs.length; i++) {
				DSs[i].FullName = DSs[i].FIRSTNAME + " " + DSs[i].LASTNAME;
			}
			vm.arrDSs = DSs;
		});
	}
	
	function getPastors(chID) {
		dataService.proLoadPastors(chID)
		.then(function (pastors) {
			if (pastors.length > 0) {
				vm.arrPastors = pastors;
				if (pastors.length == 1) {
					vm.selPastor = vm.arrPastors[0];
					getPastorUserAccount(vm.selPastor.ENTITYID);
				}
			}
		});
	}
	
	dataService.libGetASetting("ProConfEmail")
	.then(function(result) {
		if (result.length > 0) {
			vm.sReplyTo = result[0].SETTINGVALUE;
		} else { 
			dataService.emailSendError("This Conference is missing the ProConfEmail setting."); }	
	});
	
	dataService.libGetASetting("RcvEmailFromProtect")
	.then(function(result) {
		if (result.length > 0) {
			vm.sFrom = result[0].SETTINGVALUE;
		} else { dataService.emailSendError("This Conference is missing the RcvEmailFromProtect setting.")}	
	});
	
	dataService.libGetASetting("ProContactInfo")
	.then(function(result) {
		if (result.length > 0) {
			vm.sContactInfo = result[0].SETTINGVALUE;
		}
	});
	
	dataService.fxGet("Protect", "Initialization","EmailText")
	.then(function(result) {
		if (result.length > 0) {
			vm.sInitFormText = result[0].TEXT;
		}	
	});
	
	
	function getPastorUserAccount(iEntityID) {
		dataService.usersGetOneFromEntityID(iEntityID)
		.then(function(resultPR) {
			if (resultPR == "No User Account Found") {
				vm.pastorUserName = "";
					
				dataService.emGetFirstSeq(vm.selPastor.ENTITYID)
				.then(function(emails) {
					if (emails.length > 0) {
						if (emails.length == 1 && emails[0].STOPDATE != "") {
							vm.sRefEmail = emails[0].EMAIL;
						} else {
							var curEmails = arrayFactory.getCurrentOnly(emails)
							if (curEmails.length > 0) {
								vm.sRefEmail = curEmails[0].EMAIL;
							}
						}
						if (validatorService.emailIsValid(vm.sRefEmail) == true) {
							vm.bReadyToSend = "true";	
						} else {
							modalService.okAlert("Invalid Entry",
								"You must enter a valid email address before " +
								"this request can be sent.\n\nIf there is a missing or incorrect email " +
								"for the pastor selected, please contact the Safe Sanctuaries office.");
							vm.bReadyToSend = "false";
						}
					} else {
						modalService.okAlert("Invalid Entry",
							"You must enter a valid email address before " +
							"this request can be sent.\n\nIf there is a missing or incorrect email " +
							"for the pastor selected, please contact the Safe Sanctuaries office.");
						vm.bReadyToSend = "false";
					}
				});
			} else { 
				vm.pastorUserName = resultPR[0].USERNAME;
				vm.sRefEmail = resultPR[0].USEREMAIL;
				if (validatorService.emailIsValid(vm.sRefEmail) == true) {
					vm.bReadyToSend = "true";	
				}	
			}
		});
	}
	
	function getReturnCode(iMin, sParams) {
		dataService.secGetReturnCode(iMin, vm.sStepLinkFlag, sParams)
		.then(function(retCode) {
			if (retCode.length > 0) {
				vm.refReturnCode = retCode[0].RETURNCODE;
				vm.refReturnKey = retCode[0].RETURNKEY;
							
				saveProProcessRecord();
			}
		});
	}
	
	function saveProProcessRecord() {
		//MO PastorRef, ClergyProfRef do NOT Expire.
		var sRawDataString = "WebApps_Pro || " + vm.sStepLinkFlag + " || " + loginService.user.USERID;
		if ($stateParams.refSaveKey > 0) { 
			sRawDataString += " || U || SaveKey==" + $stateParams.refSaveKey; }
		else { sRawDataString += " || I"; }
		sRawDataString += " || ProID==" + $rootScope.sProID + " || StepID==" + 
			$stateParams.refStepID + " || StepNote==";
		
		//MO Only: Add Note if Ref sent to "Staff" entered thru LCProtect:
		if ($stateParams.sStepLinkFlag == "PastorRef" && vm.selPastor.APPOINTEDORSTAFF == "Staff") {
			sRawDataString += "(Staff)";
		}
		
		sRawDataString += " || StepLinkType==" + vm.sLinkType + " || StepLink==";
		if (vm.sLinkType == "PR") { 
			if (vm.sStepLinkFlag == 'DSRef') {
				sRawDataString += vm.selDS.ENTITYID; }
			else if (angular.isDefined(vm.selPastor.ENTITYID)==true) {
				sRawDataString += vm.selPastor.ENTITYID; }
			else { sRawDataString += vm.selDS.ENTITYID; }	
		} else { sRawDataString += vm.sRefName; }
		sRawDataString += " || StepProgress==Reference Request Sent || StepRefID==" +
			vm.sRefEmail + "|" + vm.refReturnKey + " ^^ ";
$log.info(sRawDataString)
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) { $log.info(result)
			if (result[0].RESULTCODE == "Success") {
				sendEmail();
			}
		});
	}
	
	function sendEmail() {
		if (vm.sDatabaseID.slice(-3) == "DEV") {
			vm.sRefEmail = "testing@greatspirit.com";
		} else if (vm.sDatabaseID == "VID") {
			vm.sRefEmail = "lyndzie@greatspirit.com";
		}
		vm.sFrom += " <" + vm.sReplyTo + ">";
		
		//Currently MO ONLY... otherwise add switch/case for sDatabaseID:
		var sProRefsURL = protectURL + "?conf=" + vm.sDatabaseID;
		var sRefJSLink = refJSURL + "?ReturnCode=" + vm.refReturnCode;
		if (vm.pastorUserName != "") {
			dataService.emailSend_PastorRef(vm.sContactInfo, 
				vm.sRefEmail, vm.sFrom, vm.sReplyTo, vm.sRefName,
				sProRefsURL, vm.pastorUserName, sRefJSLink,
				vm.sInitFormText)
			.then(function(result) {
				if (result == "Completed") {
					resetForm();
					$state.go('steps', {reload:true});
				} else {
					modalService.okAlert("Send Error",
						"An Error occurred while sending the " +
						"Reference Request email.");
				}
			});
		} else {
			dataService.emailSend_MORefLink(vm.sContactInfo, 
				vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
				vm.sReplyTo, vm.sInitFormText)
			.then(function(result) {
				if (result == "Completed") {
					resetForm();
					$state.go('steps', {reload:true});
				} else {
					modalService.okAlert("Send Error",
						"An Error occurred while sending the " +
						"Reference Request email.");
				}
			});
		}
	}
	
	//can't reload a partial without reloading parent, so clear vars here for use with next Ref:
	function resetForm() {
		vm.pastorUserName = "";
		vm.selPastor = {};
		vm.txtRefName = "";
	}
	
	
/* Broadcasts: */

/* Calls from View: */
	
	vm.cancel = function() {
		$state.go('steps', {reload:true});
	}
	
	vm.DSs_changeHandler = function() {
		if (vm.selDS != null &&
			vm.selDS.ENTITYID > 0) {
			getPastorUserAccount(vm.selDS.ENTITYID);
			if (vm.related == 'Yes') {
				vm.selPastor = {};
			}
		} else { 
			vm.selDS = {};
			vm.bReadyToSend = "false"; 
		}
	}
	
	vm.email_changeHandler = function() {
		if (validatorService.emailIsValid(vm.sRefEmail) == true) {
			if ((vm.related == 'No' && vm.selPastor.ENTITYID > 0) ||
				(vm.sStepLinkFlag == 'DSRef' && vm.selDS.ENTITYID > 0) ||
				(vm.sStepLinkFlag == 'ClergyProfRef' && vm.txtRefName != "")) {
				vm.bReadyToSend = "true";
			} else if (vm.related == 'Yes' && 
				(vm.selPastor.ENTITYID > 0 || vm.selDS.ENTITYID > 0)) {
				vm.bReadyToSend = "true";
			} else {
				modalService.okAlert("Missing Entry", 
					"You first need to select a pastor to " +
					"send this Reference Request to.")
				vm.bReadyToSend = "false";
			} 
		} else {
			modalService.okAlert("Invalid Entry",
				"You must enter a valid email address before " +
				"this request can be sent.\n\nIf there is a missing or incorrect email " +
				"for the pastor selected, please contact the Safe Sanctuaries office.");
			vm.bReadyToSend = "false";
		}	
	}
	
	vm.pastors_changeHandler = function() {
		if (vm.selPastor != null &&
			vm.selPastor.ENTITYID > 0) {
			getPastorUserAccount(vm.selPastor.ENTITYID);
			if (vm.related == 'Yes') {
				vm.selDS = {};
			} else if (vm.sStepLinkFlag == 'ClergyProfRef') {
				vm.txtRefName = "";
			}
		} else { 
			vm.selPastor = {};
			vm.bReadyToSend = "false"; 
		}
	};
	
	vm.relatedHandler = function(val) {
		if (val == 'Yes') {
			vm.related = "Yes";
			getPastors(0);
			getDSs();
		} else if (vm.iChurchID > 0) {
			vm.related = "No";
			vm.selPastor = {};
			vm.selDS = {};
			getPastors(vm.iChurchID);
		}
	};
	
	vm.sendRequest = function() {
		if (vm.bReadyToSend == "true") { 
			if (vm.bInSendProcedure == false) { //dups prevention
				vm.bInSendProcedure = true;
$log.info("Step:",vm.sStepLinkFlag);
				switch (vm.sStepLinkFlag) { 
					case "PastorRef":
						if (angular.isDefined(vm.selPastor.ENTITYID)==true) {
							if (vm.selPastor.CHURCHPASTORS.indexOf("Rev") > -1) {
								vm.sRefName = "Rev. ";
							} else { vm.sRefName = ""; }
							vm.sRefName += vm.selPastor.FIRSTNAME + " " + vm.selPastor.LASTNAME; 
						} else {
							vm.sRefName = "Rev. " + vm.selDS.FullName; 
						}
						vm.sLinkType = "PR";
					break;
					case "DSRef":
						vm.sRefName = "Rev. " + vm.selDS.FullName;
						vm.sLinkType = "PR";
					break;
					case "ClergyProfRef":
						if (vm.selPastor != null && vm.selPastor.ENTITYID > 0) {
							if (vm.selPastor.CHURCHPASTORS.indexOf("Rev") > -1) {
								vm.sRefName = "Rev. ";
							} else { vm.sRefName = ""; }
							vm.sRefName += vm.selPastor.FIRSTNAME + " " + vm.selPastor.LASTNAME;
							vm.sLinkType = "PR";
						} else if (vm.txtRefName != "") {
							vm.sRefName = vm.txtRefName;
							vm.sLinkType = "Name";
						}
					break;	
				}
				var sParams = loginService.user.USERID + "|" + loginService.user.USERFULLNAME +
					"|" + $rootScope.sProID;
				getReturnCode(525600, sParams);
			}
		} else {
			modalService.okAlert("Missing Entry", 
				"Please select a pastor before clicking to send the reference request.");
		}		
	};
	
	vm.txtRefName_changeHandler = function() {
		if (vm.txtRefName != "") {
			vm.sRefName = vm.txtRefName;
			vm.selPastor = {};
			vm.pastorUserName = "";
		}
	};

}
angular
    .module('proRefs')
    .controller('RefDefaultController', RefDefaultController);

RefDefaultController.$inject = ['webSessionStorage','$stateParams','validatorService','modalService',
	'loginService','$state','$rootScope','dataService','refJSURL','datesService','errorEmailNotification',
	'$log'];

function RefDefaultController(webSessionStorage, $stateParams, validatorService, modalService, 
	loginService, $state, $rootScope, dataService, refJSURL, datesService, errorEmailNotification,
	$log) {
    var vm = this;
    
    vm.bInSendProcedure = false;
	vm.bReadyToSend = "false";
	vm.refReturnCode = "";
	vm.refReturnKey = 0;
    vm.sContactInfo = "";
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.sFrom = "";
	vm.sInitFormText = "";
	vm.sRefEmail = "";
	vm.sRefName = "";
	vm.sReplyTo = "";
	vm.sStepExpires = "";
	
	vm.sStepLinkFlag = $stateParams.sStepLinkFlag;
	vm.refSaveKey = $stateParams.refSaveKey;
	vm.refStepID = $stateParams.refStepID;


//INITIALIZE:
	$rootScope.sCurForm = "Name-Reference Request";
$log.info($rootScope.sCurForm);
// $log.info("$stateParams:",$stateParams)	

	dataService.libGetASetting("ProConfEmail") //or use "RcvEmailReplyToProtect" setting
	.then(function(result) {
		if (result.length > 0) {
			vm.sReplyTo = result[0].SETTINGVALUE;
		} else if ($rootScope.TESTING == true) { 
			dataService.emailSendError("This Conference is missing the ProConfEmail setting."); 
		}
	});
	
	dataService.libGetASetting("RcvEmailFromProtect") //ie: "NWTX Volunteer Registrar"
	.then(function(result) {
		if (result.length > 0) {
			vm.sFrom = result[0].SETTINGVALUE;
		} else if ($rootScope.TESTING == true) { 
			dataService.emailSendError("This Conference is missing the RcvEmailFromProtect setting."); 
		}
	});

	dataService.libGetASetting("ProContactInfo")
	.then(function(result) {
		if (result.length > 0) {
			vm.sContactInfo = result[0].SETTINGVALUE;
		} else if ($rootScope.TESTING == true) { 
			dataService.emailSendError("This Conference is missing the ProContactInfo setting.");
		}
	});
	
	dataService.fxGet("Protect", "Initialization","EmailText")
	.then(function(result) {
		if (result.length > 0) {
			vm.sInitFormText = result[0].TEXT;
		}	
	});
	
	function getReturnCode(iMin, sParams) {
		dataService.secGetReturnCode(iMin, vm.sStepLinkFlag, sParams)
		.then(function(retCode) {
			if (retCode.length > 0) {
				vm.refReturnCode = retCode[0].RETURNCODE;
				vm.refReturnKey = retCode[0].RETURNKEY;
							
				saveProProcessRecord();
			}
		});
	}
	
	function saveProProcessRecord() {
		var sRawDataString = "WebProtect || " + vm.sStepLinkFlag + " || " +
			loginService.user.USERID;
		if (vm.refSaveKey != '') { 
			sRawDataString += " || U || SaveKey==" + vm.refSaveKey; }
		else { sRawDataString += " || I"; }
		sRawDataString += " || ProID==" + $rootScope.sProID + " || StepID==" + 
			vm.refStepID;
		if (vm.sStepExpires != "") {
			sRawDataString += " || StepExpires==" + vm.sStepExpires;
		}
		sRawDataString += " || StepLinkType==Name || StepLink==" + vm.sRefName +
			" || StepProgress==Reference Request Sent || StepRefID==" +
			vm.sRefEmail + "|" + vm.refReturnKey + " ^^ ";
$log.info("proSaveProcess:",sRawDataString);		
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if (result[0].RESULTCODE == "Success") {
				sendEmail();
			}
		});
	}
	
	function sendEmail() { $log.info(vm.sDatabaseID)
		if (vm.sDatabaseID.slice(-3) == "DEV") {
			vm.sRefEmail = "testing@greatspirit.com";
		} else if (vm.sDatabaseID == "VID") {
			vm.sRefEmail = "lyndzie@greatspirit.com";
		}
		vm.sFrom += " <" + vm.sReplyTo + ">";
		var sRefJSLink = refJSURL + "?ReturnCode=" + vm.refReturnCode;
$log.info("Ref:",vm.sStepLinkFlag)		
		switch (vm.sStepLinkFlag) { 
			case "GeneralRef": case "ClergyGenRef": case "ProfRef":
				if (vm.sDatabaseID == "MC" || vm.sDatabaseID == "MC-DEV") {
					dataService.emailSend_MCRefLink(vm.sContactInfo, 
						vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
						vm.sReplyTo, vm.sInitFormText)
					.then(function(result) {
						if (result == "Completed") {
							$state.go('steps', {reload:true});
						} else {
							modalService.okAlert("Send Error",
								"An Error occurred while sending the " +
								"Reference Request email.");
						}
					});
				} else { //MO:
					dataService.emailSend_MORefLink(vm.sContactInfo, 
						vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
						vm.sReplyTo, vm.sInitFormText)
					.then(function(result) {
						if (result == "Completed") {
							$state.go('steps', {reload:true});
						} else {
							modalService.okAlert("Send Error",
								"An Error occurred while sending the " +
								"Reference Request email.");
						}
					});
				}	
			break;
			case "ProfRef1": case "ProfRef2": case "PersonalRef": //All NWTX Refs
// $log.info(vm.sContactInfo, vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink, vm.sReplyTo)			
				dataService.emailSend_NWTXRefLink(vm.sContactInfo, 
					vm.sRefEmail, vm.sFrom, vm.sRefName, sRefJSLink,
					vm.sReplyTo, vm.sInitFormText)
				.then(function(result) {
					if (result == "Completed") {
						$state.go('steps', {reload:true});
					} else {
						modalService.okAlert("Send Error",
								"An Error occurred while sending the " +
								"Reference Request email.");
					}
				});
			break;
		}
	}


/* Broadcasts: */

/* Calls from View: */

	vm.cancel = function() {
		$state.go('steps', {reload:true});
	};
	
	//if name valid, validate & highlight Send as soon as email valid:
	vm.email_changeHandler = function() {
		if (vm.sStepLinkFlag == '' || vm.refStepID == 0 ||
			angular.isUndefined(vm.sStepLinkFlag)==true ||
			angular.isUndefined(vm.refStepID) == true) {
			modalService.okAlert("Oops! We lost something!",
								"We are missing the data indicating which reference you " +
								"are requesting. This may have occurred if you computer sat " +
								"idle too long. Please select to begin the Step again in order " +
								"to refresh your data.");
			$state.go('steps', {reload:true});		
		} else if (vm.sRefEmail != "") {
			if (validatorService.emailIsValid(vm.sRefEmail) == true) {
				if (vm.sRefName != "" && vm.sRefName.indexOf(" ") > -1) {
					vm.bReadyToSend = "true";	
				} else {
					modalService.okAlert("Missing Entry", 
						"Please enter the First and Last names of the person to whom " +
						"you are sending this Reference Request.");
					vm.bReadyToSend = "false";
				}
			} else { vm.bReadyToSend = "false"; }
		} else { vm.bReadyToSend = "false"; }		
	};
		
	vm.sendRequest = function() {
		if (vm.bReadyToSend == "true") {
			if (vm.bInSendProcedure == false) { //dups prevention
				vm.bInSendProcedure = true;
				var sParams = loginService.user.USERID + "|" + loginService.user.USERFULLNAME +
					"|" + $rootScope.sProID;
				switch (vm.sStepLinkFlag) { 
					case "ProfRef1": case "ProfRef2": case "PersonalRef": 	//NWTX No Exp
					case "ClergyGenRef":				//MO No Exp (ALL to Clergy)
						getReturnCode(525600, sParams);
					break;
					default: //2 weeks:
						var dToday = new Date();
						var dExp = new Date(dToday.getTime() + 1.2096e9);
						vm.sStepExpires = datesService.jsDateStrToCalendarStr(dExp);
						getReturnCode(20160, sParams);
					break;
				}		
			}
		} else {
			if (vm.sRefEmail == "") {
				modalService.okAlert("Invalid Entry",
					"You must enter a valid email address before " +
					"this request can be sent.\n\nIf there is a missing or incorrect email " +
					"for the pastor selected, please contact the Safe Sanctuaries office.");
			} else {
				modalService.okAlert("Missing Entry", 
					"Please enter the full name of the person to whom " +
					"you are sending this Reference Request.")
			}
		}		
	};
	
	vm.txtRefName_changeHandler = function() {
		if (vm.sRefName == "") { vm.bReadyToSend = "false"; }
		else if (vm.sRefName.indexOf(" ") == -1) {
			modalService.okAlert("Missing Entry", 
				"Please enter the full name of the person to whom " +
				"you are sending this Reference Request.\n"+
				"(A first and last name with a space in-between.)");
			vm.bReadyToSend = "false";
		}
	};

}

angular
    .module('proRefs')
    .controller('ReferenceController', ReferenceController);

ReferenceController.$inject = ['$rootScope','dataService','$state','modalService',
	'webSessionStorage','$stateParams','errorEmailNotification','loginService','$sce','$log'];

function ReferenceController($rootScope, dataService, $state, modalService,
	webSessionStorage, $stateParams, errorEmailNotification, loginService, $sce, $log) {
    var vm = this;
    
    vm.Applicant = "";
    vm.ApplEmail = "";
    vm.ApplUserID = 0;
	vm.back = { image: "assets/images/left_32.png" };
	vm.dNow = new Date();
	vm.formDefs = [];
	vm.header = "";
	vm.instructions = "";
	vm.iProRefUserID = 0;
	vm.iStepSaveKey = 0;
	vm.DSLabel = "";
	vm.RefData = [];
	vm.RefItems = [];
	vm.sDatabaseID = "";
	vm.sectionHdr = "";
	vm.sProID = "";
	vm.sSaveString = "";
	vm.sStepLinkFlag = "";
	vm.bSubmitted = false;  	//double-click handler
	
	
//INITIALIZE:
	$rootScope.sCurForm = "Reference";	
$log.info("retCodeKey",$stateParams.retCodeKey)	
    dataService.secGetReturnCodeFromKey($stateParams.retCodeKey)
	.then(function(data) { $log.info("data:", data);
		if (data.length > 0) {
			if (data[0].RETURNCODE == "") {
				modalService.okAlert("Reference Completed",
					"This reference has already been completed by someone else.\n" +
					"No further action is needed.\n\n" +
					"Thank-you for your willingness to participate in this process."); 
				$state.go('certMgmt',{reload:true});   
			} else {
				dataService.secReturnLogin(data[0].RETURNCODE)
				.then(function(data) {
					if (data.length > 0) {
						if (data[0].USERNAME == "Expired") {
							modalService.okAlert("Expired",
								"This Reference link has Expired.\n\n" +
								"Please check your Email to see if you have received an " +
								"updated link. If not, no further action is needed.\n\n " +
								"Thank-you for your willingness to participate in this " +
								"process.");
							$state.go('certMgmt', {reload:true}); }	
						else {
							var sParams = data[0].PARAMS;
							var arrParams = sParams.split("|");
							vm.iProRefUserID = data[0].USERID; //all Refs logged in with "ProRef"
							vm.ApplUserID = arrParams[0];
							vm.Applicant = arrParams[1];
							vm.sProID = arrParams[2];
							vm.sStepLinkFlag = data[0].FN;
							
							if (vm.ApplUserID > 0) {
								getUserInfo();
							}
							
							getFormDefs();
							getProcessRecord();
						}	
					}
				});
			}
		}
	});
	
	
	function getFormDefs() {
		dataService.proGetForm(vm.sStepLinkFlag)
		.then(function(data) {
			if (data.length > 0) {
				var obj = { question:"", answer:"", control:""}
				vm.header = data[0].GROUPNAME;
				for (var i=0; i<data.length; i++) {
					switch (data[i].CONTROLTYPE) {
						case "Label-Hdr":
							vm.subHeader = data[i].CAPTION;
						break;
						case "Subheading": 	//Section header
							vm.sectionHdr = data[i].CAPTION;
						break;
						case "txtHTML-Hdr": //contains HTML in table field.
							vm.instructions = $sce.trustAsHtml(data[i].CAPTION);
						break;
						case "Label":
							obj.instructions = data[i].CAPTION;
						break;
						case "Label-bold":
							obj.question = data[i].CAPTION;
						break;
						case "Label-sub":
							obj.example = data[i].CAPTION;
						break;
					//answers:	
						case "VRadio-grp":
						case "VRadio-sub":
						case "Radio-sub":
							obj.id = data[i].ITEMID;
							obj.answer = data[i].CAPTION;
							obj.control = "radio";
							obj.required = data[i].REQUIRED;
							obj.isDefault = false;
							var arr = obj.answer.split("|");
							for (var j=0; j<arr.length; j++) {
								switch (j) {
									case 0: obj.val0 = arr[0]; break;
									case 1: obj.val1 = arr[1]; break;
									case 2: obj.val2 = arr[2]; break;
									case 3: obj.val3 = arr[3]; break;
									case 4: obj.val4 = arr[4]; break;
									case 5: obj.val5 = arr[5]; break;
								}
							}
						break;
						case "TextArea4-sub":
							obj.id = data[i].ITEMID;
							obj.control = "textArea4";
							obj.value = "";
							obj.required = data[i].REQUIRED;
						break;
						case "CustSignature":
						case "Phone_N":
							obj.id = data[i].ITEMID;
							obj.question = data[i].CAPTION;
							obj.control = "textInput";
							obj.required = data[i].REQUIRED;				
						break;
					}
					if (obj.control != "") {
						vm.RefItems.push(obj);
						obj = {question:"", answer:"", control:""};
					}
				}
			}	
		});
	}
	
	function getProcessRecord() {
		dataService.proGetProcessRecordPub(vm.sProID)
		.then(function(data) {
			if (data.length > 0) {
				for (var i=0; i<data.length; i++) {
					if (data[i].STEPLINKFLAG == vm.sStepLinkFlag) {
						vm.iStepSaveKey = data[i].SAVEKEY;
					break; }	
				}
			}
		});	
	}
	
	function getUserInfo() {
		dataService.usersGetOne(vm.ApplUserID)
		.then(function(data) {
			if (data.length > 0) {
				vm.ApplEmail = data[0].USEREMAIL;
			}
		});
	}
	
	function saveProData() {
		vm.sSaveString = "WebApps_Pro || Ref_SaveData || " + loginService.user.USERID + " || ";
		for (var i=0; i<vm.RefData.length; i++) {
			vm.sSaveString += "I || ProID==" + vm.sProID +
				" || ItemID==" + vm.RefData[i].id + 
				" || ItemData==" + vm.RefData[i].value + " ^^ ";
		}

		dataService.proSaveFormData(vm.sSaveString)
		.then(function(data) {
			if (data.length > 0) {
				for (i=0; i<data.length; i++) {
					if (data[i].RESULTCODE == "Error") {
						modalService.okAlert("Save Error",
							"There was an error saving all of the data. \n" +
								"Please contact the Safe Sanctuaries office \n" +
								"to follow-up with any additional action needed.");
						var sEmailContent = errorEmailNotification.error2("refCtrl/saveProData");
						dataService.emailSendError(sEmailContent);			  
						
						$state.go('certMgmt',{reload:true});
					}
					else if (i == data.length-1) {
						saveProProcessStep();
					}
				}
			}
		});		
	}
	
	function saveProProcessStep() {
		var sToday = Number(vm.dNow.getMonth()+1) + "/" + vm.dNow.getDate() + "/" + 
			vm.dNow.getFullYear(); 
		vm.sSaveString = "WebApps_Pro || Ref_ProProcess || " + loginService.user.USERID + 
			" || U || SaveKey==" + vm.iStepSaveKey + " || StepDate==" + sToday + 
			" || StepExpires== || StepProgress==Completed ^^ ";
		
		dataService.proSaveProcess(vm.sSaveString)
		.then(function(data) {
			if (data.length > 0) {
				if (data[0].RESULTCODE == "Error") {
					var sEmailContent = errorEmailNotification.error2("refCtrl/saveProProcessStep");
					dataService.emailSendError(sEmailContent);	
				} else {
					deleteReturnCode();
					
					//And update new ProRefTracker:
					dataService.proSaveRefTracker(loginService.user.USERID);
				}
			}	
		});
	}
	
	function deleteReturnCode() {
		dataService.secDeleteReturnCodeFromKey($stateParams.retCodeKey)
		.then(function(data) {
			if (data[0].RESULTS != "Delete Succeeded") {
				var sEmailContent = errorEmailNotification.error1("refCtrl/deleteReturnCode");
				dataService.emailSendError(sEmailContent)
			}
			notifyApplicant_ReferenceIsComplete();									
		});
	}
	
	function notifyApplicant_ReferenceIsComplete() {
		var sDatabaseID = webSessionStorage.getStoredData("sDatabaseID");
		
		/* Currently ONLY MO uses the ProtectReferences app, as they are the only 
			conference using PR/StepLinkType with EntityIDs (used for Pastor selection). */
		switch (sDatabaseID) {
			case "MO":
				var sReplyTo = "SSanctuaries@moumethodist.org";
				var sFrom = "Safe Sanctuaries Administrator <" + sReplyTo + ">";
			break;
			case "VID":
				vm.ApplEmail = "lyndzie@greatspirit.com";
				sReplyTo = "mchelp@greatspirit.com";
				sFrom = "GSS Testing <mchelp@greatspirit.com>";
			break;
			default:
				vm.ApplEmail = "testing@greatspirit.com";
				sReplyTo = "mchelp@greatspirit.com";
				sFrom = "GSS Testing <mchelp@greatspirit.com>";
			break;	
		}
		var sSubject = "Reference Completed!";
		var sURLLink = "https://umcdata.net/MissionConnect/Public/Protect/Web_Protect.html?conf=" + sDatabaseID;
		var sEmailContent = loginService.user.USERFULLNAME +  
			" has successfully submitted the requested reference.<br><br>" +
			"You may return to the web site to verify your progress and manage references " +
			"still outstanding.<br><br>For your convenience, the link is provided below: " +
			"<br><br>" + 
			"<FONT COLOR='#0000FF'><A HREF=" + sURLLink + "><U>" + sURLLink + "</U></A></FONT>";
		dataService.emailSendCustom(vm.ApplEmail, sFrom, sReplyTo, sSubject, sEmailContent)
		.then(function(data) {
			if (data == "Completed") {
			modalService.okAlert("Success",
				"The reference for " + vm.Applicant + 
					" has been successfully submitted.");
				$state.go('certMgmt',{reload:true});
			}			      
		});	
	}
	
	
	
//Called Functions:	
	vm.goToReferral = function() {
		$state.go('refer', {
			Applicant: vm.Applicant,
			ApplUserID: vm.ApplUserID,		
			iProRefUserID: vm.iProRefUserID,
			iStepSaveKey: vm.iStepSaveKey,		
			retCodeKey: $stateParams.retCodeKey,
			sProID: vm.sProID,		
			sStepLinkFlag: vm.sStepLinkFlag
		});
	}; 
	
	vm.saveSelection = function(id, value, req) {
		if (vm.RefData.length > 0) {
			for (var i=0; i<vm.RefData.length; i++) {
				if (vm.RefData[i].id == id) {
					vm.RefData[i].value = value;
					vm.RefData[i].req = req;
				break; }
				else if (i == vm.RefData.length-1) {
					vm.RefData.push({ id:id, value:value, req:req });
				}
			}
		}
		else {
			vm.RefData.push({ id:id, value:value, req:req });
		}
	};
	
	vm.submitReference = function() {
		if (vm.RefData.length > 0) {
			var bReadyToSave = true;
			for (var i=0; i<vm.RefItems.length; i++) {
				if (bReadyToSave == true && vm.RefItems[i].required == true) {
					for (var j=0; j<vm.RefData.length; j++) {
						if (vm.RefData[j].id == vm.RefItems[i].id && vm.RefData[j].value != "") { 
						break; }
						else if (j == vm.RefData.length-1) {
							bReadyToSave = false;
							modalService.okAlert("Missing Required Entry", 
								"One or more required items is incomplete.<br>" +
								"The first missing item is:<br><br>" + vm.RefItems[i].question +
								"<br><br>Please complete the entire reference before clicking " +
								"to Submit.");
						}
					}
				} 
			}
			if (bReadyToSave && vm.bSubmitted == false) {
				vm.bSubmitted = true;
				saveProData();
			}
		} else {
			modalService.okAlert("Missing Entry", 
				"You must complete this Reference before clicking to Submit.");
		}
	};
}
angular		
	.module('proRefs')
	.controller('NWTXReqController', NWTXReqController);

NWTXReqController.$inject = ['dataService','$sce','$state'];
	
function NWTXReqController(dataService, $sce, $state) {
	var vm = this; 	//vmNReq
	
	vm.back = { image: "assets/images/left_32.png" };
	vm.sCampReq = "";
	
	
/* Initialize: */
	dataService.fxGet("WebAppsPro", "Payment", "CampReq")
		.then(function(text) {
		if (text.length > 0) {
			vm.sCampReq = $sce.trustAsHtml(text[0].TEXT);
		}
	});
	

/* Called from view: */		
	
	vm.returnToPaymentPage = function() {
        $state.go('nwtxPayment', {iCertTypeID:4}, {reload:true});
    };
	
}	

angular
    .module('proRefs')
    .controller('NWTXPaymentController', NWTXPaymentController);

NWTXPaymentController.$inject = ['dataService','$stateParams','$sce','datesService','modalService',
	'loginService','errorEmailNotification','$rootScope','vancoService','webSessionStorage',
	'$state','$httpParamSerializer','payPalService','$log'];

function NWTXPaymentController(dataService, $stateParams, $sce, datesService, modalService, 
	loginService, errorEmailNotification, $rootScope, vancoService, webSessionStorage,
	$state, $httpParamSerializer, payPalService, $log) {
    var vm = this; //NPay

	vm.newCamp = { image: "assets/images/plus_16.png" };
	vm.arrCamps = [];
	vm.arrDataFields = [];
	vm.arrFeesVouchers = [];
	vm.arrData = [];
	vm.arrDefs = [];
	vm.back = { image: "assets/images/left_32.png" };
	vm.bPayFee = false;
	vm.bSaveProcedure = false;	//double-click handler
	vm.bShow2 = false;
	vm.bShow3 = false;
	vm.bShow4 = false;
	vm.bVoucher = false;		//a Voucher is in use, so add checkBox at bottom
	vm.displayGrp1 = [];
	vm.header1 = "";
	vm.header2 = "";
	vm.iCertTypeID = $stateParams.iCertTypeID;
	vm.iRcvID = 0;
	vm.nDonateAmt = 0;
	vm.nFee = 0;
	vm.nTrainingFee = 0;
	vm.nPayAmt = 0;
	vm.paymentStepID = $stateParams.paymentStepID;
	vm.paymentSaveKey = $stateParams.paymentSaveKey;
	vm.selCamp1 = {};
	vm.selCamp2 = {};
	vm.selCamp3 = {};
	vm.selCamp4 = {};
	vm.sInstructions1 = "";
	vm.sCampInstr2 = "";
	vm.sPayPalLogin = "";
	vm.sPayPalPostURL = "";
	vm.sPayPalURL = "";
	vm.v1BtnText = "Apply Voucher";
	vm.v2BtnText = "Apply Voucher";
	vm.v3BtnText = "Apply Voucher";
	vm.v4BtnText = "Apply Voucher";
	vm.vWillPay = false;
    
    
//INITIALIZATION:
    $rootScope.sCurForm = "NWTX Payment Form";
$log.info($rootScope.sCurForm);
    
    dataService.fxGet("WebAppsPro", "Payment", "X")
	.then(function(text) {
		if ($stateParams.iCertTypeID == 4) {
			for (var i=0; i<text.length; i++) {
				switch (text[i].TEXTID) {
					case "CampInstr1": 
						vm.sInstructions1 = $sce.trustAsHtml(text[i].TEXT);
					break;
					case "CampInstr2":
						vm.sCampInstr2 = $sce.trustAsHtml(text[i].TEXT);
					break;
				}
			}	
		} else { //iCertTypeID == 5: VIM
			for (i=0; i<text.length; i++) {
				switch (text[i].TEXTID) {
					case "VIMInstr": 
						vm.sInstructions1 = $sce.trustAsHtml(text[i].TEXT);
					break;
				}
			}
		}
	});
    
    if (vm.iCertTypeID == 4) {
		dataService.libGetASetting('ProCampVolFee')
		.then(function(fee) {
			vm.nFee = fee[0].SETTINGVALUE;
		});
		
		dataService.libGetASetting('ProCampDonateAmt')
		.then(function(donate) {
			vm.nDonateAmt = donate[0].SETTINGVALUE;
		});
		
		dataService.suLoadEventsLite("|open|")
		.then(function(events) {
			vm.arrCamps = events;
			for (var i=0; i<vm.arrCamps.length; i++) {
				vm.arrCamps[i].CampListing = vm.arrCamps[i].SITENAME + ": " + 
					vm.arrCamps[i].EVENTNAME + " [" + 
					datesService.jsDateStrToCalendarStr(vm.arrCamps[i].EVENTSTARTDATE) + 
					" - " +
					datesService.jsDateStrToCalendarStr(vm.arrCamps[i].EVENTSTOPDATE) + "]"; 
			}
			
			dataService.proGetFormData("CampPayment")
			.then(function(data) { //$log.info("data:",data)
				if (data.length > 0) {
					vm.arrData = data;
				}
				
				dataService.proGetFeesVouchers()
				.then(function(feesV) {
					if (feesV.length > 0) {
						vm.arrFeesVouchers = feesV;
					}
					
					dataService.proGetForm("CampPayment")
					.then(function(defs) { //$log.info("defs:",defs)
						vm.arrDefs = defs;
							createForm();
					});
				});
			});			
		});	
    } else { 
		dataService.libGetASetting('ProVIMVolFee')
		.then(function(data) {
			vm.nFee = data[0].SETTINGVALUE;
		});
		
		dataService.libGetASetting('ProVIMTrainingFee')
		.then(function(data) {
			vm.nTrainingFee = data[0].SETTINGVALUE;
		});
		
		dataService.proGetFormData("VIMPayment")
		.then(function(data) {  //$log.info("Data:",data);
			if (data.length > 0) {
				vm.arrData = data;
			}
			
			dataService.proGetFeesVouchers()
			.then(function(feesV) {  //$log.info("Fees:",feesV);
				if (feesV.length > 0) {
					vm.arrFeesVouchers = feesV;
				}
				
				dataService.proGetForm("VIMPayment")
				.then(function(defs) { //$log.info("Defs:",defs);
					vm.arrDefs = defs;
					createForm();
				});
			});	
		});
	}
	
	function createForm() {
		for (var i=0; i<vm.arrDefs.length; i++) {
			var obj = {id:vm.arrDefs[i].ITEMID, label:"",
				control:vm.arrDefs[i].CONTROLTYPE, itemName:vm.arrDefs[i].ITEMNAME, 
				seq:vm.arrDefs[i].ITEMSEQ, saveKey:0, required:vm.arrDefs[i].REQUIRED,
				group:vm.arrDefs[i].GROUPNAME, grpSeq:vm.arrDefs[i].GROUPSEQ, data:"",
				fee:0.00, feeSaveKey:0, donate:false, donAmt:0, voucher:"", vAmt:0}

			for (var j=0; j<vm.arrData.length; j++) {
				if (vm.arrData[j].ITEMID == vm.arrDefs[i].ITEMID) {
					obj.data = vm.arrData[j].ITEMDATA;
					obj.saveKey = vm.arrData[j].SAVEKEY;
				break; }
			}

			//FeeItemID==EventID stored in obj.data:
			for (j=0; j<vm.arrFeesVouchers.length; j++) {
				if (vm.arrFeesVouchers[j].FEEITEMID == obj.data) {
					obj.donAmt = vm.arrFeesVouchers[j].DONAMT;
					if (obj.donAmt > 0) { obj.donate = true; }
					obj.fee = vm.arrFeesVouchers[j].FEEAMT.toFixed(2);
					obj.feeSaveKey = vm.arrFeesVouchers[j].SAVEKEY;
					if (vm.arrFeesVouchers[j].VOUCHERCODE != "") {
						obj.voucher = vm.arrFeesVouchers[j].VOUCHERCODE;
						getVoucherValue(obj);
					}
				break; }
			}
			
			switch (vm.arrDefs[i].CONTROLTYPE) {
				case "CheckBox":
					obj.label = vm.arrDefs[i].CAPTION;
					vm.vWillPay = obj.data; 
				break;	
				case "FeeOption":
					obj.label = vm.arrDefs[i].CAPTION;
				break;
				case "NWTX_DLCamp":
					switch (vm.arrDefs[i].ITEMNAME) {
						case "CampSelection1":
							obj.label = "1st Camp Selection";
							if (obj.data != "") {
								for (j=0; j<vm.arrCamps.length; j++) {
									if (vm.arrCamps[j].EVENTID == obj.data) {
										vm.selCamp1 = vm.arrCamps[j];
									break; }
								}	
							}
						break;
						case "CampSelection2":
							obj.label = "2nd Camp Selection";
							if (obj.data != "") {
								for (j=0; j<vm.arrCamps.length; j++) {
									if (vm.arrCamps[j].EVENTID == obj.data) {
										vm.selCamp2 = vm.arrCamps[j];
										vm.bShow2 = true;
									break; }
								}
							}	
						break;	
						case "CampSelection3":
							obj.label = "3rd Camp Selection";
							if (obj.data != "") {
								for (j=0; j<vm.arrCamps.length; j++) {
									if (vm.arrCamps[j].EVENTID == obj.data) {
										vm.selCamp3 = vm.arrCamps[j];
										vm.bShow3 = true;
									break; }
								}
							}	
						break;	
						case "CampSelection4":
							obj.label = "4th Camp Selection";
							if (obj.data != "") {
								for (j=0; j<vm.arrCamps.length; j++) {
									if (vm.arrCamps[j].EVENTID == obj.data) {
										vm.selCamp4 = vm.arrCamps[j];
										vm.bShow4 = true;
									break; }
								}
							}	
						break;	
					}
				break;
				case "TextInput":
					obj.label = vm.arrDefs[i].CAPTION;
				break;
				default:
					obj.label = vm.arrDefs[i].CAPTION;
				break;	
			}
			
			vm.arrDataFields.push(obj); //$log.info("arrDataFields:",vm.arrDataFields)
		}
		updateDataFields(); //calculatePayAmount();
	}
	
	function calculatePayAmount() {
		var total = 0;
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].fee > 0) {
				total += Number(vm.arrDataFields[i].fee);
				if (vm.arrDataFields[i].voucher != "") {
					total += Number(vm.arrDataFields[i].vAmt);
				}
			}
		}
		vm.nPayAmt = total.toFixed(2);
	}
	
	function updateDataFields() {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			switch (vm.arrDataFields[i].itemName) {
				case "CampSelection1":
					if (vm.selCamp1 != null && angular.isDefined(vm.selCamp1.EVENTID) == true) {
						vm.arrDataFields[i].data = vm.selCamp1.EVENTID;
						if (vm.arrDataFields[i].donate == false) {
							vm.arrDataFields[i].fee = vm.nFee.toFixed(2); }
						else {
							var fee = vm.nFee + vm.arrDataFields[i].donAmt;
							vm.arrDataFields[i].fee = fee.toFixed(2);
						}
					} else {
						vm.arrDataFields[i].data = "";
						vm.arrDataFields[i].voucher = "";
						vm.arrDataFields[i].vAmt = 0;
						vm.arrDataFields[i].donate = false;
						vm.arrDataFields[i].fee = 0.00;
/*	//If change SP to allow Donations, with OUT a camp selection... use this code: (copied to each Camp Selection)
						if (vm.arrDataFields[i].donate == false) {
							vm.arrDataFields[i].fee = 0.00; }
						else {
							fee = vm.arrDataFields[i].donAmt;
							vm.arrDataFields[i].fee = fee.toFixed(2);
						}
*/
					}
				break;
				case "CampSelection2": 
					if (vm.selCamp2 != null && angular.isDefined(vm.selCamp2.EVENTID) == true) {
						vm.arrDataFields[i].data = vm.selCamp2.EVENTID;
						if (vm.arrDataFields[i].donate == false) {
							vm.arrDataFields[i].fee = vm.nFee.toFixed(2); }
						else {
							fee = vm.nFee + vm.arrDataFields[i].donAmt;
							vm.arrDataFields[i].fee = fee.toFixed(2);
						}
					} else {
						vm.arrDataFields[i].data = "";
						vm.arrDataFields[i].voucher = "";
						vm.arrDataFields[i].vAmt = 0;
						vm.arrDataFields[i].donate = false;
						vm.arrDataFields[i].fee = 0.00;
					}
				break;
				case "CampSelection3": 
					if (vm.selCamp3 != null && angular.isDefined(vm.selCamp3.EVENTID) == true) {
						vm.arrDataFields[i].data = vm.selCamp3.EVENTID;
						if (vm.arrDataFields[i].donate == false) {
							vm.arrDataFields[i].fee = vm.nFee.toFixed(2); }
						else {
							fee = vm.nFee + vm.arrDataFields[i].donAmt;
							vm.arrDataFields[i].fee = fee.toFixed(2);
						}
					} else {
						vm.arrDataFields[i].data = "";
						vm.arrDataFields[i].voucher = "";
						vm.arrDataFields[i].vAmt = 0;
						vm.arrDataFields[i].donate = false;
						vm.arrDataFields[i].fee = 0.00;
					}
				break;
				case "CampSelection4": 
					if (vm.selCamp4 != null && angular.isDefined(vm.selCamp4.EVENTID) == true) {
						vm.arrDataFields[i].data = vm.selCamp4.EVENTID;
						if (vm.arrDataFields[i].donate == false) {
							vm.arrDataFields[i].fee = vm.nFee.toFixed(2); }
						else {
							fee = vm.nFee + vm.arrDataFields[i].donAmt;
							vm.arrDataFields[i].fee = fee.toFixed(2);
						}
					} else {
						vm.arrDataFields[i].data = "";
						vm.arrDataFields[i].voucher = "";
						vm.arrDataFields[i].vAmt = 0;
						vm.arrDataFields[i].donate = false;
						vm.arrDataFields[i].fee = 0.00;
					}
				break;
			}
		}
		calculatePayAmount();	
	}
	
	function getVoucherValue(objCurData) {
		dataService.rcvGetVoucher(objCurData.voucher)
		.then(function(vouch) { //$log.info("vouch:",vouch);
			if (vouch.length > 0) {
				if (vouch[0].VOUCHERTYPE == "CreditUnlimited" ||
					(vouch[0].VOUCHERTYPE == "CreditLimited" &&
					vouch[0].AMOUNTBALANCE > 0)) {
					switch (vouch[0].VALUETYPE) {
						case "percent":
							if (objCurData.donAmt > 0) {
								var vAmt = (objCurData.fee-objCurData.donAmt) * 
									(Number(vouch[0].VALUEAMOUNT)/100);
							} else {
								vAmt = objCurData.fee * (Number(vouch[0].VALUEAMOUNT)/100);
							}
						break;
						case "dollars":
							vAmt = Number(vouch[0].VALUEAMOUNT);
						break;
					}
					if (vouch[0].MAXVALUEPERUSE == "" ||
						vAmt <= vouch[0].MAXVALUEPERUSE) {
						objCurData.vAmt = Number(vAmt * -1).toFixed(2);
					} else {
						objCurData.vAmt = Number(vouch[0].MAXVALUEPERUSE * -1).toFixed(2);
					}
					switch (objCurData.itemName) {
						case "VIMType": vm.v1BtnText = "Remove Voucher"; break;
						case "CampSelection1": vm.v1BtnText = "Remove Voucher"; break;
						case "CampSelection2": vm.v2BtnText = "Remove Voucher"; break;
						case "CampSelection3": vm.v3BtnText = "Remove Voucher"; break;
						case "CampSelection4": vm.v4BtnText = "Remove Voucher"; break;
					}		
					vm.bVoucher = true; 
					calculatePayAmount();
				} else {
					modalService.okAlert("No Available Credit",
						"There is no available credit left on this Voucher. " +			
						"Please ensure you have entered the Voucher Code correctly. If so, " +
						"contact Conference staff for further assistance.");
				}
			} else {
				modalService.okAlert("Invalid Entry",
					"There is no voucher for the entered Code. " +
					"Please ensure you have entered the Voucher Code correctly.");
			}
		});
	}
	
	function saveData() {
		var sRawDataString = "WebApps_Pro || NwtxPayment || " + loginService.user.USERID + " || ";
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].data != "") {
				if (vm.arrDataFields[i].saveKey > 0) {
					sRawDataString += "U || SaveKey==" + vm.arrDataFields[i].saveKey;
				} else { sRawDataString += "I"; }
				sRawDataString += " || ProID==" + $rootScope.sProID + " || ItemID==" +
					vm.arrDataFields[i].id + " || ItemData==" + vm.arrDataFields[i].data + " ^^ "; 
			} else if (vm.arrDataFields[i].saveKey > 0) {
				sRawDataString += "D || SaveKey==" + vm.arrDataFields[i].saveKey + " ^^ ";
			}
		} //$log.info("saveData:", sRawDataString)
		
		dataService.proSaveFormData(sRawDataString) 
		.then(function(results) {
			if (results[0].RESULTCODE == 'Success') {
				saveFeesVouchers();
			} else {
				var sEmailContent = errorEmailNotification.error4("nwtxPaymentCtrl/saveData") +
					"<br><br>Error: " + results[0].RESULTCODE;
				dataService.emailSendError(sEmailContent);
			}
		});
	}
	
	function saveFeesVouchers() {
		var sRawDataString = "WebApps_Pro || NwtxPayment || " + loginService.user.USERID + " || ";
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].fee > 0) {
				if (vm.arrDataFields[i].feeSaveKey > 0) {
					sRawDataString += "U || SaveKey==" + vm.arrDataFields[i].feeSaveKey;
				} else { sRawDataString += "I"; }
				sRawDataString += " || ProID==" + $rootScope.sProID + " || FeeItemID==" + 
					vm.arrDataFields[i].data + " || FeeAmt==" + vm.arrDataFields[i].fee + 
					" || DonAmt==" + vm.arrDataFields[i].donAmt + " || VoucherCode==" + 
					vm.arrDataFields[i].voucher + " ^^ ";
			} else if (vm.arrDataFields[i].feeSaveKey > 0) {
				sRawDataString += "D || SaveKey==" + vm.arrDataFields[i].feeSaveKey + " ^^ ";
			}
		} //$log.info("saveFeesVouchers:",sRawDataString);
		
		dataService.proSaveFeesVouchers(sRawDataString)
		.then(function(results) { //$log.info("proSaveFeesVouchers:",results)
			if (results[0].RESULTCODE == 'Success') {
				savePaymentProcessStep();
			} else {
				var sEmailContent = errorEmailNotification.error4("nwtxPaymentCtrl/saveFeesVouchers");
				sEmailContent += "<br><br>Error: " + results[0].RESULTREASON;
				dataService.emailSendError(sEmailContent);
			}		
		});
	}
	
	function savePaymentProcessStep() {
		/*.132 - ReADD vm.paymentStepID data to var in stepsCtrl before passing as $stateParam to prevent 
			save as "0" here. ~ 5/16/18 lds */
		//.133 - Hardcoded paymentStepID in Steps $stateParam populating vm.paymentStepID. ~ lds	
		var sRawDataString = "WebProtect || PayFee.133 || " + loginService.user.USERID;
			if (vm.paymentSaveKey == 0) { sRawDataString += " || I"; }
			else { sRawDataString += " || U || SaveKey==" + vm.paymentSaveKey; }
		sRawDataString += " || ProID==" + $rootScope.sProID + " || StepID==" +
			vm.paymentStepID + " || StepDate==";
			
		if (vm.nPayAmt > 0) {
			sRawDataString += " || StepProgress==Started, Update Pending ^^ ";
		} else {
			sRawDataString += datesService.todayToDbString() + " || StepProgress==Completed ^^ ";
		}

		dataService.proSaveProcess(sRawDataString)
		.then(function(retProcess) {
			if (retProcess[0].RESULTCODE == "Success") {
				if (vm.nPayAmt == 0) {
					$state.go('steps',{reload:true});	
/* -- Removed. One applicant seemed to keep clicking payment button due to not clearing message,
	thus didn't advance to steps. Message not necessary. ~ 5/21/18 lds 
					
*/
					
				} else { 
					payPalService.goToPayPalVarFee(vm.nPayAmt, vm.iCertTypeID);
				}	
			} else {
				var sEmailContent = errorEmailNotification.error4("nwtxPaymentCtrl/savePaymentProcessStep");
				dataService.emailSendError(sEmailContent);
			}
		});		
	}
	
	
/* Broadcasts: */

/* Calls from View: */
	
	vm.addCamp = function() {
		if (vm.selCamp1.EVENTID != undefined) {
			if (vm.bShow2 == false) { vm.bShow2 = true; }
			else if (vm.selCamp2.EVENTID != undefined) {
				if (vm.bShow3 == false) { vm.bShow3 = true; }
				else if (vm.selCamp3.EVENTID != undefined) {
					if (vm.bShow4 == false) { vm.bShow4 = true; }	
				} else {
					modalService.okAlert("Invalid Entry",
						"Please make 3rd Camp Selection before adding " +
						"another camp.");
				}		
			} else {
				modalService.okAlert("Invalid Entry",
					"Please make 2nd Camp Selection before adding " +
					"another camp.");
			}		
		} else {
			modalService.okAlert("Invalid Entry",
				"Please make 1st Camp Selection before adding " +
				"another camp.");
		}
	};
	
	vm.changeHandler = function(id,value) { //$log.info("id",id,value)
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].id == id) {
				vm.arrDataFields[i].data = value;	
				
				switch (vm.arrDataFields[i].itemName) {
					case "FinancialChk":
						//store data for voucher payment responsibility
						vm.arrDataFields[i].data = vm.vWillPay;
					break;
					case "VIMType":
						switch (value) {
							case "Member": case "Leader":
								vm.arrDataFields[i].fee = vm.nFee.toFixed(2);
							break;
							case "Training":
								vm.arrDataFields[i].fee = vm.nTrainingFee.toFixed(2);
							break;		
						}
						calculatePayAmount();
					break;	
				}
			break; }
		}	
};
	
	/* Handled apart from all other fee fields, to allow user to 
		donate with NO CAMP selection */
	vm.donateHandler = function(id) {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].id == id) {
				if (vm.arrDataFields[i].donate == true) {
					vm.arrDataFields[i].donAmt = vm.nDonateAmt;
					var fee = Number(vm.arrDataFields[i].fee) + Number(vm.nDonateAmt);
					vm.arrDataFields[i].fee = fee.toFixed(2);
				} else { 
					vm.arrDataFields[i].donAmt = 0;
					fee = Number(vm.arrDataFields[i].fee) - Number(vm.nDonateAmt);
					vm.arrDataFields[i].fee = fee.toFixed(2);
				}
			break; }
		}
		calculatePayAmount();	
	};
	
	vm.goToCampReq = function() {
		$state.go('nwtxCampReq', {reload:true});
	};
	
	vm.payNow = function() {
		if (vm.iCertTypeID == 4) { //$log.info("selCamp1:",vm.selCamp1)
			if (vm.bSaveProcedure == false) { //v.143 05/21/18 lds
				if (vm.selCamp1 != null && angular.isDefined(vm.selCamp1.EVENTID) == true) {
					if (vm.bVoucher==false || (vm.bVoucher==true && vm.vWillPay==true)) {
						vm.bSaveProcedure = true;  
						saveData();
					} else if (vm.bVoucher==true) {
						modalService.okAlert("Missing Entry", 
							"If you are using a Voucher Code, you must check that " +
							"you have read and understand your payment responsibility.");
					}
				} else {
					modalService.okAlert("Missing Entry", 
						"The 1st Camp Selection is missing. " +
						"You must make a camp selection before clicking to Pay.");
				}		
			}
		} else { //iCertTypeID = 5 (VIM)
			for (var i=0; i<vm.arrDataFields.length; i++) {
				if (vm.arrDataFields[i].required == true && vm.arrDataFields[i].data == "") {
					modalService.okAlert("Missing Required Entry", 
						"One or more required fields " +
						"is incomplete.\n\nPlease complete ALL " +
						"required fields before clicking to Save " +
						"and Submit your data.\n\n" +
						"The first missing field is: " + vm.arrDataFields[i].label);
				break; }
				else if (i == vm.arrDataFields.length-1) {
					if (vm.bVoucher==false || (vm.bVoucher==true && vm.vWillPay==true)) {
						saveData();
					} else if (vm.bVoucher==true) {
						modalService.okAlert("Missing Entry", 
							"If you are using a Voucher Code, you must check that " +
							"you have read and understand your payment responsibility.");
					}		
				}
			}
		}	
	};
	
	vm.updateData = function () {
		updateDataFields();
	};
	
	vm.voucherHandler = function(vNum) {
		switch (vNum) {
			case 1:
				for (var i=0; i<vm.arrDataFields.length; i++) {
					if (vm.arrDataFields[i].itemName == "CampSelection1") {
						if (vm.v1BtnText == "Apply Voucher") {
							if (vm.selCamp1 != null && angular.isDefined(vm.selCamp1.EVENTID)==true) { 
								getVoucherValue(vm.arrDataFields[i]);
								vm.v1BtnText = "Remove Voucher";
							} else { 
								vm.arrDataFields[i].voucher = "";
								vm.arrDataFields[i].vAmt = 0;
								modalService.okAlert("Missing Entry", 
									"You must first select a camp before applying a " +
									"voucher towards the Camp Fee.")
							}	
						} else {
							vm.arrDataFields[i].voucher = "";
							vm.arrDataFields[i].vAmt = 0;
							vm.v1BtnText = "Apply Voucher";
							calculatePayAmount();
						}	
					break; }
					else if (vm.arrDataFields[i].itemName == "VIMType") {
						if (vm.v1BtnText == "Apply Voucher") {
							getVoucherValue(vm.arrDataFields[i]);
							vm.v1BtnText = "Remove Voucher";
						} else {
							vm.arrDataFields[i].voucher = "";
							vm.arrDataFields[i].vAmt = 0;
							vm.v1BtnText = "Apply Voucher";
							vm.bVoucher = false;
							calculatePayAmount();
						}
					}
				}
			break;
			case 2:
				for (i=0; i<vm.arrDataFields.length; i++) {
					if (vm.arrDataFields[i].itemName == "CampSelection2") {
						if (vm.v2BtnText == "Apply Voucher") {
							if (vm.selCamp2 != null && angular.isDefined(vm.selCamp2.EVENTID)==true) { 
								getVoucherValue(vm.arrDataFields[i]);
								vm.v2BtnText = "Remove Voucher";
							} else { 
								vm.arrDataFields[i].voucher = "";
								vm.arrDataFields[i].vAmt = 0;
								modalService.okAlert("Missing Entry", 
									"You must first select a camp before applying a " +
									"voucher towards the Camp Fee.")
							}
						} else {
							vm.arrDataFields[i].voucher = "";
							vm.arrDataFields[i].vAmt = 0;
							vm.v2BtnText = "Apply Voucher";
							calculatePayAmount();
						}	
					break; }
				}
			break;
			case 3:
				for (i=0; i<vm.arrDataFields.length; i++) {
					if (vm.arrDataFields[i].itemName == "CampSelection3") {
						if (vm.v3BtnText == "Apply Voucher") {
							if (vm.selCamp3 != null && angular.isDefined(vm.selCamp3.EVENTID)==true) { 
								getVoucherValue(vm.arrDataFields[i]);
								vm.v3BtnText = "Remove Voucher";
							} else { 
								vm.arrDataFields[i].voucher = "";
								vm.arrDataFields[i].vAmt = 0;
								modalService.okAlert("Missing Entry", 
									"You must first select a camp before applying a " +
									"voucher towards the Camp Fee.")
							}
						} else {
							vm.arrDataFields[i].voucher = "";
							vm.arrDataFields[i].vAmt = 0;
							vm.v3BtnText = "Apply Voucher";
							calculatePayAmount();
						}	
					break; }
				}
			break;
			case 4:
				for (i=0; i<vm.arrDataFields.length; i++) {
					if (vm.arrDataFields[i].itemName == "CampSelection4") {
						if (vm.v4BtnText == "Apply Voucher") {
							if (vm.selCamp4 != null && angular.isDefined(vm.selCamp4.EVENTID)==true) { 
								getVoucherValue(vm.arrDataFields[i]);
								vm.v4BtnText = "Remove Voucher";
							} else { 
								vm.arrDataFields[i].voucher = "";
								vm.arrDataFields[i].vAmt = 0;
								modalService.okAlert("Missing Entry", 
									"You must first select a camp before applying a " +
									"voucher towards the Camp Fee.")
							}
						} else {
							vm.arrDataFields[i].voucher = "";
							vm.arrDataFields[i].vAmt = 0;
							vm.v4BtnText = "Apply Voucher";
							calculatePayAmount();
						}	
					break; }
				}
			break;
		}
		//Find if Voucher in use:
		vm.bVoucher = false;
		for (var j=0; j<vm.arrDataFields.length; j++) {
			if (vm.arrDataFields[j].voucher != "") {
				vm.bVoucher = true;
			break; }
		}
	};
	
}
angular
    .module('proRefs')
    .controller('NewAcctController', NewAcctController);

NewAcctController.$inject = ['$rootScope','$state','passwordStrength','validatorService',
	'confirmPWChg', 'dataService','loginService','contactInfo','datesService',
	'webSessionStorage','userAcctEmails','modalService','errorEmailNotification','$log'];	

function NewAcctController($rootScope, $state, passwordStrength, validatorService,
	confirmPWChg, dataService, loginService, contactInfo, datesService, 
	webSessionStorage, userAcctEmails, modalService, errorEmailNotification, $log) {
	var vm = this;	//vmUA

    vm.bReadyToSave = 'false';
    vm.bReadyToSaveEmail = false;
    vm.bReadyToSavePW = false;
    vm.bReadyToSaveUsername = false;
    vm.imgMCBanner = { image: "assets/images/McCurdy.png" };
    vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
    vm.sPasswordStrength = "Too Short";
    vm.sProID = "";							//ONLY used in McCurdy Protect Initialization
    vm.sPWClass = "tooShort";
    vm.sSaveSuccessMsg = "";
    
    vm.data = {
		firstName:"", lastName:"",
		password:"", confirmPW:"",
		email:"", confirmEmail:"",
		userName:""};					
	vm.iEntityID = 0;
	vm.iUserID = 0;
    
//INITIALIZE:

	$rootScope.sCurForm = "New Account";
$log.info($rootScope.sCurForm);    
    
    function validateEmail() {
		var emValidate = confirmPWChg.confirmEmail(vm.data.email, vm.data.confirmEmail);
		switch (emValidate) {
			case "true": 
				if (validatorService.emailIsValid(vm.data.email) == true) {
					vm.bReadyToSaveEmail = true; }
				else {
					vm.bReadyToSaveEmail = false;
					vm.data.confirmEmail = "";
					modalService.okAlert("Invalid Email Address", 
						"The email entered is not a valid email address.<br><br>" +
						"Please enter a valid email address.");
				}
			break;
			case "false": 
				//returned when email or confirmEmail is ""
				vm.bReadyToSaveEmail = false;
			break;
			default:
				modalService.okAlert("", emValidate);
			break;
		}
    }
    
    function validatePW() {
		var validatePassword = confirmPWChg.confirmPassword(vm.data.password, vm.data.confirmPW);
		switch (validatePassword) {
			case "true": 
				if (vm.sPasswordStrength == "Strong" ||
					vm.sPasswordStrength == "Very Strong") {
						vm.bReadyToSavePW = true; 
				} else {
					vm.bReadyToSavePW = false;
					vm.data.confirmPW = "";
					modalService.okAlert("Password Strength", 
						"The password needs to meet the \"Strong\" " +
						"or \"Very Strong\" validation before it can be saved.");
				}
			break;		
			case "false":
				vm.bReadyToSavePW = false;
			break;
			default:
				vm.bReadyToSavePW = false;
				vm.data.confirmPW = "";
				modalService.okAlert("Password Validation", validatePassword);
			break;
		}
    }
    
    function validateUserName() {
		var un = vm.data.userName;
		if (un != "") {
			if (un.indexOf("'") != -1) {
				modalService.okAlert("Data Validation Error",
					"The User Name cannot contain an apostrophe ('). Please remove " +
					"the apostrophe from the User Name entry.");
				vm.bReadyToSaveUsername = false;	
			} else if (un.indexOf("gss") != -1) {
				modalService.okAlert("Data Validation Error",
					"The prefix of 'gss' is reserved for authorized Great Spirit Systems " +
					"staff only. Please use different characters for the first 3 positions in your " +
					"User Name.");
				vm.bReadyToSaveUsername = false;	
			} else if (un.length < 4) {
				modalService.okAlert("Data Validation Error",
					"The User Name must be at least 4 characters in length.");
				vm.bReadyToSaveUsername = false;
			} else { vm.bReadyToSaveUsername = true; }
		} else { vm.bReadyToSaveUsername = false; }	
    }
			
    function saveNewPersonRecord() {
		var fn = vm.data.firstName.toLowerCase();
		var fName = fn.substr(0,1).toUpperCase() + fn.slice(1);
		vm.data.firstName = fName;
		var ln = vm.data.lastName.toLowerCase();
		var lName = ln.substr(0,1).toUpperCase() + ln.slice(1);
		vm.data.lastName = lName;
		var sRawDataString = "MCWebApps || NewAccount_PR || -10 || I || FirstName==" + fName +
			" || LastName==" + lName + " || ClergyLay==L || AppName==WebProtect || Locked==-1 ^^ ";

		dataService.peoSave(sRawDataString)
		.then(function (result) {
			if (result[0].RESULTCODE == "Success") {
				var idx = result[0].RESULTREASON.indexOf("EntityID=");
				vm.iEntityID = Number(result[0].RESULTREASON.slice(idx+9));
				saveContactEmail();
			} else {
				/** Error thrown:
				 *  	01/17/19 - McCurdy. Person record created. Unable to determine cause.
				 *		02/08/19 - Resolved... No DatabaseID saved to DataService yet. Fixed.
				  **/
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/saveNewPersonRecord()",
					result[0].RESULTREASON);
				dataService.emailSendError(sEmailContent);
			}
		});
    }
    
    function saveContactEmail() {
		contactInfo.savePersonalEmail(vm.iEntityID,vm.data.email)
		.then(function(result) {
			if (result[0].RESULTCODE == "Success") {
				saveUserAccount();
			} else {
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/saveContactEmail",
					result[0].RESULTREASON);
				dataService.emailSendError(sEmailContent);
			}
		});
	}	
		
	function saveUserAccount() {
		var pwExpires = datesService.s15mosFromToday();
		var sSaveString = "MCWebApps || NewAccount_UA || -12 || I || UserName==" +
			vm.data.userName + " || UserFullName==" + vm.data.firstName + " " + vm.data.lastName +
			" || UserDesc==Public User || Active==1 || Admin==0 || Password==" + vm.data.password +
			" || PasswordExpires==" + pwExpires + " || PWStrength==" + vm.sPasswordStrength + 
			" || UserEmail==" + vm.data.email + " || UserEntityID==" + vm.iEntityID + " || UserLevel==2 ^^ ";
		
		dataService.usersSave(sSaveString)
		.then(function(result) {
            if (result[0].RESULTCODE == "Success") {
				//found bug of "." after UserID, so have to detect length,
				//and remove 1 character to get actual UserID.
				var idx = result[0].RESULTREASON.indexOf("UserID=");
				var len = result[0].RESULTREASON.length;
				vm.iUserID = result[0].RESULTREASON.substring(idx+7,len-1);

				switch (vm.sDatabaseID) {
					case "MC": case "MC-DEV":
						var sRawDataString = "MCWebApps || NewAcct_ProMain || " + vm.iUserID + 
							" || I || EntityID==" + vm.iEntityID + " || CertTypeID==4 ^^ ";
// $log.info(sRawDataString);
						dataService.proSaveMain(sRawDataString)
						.then(function(result) {
							if (result[0].RESULTCODE == "Success") {
								idx = result[0].RESULTREASON.indexOf("ProID=");
								vm.sProID = result[0].RESULTREASON.slice(idx+6);
								saveProProcessRecord();	
							}	
						});
					break;
					default:
						sendNewUserAcctEmail();
					break;
				}
			} else {
				if (result[0].RESULTREASON.indexOf("UserName") == 0 &&
					result[0].RESULTREASON.indexOf("already in use") > 0) {
					vm.data.userName = "";
					modalService.okAlert("Invalid Entry",
						result[0].RESULTREASON + 
						"<br>Please try entering another unique User Name.");
				} else {	
					var sEmailContent = errorEmailNotification.error4("newAcctCtrl/saveUserAccount",
						result[0].RESULTREASON);
					dataService.emailSendError(sEmailContent);
				}	
			}
		});
    }
    
	//McCurdy ONLY... as ONLY Protect app in use!
	function saveProProcessRecord() {
		var dStepExpires = datesService.s6mosFromToday();
		var sDbToday = datesService.todayToDbString();

		var sRawDataString = "MCWebApps || NewAcct_ProProcess || " + vm.iUserID +
			" || I || ProID==" + vm.sProID + " || StepID==400 || StepDate==" + sDbToday + 
			" || StepNote==Initialized by " + vm.data.firstName + " " + vm.data.lastName + 
			" ^^ I || ProID==" + vm.sProID + " || StepID==401 || StepExpires==" + 
			dStepExpires + " ^^ ";
		
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if(result[0].RESULTCODE == 'Success') {
				proSaveInitData();
			} else {
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/saveProProcessRecord",
					result[0].RESULTREASON);
				dataService.emailSendError(sEmailContent);
			}
		});
    }

	//McCurdy ONLY... save initial Protect data...
	function proSaveInitData() {
		var sRawDataString = "MCWebApps || NewAcct_ProData || " + vm.iUserID + " || ";

		dataService.proGetForm("Application")
		.then(function(defs) {
			if (defs.length > 0) {
				for (var i=0; i<defs.length; i++) {
					switch (defs[i].ITEMNAME) {
						case "FirstName":
							sRawDataString += "I || ProID==" + vm.sProID + " || ItemID==" +
								defs[i].ITEMID + " || ItemData==" + vm.data.firstName + " ^^ ";
						break;
						case "LastName":
							sRawDataString += "I || ProID==" + vm.sProID + " || ItemID==" +
								defs[i].ITEMID + " || ItemData==" + vm.data.lastName + " ^^ ";
						break;
						case "Email":
							sRawDataString += "I || ProID==" + vm.sProID + " || ItemID==" +
								defs[i].ITEMID + " || ItemData==" + vm.data.email + " ^^ ";
						break;
					}
				}
				
				dataService.proSaveFormData(sRawDataString)
				.then(function(results) {
					if(results[0].RESULTCODE != 'Success') {
						var sEmailContent = errorEmailNotification.error4("newAcctCtrl/proSaveInitData",
							results[0].RESULTREASON);
						dataService.emailSendError(sEmailContent);
					} else {
						sendNewUserAcctEmail();
					}
				});
			}
		});
	}
	
	function sendNewUserAcctEmail() {
		userAcctEmails.sendSelfInitUAEmail(vm.data.userName, vm.data.email)
		.then(function(result) {
			if (result == "Completed") {
				//login
				loginService.login(vm.data.userName, vm.data.password)
				.then(function(loginReturn) {
					if (loginReturn[0].SECUSERLOGIN[0].RESULT == "Success") {
						$state.go('myCerts');
					}
				});
			} else {
				var sEmailContent = errorEmailNotification.error4("newAcctCtrl/proSaveInitData",
					result);
				dataService.emailSendError(sEmailContent);
			}
		});
	}
    
    
/* Externally Called Functions: */
    vm.cancelChanges = function() {
		$state.go('login');    	
	};
    
    vm.checkPWStrength = function() {
		var pwReturn = passwordStrength.getPWStrength(vm.data.password);
		vm.sPasswordStrength = pwReturn.strength;
		vm.sPWClass = pwReturn.class;
	};  

    vm.confirmReadyToSave = function(item) {
		switch (item) {
			case "email":
				validateEmail();	
			break;
			case "pw":
				validatePW();
			break;
			case "username":
				validateUserName();
			break;
		}		
		if (vm.bReadyToSavePW == true && vm.bReadyToSaveEmail == true &&
			vm.bReadyToSaveUsername == true && vm.data.firstName != "" &&
			vm.data.lastName != "") {
			vm.bReadyToSave = 'true'; }
		else { vm.bReadyToSave = 'false'; }
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.bReadyToSave == "true") {
				//openCaptcha() *** ADD after Conference!
				saveNewPersonRecord();
			}
		}		
	};
	
	vm.saveNewAccount = function() { //$log.info(vm.bReadyToSave, vm.bReadyToSaveUsername, vm.bReadyToSaveEmail)
	//Validation that Email/Password confirmations match already done.
		if (vm.bReadyToSave == "true") {
			//v.137: Check for use of #, returns error on UserAccount save! ~ lds 6/7/18
			var pw = vm.data.password;
			if (pw.indexOf("#")<0) {
				saveNewPersonRecord();
			} else {
				modalService.okAlert("Data Validation Error",
					"A # symbol is not allowed in the password. Please enter a " +
					"password that does not use #.");
			}		
		} else if (vm.bReadyToSaveUsername == false) {
			validateUserName();
		} else if (vm.bReadyToSavePW == false) {
			pw = vm.data.password;
			if (pw.indexOf("#")<0) {
				validatePW();
			} else {
				modalService.okAlert("Data Validation Error",
					"A # symbol is not allowed in the password. Please enter a " +
					"password that does not use #.");
			}
		} else if (vm.bReadyToSaveEmail == false) {
			validateEmail();
		}
    };
    
}
angular		
	.module('proRefs')
	.controller('NavBarController', NavBarController);

NavBarController.$inject = ['$state','webSessionStorage','headerService','$scope','modalService',
	'$rootScope','loginService','version','mcWebAppsURL','lclURL','minFinURL','statsURL',
	'$window','custData','custDataDev','dataService','timeOutService','$log'];
	
function NavBarController($state, webSessionStorage, headerService, $scope, modalService,
	$rootScope, loginService, version, mcWebAppsURL, lclURL, minFinURL, statsURL, 
	$window, custData, custDataDev, dataService, timeOutService, $log) {
	var vm = this;

	vm.headerIcon = headerService.getHeaderIcon();
	vm.isCollapsed = true;
	vm.loggedIn = false;
	vm.myApps = [];
	vm.sCustomerName = headerService.customer.name;
	vm.version = version;					

	function getAppsForMenu() {
		vm.myApps = [];
		dataService.userGetChurchFunctions()
		.then(function(apps) { // $log.info("getApps:",apps, vm.myApps)
			if (apps.length > 0) {
				for (var i=0; i<apps.length; i++) {
					switch (apps[i].FN) {
						case "ChLeaders":
							vm.myApps.push("Local Church Leaders");
						break;
						case "ContactInfo":
							vm.myApps.push("Contact Information");
						break;
						case "MinFin":
							vm.myApps.push("Ministry Financials");
						break;
						case "ProRef":
							var dataSource = webSessionStorage.getStoredData('sDataSource');
							if (dataSource.slice(-3) == "Dev" || dataSource == "FalconVideos") {
								for (var j=0; j<custDataDev.length; j++) {
									custData.push(custDataDev[j]);
								}
							}
							for (j=0; j<custData.length; j++) {
								if (custData[j].DataSource == dataSource) {
									var ProRefApp = custData[j].ProRef;
								break; }
							}
							vm.myApps.push(ProRefApp);
						break;
						case "Statistics":
							vm.myApps.push("Statistics");
						break;	
					}
				}
			}
		});
	}

/* Broadcasts: */	 
	$scope.$on('closeMenu', function() {
		vm.isCollapsed = true;
	});
	
	$scope.$on('updateCustomer', function() {
		vm.headerIcon = headerService.getHeaderIcon();
		vm.sCustomerName = headerService.customer.name;
	});
	
	$scope.$on('updateNav', function() {
		vm.myApps = $rootScope.myApps;
		vm.loggedIn = loginService.user.loggedIn;
		getAppsForMenu();				
	});

	
/* Calls from View: */

	vm.goHome = function() {
		$state.go('login', {reload:true});
	};

	vm.goToAbout = function() {
		$rootScope.sCurForm = "about";
		$state.go('about');
	}
	
	vm.goToApp = function(app) {
		if ($rootScope.bPasswordExpired == true) {
			modalService.okAlert("Password Expired",
				"Your current password has expired.<br>" +
				"You must create a new password to continue.");
			$state.go('chgPW');	
		} else {
			var sFn = "";
			var sPath = "";
			switch (app) {
				case "Charges & Appointments":
					//coming
				break;
				case "Contact Information":
					sFn = "ContactInfo";
					sPath = mcWebAppsURL;
				break;
				case "Local Church Leaders":
					sFn = "ChLeaders";
					sPath = lclURL;
				break;
				case "Ministry Financials":
					sFn = "MinFin";
					sPath = minFinURL;
				break;
				case "Safe Sanctuary References": 	//MO
				case "Volunteer References":		//NWTX
				case "Protect References":			//DEFAULT
					sFn = "ProRef";
				break;
				case "SignUp":
					//coming
				break;
				case "Statistics":
					sFn = "Statistics";
					sPath = statsURL;
				break;
			}
			
		/* Validate ReturnCode, resetting to expire in 1 minute...
			Call for NEW ReturnCode set to expire in 1 minute...
			And go to new app (sFn), which will login to new app and issue new ReturnCode
				for session in new app.  */
			switch (sFn) {
				case "ProRef":
					timeOutService.resetTimer(30);
					$state.go('certMgmt', {reload:true});								
				break;
				default: //External Apps:
					loginService.secGetReturnCode(1, sFn)
					.then(function(result) {
						$window.location.replace(sPath + "?ReturnCode=" +
							result[0].RETURNCODE);
					});
				break;
			}
		}	
	}; //goToApp()
	
	vm.goToChgPW = function() { 
		$rootScope.sCurForm = "chgPW";
		$state.go('chgPW');
	};
	
	vm.goToHelpDesk = function() {
		$state.go('helpDesk', {reload:true});
	};
	
	vm.goToMyCerts = function() {
		$state.go('myCerts');
	}
	
	/** Deletes the active ReturnCode, removes all secure apps,
	sends user back to login screen, selected Customer retained: */
	vm.logOff = function() {
		vm.loggedIn = false;
		loginService.logout();
		vm.myApps = [];
		$state.go('login', {reload:true});
	};
	
}	 

angular		
	.module('proRefs')
	.controller('MyCertsController', MyCertsController);

MyCertsController.$inject = ['dataService','loginService','$state','$stateParams',
	'$rootScope','webSessionStorage','datesService','$log'];
	
function MyCertsController(dataService, loginService, $state, $stateParams,
	$rootScope, webSessionStorage, datesService, $log) {

	var vm = this;

	vm.addNew = { image: "assets/images/plus_16.png"};
	vm.arcCertRecords = [];
	vm.bCampInProcess = false;
	vm.bInProcess = false;
	vm.bLCAApproved = false;
	vm.bVIMInProcess = false;
	vm.bProcessExpiring = false;
	vm.bCertExpiring = false;
	vm.iCertTypeID = 0;
	vm.imgCamp = { image: "assets/images/NWTXCampingvolunteer.png" };
	vm.imgVIM = { image: "assets/images/VIMButton.png" };
	vm.mc32 = { image: "assets/images/MCicon32.png"};
	vm.proProcessName = "";
	vm.sChurchName = "";
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.sDbToday = datesService.todayToDbString();
	vm.username = loginService.user.USERNAME;

	
//INITIALIZE:	
	$rootScope.sCurForm = "My Certifications";
$log.info($rootScope.sCurForm);
	$rootScope.$broadcast('closeMenu');
	
	dataService.libGetASetting("ProProcessName")
	.then(function(result) { //$log.info("libGetASetting:",result)
		vm.proProcessName = result[0].SETTINGVALUE;
	});
	
	dataService.proGetCertRecords(loginService.user.USERID, loginService.user.USERENTITYID)
	.then(function(certs) { // $log.info("Certs:", certs)
		if (certs.length > 0) {
			for (var i=0; i<certs.length; i++) {
				var exp = new Date(certs[i].STATUSEXPIREDATE);
				switch (certs[i].PROSTATUS) {
					case "In Process":
					/* Check if process expires within 30 days: */
						var dt = new Date();
						dt.setDate(dt.getDate()+30);
						if (exp < dt) {
							vm.bProcessExpiring = true;
						}
						
						//Custom Handling:
						switch(vm.sDatabaseID) { 
							case "MO": case "MO-DEV": case "VID":
								switch (certs[i].CERTTYPEID) {
									case 4:
										$rootScope.certInProcess = certs[i];
									break;
									case 5:
										dataService.getChurchName(certs[i].CHURCHID)
										.then(function(result) { //$log.info("GetChurchName:", result)
											vm.sChurchName = result;
										});
									break;
								}
							break;
							case "NWTX": case "NWTX-DEV":
								if (certs[i].CERTTYPEID == 4) { vm.bCampInProcess=true; }
								if (certs[i].CERTTYPEID == 5) { vm.bVIMInProcess=true; }
							break;
							case "MC": case "MC-DEV":
								vm.bInProcess = true;
							break;
						}
					break;
					case "Certified":
					/* Check if Certification expires within 30 days: */
						dt = new Date();
						dt.setDate(dt.getDate()+180); //set "dt" to 6 mos from now.
						if (exp < dt) {
							vm.bCertExpiring = true;
						}
					break;
					case "Approved LCA":
						vm.bLCAApproved = true;
					break;
				}
			}
			vm.arcCertRecords = certs;
		}
		
		if ($stateParams.sFunction == "PayFee") { /** TEST FOR NWTX multi-certTypes!!! **/
			for (i=0; i<vm.arcCertRecords.length; i++) {
				if (vm.arcCertRecords[i].PROSTATUS == "In Process" &&
					vm.arcCertRecords[i].CERTTYPEID == 4) {
					$rootScope.sProID = vm.arcCertRecords[i].PROID;
					$rootScope.curCertRecord = vm.arcCertRecords[i];	
					$state.go('steps', {reload:true});	
				break; }
			}
		}
	});
	
	function saveMainRecord() {
		var sRawDataString = "WebApps_Pro || myCerts_New || " + loginService.user.USERID +
			" || I || EntityID==" + loginService.user.USERENTITYID + " || CertTypeID==" + 
			vm.iCertTypeID + " ^^ ";

		dataService.proSaveMain(sRawDataString)
		.then(function(main) {
			if (main.length > 0) {
				var resultReason = main[0].RESULTREASON;
				var idx = resultReason.indexOf("ProID=");
				$rootScope.sProID = resultReason.slice(idx+6);
				
				saveInitAndApplRecords();
			}
		});
	}
	
	function saveInitAndApplRecords() {
		//calculate StepExpires for Application step:
		var dStepExpires = "";
		switch (vm.sDatabaseID) {
			case "NWTX": case "NWTX-DEV": 
			case "MC": case "MC-DEV":
				// 6 mos. from Initialization Date
				dStepExpires = datesService.s6mosFromToday();
			break;
			default: // 1 year from today
				dStepExpires = 	datesService.s1yrFromToday();
			break;	
		}
		var sRawDataString = "WebApps_Pro || myCerts_New || " + loginService.user.USERID +
			" || I || ProID==" + $rootScope.sProID + " || StepID==" + vm.iCertTypeID+"00" +
			" || StepDate==" + vm.sDbToday + " || StepNote==Initialized by " + 
			loginService.user.USERFULLNAME + 
			" ^^ I || ProID==" + $rootScope.sProID + " || StepID==" + vm.iCertTypeID+"01" +
			" || StepExpires==" + dStepExpires + " ^^ ";
		
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if(result[0].RESULTCODE == 'Success') {
				$state.go('steps', {reload:true});
			}
		});
	}


/* Broadcasts: */

/* Called from view: */	
    
    vm.addNewOnlineProcess = function(certID) {
		vm.iCertTypeID = certID;
		saveMainRecord();
	};
    
    vm.loadProcessSteps = function(cert) { //$log.info('clicked cert:', cert);
		if (cert.CHURCHID != "") {
			loginService.user.CHURCHID = cert.CHURCHID;
		}
		$rootScope.sProID = cert.PROID;
		$rootScope.curCertRecord = cert;
		$state.go('steps', {reload:true});
    }; 	
}

angular
    .module('proRefs')
    .controller('ModalController', ModalController);

ModalController.$inject = ['$uibModalInstance','modType','title','alertMsg',
	'dataService','datesService','$sce','modalService','$log'];

function ModalController($uibModalInstance, modType, title, alertMsg, 
	dataService, datesService, $sce, modalService, $log) {
    var vm = this;
    
    vm.modType = modType;	//OK, printOpts, ...
    vm.sTitle = title;
    vm.sAlertMsg = $sce.trustAsHtml(alertMsg);
$log.info("ModalAlert:",modType)    

	
//modType='OK':
	vm.cancel = function() {
		$uibModalInstance.dismiss();
	};

}

angular
    .module('proRefs')
    .controller('ModalTimeoutController', ModalTimeoutController);

ModalTimeoutController.$inject = ['$uibModalInstance','$timeout'];

function ModalTimeoutController($uibModalInstance, $timeout) {
    var vm = this;
    vm.secTimer = 60;
    
    runTimer();
    
	function runTimer() {
		$timeout(function () {
			vm.secTimer--;
			if (vm.secTimer > 0) {
				runTimer();	
			} else {
				$uibModalInstance.close({continue: false});
			}
		}, 1000);		
	}
	
	vm.continue = function() {
		$uibModalInstance.close({continue: true});	
	};
}
angular
    .module('proRefs')
    .controller('ModalConfSelectController', ModalConfSelectController);

ModalConfSelectController.$inject = ['$uibModalInstance','confs','$log'];

function ModalConfSelectController($uibModalInstance, confs, $log) {
$log.info("ModalConfSelectController");	

	var vm = this;
	vm.confs = confs;
	vm.options = {};
	
	vm.ok = function (sConfSel) {
		$uibModalInstance.close(sConfSel);
    };

	vm.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	};

}
/** UPDATES:
  * 	05/28/19 lds - Added timeOutService, and resetting of Customer on form reload.
  **/

angular
    .module('proRefs')
    .controller('LoginController', LoginController);

LoginController.$inject = ['webSessionStorage','$rootScope', 'dataService', '$state',
	'loginService','$uibModal','modalService','custData','headerService','appValidationService',
	'setCustService','timeOutService','$sce','$log'];

function LoginController(webSessionStorage, $rootScope, dataService, $state,
	loginService, $uibModal, modalService, custData, headerService, appValidationService,
	setCustService, timeOutService, $sce, $log) {
    var vm = this; //as vmLI

    vm.addNew = { image: "assets/images/plus_16.png" };    
    vm.bShowConferences = false;
	vm.bAcctInit = false;
    vm.custDB = custData;
    vm.imgMCBanner = { image: "assets/images/McCurdy.png" };
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.selConf = custData[0];
	vm.sMaintenanceMsg = "";
	vm.sUsername = "";
    vm.sPassword = "";
    

    
//INITIALIZE:    
    $rootScope.sCurForm = 'login';
$log.info($rootScope.sCurForm) 
	
	/** When returning here, with {reload: true}, ensure
	  *  that Customer is still 'set' in NavBar by calling
	  *  setCustService if sDatabaseID still in Session storage:
	  **/
// if ($rootScope.TESTING) { vm.sDatabaseID = ""};	  
	if (vm.sDatabaseID !== null && vm.sDatabaseID !== "" &&
		angular.isDefined(vm.sDatabaseID) == true) {
		setCustService.fromDatabaseID(vm.sDatabaseID);	
	} else { 
		vm.bShowConferences = true; 
	}
	
	/* Display MaintenanceMsg: */
	dataService.libGetMaintenanceMsg()
	.then(function(msg) { // $log.info('msg', msg);
		if (msg.length > 0) {
			vm.sMaintenanceMsg = $sce.trustAsHtml(msg[0].SETTINGVALUE);
		}
	});

    //Display "Create New Account" button for those who use it:
	switch (vm.sDatabaseID ) {
		case "MC": case "MC-DEV":
		case "NWTX": case "NWTX-DEV":
			vm.bAcctInit = true;
		break;
		default:
			vm.bAcctInit = false;
		break;	
	}
    
    function logInUser() {
		loginService.login(vm.sUsername, vm.sPassword)
		.then(function(data) {
			if (data[0].SECUSERLOGIN[0].RESULT == "Success") {
				var sExp = data[0].SECUSERLOGIN[0].PASSWORDEXPIRES;
				var dPasswordExpires = new Date(sExp.substr(0,4),
					Number(sExp.substr(5,2))-1, sExp.substr(8,2));
				var dToday = new Date();
				if (dPasswordExpires > dToday) {
					/* Start Session Timer: */
					timeOutService.setTimer(30);
					
				/* Determine landing page... */
					if (appValidationService.validateAccess() == "CertMgmt") {
						$rootScope.sCurForm = 'Protect References';
						$state.go('certMgmt');
					} else { 
						$rootScope.sCurForm = 'MyCerts';
						$state.go('myCerts'); 
					}				
				} else {
					$rootScope.bPasswordExpired = true;
					modalService.okAlert("Expired Password",
						"Your current password has expired.\n" +
						"You must create a new password to continue.");
					$state.go('chgPW');
				}	
			} else if (data[0].SECUSERLOGIN[0].RESULT == "Fail"){
				modalService.okAlert("Login Failed",
					"We were unable to log you in with the Username and Password provided.<br><br>" +
					"Please try again, or have your password sent to you by clicking the \"Forgot " +
					"Password\" button.");
			} else if (data[0].SECUSERLOGIN[0].RESULT == "Multiple") {
				openConfSelectModal(data[0].SECUSERLOGIN[0].HELPGETDBBYUSER);
			} else {
				modalService.okAlert("Login Failed",
					"We were unable to log you in with the Username and Password provided.<br><br>" +
					"Please try again, or have your password sent to you by clicking the \"Forgot " +
					"Password\" button.");
			}
		});
	}
    
    
//Modals:
	function openConfSelectModal(arrConfs) {
		var modalInstance = $uibModal.open({
			animation: true,
			size: 'lg',
			templateUrl: 'app/modals/modConfSelectModal.html',
			controller: 'ModalConfSelectController',
			bindToController: true,
			controllerAs: 'vmSel',
			keyboard: true,
			backdrop: 'static',
			backdropClass: 'bottom:0;height:100%;margin:0;padding-bottom:0',
			resolve: {
				confs: function() {
					return arrConfs;
				}
			}
		});
		modalInstance.result
		.then(function(modResult) {
			setCustService.fromDataSource(modResult.DATASOURCE);
			vm.validateUserLogin();	
		});
	}
    
    
//Called from View:

    vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.sUsername.trim() != "" && vm.sPassword.trim() != "") {
				logInUser();
			} else {
				modalService.okAlert("Missing Entry", 
					"Please enter your Username and Password to Log " +
					"In to your account.");
			}
		}  
	};
    
    vm.forgotPassword_clickHandler = function() {
		if (vm.sDatabaseID == null || vm.sDatabaseID == "") {
			vm.bShowConferences = true;
			modalService.okAlert("Forgot Password", 
				"Please select your conference from the drop-list, and enter your Username, " +
				"then click the Forgot Password button again.");
			
		} else if (vm.sUsername == "") {
			modalService.okAlert("Missing Entry", 
				"Please enter your Username, then click the \"Forgot Password\" " +
				"button again.<br>Your password will be emailed to the Email address listed " +
				"on your account.<br><br>" +
				"If you do not receive your password within 10-15 minutes, please contact your " +
				"MissionConnect Administrator to verify that your account email address is correct.");
		} else {		
			dataService.sendForgottenPassword(vm.sUsername)
			.then(function(data) { //$log.info("sendPassword", data)
				switch (data) { 
					case "No User Account":
						modalService.okAlert("Account Not Found", 
							"There is no user account with that Username.<br><br>" +
							"Please be sure you entered it correctly. The Username is " +
							"Case-Sensitive. Otherwise, contact your MissionConnect " +
							"Administrator to verify the Username you are using is correct.");
					break;
					case "Completed":
						modalService.okAlert("Password Sent", 
							"Your password has been sent.\n\n" +
							"Check your Email Inbox for the email with Subject:<br>" +
							"\"Your MissionConnect Login Information\".<br><br>" +
							"If the email does not arrive within 10-15 minutes, be sure " +
							"to also check your spam and junk folders.");
					break;				
				}
			});
		}
    };
    
//Close MENU:
	vm.onFocus = function() {
		$rootScope.$broadcast('closeMenu');
	};
	
/* When selected Customer changes, headerService is called to "set"
	new Customer icon & name, which in turn calls to update the 
	NavBarCtrl to reflect the change. */	
	vm.selectConference = function() {
		if (vm.selConf.DataSource != "") {
			setCustService.fromDataSource(vm.selConf.DataSource);
			dataService.setDataSource();
		} else {
			headerService.setCustomer("MissionConnect");
		}
	};
    
    vm.validateUserLogin = function() {
		if (vm.sUsername.trim() != "" && vm.sPassword.trim() != "") {
			logInUser();
		} else {
			modalService.okAlert("Missing Entry", 
				"Please enter your Username and Password to Log " +
				"In to your account.");

		}
	};
}
angular
    .module('proRefs')
    .controller('LCACovenantController', LCACovenantController);

LCACovenantController.$inject = ['dataService','$rootScope','loginService','$state','modalService',
	'$stateParams','datesService','errorEmailNotification','webSessionStorage','$log'];

function LCACovenantController(dataService, $rootScope, loginService, $state, modalService,
	$stateParams, datesService, errorEmailNotification, webSessionStorage, $log) {
    var vm = this; //vmLCA
    
    vm.arrDataFields = [];
    vm.displayGrp1 = [];
    vm.header1 = "";
    vm.sChurchName = "";
    vm.sConsent = "";
    vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
    vm.sUserFullName = loginService.user.USERFULLNAME;
    
    
//INITIALIZE:
	$rootScope.sCurForm = "LCA Covenant";
$log.info($rootScope.sCurForm);

	dataService.proGetMain($rootScope.sProID)
	.then(function(main) {
		if (main.length > 0) {
			dataService.getChurchName(main[0].CHURCHID)
			.then(function(chName) {
				vm.sChurchName = chName;
				
				dataService.proGetForm("LCACovenant")
				.then(function(defs) {	//$log.info("defs:",defs)
					
					dataService.proGetFormData("LCACovenant")
					.then(function(data) { //$log.info("data:",data)
						
						createForm(defs, data);
					})
				});
			});
		}
	});
	
	function createForm(defs, data) {
		for (var i=0; i<defs.length; i++) {
			var obj = {HTML:"", id:defs[i].ITEMID, label:"",
					control:defs[i].CONTROLTYPE, itemName:defs[i].ITEMNAME, 
					seq:defs[i].ITEMSEQ, required:defs[i].REQUIRED,
					group:defs[i].GROUPNAME, grpSeq:defs[i].GROUPSEQ, data:"",
					saveKey:0 }
		
			switch (defs[i].CONTROLTYPE) {
				default:
					obj.label = defs[i].CAPTION;
				break;
			}
			
			if (data.length > 0) {
				for (var j=0; j<data.length; j++) {
					if (data[j].ITEMID == obj.id) {
						obj.saveKey = data[j].SAVEKEY;
					break; }
				}
			}
			
		/* Master list of fields for use to validate against: */
			vm.arrDataFields.push(obj);

			switch (defs[i].GROUPSEQ) {
				case 1: 
					vm.header1 = defs[i].GROUPNAME;
					vm.displayGrp1.push(obj);
				break;
			}
		}
	}
	
	function saveData() { //$log.info("saveData")
		var sRawDataString = "WebProtect || lcaCovt.143 || " + loginService.user.USERID + " || ";
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].data != "") {
				if (vm.arrDataFields[i].saveKey > 0) {
					sRawDataString += "U || SaveKey==" + vm.arrDataFields[i].saveKey;
				} else { sRawDataString += "I"; }
				sRawDataString += " || ProID==" + $rootScope.sProID + " || ItemID==" +
					vm.arrDataFields[i].id + " || ItemData==" + vm.arrDataFields[i].data + " ^^ ";
			}
		} //$log.info("saveData:",sRawDataString)
		dataService.proSaveFormData(sRawDataString)
		.then(function(results) {
			if (results[0].RESULTCODE == 'Success') {
				saveProProcessRecord();
			}
		});
	}
	
	function saveProProcessRecord() {
// 		var sDbToday = datesService.todayToDbString();
		var sRawDataString = "WebApps_Pro || lcaCovenant || " + loginService.user.USERID + 
			" || I || ProID==" + $rootScope.sProID + " || StepID==" + $stateParams.iStepID + 
			" || StepDate==" + datesService.todayToDbString() + " || StepProgress==Completed ^^ ";
			
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if (result[0].RESULTCODE == 'Success') {
				if (vm.sDatabaseID == "MO") {
					/* Per request by Tina Twenter 9/24/18 ~
						Send Email to Tina when applicant completes LCA Covenant: */
					var sLCAEmailContent = vm.sUserFullName + 
						" has completed the LCA Covenant step of the LCA process, " +
						"and will be listed as an Approved LCA for " +
						vm.sChurchName + " in the system after the nightly processes run.";
					dataService.emailSendCustom("ssanctuaries@moumethodist.org", 
						'mchelp@greatspirit.com', 'mchelp@greatspirit.com',
						'LCA Approved', sLCAEmailContent);
				}
				$state.go('steps', {reload:true});
			} else {
				var sEmailContent = errorEmailNotification.error4("lcaCovenant/saveProProcessRecord");
				dataService.emailSendError(sEmailContent);
			}
		});	
	}

/* Broadcasts: */

/* Calls from View: */
	
	vm.cancel = function() {
		$state.go('steps', {reload:true});
	};
	
	vm.changeHandler = function(id) {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].id == id) {
				vm.arrDataFields[i].data = vm.sConsent;
			break; }
		}
	};
	
	vm.agreeHandler = function () {
		vm.sConsent = vm.sConsent.trim(); //v...143 added trim. Possible reason unable to get past step. ~ lds
		if (vm.sConsent.toLowerCase() == "yes")	{
			saveData();
		} else {
			modalService.okAlert("Invalid Entry", 
				"If you agree with the Covenant, please type \"Yes\" in " +
				"the space provided. Otherwise, Cancel out of this form.");
		}
	};
	
}

angular
    .module('proRefs')
    .controller('LCPolicyController', LCPolicyController);

LCPolicyController.$inject = ['dataService','$rootScope','$sce','$state','modalService','loginService',
	'$stateParams','errorEmailNotification','datesService','$window','$log'];

function LCPolicyController(dataService, $rootScope, $sce, $state, modalService, loginService, 
	$stateParams, errorEmailNotification, datesService, $window, $log) {
    var vm = this;
    
	vm.arrDataFields = [];
	vm.arrFormDefs = [];
	vm.bCovenantViewed = false;
	vm.bPolicyViewed = false;
	vm.bReadyToSubmit = "false";
	vm.bReviewed = false;
    vm.iChurchID = 0;
    vm.obj1 = {};
    vm.sCovenantURL = "";
    vm.sDbToday = datesService.todayToDbString();
    vm.sInstructions = "";
    vm.sLCPolicyURL = "";
    
    vm.header1 = "";
    vm.displayGrp1 = [];
    
    
//INITIALIZE:
	$rootScope.sCurForm = "LC Policy";
$log.info($rootScope.sCurForm);

	dataService.proGetMain($rootScope.sProID)
	.then(function(main) {
		if (main[0].CHURCHID > 0) {
			vm.iChurchID = main[0].CHURCHID;
			
			dataService.proGetChOrgSettings(vm.iChurchID)
			.then(function(chOrg) {
				if (chOrg.length > 0) {
					if (chOrg[0].POLICYURL != "") {
						vm.sLCPolicyURL = chOrg[0].POLICYURL;
					} else {
						vm.sLCPolicyURL = "https://umcdata.net/Falcon/CustomerData/Mo/LCPolicies/SSPol_missing.pdf";
					}
					if (chOrg[0].COVENANTURL != "") {
						vm.sCovenantURL = chOrg[0].COVENANTURL;
						vm.obj1 = {HTML:"", id:0, label:"Display Safe Sanctuaries Covenant",
							control:"Button", itemName:"Covenant", 
							seq:45, required:true, group:"", grpSeq:1, data:""};
					}
					getFormDefs();
				}
			});
		} else {
			vm.sLCPolicyURL = "https://umcdata.net/Falcon/CustomerData/Mo/LCPolicies/SSPol_missing.pdf";
			getFormDefs();
		}
	});
	
	function getFormDefs() {
		dataService.proGetForm("LCPolicy")
		.then(function(defs) {
			if (defs.length > 0) {
				defs.sort(function(a, b) {
					return a.ITEMSEQ - b.ITEMSEQ
				});
				vm.arrFormDefs = defs;
				
				//Create Form:
				for (var i=0; i<vm.arrFormDefs.length; i++) {
					var obj = {HTML:"", id:vm.arrFormDefs[i].ITEMID, label:"",
						control:vm.arrFormDefs[i].CONTROLTYPE, itemName:vm.arrFormDefs[i].ITEMNAME, 
						seq:vm.arrFormDefs[i].ITEMSEQ, required:vm.arrFormDefs[i].REQUIRED,
						group:vm.arrFormDefs[i].GROUPNAME, grpSeq:vm.arrFormDefs[i].GROUPSEQ, data:""}
					switch (vm.arrFormDefs[i].CONTROLTYPE) {
						case "BoldLabel":
							obj.label = vm.arrFormDefs[i].CAPTION;
						break;	
						case "htmlText":	
							obj.HTML = $sce.trustAsHtml(vm.arrFormDefs[i].CAPTION);
						break;
						case "CheckBoxL": case "CheckBoxR": case "CheckBox":
							obj.control = "CheckBox";
							obj.label = vm.arrFormDefs[i].CAPTION;
						break;
						case "Button":
							obj.label = vm.arrFormDefs[i].CAPTION;
						break;
						default:
							obj.label = vm.arrFormDefs[i].CAPTION;
						break;
					}
					
				/* Master list of fields for use to validate against: */
					vm.arrDataFields.push(obj);
					if (obj.itemName == "LCPolicy" && vm.sCovenantURL != "") {
						vm.obj1.id = obj.id;
						vm.obj1.group = obj.group;
						vm.arrDataFields.push(vm.obj1);
					}
					
					switch (vm.arrFormDefs[i].GROUPSEQ) {
						case 1: 
							vm.header1 = vm.arrFormDefs[i].GROUPNAME;
							vm.displayGrp1.push(obj);
							if (vm.obj1.id > 0) { 
								vm.displayGrp1.push(vm.obj1);
								vm.obj1 = {};
							}
						break;
					}
					obj = {};	
					
				}
			}
		});		
	}
    
	function saveData() {
		var sRawDataString = "WebApps_Pro || LCPolicy || " + loginService.user.USERID + " || ";
		for (var i=0; i<vm.arrDataFields.length; i++) { 
			if (vm.arrDataFields[i].data != "") {
				sRawDataString += "I || ProID==" + $rootScope.sProID + " || ItemID==" +
					vm.arrDataFields[i].id + " || ItemData==" + vm.arrDataFields[i].data + " ^^ ";
			}
		}
		dataService.proSaveFormData(sRawDataString)
		.then(function(result) {
			if (result.length > 0) {
				if (result[0].RESULTCODE == "Success") {
					saveProcessStep();
				} else {
					var reason = result[0].RESULTREASON;
					if (reason.indexOf('Cannot insert duplicate key') > 0) {
						//user already saved result... so go ahead and saveProcessStep(); ~ lds 12/11/19 added
						saveProcessStep();
					} else {
						modalService.resultAlert("sm", result[0].RESULTREASON);
						var sEmailContent = errorEmailNotification.error4("lcPolicyCtrl/saveData");
						dataService.emailSendError(sEmailContent);	
					}
				}
			} else {
				sEmailContent = 
					errorEmailNotification.error4("lcPolicyCtrl/saveData");
				dataService.emailSendError(sEmailContent);	
			}
		});
	}
	
	function saveProcessStep() {
		var sRawDataString = "WebApps_Pro || LCPol_ProProcess || " + loginService.user.USERID +
			" || I || ProID==" + $rootScope.sProID + " || StepID==" + $stateParams.iStepID + 
			" || StepDate==" + vm.sDbToday + " || StepProgress==Completed ^^ ";
 
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if (result.length > 0) {
				if (result[0].RESULTCODE == "Success") {
					$state.go('steps', {reload:true});
				}
			}
		});
	}
								

/* Broadcasts: */

/* Calls from View: */
	
	vm.button_clickHandler = function(item) {
		switch (item.itemName) {
			case "LCPolicy":
				$window.open(vm.sLCPolicyURL, '_blank');
				vm.bPolicyViewed = true;
			break;
			case "Covenant":
				$window.open(vm.sCovenantURL, '_blank');
				vm.bCovenantViewed = true;
			break;
		}	
	};
	
	vm.cancel = function() {
		$state.go('steps', {reload:true});
	};
	
	vm.checkBox_changeHandler = function(item) { $log.info('item', item, vm.bPolicyViewed, vm.bCovenantViewed);
		if (vm.bPolicyViewed == true) {
			if (vm.sCovenantURL == "") {
				if (vm.bReviewed == true) {
					vm.bReadyToSubmit = "true";
					for (var i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].id == item.id) {
							vm.arrDataFields[i].data = vm.bReviewed;
						break; }
					}		
				} else {
					vm.bReadyToSubmit = "false";
					modalService.okAlert("Missing Entry", 
						"Please check that you have reviewed " +
						"and understand the Local Church Policy, then click " +
						"the Submit button. Otherwise, please cancel out of " +
						"this form.");
				}
			} else {
				if (vm.bCovenantViewed == true) {
					vm.bReadyToSubmit = "true";
					for (i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].id == item.id) {
							vm.arrDataFields[i].data = vm.bReviewed; $log.info(vm.arrDataFields[i].data, vm.bReviewed, vm.bReadyToSubmit);
						break; }
					}
				} else {	
					vm.bReviewed = false;
					vm.bReadyToSubmit = "false";
					modalService.okAlert("Missing Entry", 
						"Please ALSO review the Safe Sanctuaries Covenant " +
						"before checking that you have reviewed and understand the " +
						"Local Church Safe Sanctuaries Policy.");
				}
			}	
		} else {
			vm.bReviewed = false;
			vm.bReadyToSubmit = "false";
			modalService.okAlert("Invalid Entry",
				"Please view the Local Church Policy " +
				"before checking that you have reviewed and understand it.");
		}
	};
	
	vm.saveSubmit = function() { $log.info('submit:', vm.bReadyToSubmit);
		if (vm.bReadyToSubmit == "true") {
			saveData();
		}
	};
	
}
angular
    .module('proRefs')
    .controller('HelpDeskController', HelpDeskController);

HelpDeskController.$inject = ['helpDeskService','$state','loginService','dataService',
	'validatorService','modalService'];	

function HelpDeskController(helpDeskService, $state, loginService, dataService,
	validatorService, modalService) {
	var vm = this;	//vmHD
	
	vm.bReadyToSubmit;
	vm.iIssueID = 0;
	vm.sUserEmail = "";
	vm.sProblem = "";
	vm.sUserFullName = "";
	
	if (loginService.user.USERID > 0) {
		vm.sUserEmail = loginService.user.USEREMAIL;
		vm.sUserFullName = loginService.user.USERFULLNAME;
	}
	
	helpDeskService.helpHdInitiateIssue()
	.then(function(data) {
		if (data[0].ISSUEID > 0) {
			vm.iIssueID = data[0].ISSUEID;
		} else {
			var sError = "There was an Error retrieving the Help Desk " +
				"IssueID for UserID: " + loginService.user.USERID + ", " +
				loginService.user.USERFULLNAME + "<br><br>Reporting issue: " +
				vm.sProblem;
			dataService.emailSendError(sError);
		}		
	});
		
		
/* Externally Called Functions: */

	vm.confirmReadyToSubmit = function() {
		if (vm.sUserFullName != "" && vm.sUserEmail != "" &&
			vm.sProblem != "") {
			if (validatorService.emailIsValid(vm.sUserEmail) == true) {
				vm.bReadyToSubmit = "true"; }
			else {
				vm.bReadyToSubmit = "false";
				modalService.okAlert("Invalid Entry", 
					"The email entered is not a valid email address.<br><br>" +
					"Please enter a valid email address, then click Submit.");		
			}	
		} else { vm.bReadyToSubmit = "false"; }
	};
	
	vm.submitHD = function() {
		if (vm.bReadyToSubmit == "true") {
			if (vm.iIssueID > 0) {
				helpDeskService.helpHdSaveIssue(vm.iIssueID, vm.sUserFullName,
					vm.sUserEmail, vm.sProblem);
			}
		} else if (vm.sUserFullName == "") {
			modalService.okAlert("Missing Data", 
				"Please enter your Name before Submitting " +
				"the Help Desk issue.");
		} else if (vm.sUserEmail == "") {
			modalService.okAlert("Missing Data", 
				"Please enter your Email Address before " +
				"Submitting the Help Desk issue.");
		} else if (vm.sProblem == "") {
			modalService.okAlert("Missing Data", 
				"Please describe the issue you are experiencing " +
				"before Submitting the Help Desk issue.");
		}
	};	
	
}	

angular
    .module('proRefs')
    .controller('ChgPasswordController', ChgPasswordController);

ChgPasswordController.$inject = ['$rootScope','$state', 'passwordStrength','validatorService',
	'confirmPWChg', 'dataService','loginService','modalService','appValidationService','$log'];	

function ChgPasswordController($rootScope, $state, passwordStrength, validatorService,
	confirmPWChg, dataService, loginService, modalService, appValidationService, $log) {
	var vm = this;	//vmCP
    
    vm.bReadyToSave = "false";
    vm.bReadyToSavePW = false;
    vm.bReadyToSaveEmail = false;
    vm.sPasswordStrength = "Too Short";
    vm.sPWClass = "tooShort";
    vm.sUserEmail = loginService.user.USEREMAIL;

	vm.data = { oldPW:"",
		newPW:"", confirmPW:"",
		email:"", confirmEmail:""	
	};
    
    $rootScope.sCurForm = "Change Password/Email";


	function validateEmail() {
		var emValidate = confirmPWChg.confirmEmail(vm.data.email, vm.data.confirmEmail);
		switch (emValidate) {
			case "true": 
				if (validatorService.emailIsValid(vm.data.email) == true) {
					vm.bReadyToSaveEmail = true; }
				else {
					vm.bReadyToSaveEmail = false;
					vm.data.confirmEmail = "";
					modalService.okAlert("Invalid Email Address", 
						"The email entered is not a valid email address.<br><br>" +
						"Please enter a valid email address.");
				}
			break;
			case "false": 
				//returned when email or confirmEmail is ""
				vm.bReadyToSaveEmail = false;
			break;
			default:
				modalService.okAlert("", emValidate);
			break;
		}
	}
	
	function validatePW() {$log.info("validatePW")
		if (vm.data.oldPW != "") {
			var validatePassword = confirmPWChg.confirmPassword(vm.data.newPW, vm.data.confirmPW);
			switch (validatePassword) {
				case "true": 
					if (vm.sPasswordStrength == "Strong" ||
						vm.sPasswordStrength == "Very Strong") {
							vm.bReadyToSavePW = true; 
					} else {
						vm.bReadyToSavePW = false;
						vm.data.confirmPW = "";
						modalService.okAlert("Password Strength", 
							"The password needs to meet the \"Strong\" " +
							"or \"Very Strong\" validation before it can be saved.");
					}
				break;		
				case "false":
					vm.bReadyToSavePW = false;
				break;
				default:
					vm.bReadyToSavePW = false;
					vm.data.confirmPW = "";
					modalService.okAlert("Password Validation", validatePassword);
				break;
			}		
		}
	}
	
	//Already logged in before updating Email or Password:
    function saveNewEmail() {
		var sSaveString = "WebProtect || chgPW || " + loginService.user.USERID + 
			" || U || UserID==" + loginService.user.USERID + 
			" || UserEmail==" + vm.data.email + " ^^ ";
			
		dataService.usersSave(sSaveString)
		.then(function(data) {
            if (data[0].RESULTCODE == "Success") {
				loginService.user.USEREMAIL = vm.data.email;
				var sSaveSuccessMsg = "Your email has been updated successfully!<br>";
				if (vm.bReadyToSavePW != true) {
					modalService.okAlert("Save Successful", sSaveSuccessMsg);
					
					if (!$rootScope.bPasswordExpired) {
					/* Determine landing page... */
						if (appValidationService.validateAccess() == "CertMgmt") {
							$rootScope.sCurForm = 'Protect References';
							$state.go('certMgmt');
						} else { 
							$rootScope.sCurForm = 'MyCerts';
							$state.go('myCerts'); 
						}
					} else { 
						loginService.user.USEREMAIL = vm.data.email;
						$state.reload();
					}
				} else {
					//also saving new Password:
					saveNewPassword(sSaveSuccessMsg);	
				}
			} else {
				modalService.okAlert("Save Failed", data[0].RESULTCODE);
			}
		});
    }

	function saveNewPassword(msg) {
		var sSaveString = "WebApps_Pro || chgPW || " + loginService.user.USERID +
			" || U || UserID==" + loginService.user.USERID + " || UserName==" +
			loginService.user.USERNAME + " || OldPassword==" + vm.data.oldPW +
			" || NewPassword==" + vm.data.newPW + " || PWStrength==" + 
			vm.sPasswordStrength + " ^^ ";
			
		dataService.usersChangePassword(sSaveString)
		.then(function(data) {
			if (data[0].RESULTCODE == "Success") {
				$rootScope.bPasswordExpired = false;
				modalService.okAlert("Save Successful", 
					"Your password has been updated successfully!");
				
				//No need to store updated Password. 
				if (appValidationService.validateAccess() == "CertMgmt") {
					$rootScope.sCurForm = 'Protect References';
					$state.go('certMgmt');
				} else { 
					$rootScope.sCurForm = 'MyCerts';
					$state.go('myCerts'); 
				}
			} else {
				$state.reload();
				modalService.okAlert("Save Failed", msg + data[0].RESULTREASON);
			}
		});	
    }
    
/* Externally Called Functions: */

    vm.cancelChanges = function() {
		if ($rootScope.bPasswordExpired) {
			$state.reload();
			modalService.okAlert("Expired",
				"Your password is expired, and must be updated before you may " +
				"use the application.");
		} else {
			//Return to Landing page for app:
			if (appValidationService.validateAccess() == "CertMgmt") {
				$rootScope.sCurForm = 'Protect References';
				$state.go('certMgmt');
			} else { 
				$rootScope.sCurForm = 'MyCerts';
				$state.go('myCerts'); 
			}
		}
	};
    
    vm.checkPWStrength = function() {
		var pwReturn = passwordStrength.getPWStrength(vm.data.newPW);
		vm.sPasswordStrength = pwReturn.strength;
		vm.sPWClass = pwReturn.class;
	};  

    vm.confirmReadyToSave = function(item) {
		switch (item) {
			case "email":
				validateEmail();	
			break;
			case "pw":
				validatePW();
			break;
		}
		//May be updating PW, Email or both...		
		if (vm.bReadyToSavePW == true) {
			if ((vm.data.email=="" && vm.data.confirmEmail=="") ||
				vm.bReadyToSaveEmail == true) {
				vm.bReadyToSave = 'true'; 
			} else { vm.bReadyToSave = 'false'; }
		} else if (vm.bReadyToSaveEmail == true &&
			vm.data.newPW == "" && vm.data.confirmPW == "") {
				vm.bReadyToSave = 'true';
		} else { vm.bReadyToSave = 'false'; }
	};
	
	vm.enterKeyHandler = function($event) {
		if ($event.keyCode === 13) {
			if (vm.bReadyToSave == "true") {
				if (vm.bReadyToSaveEmail == true) {
					saveNewEmail();
				} else if (vm.bReadyToSavePW == true) {
					saveNewPassword("");
				}
			}	
		}  
	}; 	

    vm.saveChanges = function() {
		if (vm.bReadyToSave == "true") {
			if (vm.bReadyToSaveEmail == true) {
				saveNewEmail();
			} else if (vm.bReadyToSavePW == true) {
				saveNewPassword("");
			}
		} else if (vm.data.newPW != "" && vm.data.confirmPW != "") {
			validatePW();
		} else if (vm.data.email != "" && vm.data.confirmEmail != "") {
			validateEmail();
		} else { 
			modalService.okAlert("Oops!", 
				"We did not find any data changes to Save.");
		}		
    };
    
}
angular
    .module('proRefs')
    .controller('CertMgmtController', CertMgmtController);

CertMgmtController.$inject = ['dataService', '$rootScope', '$state', 'loginService', '$log'];

function CertMgmtController(dataService, $rootScope, $state, loginService, $log) {
    var vm = this;
    
    vm.churchCerts = [];
    vm.churches = [];
    vm.mChkShowAll = true;
    vm.pastorRefs = [];
    vm.refresh = { image: "assets/images/refresh_22.png" };
    vm.settings = { image: "assets/images/gear_24.png" };
	vm.sView = "refs";	/* Default */
    vm.sUserFullName = loginService.user.USERFULLNAME;
	
	$rootScope.sCurForm = "Pastor References";
	$rootScope.$broadcast('closeMenu');
	
    if (loginService.user.USERENTITYID > 0) {
		loadData();
	}
	
	function loadData() {
		dataService.proLoadPRRefs(loginService.user.USERENTITYID, vm.mChkShowAll)
        .then(function(refs) { // $log.info("refs:",refs)
			for (var i=0; i<refs.length; i++) {
				var dt = new Date(refs[i].CREATEDON);
				refs[i].DisplayDate = dt;
			}
			vm.pastorRefs = refs;
		});
		
		dataService.proGetPastorChCerts(loginService.user.USERENTITYID)
		.then(function(data) { //$log.info(data)
			if (data.length > 0) {			
				//combine certTypes into a single record:
				for (var i=0; i<data.length; i++) {
					if (data[i].CERTTYPEID == 3) {
						data[i].CERTTYPES = "L";
					} else if (data[i].CERTTYPEID == 1) {
						if (i < data.length-1 &&
							data[i+1].ENTITYID == data[i].ENTITYID &&
							data[i+1].CERTTYPEID == 3) {
							data[i].CERTTYPES = "C L";
							data.splice(i+1,1);
							i--; 
						} else {
							data[i].CERTTYPES = "C";
						}
					}
				}
				vm.churchCerts = data;
			}
		});
	}
	
	
/* Broadcasts: */
	
	
/* Called from view: */	
    
    vm.reloadData = function() {
		vm.pastorRefs = [];
		loadData();
    };

    vm.refreshPage = function() {
        $state.reload();
    };
    
    vm.loadReference = function(ref) {
		var stepRefID = ref.STEPREFID; $log.info("StepRefID:",stepRefID)
		var j = stepRefID.indexOf("|"); 
		$state.go('ref', {retCodeKey: stepRefID.slice(j+1)}, {reload:true});
	};
	
	vm.updateCurrentChurch = function(curCh) {
		vm.curChurch = curCh;	
	};
	
	vm.viewHandler = function() {
$log.info("View: ",vm.sView);
	//can add code here to do something upon view change...
	};

	
}
angular
    .module('proRefs')
    .controller('AuthorizationController', AuthorizationController);

AuthorizationController.$inject = ['$rootScope','loginService','dataService','$state', 	'modalService','$stateParams','datesService','errorEmailNotification','backgroundService',
	'webSessionStorage','$log'];

function AuthorizationController($rootScope, loginService, dataService, $state, 
	modalService, $stateParams, datesService, errorEmailNotification, backgroundService, 
	webSessionStorage, $log) {
    var vm = this;
    
    vm.arrDataFields = [];
    vm.arrFormDefs = [];
    vm.authorization = "";
    vm.bShowCursor = false;
    vm.displayGrp1 = [];
    vm.iBkgrdStepID = $stateParams.iBkgrdStepID;
//     vm.iCertTypeID = $stateParams.certRecord.CERTTYPEID; replaced with ==>
	vm.iCertTypeID = $rootScope.curCertRecord.CERTTYPEID;
    vm.header1 = "";
	vm.sDbToday = datesService.todayToDbString();

//Added to prevent double-click duplication:
    vm.bDataSaved = false;
	
// 	$log.info("iCertTypeID:",$rootScope.curCertRecord.CERTTYPEID)
    
/* Initialize: */
	$rootScope.sCurForm = "Authorization";
$log.info($rootScope.sCurForm);
	
	dataService.proGetFormData("Authorization")
	.then(function(formData) {
		
		dataService.proGetForm("Authorization")
		.then(function(defs) {
			if (defs.length > 0) {
				vm.arrFormDefs = defs;
				for (var i=0; i<vm.arrFormDefs.length; i++) {
					var obj = {HTML:"", id:vm.arrFormDefs[i].ITEMID, label:"",
						control:vm.arrFormDefs[i].CONTROLTYPE, itemName:vm.arrFormDefs[i].ITEMNAME, 
						required:vm.arrFormDefs[i].REQUIRED, group:vm.arrFormDefs[i].GROUPNAME,
						grpSeq:vm.arrFormDefs[i].GROUPSEQ, data:null, saveKey:null}
					switch (vm.arrFormDefs[i].CONTROLTYPE) {
						case "BoldLabel":
							obj.control = "L100%Bold";
							obj.label = vm.arrFormDefs[i].CAPTION;
						break;
						case "TextArea1-650":
							obj.control = "LText"; //"L100%"
							obj.label = vm.arrFormDefs[i].CAPTION;
							
						/* Consent is only field populated */	
							if (obj.itemName == "Consent" && formData.length > 0) {
								for (var j=0; j<formData.length; j++) {
									if (formData[j].ITEMID == obj.id) {
										obj.data = formData[j].ITEMDATA;
										obj.saveKey = formData[j].SAVEKEY;
										vm.authorization = obj.data;
									break; }
								}
							}
						break;
						case "Button":
							obj.control = "Button";
							obj.label = vm.arrFormDefs[i].CAPTION;
						break;
						default:
							obj.label = vm.arrFormDefs[i].CAPTION;
						break;	
					}
					
				/* Master list of fields for use to validate against: */
					vm.arrDataFields.push(obj);
					
					switch (vm.arrFormDefs[i].GROUPSEQ) {
						case 1: 
							vm.header1 = vm.arrFormDefs[i].GROUPNAME;
							vm.displayGrp1.push(obj);
						break;
					}
					obj = [];		
				}	
			}
		});
	});
	
	function validateData() {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].itemName == "Consent") {
				var str = vm.arrDataFields[i].data;
				var str1 = str.trim();
				if (str1.toLowerCase() == "yes") {
					saveData();
				} else if (str1 == "") {
					modalService.okAlert("Missing Entry",
						"You must type in the word \"Yes\" along with " +
						"clicking the \"I Agree\" button."); 
				} else {
					modalService.okAlert("Invalid Entry",
						"If you do not agree, you may simply Cancel out of " +
						"this form. Otherwise, type the word \"Yes\" into " +
						"the provided text box.");
				}
			break; }
		}
	}
	
	function saveData() {
		if (vm.bDataSaved == false) {
			vm.bDataSaved = true; //Double-click prevention... won't continue to saveProcessStep() twice.
			var sRawDataString = "WebProtect || authCtrl || " + loginService.user.USERID + " || ";
			for (var i=0; i<vm.arrDataFields.length; i++) {
				if (vm.arrDataFields[i].data != null) {
					if (vm.arrDataFields[i].saveKey == null) {
						sRawDataString += "I";
					} else { sRawDataString += "U || SaveKey==" + vm.arrDataFields[i].saveKey; }
					sRawDataString += " || ProID==" + $rootScope.sProID + " || ItemID==" + 
						vm.arrDataFields[i].id + " || ItemData==" + vm.arrDataFields[i].data + " ^^ ";
				}
			}	
			dataService.proSaveFormData(sRawDataString)
			.then(function(result) {
				if (result.length > 0) {
					for (var i=0; i<result.length; i++) {
						if (result[i].RESULTCODE != "Success") {
							modalService.resultAlert("sm", result[0]);
							var sEmailContent = errorEmailNotification.error4("authCtrl/saveData");
							dataService.emailSendError(sEmailContent);		
						break; } 
						else {
							saveProcessStep();
						}		
					}
				} else {
					sEmailContent = errorEmailNotification.error4("authCtrl/saveData") +
						"<br><br>v.101: Added double-click prevention 1/9/18... but still " +
						"hitting this error.";
					dataService.emailSendError(sEmailContent);	
				}
			});
		}	
	}
	
	function saveProcessStep() {
		var sRawDataString = "WebApps_Pro || Auth_ProProcess || " + loginService.user.USERID +
			" || I || ProID==" + $rootScope.sProID + " || StepID==" + $stateParams.iAuthStepID + 
			" || StepDate==" + vm.sDbToday + " || StepProgress==Completed ^^ ";
		
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if (result.length > 0) {
				if (result[0].RESULTCODE == "Success") {
					vm.bProcessSaved = true;
					sendBackgroundScreen();
				}
			} else {
				modalService.resultAlert("sm", result[0]);
				var sEmailContent = errorEmailNotification.error4("authCtrl/saveProcessStep");
					dataService.emailSendError(sEmailContent);
			}
		});
	}
	
	function sendBackgroundScreen() { 
		var sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
		switch (sDatabaseID) { 
			case "MO":
				/* Removed iCertTypeID... not needed in MO for now. ~ lds 6/28/18 v...139 */
				backgroundService.firstAdvantage(vm.iBkgrdStepID, bkgrdSuccess, 
					bkgrdError);
				vm.bShowCursor = true;	
			break;
			case "NWTX": case "NWTX-DEV":
			case "MC": case "MC-DEV":
				vm.bShowCursor = true;
				backgroundService.protectMyMinistry(vm.iBkgrdStepID, vm.iCertTypeID, bkgrdSuccess,
					bkgrdError);
			break;
			default:
				modalService.okAlert("Dev Database Found",
					"The background screen was NOT sent, since this is a TEST database.");
				bkgrdSuccess();
			break;
		}
	}

	function bkgrdError() {
		vm.bShowCursor = false;
		modalService.okAlert("Error",
			"An Error occurred while submitting the Background screen.");
		$state.go('steps',{reload:true});	
	}

	function bkgrdSuccess() {
		vm.bShowCursor = false;
		modalService.okAlert("Success",
			"Information for your Background " +
			"Screen has been successfully submitted.");
		$state.go('steps', {reload:true});
	}

	
/* Broadcasts: */


/* Calls from View: */
	vm.cancelHandler = function() {
		$state.go('steps', {reload:true});
	};
	
	vm.changeHandler = function(id, value) {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].id == id) {	
				vm.arrDataFields[i].data = value;
			}
		}	
	};
	
	vm.saveHandler = function() {
	/* Verify all Required complete: */
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].required == true &&
				(vm.arrDataFields[i].data == null || vm.arrDataFields[i].data == "")) {
				modalService.okAlert("Missing Required Entry", 
					"One or more required fields " +
					"is incomplete.\n\nPlease complete ALL " +
					"required fields before clicking to Save " +
					"and Submit your data.<br><br>" +
					"The first missing field is: " + vm.arrDataFields[i].label);
			break; }
			else if (i == vm.arrDataFields.length-1) {
				validateData();
			}
		}
	};

}
angular		
	.module('proRefs')
	.controller('ApplicationController', ApplicationController);

ApplicationController.$inject = ['$rootScope','loginService','dataService',
	'webSessionStorage','$sce','$state','modalService','validatorService','personRecord',
	'contactInfo','$stateParams','datesService','errorEmailNotification', 
	'formatterService','modalService','$log'];
	
function ApplicationController($rootScope, loginService, dataService,
	webSessionStorage, $sce, $state, modalService, validatorService, personRecord, 
	contactInfo, $stateParams, datesService, errorEmailNotification, 
	formatterService, modalService, $log) {
	var vm = this; 	//vmAC
	
	vm.arrDataFields = [];
	vm.arrHomeAddrs = [];
	vm.arrChurches = [];
	vm.arrPhTypes = [];
	vm.arrStates = [];
	vm.arrFormData = [];
	vm.arrFormDefs = [];
	vm.arrMain = [];
	vm.arrPeoDetails = [];
	vm.bDateOpen = false;			/* Date Calendar is open */
	vm.bBDEntered = false;			/* Used to capture field ng-blur  */
	vm.bEmailComm = false;			/* When true: make Primary, RcvEmailComm=true */
	vm.bAddAddrFieldsToForm = false;
	vm.bInSaveProcedure = false;	/* Double-click error prevention */
	vm.calcAge = "";
	vm.ageYrs = "";
	vm.dateFormat = "MM/dd/yyyy";
	vm.dBirthDate = "";				//used to calculate 19th BDay for Expiration
	vm.iMainChurchID = 0;			/* ChurchID from ProMain record */	
	vm.iEntityID = 0;
	vm.objPerson = {};				/* Person Record for applicant */
	vm.objPrimaryAddr = null;		// Current PrimaryAddr, Home or otherwise
	vm.sConfirmSSN = "";
	vm.sDatabaseID = webSessionStorage.getStoredData('sDatabaseID');
	vm.selChurch = {};
	vm.selHomeAddr = null;
	vm.selPrimPhType = {};
	vm.selSecPhType = {};
	vm.selOthPhType = {};
	vm.selState = {};
	vm.sLastName = "";
	vm.sDbToday = datesService.todayToDbString();
	
	vm.header1 = "";
	vm.header2 = "";
	vm.header3 = "";
	vm.header4 = "";
	vm.displayGrp1 = [];
	vm.displayGrp2 = [];
	vm.displayGrp3 = [];
	vm.displayGrp4 = [];
	
	
//INITIALIZE:

	$rootScope.sCurForm = "Application";
$log.info($rootScope.sCurForm);

	dataService.libLoadStates()
	.then(function(data) {
		if (data.length>0) {
			vm.arrStates = data;
			vm.selState = vm.arrStates[0];
		}
	});
	
	dataService.phLoadTypes()
	.then(function(data) {
		if (data.length > 0) {
			vm.arrPhTypes = data;
			vm.selPrimPhType = vm.arrPhTypes[0];
			vm.selSecPhType = vm.arrPhTypes[0];
			vm.selOthPhType = vm.arrPhTypes[0];
		}
	});
	
	dataService.proGetMain($rootScope.sProID)
	.then(function(dataMain) {
		if (dataMain.length > 0) {
			vm.arrMain = dataMain;
			vm.iEntityID = vm.arrMain[0].ENTITYID;
			if (vm.sDatabaseID == "MO" || vm.sDatabaseID == "MO-DEV") {
				if (vm.arrMain[0].CHURCHID != "") {
					vm.iMainChurchID = vm.arrMain[0].CHURCHID;	
				}
			}
			
			dataService.chLoadAll()
			.then(function(dataCh) {
				if (dataCh.length > 0) {
					vm.arrChurches = dataCh;
					switch (vm.sDatabaseID) {
						case "MO": case "MO-DEV":
							vm.arrChurches.splice(1, 0, {ENTITYNAME:"Conference/District Staff",
								ENTITYID:"Staff"});
							if (vm.iMainChurchID > 0) {
								for (var i=0; i<vm.arrChurches.length; i++) {
									if (vm.arrChurches[i].ENTITYID == vm.iMainChurchID) {
										vm.selChurch = vm.arrChurches[i];
									break; }
								}
							} else { vm.selChurch = vm.arrChurches[0]; }
						break;
						case "NWTX": case "NWTX-DEV":
							vm.arrChurches.splice(1, 0, {ENTITYNAME:"Other Church or Organization",
								ENTITYID:"OtherCh"});
							vm.selChurch = vm.arrChurches[0];	
						break;
						default:
							vm.selChurch = vm.arrChurches[0];
						break;
					}
				}
			});

			if (vm.iEntityID > 0) { // $log.info("iEntityID:",vm.iEntityID)
				dataService.addrGetAll(vm.iEntityID)
				.then(function(dataAddrs) {
					if (dataAddrs.length > 0) {
						
						//Filter for Only current addresses
						//Set Primary if Exists
						var dToday = new Date();
						for (var i=0; i<dataAddrs.length; i++) {
							var dStart = new Date(dataAddrs[i].STARTDATE);
							var dStop = "";
							if (dataAddrs[i].STOPDATE != "") {
								dStop = new Date(dataAddrs[i].STOPDATE);
							}
							if (dStart > dToday || 
								(dStop != "" && dStop < dToday)) {
								dataAddrs.splice(i, 1);
								i--;
							} else if (dataAddrs[i].PRIMARYADDR == true) {
								vm.objPrimaryAddr = dataAddrs[i];
								if (dataAddrs[i].ADDRTYPE == "Home") {
									vm.selHomeAddr = vm.objPrimaryAddr;
								}
							}	
						}
								
						//Collect all "Home" AddrTypes for Home droplist:
						for (i=0; i<dataAddrs.length; i++) {
							if (dataAddrs[i].ADDRTYPE == "Home") {
								vm.arrHomeAddrs.push(dataAddrs[i]);
							}
						}
						
						if (vm.arrHomeAddrs.length > 0) {
							if (vm.selHomeAddr == null) {
								vm.selHomeAddr = vm.arrHomeAddrs[0];
							}
						} else { vm.bAddAddrFieldsToForm = true; }
					} else {
						vm.bAddAddrFieldsToForm = true;
					}
				});
				
				dataService.peoGetDetails(vm.iEntityID)
				.then(function(data) { //$log.info("peoGetDetails:",data)
					if (data.length > 0) {
						vm.objPerson = data[0];
						if (vm.sLastName == "") {
							vm.sLastName = data[0].LASTNAME;
							if (vm.arrDataFields.length > 0) {
								for (var i=0; i<vm.arrDataFields.length; i++) {
									if (vm.arrDataFields[i].itemName == "LastName") {
										vm.arrDataFields[i].data = vm.sLastName;
									break; }
								}
							}
						}	
					}
					getProFormDefs();
				});	
			} else {
/* Replaced Debug with logging out... ~ ver...188 lds */
				vm.loggedIn = false;
				loginService.logout();
				vm.myApps = [];
				modalService.okAlert("Expired", 
					"Your session login has expired.<br><br>" +
					"Please log in again to continue.");
					$state.go('login', {reload:true});
			}
		}
	});
	
	function getProFormDefs() {
		dataService.proGetForm($stateParams.sStepLinkFlag)
		.then(function(defs) { //$log.info("defs:",defs);
			if (defs.length > 0) {
				vm.arrFormDefs = defs;
				
				getProFormData();
			}
		});
	}
	
	function getProFormData() {
		dataService.proGetFormData($stateParams.sStepLinkFlag, $rootScope.sProID)
		.then(function(data) { //$log.info("Data:",data)
			if (data.length > 0) {
				vm.arrFormData = data;
			}
			loadDisplay();
		});
	}
	
	function loadDisplay() {
		vm.arrDataFields = [];
		
		for (var i=0; i<vm.arrFormDefs.length; i++) {
			var obj = {HTML:"", id:vm.arrFormDefs[i].ITEMID, label:"",
				control:vm.arrFormDefs[i].CONTROLTYPE, itemName:vm.arrFormDefs[i].ITEMNAME, 
				seq:vm.arrFormDefs[i].ITEMSEQ, saveKey:"", type:"", typeID:"",
				required:vm.arrFormDefs[i].REQUIRED, group:vm.arrFormDefs[i].GROUPNAME,
				grpSeq:vm.arrFormDefs[i].GROUPSEQ, data:"", numOnly:0, emComm:false, 
				tip:vm.arrFormDefs[i].TIP}
			
			//Add any existing data to this obj:
			for (var j=0; j<vm.arrFormData.length; j++) {
				if (vm.arrFormData[j].ITEMID == obj.id) {
					obj.saveKey = vm.arrFormData[j].SAVEKEY;					
					if (obj.itemName == "LastName" && vm.sLastName != "") {
						obj.data = vm.sLastName;
					} else {
						obj.data = vm.arrFormData[j].ITEMDATA;
					}
				break; }
			}		
			
			switch (vm.arrFormDefs[i].CONTROLTYPE) {
				case "txtHTML": case "Label":
					obj.HTML = $sce.trustAsHtml(vm.arrFormDefs[i].CAPTION);
				break;
				case "LText-100": case "CText-100": case "CText-150":
				case "RText-100": case "LText-150": case "RText-80":
				case "RText-150": case "RText-250": case "LText-250":
					switch(vm.arrFormDefs[i].ITEMNAME) {
						case "FirstName": obj.control = "FName"; break;
						case "MiddleName": obj.control = "MName"; break;
						case "City": obj.control = "City"; break;	
						case "Zip": obj.control = "Zip"; break;
						default: obj.control = "LText"; break; 
					}
					obj.label = vm.arrFormDefs[i].CAPTION;
				break;
				case "RText-30":
					obj.control = "NumOnly";
					obj.label = vm.arrFormDefs[i].CAPTION;
				break;
				case "R300Text-100%": case "Text-600": case "Text-100%":
				case "TextArea1-300": case "RText-100%":
					switch (vm.arrFormDefs[i].ITEMNAME) {
						case 'Address': obj.control = "Addr1"; break;
						case "Email": obj.control = "Email"; break;
						default: obj.control = "L100%"; break;	
					}
					obj.label = vm.arrFormDefs[i].CAPTION;
				break;
				case "PhoneL": case "PhoneC": case "PhoneR":
					obj.control = "Phone";
					obj.label = vm.arrFormDefs[i].CAPTION;
					obj.data = ""; //for reEntry due to [type] prefix added, but has obj.saveKey for "Update"
				break;
				case "PhoneL-NoType": case "PhoneR-NoType":
					obj.control = "SpecPhone";
					obj.label = vm.arrFormDefs[i].CAPTION;
					if (obj.data != "") {
						obj.formattedPh = formatterService.formatPhone(obj.data);
					}
				break;
				case "RadioYN-500W": case "RadioYN-500":
					obj.control = "RadioYN";
					obj.label = vm.arrFormDefs[i].CAPTION;
				break;
				case "CDrop-230": case "LDrop-230":
					switch (vm.arrFormDefs[i].ITEMNAME) {
						case "State": 
							obj.control = "State"; 
						break;
						case "UMCChurch": 
							obj.control = "Church";
							if (vm.iMainChurchID > 0) {
								obj.data = vm.iMainChurchID;
							}
						break;
					}
					obj.label = vm.arrFormDefs[i].CAPTION;
				break;
				case "CheckBoxL": case "CheckBoxR":
					obj.control = "CheckBox";
					obj.label = vm.arrFormDefs[i].CAPTION;
				break;
				case "DateField":
					obj.label = vm.arrFormDefs[i].CAPTION;
					if (obj.itemName == "BirthDate") {
						if (obj.data != "") { 
							obj.validateDate = new Date(obj.data);
							vm.calcAge = calculateAge(obj.validateDate); 
						}
					}
				break;
				case "SSN":
					if (obj.data != "") {
						var numOnlyPattern = /[^0-9]/g;
						var valSSN = String(obj.data);
						var numOnlySSN = valSSN.replace(numOnlyPattern,'');
						obj.data = formatterService.formatSSN(numOnlySSN);
					}
					obj.label = vm.arrFormDefs[i].CAPTION; //v...141 (SSN was missing label!) ~ lds
				break;
				default:
					obj.label = vm.arrFormDefs[i].CAPTION;
				break;
			}	
			
			vm.arrDataFields.push(obj);

			switch (vm.arrFormDefs[i].GROUPSEQ) {
				case 1: 
					vm.header1 = vm.arrFormDefs[i].GROUPNAME;
					vm.displayGrp1.push(obj);
				break;
				case 2: 
					vm.header2 = vm.arrFormDefs[i].GROUPNAME; 
					vm.displayGrp2.push(obj);
				break;
				case 3: 
					vm.header3 = vm.arrFormDefs[i].GROUPNAME; 
					vm.displayGrp3.push(obj);
				break;
				case 4: 
					vm.header4 = vm.arrFormDefs[i].GROUPNAME; 
					vm.displayGrp4.push(obj);
				break;
			}
		}
		if (vm.selHomeAddr != null) {
			populateSelHomeAddr();
		} 
//$log.info("arrDataFields:",vm.arrDataFields)
	}
		
	function calculateAge(dBD) {
		var now = new Date();
		var diff = now.getTime() - dBD.getTime();
		var ageDays = diff/86400000;
		vm.ageYrs = Math.floor(ageDays/365.24); // $log.info('ageYrs:', vm.ageYrs);  // for display of Age
		var calcAge = Number(ageDays/365.24).toFixed(2); // $log.info('calcAge:', calcAge); // for calculation purposes
		
		if (calcAge < 10 || calcAge > 99) {
			modalService.okAlert("Invalid Entry",
				"Please correct the Birth Date to be your actual Date of Birth.");	
		} else {
			switch (vm.sDatabaseID) {
				case "MO": case "MO-DEV":
					if (calcAge < 14.5) {
						modalService.okAlert("Invalid Age",
							"The minimum age to be Conference certified level in the Missouri Conference is 15. In order to be considered for Local Church certification level, you must meet the Age Requirement in your specific Local Church SS Policy. The LCA at your church can provide this information to you. You can proceed to complete the training, however, it is up to the Local Church if they are able to certify you, if you are younger than the Minimum age. If you are under the minimum age of 15, you are not eligible for Conference level certification.");
					}
					//SSN required for all > 14.5, as needed for autoRenew when turn 19yo. ~ fixed 5/13/19 v...181
					 else if (calcAge < 18.5) { //v...141 corrected from 18 ~ lds
						for (var i=0; i<vm.arrDataFields.length; i++) {
							if (vm.arrDataFields[i].itemName == "SSN") {
								vm.arrDataFields[i].required = false;
							break; }
						}	
					} else {
						for (i=0; i<vm.arrDataFields.length; i++) {
							if (vm.arrDataFields[i].itemName == "SSN") {
								vm.arrDataFields[i].required = true;
							break; }
						}
					}
				break;
				case "MC": case "MC-DEV":
					/* Not required if < 19... and get lower rate. 
						But set to 18 since can turn 19 during process... but charged lower rate still. */
					for (var i=0; i<vm.arrDataFields.length; i++) {
						if (vm.arrDataFields[i].itemName == "SSN") {
							if (calcAge < 18) {
								vm.arrDataFields[i].required = false;
							} else { vm.arrDataFields[i].required = true; }
						break; }
					}
				break;
			}
		}	
		return calcAge;
	}
	
	function populateSelHomeAddr() {
		for (var i=0; i<vm.arrDataFields.length; i++) {
			switch (vm.arrDataFields[i].itemName) {
				case 'Address':
					vm.arrDataFields[i].data = vm.selHomeAddr.ADDR1;
				break;
				case 'City':
					vm.arrDataFields[i].data = vm.selHomeAddr.CITY;
				break;
				case 'State':
					vm.arrDataFields[i].data = vm.selHomeAddr.STATE;
				break;
				case 'Zip':
					vm.arrDataFields[i].data = vm.selHomeAddr.ZIP;
				break;	
			}
		}
	}

	function validateData() {
		var bReadyToSave = true;
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].data != "") {
				switch (vm.arrDataFields[i].itemName) {
					case "SSN":
					/* SSN stored in Protect as typed, but validated for correct # digits.
						SSN is NOT written to permanent Person record. */
						var numOnlyPattern = /[^0-9]/g;
						var valSSN = String(vm.arrDataFields[i].data);
						var numOnlySSN = valSSN.replace(numOnlyPattern,'');
						if (String(numOnlySSN).length != 9) {
							bReadyToSave = false;
							vm.arrDataFields[i].data = "";
							modalService.okAlert("Invalid Entry",
								"The SSN is not valid. A valid SSN " +
								"contains only 9 numbers separated by dashes " +
								"in the pattern shown. Please re-enter your SSN.");	
						}
					break;
					case "PrimaryPhone": case "SecondaryPhone": case "OtherPhone":
					case "CellPhone": case "HomePhone":
					/* Phones stored in Protect as typed, but validated here for correct # digits.
						During SAVE, the [PhoneType] is appended onto the phone number for display
						of saved info in Application or in MCProtect (ie: "(573)450-2586 [Cell]").
						Phones are NOT used in Background Screen, so not imported there.
						
						On Submit, if Phone not currently in person's Contact Info, Phone is
						stripped to "numOnly" and saved to Phones table. */
						var valPh = vm.arrDataFields[i].data;
						if (Number(valPh) == "NaN" || isNaN(valPh)) {
							numOnlyPattern = /[^0-9]/g;
							var numOnlyPh = valPh.replace(numOnlyPattern,'');
						} else { numOnlyPh = valPh; }
						if (String(numOnlyPh).length != 10) {
							bReadyToSave = false;
								modalService.okAlert("Invalid Entry",
									"The entered " + vm.arrDataFields[i].label +
									" is not valid. Please enter a valid phone number in " +
									"the format of (###) ###-####.");	
						} else {
							vm.arrDataFields[i].numOnly = numOnlyPh;
						}
					break;
					case "Zip":
						var valZip = vm.arrDataFields[i].data;
						if (String(valZip).indexOf("-") > -1) {
							numOnlyPattern = /[^0-9]/g;
							var numOnlyZip = valZip.replace(numOnlyPattern,''); }
						else { numOnlyZip = valZip; }
						if (String(numOnlyZip).length != 5 && String(numOnlyZip).length != 9) {
							bReadyToSave = false;
							vm.arrDataFields[i].data = "";
							modalService.okAlert("Invalid Entry",
								"The entered Zipcode is not valid. " +
								"A valid ZIP contains 5 digits or 9 digits when using " +
								"zip+4 format (#####-####). Please enter a valid Zipcode.");	
						}	
					break;
					case "Email":
						if (validatorService.emailIsValid(vm.arrDataFields[i].data) == false) {
							bReadyToSave = false;
							modalService.okAlert("Invalid Entry",
								"The entered email address is not " +
								"valid. Please enter a valid email address.");
						}
					break;
					case "BirthDate":
						if (new Date(vm.arrDataFields[i].validateDate) == 'Invalid Date') {
							bReadyToSave = false;
							vm.arrDataFields[i].validateDate == "";
							vm.arrDataFields[i].data = "";
							modalService.okAlert("Invalid Entry",
								"The entered Birth Date is Invalid. \n" +
								"Please enter a valid Date.");
						} else {
							var dBD = new Date(vm.arrDataFields[i].data);
							var calcAge = calculateAge(dBD);
							if (calcAge < 10 || calcAge > 99) {
								bReadyToSave = false;
								modalService.okAlert("Invalid Entry",
									"Please correct the Birth Date to be your actual Date of Birth.");
							}	
						}
					break;
				}	
			}
		}

		if (bReadyToSave == true) {
			saveData();
		}
	}
	
	function saveData() {
		var sRawDataString = "WebProtect || Application || " + String(loginService.user.USERID) +
			" || ";
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].data != "") {
				if (vm.arrDataFields[i].saveKey != "") {
					sRawDataString += "U || SaveKey==" + vm.arrDataFields[i].saveKey;
				} else { sRawDataString += "I"; }
					
				sRawDataString += " || ProID==" + $rootScope.sProID + " || ItemID==" +
					vm.arrDataFields[i].id + " || ItemData==";
						
				switch (vm.arrDataFields[i].itemName) {
					case "PrimaryPhone": case "SecondaryPhone": case "OtherPhone":
						sRawDataString += vm.arrDataFields[i].data;
						if (vm.arrDataFields[i].type != "") {
							sRawDataString += " [" + vm.arrDataFields[i].type + "]";
						} 
						sRawDataString += " ^^ ";
					break;
					default:
						sRawDataString += vm.arrDataFields[i].data + " ^^ ";
					break;

				}	
			}
		}
//$log.info(sRawDataString)
		if (vm.bInSaveProcedure == false) {
			vm.bInSaveProcedure = true;
			dataService.proSaveFormData(sRawDataString)
			.then(function(result) {
				if (result.length > 0) {
					for (var i=0; i<result.length; i++) {
						if (result[i].RESULTCODE != "Success") {
							modalService.resultAlert("sm",result[i]);
							var sEmailContent = errorEmailNotification.error4("applCtrl/saveData");
							dataService.emailSendError(sEmailContent);	
						break; } 
						else if (i == result.length-1) {
							updatePersonRecord();
						}		
					}
				} else {
					sEmailContent = 
						errorEmailNotification.error4("applCtrl/saveData");
					dataService.emailSendError(sEmailContent);	
				}
			});
		}	
	}
	
	function updatePersonRecord() {
		var sSaveString = (personRecord.createUpdateString(vm.objPerson, vm.arrDataFields));
		if (sSaveString != "") {
			dataService.peoSave(sSaveString)
			.then(function(result) {
				if (result[0].RESULTCODE != "Success") {
					modalService.resultAlert("sm", result[0]);
				}
				saveAddress();
			});	
		} else { saveAddress(); }
	}	
	
	function saveAddress() {
		if (vm.bAddAddrFieldsToForm == true) {
			contactInfo.saveHomeAddr(vm.iEntityID, vm.arrDataFields, vm.selHomeAddr, vm.objPrimaryAddr)
			.then(function(result){
				if (result[0].RESULTCODE != "Success") { 
					var sEmailContent = errorEmailNotification.error4("applCtrl/saveAddress");
					dataService.emailSendError(sEmailContent);
				}
				savePhones();
			});
		} else if (vm.objPrimaryAddr != null && 
			(vm.objPrimaryAddr.ADDRTYPE == "Home" || vm.objPrimaryAddr.ADDRTYPE == "Parsonage") &&
			vm.objPrimaryAddr.SAVEKEY != vm.selHomeAddr.SAVEKEY) {
			contactInfo.updateAddrEntityUse(vm.iEntityID, vm.selHomeAddr, vm.objPrimaryAddr)
			.then(function(result){
				if (result[0].RESULTCODE != "Success") {
					modalService.resultAlert("sm", result[0]);
				}
				savePhones();
			});	
		} else { savePhones(); }		
	}
	
	function savePhones() {
		contactInfo.saveNewPhones(vm.iEntityID, vm.arrDataFields)
		.then(function(result){
			if (result == "No New Phones") {
				saveEmail();
			} else if (result.length > 0) {
				for (var i=0; i<result.length; i++) {
					if (result[i].RESULTCODE != "Success") {
						modalService.resultAlert("sm", result[0]);
					}
				}
				saveEmail();
			}
		});	
	}
	
	function saveEmail() {
		contactInfo.saveNewEmails(vm.iEntityID, vm.arrDataFields)
		.then(function(result) {
			if (result == "No New Emails") {
				saveProcessStep();
			} else if (result.length > 0) {
				for (var i=0; i<result.length; i++) {
					if (result[i].RESULTCODE != "Success") {
						modalService.resultAlert("sm", result[0]);
					}
				}
				saveProcessStep();
			}
		});
	}	
	
	function saveProcessStep() {
		var sRawDataString = "WebProtect || applCtl_v.135 || " + loginService.user.USERID + " || ";
		if ($stateParams.iApplSaveKey != "") { 
			sRawDataString += "U || SaveKey==" + $stateParams.iApplSaveKey; }
		else { sRawDataString += "I"; }	
		sRawDataString +=" || ProID==" + $rootScope.sProID + " || StepID==" + $stateParams.iApplStepID + 
			" || StepDate==" + vm.sDbToday + " || StepProgress==Completed ^^ ";

		switch (vm.sDatabaseID)	{
			case "MC": case "MC-DEV":
			/* Youth under 19 y.o. do not complete Authorization Step or Background screen.
				Authorization Step set to expire on 19th BDay to complete and run Background
				screen at that time. */
				if (vm.calcAge > 10 && vm.calcAge < 19) {
					//Authorization Step Expires on 19th Birthday
					sRawDataString += "I || ProID==" + $rootScope.sProID + " || StepID==" +
						$stateParams.iAuthStepID + " || StepDate== || StepExpires==" + 
						datesService.get19thBirthDate(vm.dBirthDate) + 
						" || StepNote==YOUTH under 19 y.o. || StepLinkType== || StepLink==" +
						" || StepProgress==Not Applicable || StepRefID== ^^ ";	
				}
			break;
			case "MO": case "MO-DEV":
				/** Youth under 18.5 y.o. do not complete Authorization Step or Background screen.
				  * Authorization Step set to expire on 19th BDay to complete and run Background
				  * screen at that time. ~ v...141 ~ lds 
				  * Updated text to represent < 18.5 y.o. ~ v...187 lds
				  **/
				if (vm.calcAge > 10 && vm.calcAge < 18.5) {
					//Authorization Step Expires on 19th Birthday
					sRawDataString += "I || ProID==" + $rootScope.sProID + " || StepID==" +
						$stateParams.iAuthStepID + " || StepDate== || StepExpires==" + 
						datesService.get19thBirthDate(vm.dBirthDate) + 
						" || StepNote==YOUTH under 18.5 y.o. || StepLinkType== || StepLink==" +
						" || StepProgress==Not Applicable || StepRefID== ^^ ";	
				}
			break;
		}
		
		dataService.proSaveProcess(sRawDataString)
		.then(function(result) {
			if (result.length > 0) {
				if (result[0].RESULTCODE == "Success") {
					$state.go('steps', {reload:true});
				}
			}
		});
	}
	

/* Broadcasts: */
	
	
/* Called from view: */	
	
	//Necessary to use standard HTML <input type=date> in Angular as ng-model requires date:
	vm.birthDateHandler = function(item){
		vm.bBDEntered = true;
		if (new Date(item.validateDate) == 'Invalid Date') {
			item.validateDate == "";
			modalService.okAlert("Invalid Entry",
				"The entered Birth Date is Invalid. \n" +
				"Please enter a valid Date.");
		} else {
			item.data = datesService.jsDateStrToCalendarStr(item.validateDate);
			vm.dBirthDate = item.validateDate;	//v.135 needed BDate for obtaining 19th BDay Ln 619
			vm.calcAge = calculateAge(item.validateDate);
		}
	};
	
	vm.cancel = function() {
		$state.go('steps', {reload:true});
	};
	
	vm.changeHandler = function(id, value) {
		if (id=='confirmSSN') {
			var numOnlyPattern = /[^0-9]/g;
			var numOnlyConfirm = value.replace(numOnlyPattern,'');
			if (numOnlyConfirm.length == 9) {
				for (var i=0; i<vm.arrDataFields.length; i++) {
					if (vm.arrDataFields[i].itemName == "SSN") {
						var sSSN = vm.arrDataFields[i].data;
						var numOnlySSN = sSSN.replace(numOnlyPattern,'');
						if (numOnlyConfirm != numOnlySSN) {
							vm.sConfirmSSN = "";
							modalService.okAlert("Invalid Entry",
								"The Confirmed SSN did not match " +
								"the entered SSN, and has been removed.\n\n" +
								"Please verify that the SSN " +
								"entered is correct, and confirm it by typing " +
								"the same SSN a second time.");
						}		
					break; }
				}
			}
		} else {
			for (i=0; i<vm.arrDataFields.length; i++) {
				if (vm.arrDataFields[i].id == id) {	
					if (vm.arrDataFields[i].control == "Phone" || 
						vm.arrDataFields[i].control == "SpecPhone") {
						switch (vm.arrDataFields[i].itemName) {
							case "PrimaryPhone":
								if (value == vm.selPrimPhType.PHONETYPE) {
									if (value == "Type:") { 
										vm.arrDataFields[i].type = "";
										vm.arrDataFields[i].typeID = ""; 
									} else { 
										vm.arrDataFields[i].type = value;
										vm.arrDataFields[i].typeID = vm.selPrimPhType.PHONETYPEID; 
									}
								} else { vm.arrDataFields[i].data = value; }
							break;
							case "SecondaryPhone":
								if (value == vm.selSecPhType.PHONETYPE) {
									if (value == "Type:") { 
										vm.arrDataFields[i].type = "";
										vm.arrDataFields[i].typeID = "";
									} else { 
										vm.arrDataFields[i].type = value;
										vm.arrDataFields[i].typeID = vm.selSecPhType.PHONETYPEID; 
									}
								} else { vm.arrDataFields[i].data = value; }
							break;
							case "OtherPhone":
								if (value == vm.selOthPhType.PHONETYPE) {
									if (value == "Type:") { 
										vm.arrDataFields[i].type = "";
										vm.arrDataFields[i].typeID = "";
									} else { 
										vm.arrDataFields[i].type = value;
										vm.arrDataFields[i].typeID = vm.selOthPhType.PHONETYPEID; 
									}
								} else { vm.arrDataFields[i].data = value; }
							break;
							case "CellPhone":
								vm.arrDataFields[i].formattedPh = formatterService.formatPhone(value);
								var numOnlyPh = value.replace(numOnlyPattern,'');
								vm.arrDataFields[i].data = numOnlyPh;
								vm.arrDataFields[i].type = "Cell";
								for (var j=0; j<vm.arrPhTypes.length; j++) {
									if (vm.arrPhTypes[j].PHONETYPE == "Cell") {
										vm.arrDataFields[i].typeID = vm.arrPhTypes[j].PHONETYPEID;
									break; }
								}
							break;
							case "HomePhone":
								vm.arrDataFields[i].data = value;
								vm.arrDataFields[i].type = "Home";
								for (j=0; j<vm.arrPhTypes.length; j++) {
									if (vm.arrPhTypes[j].PHONETYPE == "Home") {
										vm.arrDataFields[i].typeID = vm.arrPhTypes[j].PHONETYPEID;
									break; }
								}
							break;
						}
					} else {
						vm.arrDataFields[i].data = value;
					}	
					
					//Custom checks, alerts:
					switch (vm.sDatabaseID) {
						case "MO": case "MO-DEV":
							if ((vm.arrDataFields[i].itemName == "PastoralCharge" || 
								vm.arrDataFields[i].itemName == "Clergy")
								&& vm.arrDataFields[i].data == "Yes") {
								modalService.okAlert("Validate Response",
									"The response you selected indicates that you " +
									"are a Clergy person or serving a church as a Clergy or " +
									"Lay pastor. This selection will change some of the steps " +
									"as you proceed.\n\n" +
									"Be sure this response is correct prior to Saving your changes.");
							}
						break;
					}
				break; }
			}
		}
	};
	
	vm.dateOpened = function($event) {
		$event.preventDefault();
		$event.stopPropagation();
		vm.bDateOpen = true;	
	};

	//select Home Address from several in Droplist:
	vm.selectHomeAddr = function() {
		if (vm.selHomeAddr.ADDRID > 0) {
			populateSelHomeAddr();
			
		/* If the current Primary Addr is a Home Addr, but not the one selected 
			for use... Update the AddrEntityUse table with new selection as Primary. */	
			if (vm.arrHomeAddrs.length > 1 && vm.selHomeAddr.PRIMARYADDR == false) {
				for (var i=0; i<vm.arrHomeAddrs.length; i++) {
					if (vm.arrHomeAddrs[i].PRIMARYADDR == true) {
						vm.objPrimaryAddr = vm.arrHomeAddrs[i];
					break; }
				}
			}
		}
	};
	
	vm.saveSubmit = function() { //$log.info("Data to Save:",vm.arrDataFields)
		//Verify all Required complete:
		for (var i=0; i<vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].required == true && vm.arrDataFields[i].data == "") {
				modalService.okAlert("Missing Required Entry", 
					"One or more required fields is incomplete.\n\nPlease complete ALL " +
					"required fields before clicking to Save and Submit your data.\n\n" +
					"The first missing field is: " + vm.arrDataFields[i].label);
			break; }
			else if (vm.arrDataFields[i].required == true &&
				(vm.arrDataFields[i].itemName == "PrimaryPhone" ||
				vm.arrDataFields[i].itemName == "SecondaryPhone" ||
				vm.arrDataFields[i].itemName == "OtherPhone") &&
				vm.arrDataFields[i].type == "") {
				modalService.okAlert("Missing Required Entry", 
					"A required Phone also requires selecting the Phone Type.\n\n" +
					"Please make a Phone Type selection before clicking to Save and Submit " +
					"your data.");	
			break; }
			//v...142 added validate on State requirement ~ lds 
			else if (vm.arrDataFields[i].itemName == "State" && vm.arrDataFields[i].required == true &&
				(vm.arrDataFields[i].data == "<No Selection>" ||
				angular.isDefined(vm.arrDataFields[i].data)==false)) {
				modalService.okAlert("Missing Required Entry", 
					"A State is required for your address.\n\n" +
					"Please make a State selection before clicking to Save and Submit " +
					"your data.");		
			break; }
			else if (i == vm.arrDataFields.length-1) {
				validateData();
			}	
		}
	};
	
	vm.setConfComm = function() {
		for (var i=0; vm.arrDataFields.length; i++) {
			if (vm.arrDataFields[i].itemName == "Email") { 
				if (vm.arrDataFields[i].data != "") {
					vm.arrDataFields[i].emComm = vm.bEmailComm;
				} else {
					vm.bEmailComm = false;
					modalService.okAlert("Missing Entry", 
						"Please enter an email address prior to making " +
						"the Conference communication selection.");
				}	
			break; }
		}
	};
	
	vm.updateHomeAddr = function() {
		if (vm.bAddAddrFieldsToForm == true) {
			vm.selHomeAddr = null;
			vm.selState = null;
			for (var i=0; i<vm.arrDataFields.length; i++) {
				switch (vm.arrDataFields[i].itemName) {
					case 'Address':
						vm.arrDataFields[i].data = "";
					break;
					case 'City':
						vm.arrDataFields[i].data = "";
					break;
					case 'State':
						vm.arrDataFields[i].data = "";
					break;
					case 'Zip':
						vm.arrDataFields[i].data = "";
					break;	
				}
			}
		} else {
			if (vm.arrHomeAddrs.length == 1) {
				vm.selHomeAddr = vm.arrHomeAddrs[0];
			} else if (vm.objPrimaryAddr != null) {
				vm.selHomeAddr = vm.objPrimaryAddr;
			} else { vm.selHomeAddr = vm.arrHomeAddrs[0]; }
			populateSelHomeAddr();
		}	
	};
		
}
(function() {
  'use strict';

  angular
    .module('proRefs')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
    .state('index', {
		url: '/index.html',
        templateUrl: 'app/views/login.html',
        controller: 'LoginController',
        controllerAs: 'vmLI'
    })
    .state('login', {
		url: '/login',
        templateUrl: 'app/views/login.html',
        controller: 'LoginController',
        controllerAs: 'vmLI'
    })
    .state('about', {
			url: '/about',
			templateUrl: 'app/views/about.html'
		})
    .state('application', {
		url: '/appl',
		templateUrl: 'app/views/appl.html',
		controller: 'ApplicationController',
		controllerAs: 'vmAC',
		params: {
			sStepLinkFlag: "",
			iApplSaveKey: 0,
			iApplStepID: 0,
			iAuthStepID: 0
		}
    })
    .state('authorization', {
		url: '/authorization',
		templateUrl: 'app/views/authorization.html',
		controller: 'AuthorizationController',
		controllerAs: 'vmAU',
		params: {
			iAuthStepID: 0,
			iBkgrdStepID: 0 //,certRecord: {} ==> use $rootScope.curCertRecord instead
		}
	})
    .state('certMgmt', {
        url: '/certMgmt',
        templateUrl: 'app/views/certMgmt.html',
        controller: 'CertMgmtController',
        controllerAs: 'vmCM'
    })
	.state('chgPW', {
        url: '/chgPW',
        templateUrl: 'app/views/chgPW.html',
        controller: 'ChgPasswordController',
        controllerAs: 'vmCP'
    })
    .state('helpDesk', {
		url: '/helpDesk',
		templateUrl: 'app/views/helpDesk.html',
		controller: 'HelpDeskController',
		controllerAs: 'vmHD'
	})
	.state('lcaCovenant', {
		url: '/lcaCovenant',
		templateUrl: 'app/views/lcaCovenant.html',
		controller: 'LCACovenantController',
		controllerAs: 'vmLCA',
		params: {
			iStepID: 0
		}
	})
	.state('lcPolicy', {
		url: '/lcPolicy',
		templateUrl: 'app/views/lcPolicy.html',
		controller: 'LCPolicyController',
		controllerAs: 'vmLC',
		params: {
			iStepID: 0
		}
	})
    .state('myCerts', {
		url: '/myCerts',
		templateUrl: 'app/views/myCerts.html',
		controller: 'MyCertsController',
		controllerAs: 'vmCrt',
		params: {
			sFunction: ""
		}
	})
	.state('newAcct', {
		url: '/newAcct',
		templateUrl: 'app/views/newAcct.html',
		controller: 'NewAcctController',
		controllerAs: 'vmUA'
	})
	.state('nwtxPayment', {
		url: '/nwtxPayment',
		templateUrl: 'app/views/nwtxPayment.html',
		controller: 'NWTXPaymentController',
		controllerAs: 'vmNPay',
		params: {
			iCertTypeID: 0,
			paymentSaveKey: 0,
			paymentStepID: 0
		}
	})
	.state('nwtxCampReq', {
		url: '/nwtxCampReq',
		templateUrl: 'app/views/nwtxCampReq.html',
		controller: 'NWTXReqController',
		controllerAs: 'vmNReq'
	})
	.state('ref', {
		url: '/ref',
		templateUrl: 'app/views/reference.html',
		controller: 'ReferenceController',
		controllerAs: 'vmRef',
		params: { retCodeKey: 0 }
    })
    .state('refer', {
		url: '/refer',
		templateUrl: 'app/views/refer.html',
		controller: 'ReferralController',
		controllerAs: 'vmRefer',
		params: {
			Applicant: "",
			ApplUserID: 0,
			iProRefUserID: 0,
			iStepSaveKey: 0,
			retCodeKey: 0, 
			sProID: "",	    	
			sStepLinkFlag: "" 
		}
    })
	.state('refRequest', {
		url: '/refRequest',
		templateUrl: 'app/views/refRequest.html',
		controller: 'RefRequestController',
		controllerAs: 'vmRR',
		params: {
			sStepLinkFlag: "",
			refSaveKey: 0,
			refStepID: 0
		}
	})
		.state('pastorRef', {
			parent: 'refRequest',
			templateUrl: 'app/partials/pastorRef.html',
			controller: 'RefPastorRefController',
			controllerAs: 'vmRefPR',
			params: {
				sStepLinkFlag: "",
				refSaveKey: 0,
				refStepID: 0
			}
		})
		.state('defaultRef', {
			parent: 'refRequest',
			templateUrl: 'app/partials/defaultRef.html',
			controller: 'RefDefaultController',
			controllerAs: 'vmRefDef',
			params: {
				sStepLinkFlag: "",
				refSaveKey: 0,
				refStepID: 0
			}
		})	
	.state('steps', {
		url: '/steps',
		templateUrl: 'app/views/steps.html',
		controller: 'StepsController',
		controllerAs: 'vmSC'
	})
	.state('stepInst', {
		url: '/stepInst',
		templateUrl: 'app/views/stepInst.html',
		controller: 'StepInstController',
		controllerAs: 'vmSI',
		params: {
			iCertTypeID: 4
		}
	})
	.state('train', {
		url: '/train',
		templateUrl: 'app/views/training.html',
		controller: 'TrainingController',
		controllerAs: 'vmTr',
		params: {
			objStep: {}
		}
	});
    
    $urlRouterProvider.otherwise('/index.html');
    
  }

})();

(function() {
	'use strict';

	angular
		.module('proRefs')
//TEST*/.constant('version', '1.000.109')
/*LIVE*/.constant('version', '1.000.194')
		.constant('authServiceCFC', 'https://umcdata.net/Falcon/libCFCs/AuthService.cfc')
		.constant('mcWebCFC', 'https://umcdata.net/Falcon/libCFCs/MC_Web.cfc')
		.constant('moodleCFC', 'https://umcdata.net/Falcon/libCFCs/Moodle.cfc')
		.constant('proEmailCFC', 'https://umcdata.net/Falcon/libCFCs/ProCustEmail.cfc')
		.constant('proJsCFC', 'https://umcdata.net/Falcon/libCFCs/Protect_JS.cfc')
		.constant('helpDeskCFC', 'https://umcdata.net/Falcon/libCFCs/HelpDesk.cfc')
// 		.constant('testCFC', 'https://umcdata.net/Falcon/libCFCs/Testing.cfc')
		.constant('lclURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/LCLeaders/#/index.html')
		.constant('mcWebAppsURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/#/index.html')
		.constant('minFinURL', 'https://umcdata.net/MissionConnect/Public/RcvWeb/#/login')
		.constant('protectURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/Protect/#/index.html')
		.constant('refJSURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/Protect/RefJS1/#/index.html')
		.constant('statsURL', 'https://umcdata.net/MissionConnect/Public/MCWebApps/Statistics/#/index.html')
		.constant('vancoPay', 'https://umcdata.net/MissionConnect/Public/VancoPay/#/index.html')
		.constant('webProMO', 'https://umcdata.net/MORefs')
		.constant('butmanCampEmail', 'campvolunteer@butmancamp.org')
		.constant('cetaCampEmail', 'april@cetacanyon.org')
		.constant('vimEmail', 'hughs@nwtxconf.org')
		.constant('custData',
			[{
				"DataSource":"",
				"DatabaseID":"GSS",
				"CustomerName":"<No Selection>"
			},
			{
				"DataSource":"FalconArk",
				"DatabaseID":"AR",
				"CustomerName":"Arkansas Conference"
			},
/*
			{
				"DataSource":"FalconDemo",
				"DatabaseID":"Demo",
				"CustomerName":"Demo Database"
			},
*/
			//EOH
			{
				"DataSource":"FalconKy",
				"DatabaseID":"KY",
				"CustomerName":"Kentucky Annual Conference"
			},
			{
				"DataSource":"FalconLa",
				"DatabaseID":"LA",
				"CustomerName":"Louisiana Conference"
			},
			{
				"DataSource":"FalconMc",
				"DatabaseID":"MC",
				"CustomerName":"McCurdy Ministries Community Center",
				"ProRef": "Safe Sanctuary References"
			},
			{
				"DataSource":"FalconMem",
				"DatabaseID":"MEM",
				"CustomerName":"Memphis Conference"
			},
			{
				"DataSource":"FalconMo",
				"DatabaseID":"MO",
				"CustomerName":"Missouri Conference",
				"ProRef":"Safe Sanctuary References"
			},
			//MN,FalconMinn
			{
				"DataSource":"FalconNm",
				"DatabaseID":"NM",
				"CustomerName":"New Mexico Conference"
			},
			{
				"DataSource":"FalconNwtx",
				"DatabaseID":"NWTX",
				"CustomerName":"Northwest Texas Conference",
				"ProRef":"Volunteer References"
			},
			//PR
			{
				"DataSource":"FalconRm",
				"DatabaseID":"RM",
				"CustomerName":"Rocky Mountain Conference"
			},
			{
				"DataSource":"FalconSwtx",
				"DatabaseID":"SWTX",
				"CustomerName":"Rio Texas Conference"
			},
			{
				"DataSource":"FalconSg",
				"DatabaseID":"SGA",
				"CustomerName":"South Georgia Conference"
			},
			{
				"DataSource":"FalconTenn",
				"DatabaseID":"TN",
				"CustomerName":"Tennessee Conference"
			},
			{
				"DataSource":"FalconUny",
				"DatabaseID":"UNY",
				"CustomerName":"Upper New York Conference"
			},
			//VID,FalconVideos
			//WI,FalconWi
			//WOH,FalconWoh
			{
				"DataSource":"FalconYw",
				"DatabaseID":"YW",
				"CustomerName":"Mountain Sky Conference"
			}
		])
		.constant('custDataDev', [
			{
				"DataSource":"FalconArkDev",
				"DatabaseID":"AR-DEV",
				"CustomerName":"Arkansas Conference  (AR-DEV)"
			},
			{
				"DataSource":"FalconKyDev",
				"DatabaseID":"KY-DEV",
				"CustomerName":"Kentucky Annual Conference  (KY-DEV)"
			},
			{
				"DataSource":"FalconLaDev",
				"DatabaseID":"LA-DEV",
				"CustomerName":"Louisiana Conference (LA-DEV)"
			},
			{
				"DataSource":"FalconMcDev",
				"DatabaseID":"MC-DEV",
				"CustomerName":"McCurdy Ministries (MC-DEV)",
				"ProRef": "Protect References"
			},
			{
				"DataSource":"FalconMemDev",
				"DatabaseID":"MEM-DEV",
				"CustomerName":"Memphis Conference  (MEM-DEV)"
			},
			{	
				"DataSource":"FalconMoDev",
				"DatabaseID":"MO-DEV",
				"CustomerName":"Missouri Conference (MO-DEV)",
				"ProRef":"Safe Sanctuary References"
			},
			{
				"DataSource":"FalconNmDev",
				"DatabaseID":"NM-DEV",
				"CustomerName":"New Mexico Conference (NM-DEV)"
			},
			{
				"DataSource":"FalconNwtxDev",
				"DatabaseID":"NWTX-DEV",
				"CustomerName":"NWTX Conference (NWTX-DEV)",
				"ProRef":"Volunteer References"
			},
			{
				"DataSource":"FalconSwtxDev",
				"DatabaseID":"SWTX-DEV",
				"CustomerName":"Rio Texas Conference (SWTX-DEV)"
			},
			{
				"DataSource":"FalconSgDev",
				"DatabaseID":"SGA-DEV",
				"CustomerName":"South Georgia Conference  (SGA-DEV)"
			},
			{
				"DataSource":"FalconTennDev",
				"DatabaseID":"TN-DEV",
				"CustomerName":"Tennessee Conference  (TN-DEV)"
			},
			{
				"DataSource":"FalconUnyDev",
				"DatabaseID":"UNY-DEV",
				"CustomerName":"Upper New York Conference  (UNY-DEV)"
			},
			{
				"DataSource":"FalconVideos",
				"DatabaseID":"VID",
				"CustomerName":"Demo Conference",
				"ProRef":"Safe Sanctuary References"
			}
		]);
})();

(function() {
// 	'use strict';

	angular
		.module('proRefs')
		.config(config);

	function config($sceDelegateProvider) {
		$sceDelegateProvider.resourceUrlWhitelist([
			'self',
			'https://umcdata.net/**'
		]);
	}

})();

angular.module("proRefs").run(["$templateCache", function($templateCache) {$templateCache.put("app/modals/modAlert.html","<div><!-- ng-controller=\"ModalController as vmMod\" --><div class=\"modal-header MCRed75\"><h3 class=modal-title>{{ vmMod.sTitle }}</h3></div><div class=modal-body><!-- HTML Message: --><p ng-bind-html=vmMod.sAlertMsg></p></div><div class=modal-footer><!-- OK Alert Footer: --><div class=divR ng-show=\"vmMod.modType==\'OK\'\"><button class=\"btn btn-primary\" type=button ng-click=vmMod.cancel()>OK</button></div></div></div>");
$templateCache.put("app/modals/modConfSelectModal.html","<div><!-- ng-controller=\"ModalController as vmSel\" --><div class=\"modal-header MCGold\"><h3 class=modal-title>Please Select a Conference</h3></div><div class=\"modal-body text-center\"><div><p>Oops! We are having trouble locating your account, and need a little more information.<br>Please make a selection from the following:</p><span ng-repeat=\"item in vmSel.confs\"><button class=\"btn-sm btn-default\" style=\"width: 250px\" ng-click=vmSel.ok(item)>{{item.CONFNAME}}</button><br></span></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=vmSel.cancel()>Cancel</button></div></div>");
$templateCache.put("app/modals/modTimeout.html","<div><!-- ng-controller=\"ModalTimeoutController as modTO\" --><div class=\"modal-header MCGrn75\"><h3 class=modal-title>Session Timeout</h3></div><div class=modal-body><!-- HTML Message: --><p>Are you still there?</p><p>Inactivity has been detected. If you would like to continue this session, please click the Continue button within {{ modTO.secTimer }} seconds.</p></div><div class=modal-footer><!-- modType=\'Continue\': --><div class=divR><button class=\"btn btn-primary\" type=button ng-click=modTO.continue()>Continue</button></div></div></div>");
$templateCache.put("app/modals/resendRef.html","<div><!-- ng-controller=\"ResendRefController as vmRRef\" --><div class=modal-header><h3 class=modal-title>Resend Reference</h3></div><div class=modal-body style=\"padding-top: 5px\"><h5 ng-show=\"vmRRef.sStepLinkType==\'Name\'\">Resend this Reference to the same Person, or a different Person by editing the Name and/or Email below:</h5><h5 ng-show=\"vmRRef.sStepLinkType==\'PR\'\">Resend this Reference to the same Pastor, or select a different Pastor from the drop-list below:</h5><div class=div ng-show=\"vmRRef.bRelated==\'Yes\' || vmRRef.sStepLinkFlag==\'DSRef\'\"><label for=DSs>Your District Superintendent:</label><select id=DSs class=form-control ng-model=vmRRef.selDS ng-options=\"ds as ds.FullName for ds in vmRRef.arrDSs |\n					orderBy: \'LASTNAME\'\" ng-change=vmRefPR.DSs_changeHandler(ds)><option value=\"\">&lt;No Selection&gt;</option></select></div><div class=divL ng-show=\"vmRRef.sStepLinkType==\'PR\' && vmRRef.sStepLinkFlag!=\'DSRef\'\"><label for=pastors ng-show=\"vmRRef.sStepLinkFlag==\'PastorRef\'\">Your Pastor:</label><label for=pastors ng-show=\"vmRRef.sStepLinkFlag==\'ClergyProfRef\'\">MO Conference Clergy:</label><select id=pastors class=form-control ng-model=vmRRef.selPastor ng-options=\"pastor as pastor.CHURCHPASTORS for pastor in vmRRef.arrPastors |\n					orderBy: \'CHURCHPASTORS\'\" ng-change=vmRRef.pastors_changeHandler(pastor)><option value=\"\" ng-show=\"vmRRef.arrPastors.length>1\">&lt;No Selection&gt;</option></select></div><div class=div ng-show=\"vmRRef.sStepLinkType==\'Name\'\"><label for=txtRefName>Reference Name:</label><input name=txtRefName type=text class=form-control ng-model=vmRRef.sRefName ng-blur=vmRRef.txtRefName_changeHandler(value)></div><div class=div><label for=email>Email:</label><input name=email type=text class=form-control ng-model=vmRRef.sRefEmail ng-disabled=\"vmRRef.sStepLinkType==\'PR\'\" ng-blur=vmRRef.email_changeHandler()></div></div><div class=modal-footer><div class=divL><button class=\"btn btn-default\" type=button ng-click=vmRRef.cancel()>Cancel</button> <button class=\"btn MCGold\" type=button ng-click=vmRRef.sendRequest()>Resend Reference</button></div></div></div>");
$templateCache.put("app/partials/certsList.html","");
$templateCache.put("app/partials/defaultRef.html","<div class=div><!-- vmRefDef = RefDefaultController --><!-- GeneralRef, ClergyGenRef, PersonalRef --><div><p>Please enter the name and Email address for your reference in the spaces provided.</p></div><div class=div><label for=txtRefName>Reference Name:</label><input name=txtRefName type=text class=form-control ng-model=vmRefDef.sRefName placeholder=\"First and Last Name\" ng-blur=vmRefDef.txtRefName_changeHandler()></div><div class=div><label for=email>Email:</label><input name=email type=text class=form-control ng-model=vmRefDef.sRefEmail ng-change=vmRefDef.email_changeHandler()></div><div class=divR><button ng-click=vmRefDef.cancel()>Cancel</button> <button id=sendReq ng-class=vmRefDef.bReadyToSend ng-click=vmRefDef.sendRequest()>Send Request</button></div></div>");
$templateCache.put("app/partials/dsRef.html","<div class=div><input class=chk type=checkbox checked value=\"{{ vmCM.mChkShowAll }}\" ng-model=vmCM.mChkShowAll ng-click=vmCM.reloadData()> <span class=f15>Show Incomplete References Only</span></div><div><table id=tblRefs class=noLinesGrid><thead><th>Request Date</th><th>Request From</th></thead><tbody ng-show=\"vmCM.pastorRefs.length>0\"><tr ng-repeat=\"ref in vmCM.pastorRefs track by $index\"><td class=\"txtCtr f15\">{{ ref.DisplayDate | date : \"MM/dd/yyyy\" }}</td><td><button id=cmdRef ng-click=vmCM.loadReference($index) ng-hide=\"(ref.STEPPROGRESS==\'Completed\')\">{{ ref.REFREQUESTFROM }}</button> <span class=f15 ng-show=\"(ref.STEPPROGRESS==\'Completed\')\">{{ ref.REFREQUESTFROM }}</span></td></tr></tbody></table></div>");
$templateCache.put("app/partials/pastorRef.html","<div><!-- PastorRef, ClergyProfRef, DSRef (MO Only)	 --><div><form class=div ng-show=\"vmRefPR.sStepLinkFlag == \'PastorRef\'\"><span>Are you related to your Local Church Pastor?</span> <input type=radio name=relation value=Yes ng-model=vmRefPR.related ng-change=\"vmRefPR.relatedHandler(\'Yes\')\">&nbsp;&nbsp;Yes&nbsp;&nbsp; <input type=radio name=relation value=No ng-model=vmRefPR.related ng-change=\"vmRefPR.relatedHandler(\'No\')\">&nbsp;No</form></div><div><p ng-show=\"vmRefPR.sStepLinkFlag==\'PastorRef\' && vmRefPR.related==\'No\'\">Please select your pastor from the list below. If there is only one, just confirm the email and click the Send Request button.</p><p ng-show=\"vmRefPR.related==\'Yes\'\">Please select your District Superintendent for your pastor reference from the list below. Or you may choose another MO Conference pastor who knows you well.</p><p ng-show=\"vmRefPR.sStepLinkFlag==\'ClergyProfRef\'\">Please select a clergy from the drop-list, or enter the Name and Email address for your reference in the spaces provided.</p><p ng-show=\"vmRefPR.sStepLinkFlag==\'DSRef\'\">Please select your District Superintendent from the list below.</p></div><!-- PastorRef & DSRef --><div class=div ng-show=\"vmRefPR.related==\'Yes\' || vmRefPR.sStepLinkFlag==\'DSRef\'\"><label for=DSs>Your District Superintendent:</label><select id=DSs class=form-control style=max-width:300px ng-model=vmRefPR.selDS ng-options=\"ds as ds.FullName for ds in vmRefPR.arrDSs |\n				orderBy: \'LASTNAME\'\" ng-change=vmRefPR.DSs_changeHandler(ds)><option value=\"\">&lt;No Selection&gt;</option></select></div><div class=divL ng-hide=\"vmRefPR.sStepLinkFlag==\'DSRef\'\"><label for=pastors ng-show=\"vmRefPR.sStepLinkFlag==\'PastorRef\' && vmRefPR.related==\'No\'\">Your Pastor:</label><label for=pastors ng-show=\"vmRefPR.related==\'Yes\' || vmRefPR.sStepLinkFlag == \'ClergyProfRef\'\">MO Conference Clergy:</label><select id=pastors class=form-control ng-model=vmRefPR.selPastor ng-options=\"pastor as pastor.CHURCHPASTORS for pastor in vmRefPR.arrPastors |\n				orderBy: \'CHURCHPASTORS\'\" ng-disabled=\"vmRefPR.arrPastors.length==1\" ng-change=vmRefPR.pastors_changeHandler(pastor)><option value=\"\" ng-show=\"vmRefPR.arrPastors.length>1\">&lt;No Selection&gt;</option></select></div><div class=div><div class=div ng-show=\"vmRefPR.sStepLinkFlag==\'ClergyProfRef\'\"><label for=txtRefName>Reference Name:</label><input name=txtRefName type=text class=form-control ng-model=vmRefPR.txtRefName ng-change=vmRefPR.txtRefName_changeHandler(value)></div><div class=div><label for=email>Email:</label><input name=email type=text class=form-control ng-model=vmRefPR.sRefEmail ng-disabled=\"vmRefPR.txtRefName==\'\'\" ng-blur=vmRefPR.email_changeHandler()></div></div><div class=divR><button ng-click=vmRefPR.cancel()>Cancel</button> <button id=sendReq ng-class=vmRefPR.bReadyToSend ng-click=vmRefPR.sendRequest()>Send Request</button></div></div>");
$templateCache.put("app/partials/refsList.html","<div class=div><input class=chk type=checkbox checked value=\"{{ vmCM.mChkShowAll }}\" ng-model=vmCM.mChkShowAll ng-click=vmCM.reloadData()> <span class=f15>Show Incomplete References Only</span></div><div><table id=tblRefs class=noLinesGrid><thead><th>Request Date</th><th>Request From</th></thead><tbody ng-show=\"vmCM.pastorRefs.length>0\"><tr ng-repeat=\"ref in vmCM.pastorRefs track by $index\"><td class=\"txtCtr f15\">{{ ref.DisplayDate | date : \"MM/dd/yyyy\" }}</td><td><button id=cmdRef ng-click=vmCM.loadReference($index) ng-hide=\"(ref.STEPPROGRESS==\'Completed\')\">{{ ref.REFREQUESTFROM }}</button> <span class=f15 ng-show=\"(ref.STEPPROGRESS==\'Completed\')\">{{ ref.REFREQUESTFROM }}</span></td></tr></tbody></table></div>");
$templateCache.put("app/views/about.html","<section class=section><div align=center><span style=\"font-size: 16px\">This software was created by<br>Great Spirit Systems Corporation&trade;<br>specializing in software development to<br>meet the unique needs of religious<br>organizations since 1994.<br><br>Inquiries should be addressed to<br><font color=#0000FF><a href=\"mailto:al@greatspirit.com?subject=Inquiry\"><u>al@greatspirit.com</u></a></font></span></div></section>");
$templateCache.put("app/views/appl.html","<section><!-- vmAC  ApplicationController --><div><h4 id=Top class=h4L>{{vmAC.header1}}</h4><div ng-repeat=\"item in vmAC.displayGrp1 | orderBy: \'seq\' track by $index\"><p ng-bind-html=item.HTML></p><div class=div ng-show=\"item.control==\'CheckBox\'\"><input type=checkbox name=item.id ng-model=item.data>&nbsp;&nbsp; <span ng-class={required:item.required}>{{ item.label }}</span></div></div></div><div><h4 class=h4L>{{vmAC.header2}}</h4><div ng-repeat=\"item in vmAC.displayGrp2 | orderBy: \'seq\' track by $index\"><p ng-bind-html=item.HTML></p><div class=div ng-show=\"item.control==\'CheckBoxR\'\"><input type=checkbox name=item.id ng-model=item.data>&nbsp;&nbsp; <span ng-class={required:item.required}>{{ item.label }}</span></div><div class=divL ng-show=\"item.control==\'FName\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=text class=form-control ng-model=item.data></div><div class=divL ng-show=\"item.control==\'MName\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=text class=form-control ng-model=item.data uib-tooltip=\"Enter N/A if no Middle name\" tooltip-placement=top></div><div class=div ng-show=\"item.control==\'LastName\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=text class=form-control ng-model=vmAC.sLastName ng-disabled=\"vmAC.sLastName != \'\'\"></div><div class=divL ng-show=\"item.control==\'LText\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=text class=form-control ng-model=item.data></div><div class=divL ng-if=\"item.control==\'NumOnly\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=number class=form-control style=\"width: 60px\" ng-model=item.data uib-tooltip={{item.tip}} tooltip-placement=top></div><!-- 	Email	 --><div class=div ng-show=\"item.control==\'Email\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=text class=form-control ng-model=item.data></div><div class=div ng-show=\"item.control==\'Email\' && vmAC.sDatabaseID!=\'MC\' && \n				vmAC.sDatabaseID!=\'MC-DEV\'\"><input id=confComm type=checkbox name=emailUpdate ng-model=vmAC.bEmailComm ng-click=vmAC.setConfComm()>&nbsp;&nbsp; <span>Check here if this email should be used for other communications from the Conference.</span></div><div class=div ng-show=\"item.control==\'L100%\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input id=item.id name=item.id type=text class=form-control ng-model=item.data></div><div class=div ng-show=\"item.control==\'RadioMF\'\"><label for=item.id ng-class={required:item.required}>Gender&nbsp;&nbsp;</label><input type=radio name=item.id value=M ng-model=item.data ng-click=\"vmAC.changeHandler(item.id, \'M\')\">&nbsp;Male&nbsp;&nbsp; <input type=radio name=item.id value=F ng-model=item.data>&nbsp;Female</div><!-- 	BirthDate  (ui.bootstrap DatePicker-PopUp) --><div class=div155 ng-show=\"item.itemName==\'BirthDate\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }} <span style=font-weight:400;color:#000>&nbsp;&nbsp;Age: {{ vmAC.ageYrs }}</span></label><div class=input-group><input name=item.id type=text class=form-control size=12 uib-datepicker-popup=\"{{ vmAC.dateFormat }}\" ng-model=item.validateDate maxlength=10 placeholder=MM/DD/YYYY ng-class=\"{alert:(vmAC.bBDEntered == true && item.validateDate==undefined) || \n							item.id.input.$error.date}\" ng-blur=vmAC.birthDateHandler(item) is-open=vmAC.bDateOpen> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vmAC.dateOpened($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><!-- 	AddressBlock:	 --><div class=\"div required\" ng-show=\"item.itemName==\'Address\' && vmAC.arrHomeAddrs.length>0 && vmAC.bAddAddrFieldsToForm==false\">Current Home Address:<select name=curAddrs class=form-control ng-model=vmAC.selHomeAddr ng-options=\"addr as addr.ADDRITEM for addr in vmAC.arrHomeAddrs track by addr.ADDRID\" ng-blur=vmAC.selectHomeAddr()></select></div><div class=div ng-show=\"item.itemName==\'Address\' && vmAC.arrHomeAddrs.length>0\"><input type=checkbox name=addrUpdate ng-model=vmAC.bAddAddrFieldsToForm ng-click=vmAC.updateHomeAddr()>&nbsp;&nbsp; <span>Check here to update your Home address.</span></div><div class=div ng-show=\"item.control==\'Addr1\' && vmAC.bAddAddrFieldsToForm==true\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input id=item.id name=item.id type=text class=form-control ng-model=item.data></div><div class=divL ng-show=\"item.control==\'City\' && vmAC.bAddAddrFieldsToForm==true\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input id=item.id name=item.id type=text class=form-control ng-model=item.data></div><div class=divL ng-show=\"item.control==\'State\' && vmAC.bAddAddrFieldsToForm==true\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><select class=form-control id=item.id ng-model=vmAC.selState ng-options=\"state as state.STATENAME for state in vmAC.arrStates |\n						orderBy: [\'SORTORDER\',\'STATENAME\']\" ng-blur=\"vmAC.changeHandler(item.id, vmAC.selState.STATEABBRV)\"></select></div><div id=zipForm class=divL ng-show=\"item.control==\'Zip\' && vmAC.bAddAddrFieldsToForm==true\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input id=item.id name=item.id type=text class=form-control ng-model=item.data></div><!-- 		RadioYN	 --><form class=div ng-show=\"item.control==\'RadioYN\'\"><span ng-class={required:item.required}>{{ item.label }}</span><br><input id=item.id type=radio name=item.id value=Yes ng-model=item.value ng-click=\"vmAC.changeHandler(item.id, item.value)\">&nbsp;Yes&nbsp;&nbsp; <input id=item.id type=radio name=item.id value=No ng-model=item.value ng-click=\"vmAC.changeHandler(item.id, item.value)\">&nbsp;No</form><!-- 	Phones: --><div class=divL ng-show=\"item.label==\'Primary Phone\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input type=text name=item.id class=form-control ng-model=item.data ng-change=\"vmAC.changeHandler(item.id, item.data)\"><select name=item.id class=\"form-control divL\" ng-model=vmAC.selPrimPhType ng-options=\"type as type.PHONETYPE for type in vmAC.arrPhTypes | \n						orderBy: [\'SORTORDER\',\'PHONETYPE\']\" ng-blur=\"vmAC.changeHandler(item.id, vmAC.selPrimPhType.PHONETYPE)\"></select></div><div class=divL ng-show=\"item.label==\'Secondary Phone\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input type=text name=item.id class=form-control ng-model=item.value ng-change=\"vmAC.changeHandler(item.id, item.value)\"><select name=item.id class=\"form-control divL\" ng-model=vmAC.selSecPhType ng-options=\"type as type.PHONETYPE for type in vmAC.arrPhTypes | \n						orderBy: [\'SORTORDER\',\'PHONETYPE\']\" ng-blur=\"vmAC.changeHandler(item.id, vmAC.selSecPhType.PHONETYPE)\"></select></div><div class=divL ng-show=\"item.label==\'Other Phone\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input type=text name=item.id class=form-control ng-model=item.value ng-change=\"vmAC.changeHandler(item.id, item.value)\"><select name=item.id class=\"form-control divL\" ng-model=vmAC.selOthPhType ng-options=\"type as type.PHONETYPE for type in vmAC.arrPhTypes | \n						orderBy: [\'SORTORDER\',\'PHONETYPE\']\" ng-blur=\"vmAC.changeHandler(item.id, vmAC.selOthPhType.PHONETYPE)\"></select></div><!-- Specific PhoneType (ie: Cell Phone) --><div class=divL ng-show=\"item.control==\'SpecPhone\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input type=text name=item.id class=form-control ng-model=item.formattedPh ng-change=\"vmAC.changeHandler(item.id, item.formattedPh)\"></div><!-- 	SSN: --><div class=divL ng-show=\"item.control==\'SSN\'\"><label for=item.id ng-class={required:item.required}>{{item.label}}</label><input id=item.id name=item.id type=text class=form-control placeholder=###-##-#### ng-model=item.data ng-disabled=\"(vmAC.calcAge>0 && vmAC.calcAge<18) && \n						(vmAC.sDatabaseID==\'MC\' || vmAC.sDatabaseID==\'MC-DEV\')\"><label for=confirmSSN ng-class={required:item.required}>Confirm SSN</label><input id=confirmSSN name=confirmSSN type=text class=form-control placeholder=###-##-#### ng-model=vmAC.sConfirmSSN ng-disabled=\"(vmAC.calcAge>0 && vmAC.calcAge<18) && \n						(vmAC.sDatabaseID==\'MC\' || vmAC.sDatabaseID==\'MC-DEV\')\" ng-change=\"vmAC.changeHandler(\'confirmSSN\', vmAC.sConfirmSSN)\"></div><!--	Church: --><div class=divL ng-show=\"item.control==\'Church\'\"><label for=item.id style=\"margin-bottom: 2\" ng-class={required:item.required}>{{ item.label }}</label><select class=form-control id=item.id ng-model=vmAC.selChurch ng-disabled=\"vmAC.iMainChurchID != 0 && vmAC.iMainChurchID == vmAC.selChurch.ENTITYID\" ng-options=\"church as church.ENTITYNAME for church in vmAC.arrChurches\" ng-change=\"vmAC.changeHandler(item.id, vmAC.selChurch.ENTITYID)\"></select></div></div></div><h4 class=h4L>{{vmAC.header3}}</h4><div ng-repeat=\"item in vmAC.displayGrp3 | orderBy: \'seq\' track by $index\"><p ng-bind-html=item.HTML></p><form class=div ng-show=\"item.control==\'RadioYN\'\"><span ng-class={required:item.required}>{{ item.label }}</span><br><input id=item.id type=radio name=item.id value=Yes ng-model=item.value ng-click=\"vmAC.changeHandler(item.id, item.value)\">&nbsp;Yes&nbsp;&nbsp; <input id=item.id type=radio name=item.id value=No ng-model=item.value ng-click=\"vmAC.changeHandler(item.id, item.value)\">&nbsp;No</form></div><h4 class=h4L>{{vmAC.header4}}</h4><div ng-repeat=\"item in vmAC.displayGrp4 | orderBy: \'seq\' track by $index\"><p ng-bind-html=item.HTML></p><form class=div ng-show=\"item.control==\'RadioYN\'\"><span ng-class={required:item.required}>{{ item.label }}</span><br><input type=radio name=item.id value=Yes ng-click=\"vmAC.changeHandler(item.id, \'Yes\')\">&nbsp;Yes&nbsp;&nbsp; <input type=radio name=item.id value=No ng-click=\"vmAC.changeHandler(item.id, \'No\')\">&nbsp;No</form></div><div class=divR><button ng-click=vmAC.cancel()>Cancel</button> <button id=saveSubmit class=MCGold ng-click=vmAC.saveSubmit()>Save/Submit</button></div></section>");
$templateCache.put("app/views/authorization.html","<section><!-- vmAU  AuthorizationController --><div class=Modal-backdrop ng-show=vmAU.bShowCursor><div class=Modal-holder><div class=Modal-box><div style=\"float:left; width: 70px\"><img src=assets/images/spinner.gif>&nbsp;&nbsp;&nbsp;</div><div style=\"width: 250px; margin:15px auto; text-align: center\"><span class=spinner style=\"text-align: center\"><b>Sending Background Screen</b><br>Please be patient as this may take a minute or two!</span></div></div></div></div><h4 id=Top class=h4>{{vmAU.header1}}</h4><div ng-repeat=\"item in vmAU.displayGrp1 | orderBy: \'seq\' track by $index\"><div class=div ng-show=\"item.control==\'L100%Bold\'\"><p style=\"font-weight: bold\">{{ item.label }}</p></div><div class=div ng-show=\"item.control==\'L100%\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input id=item.id name=item.id type=text class=form-control ng-model=item.value ng-change=\"vmAU.changeHandler(item.id, item.value)\"></div><div class=div ng-show=\"item.control==\'LText\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=text class=form-control ng-model=vmAU.authorization ng-change=\"vmAU.changeHandler(item.id, vmAU.authorization)\"></div><div class=divR ng-show=\"item.control==\'Button\'\"><button id=cancel ng-click=vmAU.cancelHandler()>Cancel</button> <button class=MCGold id=item.id ng-click=vmAU.saveHandler()>{{ item.label }}</button></div></div></section>");
$templateCache.put("app/views/certMgmt.html","<section class=section><!-- vmCM - CertMgmtController --><div class=div><div class=divL><span class=\"status f16\">Reference Requests for:<br>{{ vmCM.sUserFullName }}</span></div><div class=divR><button id=cmdRefresh uib-tooltip=\"Refresh References\" tooltip-placement=left class=\"btn btn-default custTip\" ng-click=vmCM.refreshPage()><img ng-src=\"{{ vmCM.refresh.image }}\" alt=\"Refresh Page\"></button></div></div><div><div class=divLCtr><label for=optRefs class=radio-inline><input id=optRefs type=radio ng-model=vmCM.sView autocomplete=false value=refs ng-change=vmCM.viewHandler()> References</label></div><div><label for=optCerts class=radio-inline><input id=optCerts type=radio ng-model=vmCM.sView value=certs ng-change=vmCM.viewHandler()> Certifications</label></div></div><div ng-show=\"vmCM.sView==\'refs\'\"><div class=div><input class=chk type=checkbox checked value=\"{{ vmCM.mChkShowAll }}\" ng-model=vmCM.mChkShowAll ng-click=vmCM.reloadData()> <span class=f15>Show Incomplete References Only</span></div><table id=tblRefs class=noLinesGrid><thead><th>Request Date</th><th>Request From</th></thead><tbody ng-show=\"vmCM.pastorRefs.length>0\"><tr ng-repeat=\"ref in vmCM.pastorRefs track by $index\"><td class=\"txtCtr f15\">{{ ref.DisplayDate | date : \"MM/dd/yyyy\" }}</td><td><button id=cmdRef ng-click=vmCM.loadReference(ref) ng-hide=\"(ref.STEPPROGRESS==\'Completed\')\">{{ ref.REFREQUESTFROM }}</button> <span class=f15 ng-show=\"(ref.STEPPROGRESS==\'Completed\')\">{{ ref.REFREQUESTFROM }}</span></td></tr></tbody></table></div><div ng-show=\"vmCM.sView==\'certs\'\"><h4 class=txtCtr><b>Certifications by Church</b></h4><h5 class=txtCtr>C=Conference&nbsp;&nbsp;&nbsp;&nbsp;L=Local Church<br>LCA=Local Church Safe Sanctuaries Assoc.</h5><table id=tblCerts class=noLinesGrid><thead><th>Name</th><th>Cert Type</th><th>Exp Date</th></thead><tbody ng-show=\"vmCM.churchCerts.length>0\"><tr ng-repeat=\"cert in vmCM.churchCerts track by $index\"><td class=f15 ng-show=\"cert.CHURCHNAME != vmCM.churchCerts[$index-1].CHURCHNAME\"><b>{{ cert.CHURCHNAME }}</b><br><span class=f14>{{ cert.PERSONNAME }}</span></td><td class=f14 ng-show=\"cert.CHURCHNAME == vmCM.churchCerts[$index-1].CHURCHNAME\">{{ cert.PERSONNAME }}</td><td class=\"txtCtr f15\" ng-show=\"cert.CHURCHNAME != vmCM.churchCerts[$index-1].CHURCHNAME\"><br>{{ cert.CERTTYPES }}</td><td class=\"txtCtr f15\" ng-show=\"cert.CHURCHNAME == vmCM.churchCerts[$index-1].CHURCHNAME\">{{ cert.CERTTYPES }}</td><td class=\"txtCtr f15\" ng-show=\"cert.CHURCHNAME != vmCM.churchCerts[$index-1].CHURCHNAME\"><span ng-show=\"cert.PROSTATUS==\'Certified\'\"><br>{{ cert.STATUSEXPIREDATE | date : \"MM/dd/yyyy\" }}</span> <span class=status ng-show=\"cert.PROSTATUS!=\'Certified\'\"><br>{{ cert.PROSTATUS }}</span></td><td class=\"txtCtr f15\" ng-show=\"cert.CHURCHNAME == vmCM.churchCerts[$index-1].CHURCHNAME\"><span ng-show=\"cert.PROSTATUS==\'Certified\'\">{{ cert.STATUSEXPIREDATE | date : \"MM/dd/yyyy\" }}</span> <span class=status ng-show=\"cert.PROSTATUS!=\'Certified\'\">{{ cert.PROSTATUS }}</span></td></tr></tbody></table></div></section>");
$templateCache.put("app/views/chgPW.html","<section class=section><!-- ChgPasswordController as vmCP --><div><h5><b>Tips for making the password stronger:</b></h5><ul><li>Make it longer</li><li>Use both UPPER &amp; lower case</li><li>Add a number</li><li>Add a special character: #*@!&amp;,^%</li></ul></div><div class=form-group><label for=txtOldPW>Old Password</label><input id=txtOldPW class=form-control type=text autofocus ng-model=vmCP.data.oldPW></div><h5>[New Password must not match old]</h5><div class=form-group><label for=txtNewPW>New Password</label><input id=txtNewPW class=form-control type=password ng-model=vmCP.data.newPW ng-change=vmCP.checkPWStrength() ng-blur=\"vmCP.confirmReadyToSave(\'pw\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><div>Password Strength is&nbsp;&nbsp;<span id=pwStrength class=\"ng-class: vmCP.sPWClass\">&nbsp;&nbsp;<b>{{ vmCP.sPasswordStrength }}</b>&nbsp;&nbsp;</span></div><div class=form-group><label for=txtConfirmPW>Confirm Password</label><input id=txtConfirmPW class=form-control type=password ng-model=vmCP.data.confirmPW ng-blur=\"vmCP.confirmReadyToSave(\'pw\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><h5><b>Current User Account Email: {{ vmCP.sUserEmail }}</b></h5><div class=div><label for=email>Update Email Address</label><input id=email class=form-control type=text ng-model=vmCP.data.email ng-blur=\"vmCP.confirmReadyToSave(\'email\')\"></div><div class=div><label for=confirmEmail>Confirm Email Address</label><input id=confirmEmail class=form-control type=text ng-model=vmCP.data.confirmEmail ng-blur=\"vmCP.confirmReadyToSave(\'email\')\" ng-keypress=vmCP.enterKeyHandler($event)></div><div class=divR><button ng-click=vmCP.cancelChanges()>Cancel</button> <button id=saveNewPW ng-class=vmCP.bReadyToSave style=width:100px ng-click=vmCP.saveChanges()>Save</button></div></section>");
$templateCache.put("app/views/helpDesk.html","<section class=section><!-- HelpDeskController vmHD --><div style=\"font-size: 21px; font-weight: bold\">MissionConnect: Help Desk</div><div class=form-group><label>Name:</label><input class=form-control placeholder=\"Enter Full Name\" type=text autofocus ng-model=vmHD.sUserFullName value=\"{{ vmHD.sUserFullName }}\" ng-change=vmHD.confirmReadyToSubmit()></div><div class=form-group><label>Email:</label><input class=form-control placeholder=\"Email Address\" type=text value=\"{{ vmHD.sUserEmail }}\" ng-model=vmHD.sUserEmail ng-change=vmHD.confirmReadyToSubmit()></div><div class=form-group><label>Describe the problem. Please include details.</label><textarea class=form-control ng-model=vmHD.sProblem ng-change=vmHD.confirmReadyToSubmit()></textarea></div><div><button id=submitHD class=btnCtr ng-class=vmHD.bReadyToSubmit ng-click=vmHD.submitHD()>Submit</button></div></section>");
$templateCache.put("app/views/lcPolicy.html","<section><h4>{{vmLC.header1}}</h4><div ng-repeat=\"item in vmLC.displayGrp1 | orderBy: \'seq\' track by $index\"><p ng-bind-html=item.HTML></p><p ng-show=\"item.control==\'BoldLabel\'\"><b>{{ item.label }}</b></p><div class=div ng-show=\"item.control==\'Button\'\" ng-click=vmLC.button_clickHandler(item)><button class=btnCtr>{{ item.label }}</button></div><div class=div ng-show=\"item.control==\'CheckBox\'\"><input type=checkbox name=item.id ng-model=vmLC.bReviewed ng-change=vmLC.checkBox_changeHandler(item)>&nbsp;&nbsp; <span ng-class={required:item.required}>{{ item.label }}</span></div></div><div class=divR><button ng-click=vmLC.cancel()>Cancel</button> <button id=saveSubmit ng-class=vmLC.bReadyToSubmit ng-click=vmLC.saveSubmit()>Submit</button></div></section>");
$templateCache.put("app/views/lcaCovenant.html","<section><!-- Controller: LCACovenantController --><h4>{{vmLCA.header1}}</h4><div ng-repeat=\"item in vmLCA.displayGrp1 | orderBy: \'seq\' track by $index\"><p ng-show=\"item.itemName==\'CovText1\'\"><b>I, {{ vmLCA.sUserFullName }}, {{ item.label }} {{ vmLCA.sChurchName }}</b></p><p ng-show=\"item.control==\'BoldLabel\' && item.itemName!=\'CovText1\'\"><b>{{ item.label }}</b></p><div class=div ng-show=\"item.control==\'TextArea1-650\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input name=item.id type=text style=\"width: 50px\" ng-model=vmLCA.sConsent ng-change=vmLCA.changeHandler(item.id)></div><div class=div ng-show=\"item.control==\'Button\'\"><button class=btnCtr ng-click=vmLCA.agreeHandler()>{{ item.label }}</button></div></div><div class=div><button ng-click=vmLCA.cancel()>Cancel</button></div></section>");
$templateCache.put("app/views/login.html","<section><div class=div style=\"background-color: white\" ng-show=\"vmLI.sDatabaseID==\'MC\' ||\n		vmLI.sDatabaseID==\'MC-DEV\'\"><img ng-src=\"{{ vmLI.imgMCBanner.image }}\" alt=\"McCurdy Ministries Community Center\"></div><div uib-alert ng-if=\"vmLI.sMaintenanceMsg !== \'\'\" class=\"alert alert-danger text-center\"><span ng-bind-html=vmLI.sMaintenanceMsg></span></div><div class=section><div ng-show=vmLI.bShowConferences><h4 class=txtCtr>Select your Conference:</h4><div><select class=ddlCtr ng-change=vmLI.selectConference(cust) ng-model=vmLI.selConf ng-options=\"cust as cust.CustomerName for cust in vmLI.custDB | \n						orderBy:cust.DataSource\"></select></div></div><div ng-show=\"vmLI.bAcctInit==true\"><p>If you do not already have a user account, you may create one by clicking the button below:</p><div class=divCtr style=width:210px><button style=width:210px;margin-bottom:10px ui-sref=newAcct><img ng-src=\"{{ vmLI.addNew.image }}\" alt=\"Create a new Account\"> &nbsp;&nbsp;Create a New Account</button></div></div><h5><b>Login to access Secure Applications</b><br><span class=txtMCRed>Username &amp; Password are Case Sensitive!</span></h5><div class=form-group><label for=txtUsername>Username</label><input id=txtUsername type=text class=form-control autofocus placeholder=Username ng-model=vmLI.sUsername ng-focus=vmLI.onFocus() ng-keypress=vmLI.enterKeyHandler($event)></div><div class=form-group><label for=txtPassword>Password</label><input id=txtPassword class=form-control type=password placeholder=Password ng-model=vmLI.sPassword ng-focus=vmLI.onFocus() ng-keypress=vmLI.enterKeyHandler($event)></div><div><div class=divL><button class=\"btn115 MCGold\" ng-click=vmLI.validateUserLogin() ng-keypress=vmLI.enterKeyHandler($event)>Login</button></div><div class=divR><button ng-click=vmLI.forgotPassword_clickHandler()>Forgot Password?</button></div></div><div class=div><h5>[For security reasons, the application will log off if idle for 30 minutes.]</h5></div></div></section>");
$templateCache.put("app/views/myCerts.html","<section><!-- 	<h4 style=\"text-align: center\">{{vmCrt.proProcessName}}</h4> --><div class=status>Username: {{vmCrt.username}}</div><div class=section><h4 class=txtMCRed>My {{vmCrt.proProcessName}}</h4><hr class=.hr250><div ng-repeat=\"cert in vmCrt.arcCertRecords | orderBy:\'-STATUSDATE\' track by $index\"><div class=divN><div style=\"position: relative; float: left; width: 70%\">{{ cert.CERTTYPEID | certTypeDesc }} <span ng-show=\"cert.CERTTYPEID==5 && \n						(vmCrt.sDatabaseID==\'MO-DEV\' || vmCrt.sDatabaseID==\'MO\' || vmCrt.sDatabaseID==\'VID\')\">&nbsp;for {{ vmCrt.sChurchName }}</span></div><div style=\"position: relative; float: right; width: 30%; text-align: right\">&lt;{{ cert.PROID }}&gt;</div></div><div class=divN><!-- In Process, with Continue button: --><div style=\"position: relative; float: left; width: 35%\"><button class=btnN ng-show=\"(cert.PROSTATUS==\'In Process\')\" ng-click=vmCrt.loadProcessSteps(cert)>Continue</button><!-- Don\'t show ProStatus when Certified & Expiring in 6 mos. --> <span ng-hide=\"cert.PROSTATUS==\'In Process\' || \n						(cert.PROSTATUS==\'Certified\' && vmCrt.bCertExpiring)\">{{ cert.PROSTATUS }}</span><!-- Replace \"ProStatus with \"Expiring SOON! if Expiring in 6 mos. --> <span ng-show=\"cert.PROSTATUS==\'Certified\' && vmCrt.bCertExpiring\" class=alert>Expiring SOON!</span></div><!-- In Process Expiring... --><div style=\"position: relative; float: right; width: 65%; text-align: right\" ng-show=\"cert.PROSTATUS==\'In Process\'\"><span ng-model=vmCrt.bProcessExpiring ng-class={alert:vmCrt.bProcessExpiring}>Exp: {{cert.STATUSEXPIREDATE|date:\"MM/dd/yyyy\"}}</span></div><!-- Other statuses: --><div style=position:relative;float:right;width:65%;text-align:right ng-hide=\"cert.PROSTATUS==\'In Process\'\"><span ng-model=vmCrt.bCertExpiring ng-class=\"{alert:(vmCrt.bCertExpiring && cert.PROSTATUS==\'Certified\')}\">[{{ cert.STATUSDATE | date:\"MM/dd/yyyy\"}} - {{ cert.STATUSEXPIREDATE | date:\"MM/dd/yyyy\" }}]</span></div></div><hr class=.hrN></div></div><!-- NWTX View ONLY: --><div style=\"position: relative; margin:auto\" ng-show=\"vmCrt.sDatabaseID==\'NWTX\' || vmCrt.sDatabaseID==\'NWTX-DEV\'\"><h4 class=txtMCRed ng-hide=\"vmCrt.bCampInProcess==true && vmCrt.bVIMInProcess==true\">Click a button below to begin a new Volunteer Process:</h4><div style=\"width:80%; margin:auto\"><img style=\"width:47%; float: left\" ng-src=\"{{ vmCrt.imgCamp.image }}\" alt=\"Begin Camping Volunteer process\" ng-hide=\"vmCrt.bCampInProcess==true\" ng-click=vmCrt.addNewOnlineProcess(4)> <img style=\"width:47%; float: right\" ng-src=\"{{ vmCrt.imgVIM.image }}\" alt=\"Begin VIM Volunteer process\" ng-hide=\"vmCrt.bVIMInProcess==true\" ng-click=vmCrt.addNewOnlineProcess(5)></div></div><!-- 	MC View Only: --><div class=divCtr style=width:280px ng-show=\"vmCrt.sDatabaseID==\'MC\'||vmCrt.sDatabaseID==\'MC-DEV\'\"><button style=\"width: 280px\" ng-hide=\"vmCrt.bInProcess==true\" ng-click=vmCrt.addNewOnlineProcess(4)><img ng-src=\"{{ vmCrt.addNew.image }}\" alt=\"Add New Certification Process\">&nbsp;&nbsp; Add new Certification Process</button></div><div class=divCtr style=\"width: 260px\" ng-show=\"vmCrt.bLCAApproved==true\"><a href=https://umcdata.net/MoSafeLC target=_blank><button style=\"width: 260px; height: 50px; vertical-align: middle\"><img style=float:left ng-src=\"{{ vmCrt.mc32.image }}\" alt=\"Download Safe Sanctuaries LCA Software\">&nbsp;&nbsp; <span>Download Safe Sanctuaries<br>LCA Software</span></button></a></div></section>");
$templateCache.put("app/views/newAcct.html","<section><!-- NewAcctController as vmUA --><div class=div ng-show=\"vmUA.sDatabaseID==\'MC\' || vmUA.sDatabaseID==\'MC-DEV\'\"><img style=width:100% ng-src=\"{{ vmUA.imgMCBanner.image }}\" alt=\"McCurdy Ministries Community Center\"></div><h4 style=\"text-align: center\">Create a New Account</h4><div class=section><div><h5><b>Tips for making the password stronger:</b></h5><ul><li>Make it longer</li><li>Use both UPPER &amp; lower case</li><li>Add a number</li><li>Add a special character: *@!&amp;,^%</li></ul></div><div><div class=divL><label for=firstName class=required>First Name</label><input name=firstName type=text class=form-control style=width:130px ng-model=vmUA.data.firstName autofocus></div><div class=divL><label for=lastName class=required>Last Name</label><input name=lastName type=text class=form-control style=width:165px ng-model=vmUA.data.lastName autofocus></div><div class=div><label for=userName class=required>User Name <span style=font-weight:400;color:#000>[Minimum of 4 characters]</span></label><input id=userName class=form-control type=text autofocus class=form-control ng-model=vmUA.data.userName ng-blur=\"vmUA.confirmReadyToSave(\'username\')\"></div><div class=div>Password Strength is:&nbsp;&nbsp; <span id=pwStrength class=\"ng-class: vmUA.sPWClass\">&nbsp;&nbsp;<b>{{ vmUA.sPasswordStrength }}</b>&nbsp;&nbsp;</span></div><div class=div><label for=password class=required>Password</label><input id=password class=form-control type=password ng-model=vmUA.data.password ng-change=vmUA.checkPWStrength() ng-blur=\" vmUA.confirmReadyToSave(\'pw\')\" ng-keypress=vmUA.enterKeyHandler($event)></div><div class=div><label for=confirmPW class=required>Confirm Password</label><input id=confirmPW class=form-control type=password ng-model=vmUA.data.confirmPW ng-blur=\"vmUA.confirmReadyToSave(\'pw\')\" ng-keypress=vmUA.enterKeyHandler($event)></div><div class=div><label for=email class=required>Email Address</label><input id=email class=form-control type=text ng-model=vmUA.data.email ng-blur=\"vmUA.confirmReadyToSave(\'email\')\"></div><div class=div><label for=confirmEmail class=required>Confirm Email Address</label><input id=confirmEmail class=form-control type=text ng-model=vmUA.data.confirmEmail ng-blur=\"vmUA.confirmReadyToSave(\'email\')\" ng-keypress=vmUA.enterKeyHandler($event)></div></div><div class=divR><button ui-sref=login>Cancel</button> <button id=saveNewPW class=\"ng-class: vmUA.bReadyToSave\" style=width:100px ng-click=vmUA.saveNewAccount()>Save</button></div></div></section>");
$templateCache.put("app/views/nwtxCampReq.html","<section><!-- vmNReq  NWTXReqController --><div><img ng-src=\"{{ vmNReq.back.image }}\" alt=\"Return to Payment page\" uib-tooltip=\"Return to Payment page\" tooltip-placement=right ng-click=vmNReq.returnToPaymentPage()></div><p ng-bind-html=vmNReq.sCampReq></p></section>");
$templateCache.put("app/views/nwtxPayment.html","<section><!-- vmNPay --><p ng-bind-html=vmNPay.sInstructions1></p><button class=btnCtr ng-show=\"vmNPay.iCertTypeID==4\" ng-click=vmNPay.goToCampReq()>Age Requirements &amp; Restrictions</button><p ng-bind-html=vmNPay.sCampInstr2></p><p style=\"text-align: center\"><b>[Scroll to bottom of page to Pay]</b></p><h4 class=h4L>{{vmNPay.header1}}</h4><div ng-repeat=\"item in vmNPay.arrDataFields | orderBy: \'seq\' track by $index\"><!--    VIM	 --><div class=div ng-show=\"item.itemName==\'TeamLeader\'\"><label for=item.id ng-class={required:item.required}>{{ item.label }}</label><input id=item.id name=item.id type=text class=form-control ng-model=item.data></div><div ng-show=\"item.itemName==\'VIMType\'\"><div class=div><label class=divL for=item.id ng-class={required:item.required}>{{ item.label }}</label><input class=divR style=\"width:80px; background-color:#C0CCDB; text-align:center\" name=fee1 type=text ng-disabled=true ng-model=item.fee><label class=divR>Fee:</label></div><input type=radio name=item.id value=Member ng-model=item.data ng-click=\"vmNPay.changeHandler(item.id,\'Member\')\">&nbsp;Member of a VIM Team<br><input type=radio name=item.id value=Leader ng-model=item.data ng-click=\"vmNPay.changeHandler(item.id,\'Leader\')\">&nbsp;Leading a VIM Team (I have been certified/trained as a VIM Team leader in the last four years through a UMC Conference VIM Coordinator<br><input type=radio name=item.id value=Training ng-model=item.data ng-click=\"vmNPay.changeHandler(item.id,\'Training\')\"> &nbsp;I am registering for Team Leader training</div><div class=div ng-show=\"item.itemName==\'VIMType\' && vmNPay.iCertTypeID==5\"><div class=divL><label for=voucher1>Voucher Code:</label><input name=voucher1 type=text class=input-sm ng-model=item.voucher ng-disabled=\"vmNPay.v1BtnText==\'Remove Voucher\'\"> <button ng-class=\"{vApply:vmNPay.v1BtnText==\'Apply Voucher\',\n					vRemove:vmNPay.v1BtnText==\'Remove Voucher\'}\" ng-model=vmNPay.v1BtnText ng-click=vmNPay.voucherHandler(1)>{{ vmNPay.v1BtnText }}</button></div><div class=divR><input class=divR style=\"width:80px; background-color:#C0CCDB; text-align:center\" name=fee1 type=text ng-disabled=true ng-model=item.vAmt><label class=divR>Credit Applied:</label></div></div><!--    Camps	 --><div class=div ng-show=\"item.itemName==\'CampSelection1\'\"><label for=item.id style=\"margin-bottom: 0\" ng-class={required:item.required}>{{ item.label }}</label><select class=form-control id=item.id ng-model=vmNPay.selCamp1 ng-options=\"camp as camp.CampListing for camp in vmNPay.arrCamps\" ng-change=vmNPay.updateData()><option value=\"\">&lt;No Selection&gt;</option></select><div class=div><input class=divL type=checkbox name=item.id ng-model=item.donate ng-change=vmNPay.donateHandler(item.id)>&nbsp;&nbsp; <span>Pay in Full as Donation</span> <input class=divR style=\"width:80px; background-color:#C0CCDB; text-align:center\" name=fee1 type=text ng-disabled=true ng-model=item.fee><label class=divR>Fee:</label></div><div class=divL><label for=voucher1>1st Camp Voucher Code (if applicable):</label><input name=voucher1 type=text class=input-sm ng-model=item.voucher ng-disabled=\"vmNPay.v1BtnText==\'Remove Voucher\'\"> <button ng-class=\"{vApply:vmNPay.v1BtnText==\'Apply Voucher\',\n					vRemove:vmNPay.v1BtnText==\'Remove Voucher\'}\" ng-model=vmNPay.v1BtnText ng-click=vmNPay.voucherHandler(1)>{{ vmNPay.v1BtnText }}</button></div><div class=divR><input class=divR style=\"width:80px; background-color:#C0CCDB; text-align:center\" name=fee1 type=text ng-disabled=true ng-model=item.vAmt><label class=divR>Credit Applied:</label></div></div><div class=div ng-show=\"item.itemName==\'CampSelection2\' && vmNPay.bShow2==true\"><label for=item.id style=\"margin-bottom: 0\" ng-class={required:item.required}>{{ item.label }}</label><select class=form-control id=item.id ng-model=vmNPay.selCamp2 ng-options=\"camp as camp.CampListing for camp in vmNPay.arrCamps\" ng-change=vmNPay.updateData()><option value=\"\">&lt;No Selection&gt;</option></select><div class=div><input class=divL type=checkbox name=item.id ng-model=item.donate value=false ng-change=vmNPay.donateHandler(item.id)>&nbsp;&nbsp; <span>Pay in Full as Donation</span> <input class=divR style=\"width:80px; background-color:#C0CCDB; text-align:center\" name=fee2 type=text ng-disabled=true ng-model=item.fee><label class=divR>Fee:</label></div><div class=divL><label for=voucher2>2nd Camp Voucher Code (if applicable):</label><input name=voucher2 type=text class=input-sm ng-model=item.voucher ng-disabled=\"vmNPay.v2BtnText==\'Remove Voucher\'\"> <button ng-class=\"{vApply:vmNPay.v2BtnText==\'Apply Voucher\',\n					vRemove:vmNPay.v2BtnText==\'Remove Voucher\'}\" ng-model=vmNPay.v2BtnText ng-click=vmNPay.voucherHandler(2)>{{ vmNPay.v2BtnText }}</button></div><div class=divR><input class=divR style=\"width: 80px; background-color:#C0CCDB; text-align:center\" name=credit2 type=text ng-disabled=true ng-model=item.vAmt><label class=divR for=credit2>Credit Applied:</label></div></div><div class=div ng-show=\"item.itemName==\'CampSelection3\' && vmNPay.bShow3==true\"><label for=item.id style=\"margin-bottom: 0\" ng-class={required:item.required}>{{ item.label }}</label><select class=form-control id=item.id ng-model=vmNPay.selCamp3 ng-options=\"camp as camp.CampListing for camp in vmNPay.arrCamps\" ng-change=vmNPay.updateData()><option value=\"\">&lt;No Selection&gt;</option></select><div class=div><input class=divL type=checkbox name=item.id ng-model=item.donate ng-change=vmNPay.donateHandler(item.id)>&nbsp;&nbsp; <span>Pay in Full as Donation</span> <input class=divR style=\"width:80px; background-color:#C0CCDB; text-align:center\" name=fee3 type=text ng-disabled=true ng-model=item.fee><label class=divR>Fee:</label></div><div class=divL><label for=voucher3>3rd Camp Voucher Code (if applicable):</label><input name=voucher3 type=text class=input-sm ng-model=item.voucher ng-disabled=\"vmNPay.v3BtnText==\'Remove Voucher\'\"> <button ng-class=\"{vApply:vmNPay.v3BtnText==\'Apply Voucher\',\n					vRemove:vmNPay.v3BtnText==\'Remove Voucher\'}\" ng-model=vmNPay.v3BtnText ng-click=vmNPay.voucherHandler(3)>{{ vmNPay.v3BtnText }}</button></div><div class=divR><input class=divR style=\"width: 80px; background-color:#C0CCDB; text-align:center\" name=credit3 type=text ng-disabled=true ng-model=item.vAmt><label class=divR for=credit3>Credit Applied:</label></div></div><div class=div ng-show=\"item.itemName==\'CampSelection4\' && vmNPay.bShow4==true\"><label for=item.id style=\"margin-bottom: 0\" ng-class={required:item.required}>{{ item.label }}</label><select class=form-control id=item.id ng-model=vmNPay.selCamp4 ng-options=\"camp as camp.CampListing for camp in vmNPay.arrCamps\" ng-change=vmNPay.updateData()><option value=\"\">&lt;No Selection&gt;</option></select><div class=div><input class=divL type=checkbox name=item.id ng-model=item.donate ng-change=vmNPay.donateHandler(item.id)>&nbsp;&nbsp; <span>Pay in Full as Donation</span> <input class=divR style=\"width:80px; background-color:#C0CCDB; text-align:center\" name=fee4 type=text ng-disabled=true ng-model=item.fee><label class=divR>Fee:</label></div><div class=divL><label for=voucher4>4th Camp Voucher Code (if applicable):</label><input name=voucher4 type=text class=input-sm ng-model=item.voucher ng-disabled=\"vmNPay.v4BtnText==\'Remove Voucher\'\"> <button ng-class=\"{vApply:vmNPay.v4BtnText==\'Apply Voucher\',\n					vRemove:vmNPay.v4BtnText==\'Remove Voucher\'}\" ng-model=vmNPay.v4BtnText ng-click=vmNPay.voucherHandler(4)>{{ vmNPay.v4BtnText }}</button></div><div class=divR><input class=divR style=\"width: 80px; background-color:#C0CCDB; text-align:center\" name=credit4 type=text ng-disabled=true ng-model=item.vAmt><label class=divR for=credit4>Credit Applied:</label></div></div><div class=div ng-show=\"item.control==\'CheckBox\' && vmNPay.bVoucher==true\"><input type=checkbox name=item.id ng-model=vmNPay.vWillPay ng-change=\"vmNPay.changeHandler(item.id, item.value)\">&nbsp;&nbsp; <span ng-class={required:item.required}>{{ item.label }}</span></div></div><div class=divL ng-hide=\"vmNPay.bShow4==true || vmNPay.iCertTypeID==5\"><button id=cmdAddCamp class=\"btn btn-default\" ng-click=vmNPay.addCamp()><img ng-src=\"{{ vmNPay.newCamp.image }}\" alt=\"Refresh Page\"> Add Another Camp</button></div><div class=divR><button class=MCGold ng-click=vmNPay.payNow()><b>Pay Total Amount Due</b></button> &nbsp;&nbsp;<b>$</b> <input style=\"width: 80px; font-weight: bold; background-color:#C0CCDB; text-align:center\" name=total type=text ng-disabled=true ng-model=vmNPay.nPayAmt></div></section>");
$templateCache.put("app/views/refRequest.html","<section><!-- vmRR - RefRequestController --><h3 style=\"width: 100%; text-align: center\">{{ vmRR.refHeader }}</h3><div style=\"width: 80%; margin: auto; text-align: center\"><h5>{{ vmRR.refSubheader }}<h5><h4 ng-hide=\"vmRR.sStepLinkFlag==\'DSRef\'\">Requirements</h4><h5 ng-hide=\"vmRR.sStepLinkFlag==\'DSRef\'\"><b>Before requesting your reference, please read the requirements below.</b></h5><p style=\"line-height: 1.0\">{{ vmRR.refRequirement }}</p></h5></h5></div><!-- Specific Reference goes here:	 --><div style=\"padding-top: 10px\"><ui-view></ui-view></div></section>");
$templateCache.put("app/views/refer.html","<section><div class=div><div class=divL><span class=\"status f18\">Applicant:<br>{{ vmRefer.Applicant }}</span></div><div class=divR><button ui-sref=certMgmt uib-tooltip=\"Return to Reference\" tooltip-placement=left type=button class=\"btn btn-default custTip\"><img ng-src=\"{{ vmRefer.back.image }}\" alt=\"Return to Reference List\"></button></div></div><p>If this reference has been sent to you, but you feel there is another Pastor or listed Staff member better equipped to provide a reference for {{ vmRefer.Applicant }}, please select them from the list and click &quot;Send.&quot; They will be sent a new Reference Request and this one will become invalid.</p><div class=div><select id=ddlPastors ng-model=vmRefer.selPastor ng-options=\"pastor as pastor.CHURCHPASTORS for pastor in vmRefer.otherPastors\"></select><button id=cmdSend ng-click=vmRefer.sendRefToOtherPastor()>Send</button></div></section>");
$templateCache.put("app/views/reference.html","<section><!-- vmRef - ReferenceController --><div class=div><div class=divL><span class=\"status f18\">Applicant:<br>{{ vmRef.Applicant }}</span></div><div class=divR><button ui-sref=certMgmt uib-tooltip=\"Return to Reference List\" tooltip-placement=left type=button class=\"btn btn-default custTip\"><img ng-src=\"{{ vmRef.back.image }}\" alt=\"Return to Reference List\"></button></div></div><div class=div ng-show=\"vmRef.sStepLinkFlag === \'PastorRef\'\"><button class=fltLClrR ng-click=vmRef.goToReferral()>Refer Reference</button><p class=lnHtSm>&nbsp;&nbsp;to another pastor or<br>&nbsp;&nbsp;staff person</p></div><div class=div ng-hide=\"vmRef.sStepLinkFlag === \'PastorRef\'\"><p><button class=wrapL ng-click=vmRef.declineRef()>Decline</button> If you wish to decline providing a Reference for {{ vmRef.Applicant }}, please do so by clicking the &quot;Decline&quot; button to the right.<br>Thank-you for your consideration in this process.</p></div><h3 class=txtCtr><b>{{ vmRef.header }}</b></h3><h4 class=txtCtr>{{ vmRef.subHeader }}</h4><p ng-bind-html=vmRef.instructions></p><hr><h3 id=sectionHdr ng-show=\"vmRef.sStepLinkFlag === \'DSRef\'\">{{ vmRef.sectionHdr }}</h3><div ng-repeat=\"item in vmRef.RefItems\"><div class=question><p>{{ item.question }}</p><input class=txtInput ng-hide=\"item.control != \'textInput\'\" type=text name=item.id ng-model=item.value ng-change=\"vmRef.saveSelection(item.id, item.value, item.required)\"></div><p class=example ng-show=\"item.example != null\">[{{ item.example }}]</p><p class=example ng-hide=\"vmRef.sStepLinkFlag != \'DSRef\'\">{{ item.instructions }}</p><div class=answer><input type=radio name={{item.id}} ng-model=item.val0 ng-hide=\"item.val0 == null\" value={{item.isDefault}} ng-value=item.val0 autocomplete=off ng-click=\"vmRef.saveSelection(item.id, item.val0, item.required)\"> {{ item.val0 }}<br ng-hide=\"item.val0 == null\"><input type=radio name={{item.id}} ng-model=item.val1 ng-hide=\"item.val1 == null\" value={{item.isDefault}} ng-value=item.val1 autocomplete=off ng-click=\"vmRef.saveSelection(item.id, item.val1, item.required)\"> {{ item.val1 }}<br ng-hide=\"item.val1 == null\"><input type=radio name={{item.id}} ng-model=item.val2 ng-hide=\"item.val2 == null\" value={{item.isDefault}} ng-value=item.val2 autocomplete=off ng-click=\"vmRef.saveSelection(item.id, item.val2, item.required)\"> {{ item.val2 }}<br ng-hide=\"item.val2 == null\"><input type=radio name={{item.id}} ng-model=item.val3 ng-hide=\"item.val3 == null\" value={{item.isDefault}} ng-value=item.val3 autocomplete=off ng-click=\"vmRef.saveSelection(item.id, item.val3, item.required)\"> {{ item.val3 }}<br ng-hide=\"item.val3 == null\"><input type=radio name={{item.id}} ng-model=item.val4 ng-hide=\"item.val4 == null\" value={{item.isDefault}} ng-value=item.val4 autocomplete=off ng-click=\"vmRef.saveSelection(item.id, item.val4, item.required)\"> {{ item.val4 }}<br ng-hide=\"item.val4 == null\"><input type=radio name={{item.id}} ng-model=item.val5 ng-hide=\"item.val5 == null\" value={{item.isDefault}} ng-value=item.val5 autocomplete=off ng-click=\"vmRef.saveSelection(item.id, item.val5, item.required)\"> {{ item.val5 }}<textarea id=txtArea ng-hide=\"item.control != \'textArea4\'\" ng-model=item.value ng-change=\"vmRef.saveSelection(item.id, item.value, item.required)\">\n			</textarea></div></div><div class=div><button class=MCGold ng-click=vmRef.submitReference() ng-dblclick=vmRef.submitReference()>Submit Reference for {{ vmRef.Applicant }}</button> <button ui-sref=certMgmt>Cancel</button></div></section>");
$templateCache.put("app/views/stepInst.html","<section><!-- vmSI  StepInstController --><div><img ng-src=\"{{ vmSI.back.image }}\" alt=\"Return to Steps page\" uib-tooltip=\"Return to Steps page\" tooltip-placement=right ng-click=vmSI.returnToSteps()></div><p ng-bind-html=vmSI.sInstructions></p></section>");
$templateCache.put("app/views/steps.html","<section><!-- vmSC  Steps Controller --><div class=status><span ng-hide=\"vmSC.sDatabaseID==\'MC\'||vmSC.sDatabaseID==\'MC-DEV\'||vmSC.sAppExpire==\'\'\">All Steps Must be Completed By {{ vmSC.sAppExpire }}</span> <button id=cmdRefresh uib-tooltip=\"Refresh Steps\" tooltip-placement=left class=\"btn btn-default custTip\" ng-click=vmSC.refreshPage()><img ng-src=\"{{ vmSC.refresh.image }}\" alt=\"Refresh Page\"></button></div><div><button class=MCGold ng-click=vmSC.openStepInst()>Additional Information - Please Read</button></div><!-- Steps: --><div ng-repeat=\"step in vmSC.arrSteps track by $index\"><div><p id=step>{{ $index+1}}.&nbsp;{{ step.STEPNAME }}</p><p class=statusSM ng-show=\"step.STEPDATE==\'\' && step.STEPPROGRESS != \'\'\">{{ step.STEPPROGRESS }} {{ step.sCreatedOn }}</p><p class=status ng-show=\"step.STEPDATE != \'\'\">Completed {{ step.STEPDATE|date:\"MM/dd/yyyy\" }}</p><img class=fltR ng-src=\"{{ vmSC.completed.image }}\" alt=\"Step Complete\" ng-show=\"step.STEPPROGRESS==\'Completed\' || step.STEPPROGRESS==\'Training Request Sent\'\n					|| step.STEPPROGRESS==\'Reference Request Sent\'\"><!--CONTINUE --> <button class=fltR ng-show=\"step.STEPDATE == \'\' && step.hideBtn != \'true\' &&\n				step.STEPPROGRESS != \'Reference Request Sent\'\" ng-click=vmSC.goToStep(step.STEPLINKFLAG)>{{ step.btnLabel }}</button><!--RESEND Reference: --> <button class=fltR ng-show=\"step.STEPPROGRESS==\'Reference Request Sent\'\" uib-tooltip={{step.toolTip}} tooltip-placement=left class=\"btn btn-default custTip\" ng-click=vmSC.resendRef(step)>Resend</button></div><p class=clrB ng-bind-html=step.HtmlStepDesc></p></div><div class=divCtr style=\"width: 260px\"><p class=status style=text-align:center>If all steps above are checked,<br>your process is complete!</p></div><div class=divCtr style=\"width: 120px\"><button class=MCGold style=width:120px ng-click=vmSC.logOff()>Log Out</button></div></section>");
$templateCache.put("app/views/training.html","<section><h4>{{ vmTr.header }}</h4><h4>{{ vmTr.subheader }}</h4><div class=divCtr style=width:200px><button ng-class=\"(vmTr.sCurPage==\'C-1\')||(vmTr.sCurPage.substr(0,1)!=\'C\')?\'invisible\':\'visible\'\" ng-click=vmTr.goBack()>&lt;&lt;&nbsp;Back</button> <button class=fltR ng-class=\"vmTr.bIncorrect==true ? \'invisible\' : \'visible\';\n	    	vmTr.bQuestion==false ? \'visible\' : \'invisible\'\" ng-hide=\"vmTr.sCurPage==\'Score\'\" ng-click=vmTr.goNext()>Next&nbsp;&gt;&gt;</button></div><p><b><u>{{ vmTr.sectionHdr }}</u></b></p><div ng-repeat=\"item in vmTr.arrDataFields | orderBy: \'seq\' track by $index\"><p ng-bind-html=item.HTML></p><div class=divCtr ng-if=\"item.control==\'Video\'\"><video id=vid width=100% height=100% type=video/mp4 style=\"border: none\" controls ng-src={{vmTr.videoPath}} autoplay></video></div><!-- 	Questions: --><p ng-if=\"item.curPage.substr(0,1)==\'Q\'\"><b>{{ item.label }}</b></p><!-- 	Answers: --><div class=div style=margin-left:20px ng-if=\"item.control==\'RadioTF\'\"><input type=radio name=item.id value=True ng-model=item.response ng-disabled=\"item.response != \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)> &nbsp;True&nbsp;&nbsp; <input type=radio name=item.id value=False ng-model=item.response autocomplete=off ng-disabled=\"item.response != \'\'\" ng-click=vmTr.answerHandler(item.id)>&nbsp;False&nbsp;&nbsp;</div><div class=div style=margin-left:20px ng-if=\"item.control==\'RadioYN\'\"><input type=radio name=item.id value=Yes ng-model=item.response ng-disabled=\"item.response != \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)>&nbsp;Yes&nbsp;&nbsp; <input type=radio name=item.id value=No ng-model=item.response autocomplete=off ng-disabled=\"item.response != \'\'\" ng-click=vmTr.answerHandler(item.id)>&nbsp;No&nbsp;&nbsp;</div><div style=margin-left:20px ng-if=\"item.control==\'Radio-sub\'\"><input type=radio name=item.id ng-model=item.response ng-value=item.opt0.SELECTIONID ng-disabled=\"item.response != \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)> {{ item.opt0.SELECTIONTEXT }}<br><br><input type=radio name=item.id ng-model=item.response ng-value=item.opt1.SELECTIONID ng-disabled=\"item.response != \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)> {{ item.opt1.SELECTIONTEXT }}<br><br><input type=radio name=item.id ng-model=item.response ng-value=item.opt2.SELECTIONID ng-disabled=\"item.response != \'\'\" ng-hide=\"item.opt2 == \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)> {{ item.opt2.SELECTIONTEXT }}<br><br><input type=radio name=item.id ng-model=item.response ng-value=item.opt3.SELECTIONID ng-disabled=\"item.response != \'\'\" ng-hide=\"item.opt3 == \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)> {{ item.opt3.SELECTIONTEXT }}<br><br><input type=radio name=item.id ng-model=item.response ng-value=item.opt4.SELECTIONID ng-disabled=\"item.response != \'\'\" ng-hide=\"item.opt4 == \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)> {{ item.opt4.SELECTIONTEXT }}<br><br><input type=radio name=item.id ng-model=item.response ng-value=item.opt5.SELECTIONID ng-disabled=\"item.response != \'\'\" ng-hide=\"item.opt5 == \'\'\" autocomplete=off ng-click=vmTr.answerHandler(item.id)> {{ item.opt5.SELECTIONTEXT }}<br></div><!-- 	Incorrect Response --><div class=div ng-show=\"item.control==\'FailText\' && vmTr.bIncorrect==true\"><span class=status>{{ item.label }}</span> <button style=\"background-color: #AF6867;float: right\" ng-click=vmTr.tryAgain()>Try Again!</button></div><div ng-show=\"item.control==\'FailText\' && vmTr.bCorrect==true\"><span class=status>That is correct!</span></div></div><!-- 	Score --><div class=divCtr style=\"max-width: 320px\" ng-if=\"vmTr.sCurPage==\'Score\'\"><div><p style=\"float:left; width: 270px\"><b>Your score for correctly answering the question on your first attempt is:</b></p><p class=status style=float:right;width:40px;text-align:center>{{vmTr.Score|number:0}}%</p></div><div><p style=float:left><b>Questions requiring 2 tried to get correct:</b></p><p class=status style=float:right;width:40px;text-align:center>{{ vmTr.Tries2}}</p></div><div><p style=float:left><b>Questions requiring 3 tried to get correct:</b></p><p class=status style=float:right;width:40px;text-align:center>{{ vmTr.Tries3 }}</p></div><div><p style=float:left><b>Questions requiring 4 tried to get correct:</b></p><p class=status style=float:right;width:40px;text-align:center>{{ vmTr.Tries4 }}</p></div><div><p style=float:left><b>Questions requiring 5 tried to get correct:</b></p><p class=status style=float:right;width:40px;text-align:center>{{ vmTr.Tries5 }}</p></div><div class=divCtr style=\"width: 180px\"><button class=MCGold style=\"width: 180px\" ui-sref=steps>Return to Steps</button></div></div><footer ng-hide=\"vmTr.sCurPage==\'Score\'\"><div><button style=\"float: right\" ui-sref=steps>Return to Steps</button><div style=\"width: 185px; float: right\">You may leave the Training at any time, to return and finish later.</div></div></footer></section>");}]);